"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[989],{

/***/ 41154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ safeUrl; },
/* harmony export */   "L": function() { return /* binding */ handlePathDelay; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "Qs": function() { return /* binding */ parseTourLink; },
/* harmony export */   "k6": function() { return /* binding */ asyncStore; },
/* harmony export */   "nA": function() { return /* binding */ checkIsFavourite; },
/* harmony export */   "wv": function() { return /* binding */ parsePathDestinationSweepData; }
/* harmony export */ });
/* unused harmony export capitalizeFirstLetter */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var _models_Game__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81766);


var asyncStore = {
    regularActivePath: null,
    pathSnapshot: {},
    pathIds: [],
    locksPathTimeline: {},
    hidePathTimeline: {},
    revealPathTimeline: {},
    restoreTagsTimeline: {},
    pushRestoreTagsTimeline: function(pathId, tagSid) {
        console.log("bbb pushRestoreTagsTimeline", pathId, tagSid);
        if (!asyncStore.restoreTagsTimeline[pathId]) {
            asyncStore.restoreTagsTimeline[pathId] = [];
        }
        asyncStore.restoreTagsTimeline[pathId].push(tagSid);
    },
    pushRevealPathTimeline: function(pathId, conditions) {
        var _pathId;
        if (!asyncStore.revealPathTimeline[pathId]) {
            asyncStore.revealPathTimeline[pathId] = [];
        }
        (_pathId = asyncStore.revealPathTimeline[pathId]).push.apply(_pathId, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(conditions));
    },
    pushHidePathTimeline: function(pathId, conditions) {
        var _pathId;
        if (!asyncStore.hidePathTimeline[pathId]) {
            asyncStore.hidePathTimeline[pathId] = [];
        }
        (_pathId = asyncStore.hidePathTimeline[pathId]).push.apply(_pathId, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(conditions));
    },
    pushLockPathTimeline: function(pathId, lockData) {
        if (!asyncStore.locksPathTimeline[pathId]) {
            asyncStore.locksPathTimeline[pathId] = [];
        }
        asyncStore.locksPathTimeline[pathId].push(lockData);
    }
};
var parseTourLink = function(link, slug) {
    var linkSlug = link.replace(/(.+\/)|(\?.+)/g, "");
    if (slug && linkSlug !== slug) return false;
    var res = new URLSearchParams(link.replace(/(.+\?)/, "?"));
    return {
        s: res.get("s"),
        x: Number(res.get("x")),
        y: Number(res.get("y"))
    };
};
var checkIsFavourite = function() {
    var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], product = arguments.length > 1 ? arguments[1] : void 0, mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (mode === 0) {
        return products === null || products === void 0 ? void 0 : products.find(function(id) {
            return id === (product === null || product === void 0 ? void 0 : product.id);
        });
    }
    return products === null || products === void 0 ? void 0 : products.find(function(id) {
        return id === (product === null || product === void 0 ? void 0 : product.eCommerceProductId);
    });
};
var capitalizeFirstLetter = function(str) {
    if (!str) return null;
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var safeUrl = function(url) {
    if (!url.includes("http")) return "http://".concat(url);
    return url;
};
var appearanceDelayTimeout = null;
var handlePathDelay = function(delay, setDelayedDisable) {
    if (appearanceDelayTimeout) {
        clearTimeout(appearanceDelayTimeout);
        appearanceDelayTimeout = null;
    }
    if (delay) {
        setDelayedDisable(true);
        appearanceDelayTimeout = setTimeout(function() {
            setDelayedDisable(false);
        }, delay * 1000);
    } else {
        setDelayedDisable(false);
    }
};
var isImage = function(value) {
    return /[^"]*?\.(jpg|png|bmp|wepb|webp|gif|jpeg|tif|tiff)/.test(value === null || value === void 0 ? void 0 : value.toLowerCase());
};
var parsePathDestinationSweepData = function(pathData) {
    var res = {
        sweepUuid: pathData === null || pathData === void 0 ? void 0 : pathData.sweepUuid,
        isTourLink: (pathData === null || pathData === void 0 ? void 0 : pathData.locationSrc) === _models_Game__WEBPACK_IMPORTED_MODULE_0__/* .LocationSrc.tourLink */ .JK.tourLink,
        x: null,
        y: null
    };
    try {
        if (res.isTourLink) {
            var parsedLink = parseTourLink(pathData.locationSmartLink);
            if (parsedLink && (parsedLink === null || parsedLink === void 0 ? void 0 : parsedLink.s) && (parsedLink === null || parsedLink === void 0 ? void 0 : parsedLink.x) && (parsedLink === null || parsedLink === void 0 ? void 0 : parsedLink.y)) {
                res.x = parsedLink.x;
                res.y = parsedLink.y;
                res.sweepUuid = parsedLink.s;
            }
        }
    } finally{
        return res;
    }
};


/***/ }),

/***/ 66725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ dLog; },
/* harmony export */   "d": function() { return /* binding */ stopLogs; }
/* harmony export */ });


var colors = "#556b2f,#a0522d,#483d8b,#008000,#008b8b,#9acd32,#00008b,#7f007f,#8fbc8f,#b03060,#ff4500,#ff8c00,#ffd700,#7cfc00,#8a2be2,#00ff7f,#dc143c,#00ffff,#00bfff,#f4a460,#0000ff,#b0c4de,#ff00ff,#1e90ff,#90ee90,#ff1493,#ee82ee,#ffe4b5,#ffb6c1".split(",");
var components = {};
var cr = function() {
    return Math.random() * (255 - 1) + 1;
};
var showRenderStats = function() {
    var componentsMap = Object.keys(components).map(function(key) {
        return _object_spread_props(_object_spread({}, components[key]), {
            name: key
        });
    }).sort(function(comp1, comp2) {
        return comp1.i > comp2 ? 1 : comp1 === comp2 ? 0 : -1;
    });
    componentsMap.forEach(function(comp) {
        console.log("%c render_d ".concat(comp.name, " ").concat(comp.i), "color:white;background:".concat(comp.color, ";"));
    });
};
var stopLogs = true;
if (false) {}
var dLog = function(componentName) {
    if (false) {}
};


/***/ }),

/***/ 2828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Agent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40488);



var Agent = function Agent() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Agent);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.phone = model.phone || null;
    this.clientId = model.clientId || null;
    this.logo = this.id && model.clientId && model.logo ? "".concat("https://cdn.treedis.com", "/clients/").concat(model.clientId, "/agents/").concat(this.id, "/logo.png").concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getVersion */ .bo)(this.updatedAt)) : null;
    this.widthLogo = model.widthLogo || false;
    this.agentTours = model.agentTours || [];
    this.updatedAt = model.updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(model.updatedAt) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
    this.permissionId = model.permissionId || null;
    this.agentPermission = model.agentPermission || null;
};


/***/ }),

/***/ 41292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Res; },
/* harmony export */   "u": function() { return /* binding */ PaymentType; }
/* harmony export */ });
var Res;
(function(Res) {
    Res["Percentage"] = "percentage";
    Res["Pixels"] = "pixels";
})(Res || (Res = {}));
var PaymentType;
(function(PaymentType) {
    PaymentType["Paypal"] = "paypal";
    PaymentType["Card"] = "card";
    PaymentType["External"] = "external";
    PaymentType["NoPaid"] = "noPaid";
    PaymentType["Stripe"] = "stripe";
})(PaymentType || (PaymentType = {}));


/***/ }),

/***/ 81766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ LockLocationType; },
/* harmony export */   "BY": function() { return /* binding */ EMPTY_LOCATION_ITEM; },
/* harmony export */   "CP": function() { return /* binding */ ConditionType; },
/* harmony export */   "Gn": function() { return /* binding */ LockType; },
/* harmony export */   "JK": function() { return /* binding */ LocationSrc; },
/* harmony export */   "KO": function() { return /* binding */ GameLockPathTransitionType; },
/* harmony export */   "LV": function() { return /* binding */ Res; },
/* harmony export */   "Tl": function() { return /* binding */ LOCK_SOLUTION_SEPARATOR; },
/* harmony export */   "Xr": function() { return /* binding */ ScoreType; },
/* harmony export */   "lA": function() { return /* binding */ Game; },
/* harmony export */   "py": function() { return /* binding */ EntityType; },
/* harmony export */   "zc": function() { return /* binding */ ContentType; }
/* harmony export */ });
/* unused harmony exports GameTimerType, LockLocationTypeLabel, HintContentType, FinishScreenTemplate, GameGeneral, GameCondition, GameLockQuestion, GameLockPath, GameLock, GameHint */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71418);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59603);
/* harmony import */ var _game_GameBook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97741);
/* harmony import */ var _helpers_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41154);
/* eslint-disable camelcase */ // eslint-disable-next-line max-classes-per-file











var Res;
(function(Res) {
    Res["Percentage"] = "percentage";
    Res["Pixels"] = "pixels";
})(Res || (Res = {}));
var GameTimerType;
(function(GameTimerType) {
    GameTimerType["CountDown"] = "countdown";
    GameTimerType["StopWatch"] = "stopwatch";
})(GameTimerType || (GameTimerType = {}));
var ScoreType;
(function(ScoreType) {
    ScoreType["Progress"] = "progress";
    ScoreType["Points"] = "points";
})(ScoreType || (ScoreType = {}));
var LockType;
(function(LockType) {
    LockType["Code"] = "code";
    LockType["Keyboard"] = "keyboard";
    LockType["Sequence"] = "sequence";
    LockType["PopUpTrivia"] = "popUpTrivia";
    LockType["CollectItems"] = "collectItems";
    LockType["Path"] = "path";
    LockType["Genially"] = "genial_ly";
})(LockType || (LockType = {}));
var LockLocationType;
(function(LockLocationType) {
    LockLocationType["Tag"] = "tag";
    LockLocationType["TransparentBox"] = "transparentBox";
    LockLocationType["vsItem"] = "vsItem";
    LockLocationType["Polygon"] = "Polygon";
    LockLocationType["vsVideo"] = "vsVideo";
    LockLocationType["vsImage"] = "vsImage";
})(LockLocationType || (LockLocationType = {}));
var LockLocationTypeLabel;
(function(LockLocationTypeLabel) {
    LockLocationTypeLabel["tag"] = "tag";
    LockLocationTypeLabel["transparentBox"] = "transparentBox";
    LockLocationTypeLabel["vsItem"] = "VSitem";
})(LockLocationTypeLabel || (LockLocationTypeLabel = {}));
var EntityType;
(function(EntityType) {
    EntityType["Tag"] = "tag";
    EntityType["Sweep"] = "sweep";
    EntityType["Popup"] = "popup";
    EntityType["Polygon"] = "polygon";
    EntityType["VSItem"] = "vsItem";
    EntityType["VSImage"] = "vsImage";
    EntityType["VSVideo"] = "vsVideo";
    EntityType["VSHTML"] = "vsHTML";
})(EntityType || (EntityType = {}));
var ConditionType;
(function(ConditionType) {
    ConditionType["HIDE"] = "hide";
    ConditionType["REVEAL"] = "reveal";
})(ConditionType || (ConditionType = {}));
var HintContentType;
(function(HintContentType) {
    HintContentType["Text"] = "text";
    HintContentType["Picture"] = "picture";
    HintContentType["Video"] = "video";
})(HintContentType || (HintContentType = {}));
var ContentType;
(function(ContentType) {
    ContentType["Sound"] = "sound";
    ContentType["Picture"] = "picture";
    ContentType["Text"] = "text";
    ContentType["Video"] = "video";
    ContentType["ExperiencePopupImage"] = "experiencePopupImage";
    ContentType["ExperiencePopupVideo"] = "experiencePopupVideo";
})(ContentType || (ContentType = {}));
var LOCK_SOLUTION_SEPARATOR = "|";
var EMPTY_LOCATION_ITEM = "-1";
var DEFAULT_RES = Res.Pixels;
var DEFAULT_WIDTH = 80;
var DEFAULT_HEIGHT = 60;
var FinishScreenTemplate;
(function(FinishScreenTemplate) {
    FinishScreenTemplate["DEFAULT"] = "default";
    FinishScreenTemplate["CUSTOM"] = "custom";
})(FinishScreenTemplate || (FinishScreenTemplate = {}));
var GameGeneral = function GameGeneral() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameGeneral);
    this.id = model.id || null;
    this.name = model.name || null;
    this.credits = model.credits || null;
    this.greetingRes = model.greetingRes || DEFAULT_RES;
    this.greetingImg = model.greetingImg || null;
    this.greetingImgW = model.greetingImgW || DEFAULT_WIDTH;
    this.greetingImgH = model.greetingImgH || DEFAULT_HEIGHT;
    this.greetingImgMob = model.greetingImgMob || null;
    this.greetingImgMobW = model.greetingImgMobW || DEFAULT_WIDTH;
    this.greetingImgMobH = model.greetingImgMobH || DEFAULT_HEIGHT;
    this.greetingVideo = model.greetingVideo || null;
    this.greetingMobVideo = model.greetingMobVideo || null;
    this.timerType = model.timerType || GameTimerType.CountDown;
    this.limitTime = model.limitTime || 0;
    this.timeUpRes = model.timeUpRes || DEFAULT_RES;
    this.timeUpImg = model.timeUpImg || null;
    this.timeUpImgW = model.timeUpImgW || DEFAULT_WIDTH;
    this.timeUpImgH = model.timeUpImgH || DEFAULT_HEIGHT;
    this.timeUpImgMob = model.timeUpImgMob || null;
    this.timeUpImgMobW = model.timeUpImgMobW || DEFAULT_WIDTH;
    this.timeUpImgMobH = model.timeUpImgMobH || DEFAULT_HEIGHT;
    this.timeUpVideo = model.timeUpVideo || null;
    this.timeUpMobVideo = model.timeUpMobVideo || null;
    this.scoreType = model.scoreType || ScoreType.Progress;
    this.lock_points = model.lock_points || 0;
    this.nextHintTime = model.nextHintTime || 0;
    this.scoreHint1 = model.scoreHint1 || 0;
    this.scoreHint2 = model.scoreHint2 || 0;
    this.scoreSolution = model.scoreSolution || 0;
    this.tutorialRes = model.tutorialRes || DEFAULT_RES;
    this.tutorialImg = model.tutorialImg || null;
    this.tutorialImgW = model.tutorialImgW || DEFAULT_WIDTH;
    this.tutorialImgH = model.tutorialImgH || DEFAULT_HEIGHT;
    this.tutorialImgMob = model.tutorialImgMob || null;
    this.tutorialImgMobW = model.tutorialImgMobW || DEFAULT_WIDTH;
    this.tutorialImgMobH = model.tutorialImgMobH || DEFAULT_HEIGHT;
    this.tutorialVideo = model.tutorialVideo || null;
    this.tutorialMobVideo = model.tutorialMobVideo || null;
    this.autoplayTutorial = model.autoplayTutorial || false;
    this.subscriptionId = model.subscriptionId || null;
    this.paid = model.paid || false;
    this.introClip = model.introClip || false;
    this.introClipUrl = model.introClipUrl || null;
    this.hideSkipBtn = model.hideSkipBtn || null;
    this.uploadedIntroUrl = model.uploadedIntroUrl || "";
    this.outroClip = model.outroClip || false;
    this.outroClipUrl = model.outroClipUrl || null;
    this.uploadedOutroUrl = model.uploadedOutroUrl || "";
    this.answerIndicatorOn = model.answerIndicatorOn || false;
    this.finishScreenOn = model.finishScreenOn || false;
    this.finishScreenType = model.finishScreenType || FinishScreenTemplate.DEFAULT;
    this.finishScreenTitle = model.finishScreenTitle;
    var _finishScreenShareOn;
    this.finishScreenShareOn = (_finishScreenShareOn = model.finishScreenShareOn) !== null && _finishScreenShareOn !== void 0 ? _finishScreenShareOn : false;
    var _finishScreenLeaderboardOn;
    this.finishScreenLeaderboardOn = (_finishScreenLeaderboardOn = model.finishScreenLeaderboardOn) !== null && _finishScreenLeaderboardOn !== void 0 ? _finishScreenLeaderboardOn : false;
    var _finishScreenRateOn;
    this.finishScreenRateOn = (_finishScreenRateOn = model.finishScreenRateOn) !== null && _finishScreenRateOn !== void 0 ? _finishScreenRateOn : false;
    this.timerOn = model.timerOn || false;
    this.progressOn = model.progressOn || false;
    this.hintsOn = model.hintsOn || false;
    this.backpackOn = model.backpackOn || false;
    this.showBackpackByDefault = model.showBackpackByDefault || false;
    this.gameBookOn = model.gameBookOn || false;
    this.buttonSound = model.buttonSound || false;
    this.buttonSoundUrl = model.buttonSoundUrl || null;
    this.registration = model.registration || false;
    this.shareResult = model.shareResult || false;
    this.updatedAt = model.updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(model.updatedAt) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
    this.finishScreenImage = model.finishScreenImage || "";
};
var GameCondition = function GameCondition() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameCondition);
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lock_ids = model.lock_ids || null;
    this.conditionType = model.conditionType || ConditionType.REVEAL;
    this.entity_type = model.entity_type || null;
    this.entity_ids = model.entity_ids || null;
    this.color = model.color || null;
    this.teleportToSweep = model.teleportToSweep || null;
    this.content_type = model.content_type || ContentType.Text;
    this.content_value = model.content_value || null;
    this.gameBackpack = model.gameBackpack || false;
    this.autoPlay = model.autoPlay || false;
    this.fullscreen = model.fullscreen || false;
    this.res = model.res || Res.Percentage;
    this.resMobile = model.resMobile || Res.Percentage;
    this.width = model.width || 60;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 60;
    this.heightMobile = model.heightMobile || 60;
    this.lockPathId = model.lockPathId || null;
    this.experienceTitle = model.experienceTitle || null;
    this.experienceDescription = model.experienceDescription || null;
    this.autoClose = model.autoClose || false;
    this.teleportLocationType = model.teleportLocationType;
    this.teleportLocationTourLink = model.teleportLocationTourLink;
};
var GameLockQuestion = function GameLockQuestion() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameLockQuestion);
    this.id = model.id || null;
    this.title = model.title || null;
    this.answer1 = model.answer1 || null;
    this.answer2 = model.answer2 || null;
    this.answer3 = model.answer3 || null;
    this.answer4 = model.answer4 || null;
    this.correctAnswer = model.correctAnswer || null;
};
var GameLockPathTransitionType;
(function(GameLockPathTransitionType) {
    GameLockPathTransitionType["FADEOUT"] = "fadeout";
    GameLockPathTransitionType["FLY"] = "fly";
    GameLockPathTransitionType["INSTANT"] = "instant";
    GameLockPathTransitionType["MANUAL"] = "manual";
})(GameLockPathTransitionType || (GameLockPathTransitionType = {}));
var LocationSrc;
(function(LocationSrc) {
    LocationSrc["chooseSweep"] = "chooseSweep";
    LocationSrc["tourLink"] = "tourLink";
})(LocationSrc || (LocationSrc = {}));
var GameLockPath = /*#__PURE__*/ function() {
    "use strict";
    function GameLockPath() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameLockPath);
        this.id = model.id || null;
        this.title = model.title || null;
        this.sweepUuid = model.sweepUuid || null;
        this.description = model.description || null;
        this.locationType = model.locationType || null;
        this.locationItem = model.locationType && model.locationItem ? model.locationItem : null;
        this.triggerType = model.triggerType || null;
        this.autoOpenDestination = model.autoOpenDestination || false;
        this.hideStep = model.hideStep || false;
        this.disableTeleport = model.disableTeleport || false;
        this.disableNextBeforeCompletingTask = model.disableNextBeforeCompletingTask || false;
        this.appearanceDelay = model.appearanceDelay || 0;
        this.locationSrc = model.locationSrc || LocationSrc.chooseSweep;
        this.locationSmartLink = model.locationSmartLink || "";
        this.triggerItem = model.triggerType && model.triggerItem ? model.triggerItem : null;
        this.transitionType = model.transitionType || GameLockPathTransitionType.INSTANT;
        this.icon = model.icon ? "".concat("https://cdn.treedis.com", "/").concat(model.icon) : null;
        if (this.sweepUuid === null && this.locationSmartLink) {
            this.setSweepUuid(this.locationSmartLink);
        }
    }
    var _proto = GameLockPath.prototype;
    _proto.setSweepUuid = function setSweepUuid(locationSmartLink) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .parsePathDestinationSweepData */ .wv)({
                                locationSmartLink: locationSmartLink,
                                locationSrc: _this.locationSrc
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        _this.sweepUuid = res === null || res === void 0 ? void 0 : res.sweepUuid;
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return GameLockPath;
}();
var GameLockPathSetting = function GameLockPathSetting(model) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameLockPathSetting);
    this.id = (model === null || model === void 0 ? void 0 : model.id) || null;
    this.gameLockId = (model === null || model === void 0 ? void 0 : model.gameLockId) || null;
    this.colorBackground = (model === null || model === void 0 ? void 0 : model.colorBackground) || "#ffffff";
    this.colorText = (model === null || model === void 0 ? void 0 : model.colorText) || "#636363";
    this.colorButton = (model === null || model === void 0 ? void 0 : model.colorButton) || "#ea475c";
    this.colorButtonText = (model === null || model === void 0 ? void 0 : model.colorButtonText) || "#ffffff";
    this.opacityBackground = (model === null || model === void 0 ? void 0 : model.opacityBackground) || 0.75;
    this.titleColorText = (model === null || model === void 0 ? void 0 : model.titleColorText) || "#000000";
    this.titleOpacityText = (model === null || model === void 0 ? void 0 : model.titleOpacityText) || 1;
    this.opacityText = (model === null || model === void 0 ? void 0 : model.opacityText) || 1;
    this.opacityButton = (model === null || model === void 0 ? void 0 : model.opacityButton) || 1;
    this.opacityButtonText = (model === null || model === void 0 ? void 0 : model.opacityButtonText) || 1;
    this.icon = (model === null || model === void 0 ? void 0 : model.icon) || null;
    this.titleEnabled = (model === null || model === void 0 ? void 0 : model.titleEnabled) || false;
    this.stepEnabled = (model === null || model === void 0 ? void 0 : model.stepEnabled) || false;
    this.defaultPath = model.defaultPath || false;
    this.resetPathOnSwitch = model.resetPathOnSwitch || false;
};
var GameLock = function GameLock() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameLock);
    this.id = model.id || null;
    this.name = model.name || null;
    this.type = model.type || null;
    this.url = model.url || null;
    this.mobileUrl = model.mobileUrl || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationItem || null;
    this.solution = model.solution || null;
    this.correctMusic = model.correctMusic || null;
    this.incorrectMusic = model.incorrectMusic || null;
    this.finishMusic = model.finishMusic || null;
    this.questions = model.questions && model.questions.map(function(question) {
        return new GameLockQuestion(question);
    }) || [];
    this.paths = ((model === null || model === void 0 ? void 0 : model.paths) || []).map(function(path) {
        return new GameLockPath(path);
    });
    var ref;
    this.keepHighlight = (ref = model === null || model === void 0 ? void 0 : model.keepHighlight) !== null && ref !== void 0 ? ref : true;
    this.resetHighlight = model.resetHighlight || 0;
    this.vsRes = model.vsRes || Res.Percentage;
    this.vsImg = model.vsImg || null;
    this.vsImgW = model.vsImgW || DEFAULT_WIDTH;
    this.vsImgH = model.vsImgH || DEFAULT_HEIGHT;
    this.vsMobImg = model.vsMobImg || null;
    this.vsMobImgW = model.vsMobImgW || DEFAULT_WIDTH;
    this.vsMobImgH = model.vsMobImgH || DEFAULT_HEIGHT;
    this.collected = [];
    this.icon = model.icon || null;
    var _hideItems;
    this.hideItems = (_hideItems = model.hideItems) !== null && _hideItems !== void 0 ? _hideItems : false;
    var _allowSkipping;
    this.allowSkipping = (_allowSkipping = model.allowSkipping) !== null && _allowSkipping !== void 0 ? _allowSkipping : false;
    var _last;
    this.last = (_last = model.last) !== null && _last !== void 0 ? _last : false;
    this.point = model.point || 0;
    var _timerEnabled;
    this.timerEnabled = (_timerEnabled = model.timerEnabled) !== null && _timerEnabled !== void 0 ? _timerEnabled : false;
    var _allowWrongAnswer;
    this.allowWrongAnswer = (_allowWrongAnswer = model.allowWrongAnswer) !== null && _allowWrongAnswer !== void 0 ? _allowWrongAnswer : false;
    var _confettiEnabled;
    this.confettiEnabled = (_confettiEnabled = model.confettiEnabled) !== null && _confettiEnabled !== void 0 ? _confettiEnabled : false;
    var _guidCanClose;
    this.guidCanClose = (_guidCanClose = model.guidCanClose) !== null && _guidCanClose !== void 0 ? _guidCanClose : false;
    var _lockTimer;
    this.lockTimer = (_lockTimer = model.lockTimer) !== null && _lockTimer !== void 0 ? _lockTimer : 0;
    var _multipleAttempts;
    this.multipleAttempts = (_multipleAttempts = model.multipleAttempts) !== null && _multipleAttempts !== void 0 ? _multipleAttempts : false;
    var _lockPopUpCanBeClosed;
    this.lockPopUpCanBeClosed = (_lockPopUpCanBeClosed = model.lockPopUpCanBeClosed) !== null && _lockPopUpCanBeClosed !== void 0 ? _lockPopUpCanBeClosed : false;
    var _guidCanBeClosed;
    this.guidCanBeClosed = (_guidCanBeClosed = model.guidCanBeClosed) !== null && _guidCanBeClosed !== void 0 ? _guidCanBeClosed : false;
    var _quantityOfAttempts;
    this.quantityOfAttempts = (_quantityOfAttempts = model.quantityOfAttempts) !== null && _quantityOfAttempts !== void 0 ? _quantityOfAttempts : 0;
    var pS = model.pathSetting || {};
    this.pathSetting = new GameLockPathSetting((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, pS), {
        stepEnabled: model.stepEnabled,
        titleEnabled: model.titleEnabled
    }));
    this.hint = model.hint || null;
    this.description = model.description || "";
    this.previousStep = model.previousStep || false;
    this.buttonOnlyMode = model.buttonOnlyMode || false;
    this.nextButtonVisibility = model.nextButtonVisibility || _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__/* .TLocksButtonVisibility.ShowAll */ .XZ.ShowAll;
    this.pathSwitcher = model.pathSwitcher || null;
    this.endPathIcon = model.endPathIcon || false;
};
var GameHint = function GameHint() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameHint);
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lockId = model.lockId || null;
    this.hint1_active = model.hint1_active || false;
    this.hint1_type = model.hint1_type || null;
    this.hint1_value = model.hint1_value || null;
    this.hint1_deductPoints = model.hint1_deductPoints || 0;
    this.hint1_unlockTime = model.hint1_unlockTime || 0;
    this.hint2_active = model.hint2_active || false;
    this.hint2_type = model.hint2_type || null;
    this.hint2_value = model.hint2_value || null;
    this.hint2_deductPoints = model.hint2_deductPoints || 0;
    this.hint2_unlockTime = model.hint2_unlockTime || 0;
    this.solution_active = model.solution_active || false;
    this.solution_type = model.solution_type || null;
    this.solution_value = model.solution_value || null;
    this.solution_deductPoints = model.solution_deductPoints || 0;
    this.solution_unlockTime = model.solution_unlockTime || 0;
};
var Game = /*#__PURE__*/ function(GameGeneral) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Game, GameGeneral);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Game);
    function Game() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, Game);
        var _this;
        var ref;
        _this = _super.call(this, model);
        var paths = ((model === null || model === void 0 ? void 0 : model.locks) || []).filter(function(lock) {
            return lock.type === LockType.Path;
        });
        _this.id = model.id || null;
        _this.locks = ((ref = model.locks) === null || ref === void 0 ? void 0 : ref.length) && model.locks.filter(function(lock) {
            return lock.type !== LockType.Path;
        }).map(function(lock) {
            return new GameLock(lock);
        }) || [];
        _this.paths = paths.length ? paths.map(function(p) {
            return new GameLock(p);
        }) : null;
        _this.hints = model.hints && model.hints.map(function(hint) {
            return new GameHint(hint);
        }) || [];
        _this.conditions = model.conditions && model.conditions.map(function(condition) {
            return new GameCondition(condition);
        }) || [];
        _this.book = model.book ? new _game_GameBook__WEBPACK_IMPORTED_MODULE_2__/* .GameBook */ .Rw(model.book) : null;
        return _this;
    }
    return Game;
}(GameGeneral);


/***/ }),

/***/ 78073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ MenuType; }
/* harmony export */ });
var MenuType;
(function(MenuType) {
    MenuType["Treedis"] = "treedis";
    MenuType["NavigationPath"] = "navigationPath";
    MenuType["Matterport"] = "matterport";
    MenuType["MatterportInstant"] = "matterport-instant";
    MenuType["MatterportLabel"] = "matterport-label";
    MenuType["MatterportFloor"] = "matterport-floor";
    MenuType["Popup"] = "popup";
    MenuType["Tab"] = "tab";
    MenuType["Tag"] = "tag";
    MenuType["Panorama"] = "panorama";
    MenuType["Product"] = "product";
    MenuType["Iframe"] = "iframe";
    MenuType["Category"] = "category";
    MenuType["BIMItem"] = "BIMItem";
    MenuType["Gallery"] = "gallery";
})(MenuType || (MenuType = {}));


/***/ }),

/***/ 42725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "An": function() { return /* binding */ TagRes; },
/* harmony export */   "Qy": function() { return /* binding */ TagType; },
/* harmony export */   "uT": function() { return /* binding */ Transition; }
/* harmony export */ });
/* unused harmony export TagNavigationType */
/* eslint-disable no-unused-vars */ var TagType;
(function(TagType) {
    TagType["None"] = "none";
    TagType[// Text = 'text',
    // Image = 'image',
    // Gallery = 'gallery',
    "Popup"] = "popup";
    TagType["Music"] = "music";
    TagType[// Video = 'video',
    "Iframe"] = "iframe";
    TagType["Tab"] = "tab";
    TagType["Panorama"] = "panorama";
    TagType["Menu"] = "menu";
    TagType["Matterport"] = "matterport";
    TagType["MatterportInstant"] = "matterport-instant";
    TagType["Treedis"] = "treedis";
    TagType["VideoChat"] = "video-chat";
    TagType["Navigation"] = "navigation";
    TagType["ExperiencePopUp"] = "experiencePopUp";
    TagType["Flow"] = "flow";
})(TagType || (TagType = {}));
var TagNavigationType;
(function(TagNavigationType) {
    TagNavigationType["Menu"] = "menu";
    TagNavigationType["Polygon"] = "polygon";
    TagNavigationType["Tag"] = "tag";
})(TagNavigationType || (TagNavigationType = {}));
var Transition;
(function(Transition) {
    Transition["Instant"] = "instant";
    Transition["FlyOver"] = "fly-over";
})(Transition || (Transition = {}));
var TagRes;
(function(TagRes) {
    TagRes["Percentage"] = "percentage";
    TagRes["Pixels"] = "pixels";
})(TagRes || (TagRes = {}));


/***/ }),

/***/ 40784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lC": function() { return /* binding */ AssetPageType; },
  "Bg": function() { return /* binding */ CustomButtonTypeOpenAsType; },
  "tP": function() { return /* binding */ TagDockSideType; },
  "Oj": function() { return /* binding */ Tour; },
  "zz": function() { return /* binding */ TourMode; },
  "v": function() { return /* binding */ TourType; },
  "YO": function() { return /* binding */ TourTypeURL; }
});

// UNUSED EXPORTS: AdRes, TourAddons, TourStatus, UnitSystem, WeekDays

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
;// CONCATENATED MODULE: ./_models/Client.tsx



var Client = function Client() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_class_call_check/* default */.Z)(this, Client);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.linkedin = model.linkedin || null;
    this.facebook = model.facebook || null;
    this.instagram = model.instagram || null;
    this.twitter = model.twitter || null;
    this.fbAppId = model.fbAppId || null;
    this.whitelabelId = model.whitelabelId || null;
    this.whitelabelLogo = model.whitelabelLogo || null;
    this.rtl = model.rtl || false;
    this.googleViewId = model.googleViewId || null;
    this.fbPixel = model.fbPixel || null;
    this.tours = model.tours || [];
    this.updatedAt = model.updatedAt ? moment_default()(model.updatedAt) : moment_default()();
    this.logo = this.id && model.logo ? "".concat("https://cdn.treedis.com", "/clients/").concat(this.id, "/logo.png").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.watermark = this.id && model.watermark ? "".concat("https://cdn.treedis.com", "/clients/").concat(this.id, "/watermark.png").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.widthLogo = model.widthLogo || false;
    this.folders = model.folders || [];
    this.videoCredits = model.videoCredits || 0;
    this.monthlyVideoCredits = model.monthlyVideoCredits || 0;
    this.subscriptionId = model.subscriptionId || null;
    this.user = model.user || null;
    this.subscriptionType = model.subscriptionType || null;
    this.clientPermission = model.clientPermission || {};
    this.paypalClientId = model.paypalClientId || null;
    this.primaryColor = model.primaryColor || "#292929";
    this.secondaryColor = model.secondaryColor || "#ea475c";
    this.meetingSlotMinutes = model.meetingSlotMinutes || 10;
    this.meetingSlotPpl = model.meetingSlotPpl || 5;
    this.hubMinutes = model.hubMinutes || 0;
};

// EXTERNAL MODULE: ./_models/Agent.tsx
var Agent = __webpack_require__(2828);
// EXTERNAL MODULE: ./_models/User.tsx
var User = __webpack_require__(43500);
;// CONCATENATED MODULE: ./_models/Tour.tsx
/* eslint-disable camelcase */ 






var TourStatus;
(function(TourStatus) {
    TourStatus["Idle"] = "idle";
    TourStatus["Ready"] = "ready";
    TourStatus["Error"] = "error";
    TourStatus["Pay"] = "pay";
})(TourStatus || (TourStatus = {}));
var TourMode;
(function(TourMode) {
    TourMode["DOLLHOUSE"] = "mode.dollhouse";
    TourMode["FLOORPLAN"] = "mode.floorplan";
    TourMode["INSIDE"] = "mode.inside";
    TourMode["OUTSIDE"] = "mode.outside";
    TourMode["TRANSITIONING"] = "mode.transitioning";
})(TourMode || (TourMode = {}));
var UnitSystem;
(function(UnitSystem) {
    UnitSystem["Metric"] = "metric";
    UnitSystem["Imperial"] = "imperial";
})(UnitSystem || (UnitSystem = {}));
var AssetPageType;
(function(AssetPageType) {
    AssetPageType["Classic"] = "classic";
    AssetPageType["Slick"] = "slick";
    AssetPageType["Modern"] = "modern";
})(AssetPageType || (AssetPageType = {}));
var CustomButtonTypeOpenAsType;
(function(CustomButtonTypeOpenAsType) {
    CustomButtonTypeOpenAsType["Iframe"] = "iframe";
    CustomButtonTypeOpenAsType["Tab"] = "tab";
})(CustomButtonTypeOpenAsType || (CustomButtonTypeOpenAsType = {}));
var WeekDays;
(function(WeekDays) {
    WeekDays["Sunday"] = "sunday";
    WeekDays["Monday"] = "monday";
    WeekDays["Tuesday"] = "tuesday";
    WeekDays["Wednesday"] = "wednesday";
    WeekDays["Thursday"] = "thursday";
    WeekDays["Friday"] = "friday";
    WeekDays["Saturday"] = "saturday";
})(WeekDays || (WeekDays = {}));
var TourType;
(function(TourType) {
    TourType["Regular"] = "regular";
    TourType["Game"] = "game";
    TourType["ECommerce"] = "ecommerce";
    TourType["Ticket"] = "ticket";
    TourType["Kiosk"] = "kiosk";
})(TourType || (TourType = {}));
var TourTypeURL = {
    regular: "tour",
    game: "game",
    ecommerce: "e-commerce-tour",
    ticket: "ticket",
    video: "video"
};
var TagDockSideType;
(function(TagDockSideType) {
    TagDockSideType["Right"] = "right";
    TagDockSideType["Left"] = "left";
})(TagDockSideType || (TagDockSideType = {}));
var TourAddons = {
    title: 0,
    brand: false,
    hl: 0,
    tourcta: 1,
    dh: true,
    mt: true,
    nozoom: true,
    pin: true,
    mls: 0,
    qs: false,
    gt: true,
    portal: true,
    f: true,
    wh: true,
    kb: true,
    lp: false,
    vr: true,
    ts: -1,
    help: -1,
    nt: false,
    search: false,
    hidetags: false,
    lang: ""
};
var AdRes;
(function(AdRes) {
    AdRes["Percentage"] = "percentage";
    AdRes["Pixels"] = "pixels";
})(AdRes || (AdRes = {}));
var Tour = /*#__PURE__*/ function() {
    "use strict";
    function Tour() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, Tour);
        this.id = model.id || null;
        this.introScreen = model.introScreen || null;
        this.subTitle = model.subTitle || null;
        this.slug = model.slug || null;
        this.useSlug = model.useSlug || false;
        this.panoramaTransition = model.panoramaTransition || false;
        this.ticket = model.ticket || false;
        this.minimapVisible = model.minimapVisible || false;
        this.pay = model.pay;
        this.waitingPayment = model.waitingPayment;
        this.clientId = model.clientId || null;
        this.userId = model.userId || null;
        this.parentId = model.parentId || null;
        this.user = model.user ? new User/* User */.n5(model.user) : null;
        this.users = model.users ? (0,_to_consumable_array/* default */.Z)(model.users.map(function(user) {
            return new User/* User */.n5(user);
        })) : null;
        this.adLeads = model.adLeads || false;
        this.sameMusicForAllFloors = model.sameMusicForAllFloors;
        this.error = model.error || null;
        this.title = model.title || null;
        this.password = model.password || null;
        this.mainImage = model.mainImage || null;
        this.address = model.address || null;
        this.internalAddress = model.internalAddress || null;
        this.size = model.size || null;
        this.beds = model.beds || null;
        this.cars = model.cars || null;
        this.showers = model.showers || null;
        this.accomodation = model.accomodation || null;
        this.vrUrl = model.vrUrl || null;
        this.summary = model.summary || null;
        this.minimap = model.minimap || null;
        this.panorama = model.panorama || null;
        this.autoplayVideo = model.autoplayVideo || false;
        this.disableContext = model.disableContext || false;
        this.bookUrl = model.bookUrl || null;
        this.bookText = model.bookText || null;
        this.bookColor = model.bookColor || "#292929";
        this.exploreText = model.exploreText || null;
        this.ad = model.ad || false;
        this.share = model.share || false;
        this.adTime = model.adTime || null;
        this.adRes = model.adRes || AdRes.Percentage;
        this.adResMobile = model.adResMobile || AdRes.Percentage;
        this.adWidth = model.adWidth || 80;
        this.adHeight = model.adHeight || 60;
        this.adWidthMobile = model.adWidthMobile || 80;
        this.adHeightMobile = model.adHeightMobile || 60;
        this.adUrl = model.adUrl || null;
        this.droneUrl = model.droneUrl || null;
        this.videoUrl = model.videoUrl || null;
        this.videoWidth = model.videoWidth || null;
        this.videoHeight = model.videoHeight || null;
        this.floorPlansEnabled = model.floorPlansEnabled || false;
        this.customMinimap = model.customMinimap || false;
        this.menuEnabled = model.menuEnabled || false;
        this.menuOnStart = model.menuOnStart || false;
        this.menuAlwaysOpenMobile = false;
        this.menuAlwaysOpenDesktop = model.menuAlwaysOpenDesktop || false;
        this.music = model.music || false;
        this.autoplayMusic = model.autoplayMusic;
        this.audioVolume = model.audioVolume;
        this.screenshotEnabled = model.screenshotEnabled || false;
        this.status = model.status || TourStatus.Idle;
        this.matterId = model.matterId || null;
        this.images = model.images || [];
        this.showTitle = model.showTitle || false;
        this.floorPlans = model.floorPlans || [];
        this.tags = model.tags || [];
        this.clientFolderId = model.clientFolderId || null;
        this.updatedAt = model.updatedAt ? moment_default()(model.updatedAt) : moment_default()();
        this.client = model.client ? new Client(model.client) : null;
        this.tokenDuration = model.tokenDuration || -1;
        this.description = model.description || null;
        this.assetDescription = model.assetDescription || null;
        this.price = model.price || null;
        this.appointmentTime = model.appointmentTime || 30;
        this.fee = model.fee || 0;
        this.unitSystem = model.unitSystem || UnitSystem.Metric;
        this.appointmentsOn = model.appointmentsOn || false;
        this.agentSelecting = model.agentSelecting || false;
        this.appointmentTooltipOn = isNil_default()(model.appointmentTooltipOn) || model.appointmentTooltipOn;
        this.enableAvatar = isNil_default()(model.enableAvatar) || model.enableAvatar;
        this.enableIot = isNil_default()(model.enableIot) || model.enableIot;
        this.iot2FAEnabled = isNil_default()(model.iot2FAEnabled) || model.iot2FAEnabled;
        this.imageInsteadOfAvatar = isNil_default()(model.imageInsteadOfAvatar) || model.imageInsteadOfAvatar;
        this.getInTouchTooltipOn = isNil_default()(model.getInTouchTooltipOn) || model.getInTouchTooltipOn;
        this.menuTooltipOn = isNil_default()(model.menuTooltipOn) || model.menuTooltipOn;
        this.timezone = model.timezone || 0;
        this.sweepGroups = model.sweepGroups || [];
        this.unbranded = model.unbranded || false;
        this.translation = model.translation || null;
        this.messengerLink = model.messengerLink || null;
        this.messengerGreeting = model.messengerGreeting || null;
        this.assetPageType = model.assetPageType || AssetPageType.Classic;
        this.reel = model.reel || false;
        this.reels = model.reels || [];
        this.reelCategories = model.reelCategories || [];
        this.brightness = model.brightness || 1;
        this.saturation = model.saturation || 1;
        this.contrast = model.contrast || 1;
        this.contactForm = model.contactForm || false;
        this.panoramaStart = model.panoramaStart || false;
        var _panoramaCompass;
        this.panoramaCompass = (_panoramaCompass = model.panoramaCompass) !== null && _panoramaCompass !== void 0 ? _panoramaCompass : false;
        this.panoramaHd = model.panoramaHd || false;
        this.hideMinimapHotspots = model.hideMinimapHotspots || false;
        this.enableVS = model.enableVS || false;
        this.allowGuestBeforeHost = model.allowGuestBeforeHost || false;
        this.collectLeads = model.collectLeads || false;
        this.leadsEmail = model.leadsEmail || false;
        this.leadsPhone = model.leadsPhone || false;
        this.leadsTimedPhone = model.leadsTimedPhone || false;
        this.leadsTimedName = model.leadsTimedName || false;
        this.leadsTimedEmail = model.leadsTimedEmail || false;
        this.leadsComment = model.leadsComment || null;
        this.legalNote = model.legalNote || null;
        this.legalBookingBox = model.legalBookingBox || null;
        this.legalBookingBox2 = model.legalBookingBox2 || null;
        this.termsUrl = model.termsUrl || null;
        this.enableBlackColorMenu = model.enableBlackColorMenu || false;
        this.vsRenderRange = model.vsRenderRange || 25;
        this.vsAnimationDistance = model.vsAnimationDistance && model.vsAnimationDistance > 0 ? model.vsAnimationDistance : 5;
        this.mpReel = model.mpReel || false;
        this.mpPlay = model.mpPlay || false;
        this.hidePucks = model.hidePucks;
        this.menuSearch = model.menuSearch || false;
        this.menuCategoryExpand = model.menuCategoryExpand || false;
        this.hideCookie = model.hideCookie || false;
        this.registrationBackground = model.registrationBackground || null;
        this.oauthAccess = model.oauthAccess;
        this.tourEmail = model.tourEmail || {
            contactName: null,
            contactPhone: null,
            leadSweeps: null,
            leadForms: null,
            videoAppointment: null,
            assertContactIcon: null,
            assertGetInTouch: null,
            menuGetInTouch: null
        };
        this.noAudioMode = model.noAudioMode || false;
        this.mode = model.mode;
        this.gameId = model.gameId || null;
        this.hideClientContact = model.hideClientContact || false;
        this.musics = model.tourMusics || [];
        this.agents = model.agentTours && model.agentTours.map(function(agentTour) {
            return new Agent/* Agent */.P(agentTour.agent);
        });
        this.htmlActive = model.htmlActive || false;
        this.htmlCode = model.htmlCode || "";
        // URL Addons
        Object.keys(TourAddons).forEach(function(addon) {
            _this["addon_".concat(addon)] = model["addon_".concat(addon)] || 0;
        });
        this.amenities = model.amenities || null;
        this.publicId = model.matterId ? encodeURIComponent(btoa(model.matterId)) : null;
        this.scannedAt = model.scannedAt ? moment_default()(model.scannedAt).format("DD/MM/YYYY") : moment_default()().format("DD/MM/YYYY");
        this.showNavTools = model.showNavTools || false;
        this.stopAfterSweep = model.stopAfterSweep || 0;
        this.rotationAngle = model.rotationAngle || 0;
        this.rotationSpeed = model.rotationSpeed || 0;
        this.transitionSpeed = model.transitionSpeed || 0;
        this.showNavPath = model.showNavPath || false;
        this.walkNav = model.walkNav || false;
        this.teleportNav = model.teleportNav || false;
        this.autoNav = model.autoNav || false;
        this.customButton = model.customButton || false;
        this.customButtonIcon = model.customButtonIcon || null;
        this.customButtonUrl = model.customButtonUrl || null;
        this.customButtonOpenAs = model.customButtonOpenAs || CustomButtonTypeOpenAsType.Tab;
        this.ecommerceSubscriptionId = model.ecommerceSubscriptionId || null;
        this.mpPasswordActive = model.mpPasswordActive || false;
        var _musicControl;
        this.musicControl = (_musicControl = model.musicControl) !== null && _musicControl !== void 0 ? _musicControl : true;
        var _languageId;
        this.languageId = (_languageId = model.languageId) !== null && _languageId !== void 0 ? _languageId : null;
        var _initialDuplicates;
        this.initialDuplicates = (_initialDuplicates = model.initialDuplicates) !== null && _initialDuplicates !== void 0 ? _initialDuplicates : [];
        this.isSample = model.isSample || false;
        var _storeEnabled;
        this.storeEnabled = (_storeEnabled = model.storeEnabled) !== null && _storeEnabled !== void 0 ? _storeEnabled : true;
        var _callIconEnabled;
        this.callIconEnabled = (_callIconEnabled = model.callIconEnabled) !== null && _callIconEnabled !== void 0 ? _callIconEnabled : false;
        var _addressIconEnabled;
        this.addressIconEnabled = (_addressIconEnabled = model.addressIconEnabled) !== null && _addressIconEnabled !== void 0 ? _addressIconEnabled : false;
        var _hideSidebarConfigs;
        this.hideSidebarConfigs = (_hideSidebarConfigs = model.hideSidebarConfigs) !== null && _hideSidebarConfigs !== void 0 ? _hideSidebarConfigs : false;
        var _hideSoundControls;
        this.hideSoundControls = (_hideSoundControls = model.hideSoundControls) !== null && _hideSoundControls !== void 0 ? _hideSoundControls : false;
        var _hideLanguageSelect;
        this.hideLanguageSelect = (_hideLanguageSelect = model.hideLanguageSelect) !== null && _hideLanguageSelect !== void 0 ? _hideLanguageSelect : false;
        var _hideSubtitlesSelect;
        this.hideSubtitlesSelect = (_hideSubtitlesSelect = model.hideSubtitlesSelect) !== null && _hideSubtitlesSelect !== void 0 ? _hideSubtitlesSelect : false;
        this.ss = model.ss || "";
        this.sr = model.sr || "";
        this.hideMPTagSwitcher = model.hideMPTagSwitcher || false;
        this.hideMPTagDock = model.hideMPTagDock || false;
        this.background = model.background || null;
        this.backgroundImage = model.backgroundImage || null;
        this.cookieIsMandatory = model.cookieIsMandatory;
        this.loadTourAfterCookie = model.loadTourAfterCookie;
        var _cookieBackgroundImage;
        this.cookieBackgroundImage = (_cookieBackgroundImage = model.cookieBackgroundImage) !== null && _cookieBackgroundImage !== void 0 ? _cookieBackgroundImage : "";
        var _cookieBackgroundVideo;
        this.cookieBackgroundVideo = (_cookieBackgroundVideo = model.cookieBackgroundVideo) !== null && _cookieBackgroundVideo !== void 0 ? _cookieBackgroundVideo : "";
        var _cookieBackgroundVideoUrl;
        this.cookieBackgroundVideoUrl = (_cookieBackgroundVideoUrl = model.cookieBackgroundVideoUrl) !== null && _cookieBackgroundVideoUrl !== void 0 ? _cookieBackgroundVideoUrl : "";
        this.mpTagDockSide = model.mpTagDockSide || TagDockSideType.Right;
        this.patchIcon = model.patchIcon || "";
        this.patchIconEnabled = model.patchIconEnabled || false;
        this.isThreadsEnabled = model.isThreadsEnabled || false;
        this.textChatEnabled = model.textChatEnabled || false;
        this.navigationWebEnabled = model.navigationWebEnabled || false;
        this.isSAPActive = model.isSAPActive || false;
    }
    var _proto = Tour.prototype;
    _proto.getAddonsUrl = function getAddonsUrl() {
        var _this = this;
        var string = "&play=1&newtags=1&xruntested=1";
        Object.keys(TourAddons).map(function(addon) {
            var value = _this["addon_".concat(addon)] ? "1" : "0";
            if (typeof _this["addon_".concat(addon)] === "number" || typeof _this["addon_".concat(addon)] === "string") value = _this["addon_".concat(addon)];
            if (addon === "help" && _this["addon_".concat(addon)] === -1) value = null;
            if (addon === "lang" && !_this["addon_".concat(addon)]) return null;
            if (addon === "ts") return null; // we do our own ts logic
            string += "&".concat(addon, "=").concat(value);
            return null;
        });
        return string;
    };
    return Tour;
}();


/***/ }),

/***/ 43500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MX": function() { return /* binding */ UserSubscription; },
/* harmony export */   "n5": function() { return /* binding */ User; }
/* harmony export */ });
/* unused harmony exports UserType, Mode */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40488);



var UserSubscription;
(function(UserSubscription) {
    UserSubscription[//old
    "Trial"] = "trial";
    UserSubscription["Month"] = "month";
    UserSubscription["Year"] = "year";
    UserSubscription["Pay"] = "pay";
    UserSubscription[//new
    "Free"] = "free";
    UserSubscription["Growth"] = "growth";
    UserSubscription["Business"] = "business";
    UserSubscription["Enterprise"] = "enterprise";
})(UserSubscription || (UserSubscription = {}));
var UserType;
(function(UserType) {
    UserType["Admin"] = "admin";
    UserType["User"] = "user";
})(UserType || (UserType = {}));
var Mode;
(function(Mode) {
    Mode["Regular"] = "regular";
    Mode["Conference"] = "conference";
    Mode["Game"] = "game";
    Mode["Ticket"] = "ticket";
})(Mode || (Mode = {}));
var User = function User() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, User);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.country = model.country || null;
    this.type = model.type || null;
    this.fbAppId = model.fbAppId || null;
    this.videoCredits = model.videoCredits || 0;
    this.updatedAt = model.updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(model.updatedAt) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
    this.profile = this.id && model.profile ? "".concat("https://cdn.treedis.com", "/users/").concat(this.id, "/profile.jpg").concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getVersion */ .bo)(this.updatedAt)) : null;
    this.subscription = model.subscription || UserSubscription.Trial;
    this.paypalEmail = model.paypalEmail || null;
    this.whitelabelId = model.whitelabelId || null;
    this.logo = this.id && this.whitelabelId ? "".concat("https://cdn.treedis.com", "/users/").concat(this.id, "/logo.png").concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getVersion */ .bo)(this.updatedAt)) : null;
    this.domainUrl = model.domainUrl || "";
    this.adminUrl = model.adminUrl || "";
    this.whitelabelEmail = model.whitelabelEmail || "";
    this.mpSDK = window.location.hostname === "my.treedis.com" ? "295ba0c0f04541318359a8e75af33043" : model.mpSDK || "295ba0c0f04541318359a8e75af33043";
    this.primaryColor = model.primaryColor || "#292929";
    this.secondaryColor = model.secondaryColor || "#ea475c";
    this.username = model.username || null;
    this.refer = model.refer || null;
    this.company = model.company || null;
    this.admin = model.admin || null;
    this.googleViewId = model.googleViewId || null;
    this.oauth = model.oauth;
    this.oauthToken = model.oauthToken;
};


/***/ }),

/***/ 97741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ GameBook; },
/* harmony export */   "_U": function() { return /* binding */ ChapterType; },
/* harmony export */   "u6": function() { return /* binding */ GameBookType; }
/* harmony export */ });
/* unused harmony export GameBookChapter */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71418);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7654);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41292);
/* harmony import */ var _components_tour_game_gameBook_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81389);
// eslint-disable-next-line max-classes-per-file







var ChapterType;
(function(ChapterType) {
    ChapterType["Tag"] = "tag";
    ChapterType["Polygon"] = "polygon";
    ChapterType["VSItem"] = "vsItem";
    ChapterType["VSImage"] = "vsImage";
    ChapterType["VSVideo"] = "vsVideo";
})(ChapterType || (ChapterType = {}));
var GameBookType;
(function(GameBookType) {
    GameBookType["Open"] = "open";
    GameBookType["Close"] = "close";
})(GameBookType || (GameBookType = {}));
var ImageSettings = function ImageSettings(model) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ImageSettings);
    this.res = model.res || _Common__WEBPACK_IMPORTED_MODULE_2__/* .Res.Percentage */ .L.Percentage;
    this.resMobile = model.resMobile || _Common__WEBPACK_IMPORTED_MODULE_2__/* .Res.Percentage */ .L.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 80;
    this.heightMobile = model.heightMobile || 60;
    this.img = model.img || null;
    this.imgMobile = model.imgMobile || null;
};
var GameBookChapter = /*#__PURE__*/ function(ImageSettings) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GameBookChapter, ImageSettings);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GameBookChapter);
    function GameBookChapter(model) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameBookChapter);
        var _this;
        _this = _super.call(this, model);
        _this.id = model.id || null;
        _this.title = model.title || null;
        _this.type = model.type || null;
        _this.value = model.value || null;
        _this.order = model.order || null;
        _this.sweepUuid = model.sweepUuid || null;
        _this.description = model.description || null;
        _this.locationType = model.locationType || _components_tour_game_gameBook_types__WEBPACK_IMPORTED_MODULE_3__/* .GameBookLocationType.sweep */ .d.sweep;
        _this.locationTourLink = model.locationTourLink || "";
        return _this;
    }
    return GameBookChapter;
}(ImageSettings);
var GameBook = /*#__PURE__*/ function(ImageSettings) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GameBook, ImageSettings);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GameBook);
    function GameBook() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameBook);
        var _this;
        var ref;
        _this = _super.call(this, model);
        _this.id = model.id || null;
        _this.description = model.description || null;
        _this.chapters = (model === null || model === void 0 ? void 0 : (ref = model.chapters) === null || ref === void 0 ? void 0 : ref.map(function(chapter) {
            return new GameBookChapter(chapter);
        })) || [];
        _this.gameId = model.gameId || null;
        _this.type = model.type || GameBookType.Close;
        _this.chapterLocked = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.chapterLocked) ? true : model.chapterLocked;
        _this.openByDefault = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.openByDefault) ? false : model.openByDefault;
        _this.backgroundColor = model.backgroundColor || "#000000";
        _this.backgroundOpacity = lodash_isNaN__WEBPACK_IMPORTED_MODULE_1___default()(model.backgroundOpacity) ? 0.5 : model.backgroundOpacity;
        _this.textColor = model.textColor || "#ffffff";
        _this.buttonColor = model.buttonColor || "#2055FF";
        return _this;
    }
    return GameBook;
}(ImageSettings);


/***/ }),

/***/ 36834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ segmentToPipeMap; },
/* harmony export */   "y": function() { return /* binding */ pipesConfig; }
/* harmony export */ });
var pipesConfig = {
    pipes: [
        {
            id: 0,
            name: "Pipe 1",
            segments: [
                {
                    name: "Pipe_Types_Standard_2302961"
                },
                {
                    name: "Pipe_Types_Standard_2302977"
                },
                {
                    name: "Pipe_Types_Standard_2302963"
                },
                {
                    name: "Pipe_Types_Standard_2302970"
                }, 
            ],
            animatedSegments: [
                {
                    name: "Pipe_Types_Standard_2302961",
                    inputs: {
                        textureRotation: -Math.PI / 2,
                        offsetSpeedX: 0.0003,
                        offsetSpeedY: 0
                    }
                },
                {
                    name: "Pipe_Types_Standard_2302977",
                    inputs: {
                        textureRotation: Math.PI / 2,
                        offsetSpeedX: 0.0003,
                        offsetSpeedY: 0
                    }
                }, 
            ]
        },
        {
            id: 1,
            name: "Pipe 2",
            segments: [
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2177270"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2177299"
                },
                {
                    name: "Pipe_Types_Standard_2177264"
                },
                {
                    name: "Pipe_Types_Standard_2177268"
                },
                {
                    name: "Pipe_Types_Standard_2177297"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2177985"
                },
                {
                    name: "Pipe_Types_Standard_2177295"
                },
                {
                    name: "Pipe_Types_Standard_2177850"
                },
                {
                    name: "Pipe_Types_Standard_2202212"
                },
                {
                    name: "Pipe_Types_Standard_2177969"
                },
                {
                    name: "Pipe_Types_Standard_2178547"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2191430"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2191430"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2192067"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2191555"
                },
                {
                    name: "Pipe_Types_Standard_2178766"
                },
                {
                    name: "Pipe_Types_Standard_2178886"
                },
                {
                    name: "Pipe_Types_Standard_2191431"
                },
                {
                    name: "Pipe_Types_Standard_2191185"
                },
                {
                    name: "Pipe_Types_Standard_2191925"
                },
                {
                    name: "Pipe_Types_Standard_2192007"
                },
                {
                    name: "Pipe_Types_Standard_2192087"
                },
                {
                    name: "Flexible_Coupling_3_Type_3_2251381"
                },
                {
                    name: "Pipe_Types_Standard_2192068"
                },
                {
                    name: "Pipe_Types_Standard_2202024"
                },
                {
                    name: "Flexible_Coupling_3_Type_3_2228342"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2191260"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2191933"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2202032"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2192095"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2191573"
                },
                {
                    name: "M_Transition_-_Welded_-_Generic_Standard_2320962"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2191426"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2202211"
                },
                {
                    name: "Pipe_Types_Standard_2279517"
                },
                {
                    name: "Pipe_Types_Standard_2276814"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2280930"
                },
                {
                    name: "Pipe_Types_Standard_2280917"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2281031"
                },
                {
                    name: "Pipe_Types_Standard_2281021"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2282110"
                },
                {
                    name: "Pipe_Types_Standard_2281509"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2282112"
                },
                {
                    name: "Pipe_Types_Standard_2281677"
                },
                {
                    name: "Pipe_Types_Standard_2282113"
                }, 
            ],
            animatedSegments: [
                {
                    name: "Pipe_Types_Standard_2177850",
                    inputs: {
                        textureRotation: -Math.PI / 2,
                        offsetSpeedX: 0.0003,
                        offsetSpeedY: 0
                    }
                },
                {
                    name: "Pipe_Types_Standard_2177264",
                    inputs: {
                        textureRotation: -Math.PI / 2,
                        offsetSpeedX: 0.0003,
                        offsetSpeedY: 0
                    }
                },
                {
                    name: "Pipe_Types_Standard_2202212",
                    inputs: {
                        textureRotation: Math.PI / 2,
                        offsetSpeedX: 0.0003,
                        offsetSpeedY: 0
                    }
                }, 
            ]
        },
        {
            id: 2,
            name: "Pipe 3",
            segments: [
                {
                    name: "Pipe_Types_Standard_2028391"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2028393"
                },
                {
                    name: "Pipe_Types_Standard_2028387"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2028389"
                },
                {
                    name: "Pipe_Types_Standard_2028382"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2028384"
                },
                {
                    name: "Pipe_Types_Standard_2024658"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2028402"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2028398"
                },
                {
                    name: "Pipe_Types_Standard_2024792"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2030301"
                },
                {
                    name: "Pipe_Types_Standard_2030293"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2030319"
                },
                {
                    name: "Pipe_Types_Standard_2030307"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2030475"
                },
                {
                    name: "Pipe_Types_Standard_2028396"
                },
                {
                    name: "Pipe_Types_Standard_2024670"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2024675"
                },
                {
                    name: "Pipe_Types_Standard_2031040"
                },
                {
                    name: "Fitting-Tee-Equal_Reducing-Flanged-Anvil-CI-811_812-Fla_11e55ff"
                },
                {
                    name: "Pipe_Types_Standard_2014678"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2024677"
                },
                {
                    name: "Pipe_Types_Standard_2021265"
                }, 
            ],
            animatedSegments: [
                {
                    name: "Pipe_Types_Standard_2024792",
                    inputs: {
                        textureRotation: -Math.PI / 2,
                        offsetSpeedX: 0.0003,
                        offsetSpeedY: 0
                    }
                },
                {
                    name: "Pipe_Types_Standard_2024670",
                    inputs: {
                        textureRotation: -Math.PI / 2,
                        offsetSpeedX: 0.0003,
                        offsetSpeedY: 0
                    }
                }, 
            ]
        },
        {
            id: 3,
            name: "Pipe 4",
            segments: [
                {
                    name: "Pipe_Types_Standard_2335688"
                },
                {
                    name: "Pipe_Types_Standard_2335563"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2335567"
                },
                {
                    name: "Pipe_Types_Standard_2335565"
                },
                {
                    name: "M_Globe_Valve_-_50-450_mm_-_Flanged_100_mm_2335581"
                },
                {
                    name: "M_Globe_Valve_-_50-450_mm_-_Flanged_100_mm_2335581"
                },
                {
                    name: "Pipe_Types_Standard_2335571"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2335573"
                },
                {
                    name: "Pipe_Types_Standard_2335569"
                },
                {
                    name: "Pipe_Types_Standard_2335652"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2335737"
                },
                {
                    name: "Pipe_Types_Standard_2335725"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2337089"
                },
                {
                    name: "Pipe_Types_Standard_2335768"
                },
                {
                    name: "M_Transition_-_Welded_-_Generic_Standard_2337101"
                },
                {
                    name: "M_Tee_-_Welded_-_Generic_Standard_2337093"
                },
                {
                    name: "Pipe_Types_Standard_2337094"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2375125"
                },
                {
                    name: "Pipe_Types_Standard_2375123"
                },
                {
                    name: "Pipe_Types_Standard_2358236"
                },
                {
                    name: "Pipe_Types_Standard_2337079"
                },
                {
                    name: "M_Elbow_-_Welded_-_Generic_Standard_2337970"
                },
                {
                    name: "Pipe_Types_Standard_2337962"
                }, 
            ],
            animatedSegments: []
        }
    ]
};
var segmentToPipeMap = new Map();
pipesConfig.pipes.forEach(function(pipe) {
    pipe.segments.forEach(function(segment) {
        segmentToPipeMap.set(segment.name, pipe);
    });
    pipe.animatedSegments.forEach(function(segment) {
        segmentToPipeMap.set(segment.name, pipe);
    });
});


/***/ }),

/***/ 35083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getCurveLength; }
/* harmony export */ });
var getCurveLength = function(curve) {
    var point1 = curve.getPointAt(0);
    var point2 = curve.getPointAt(1);
    // Calculate the Euclidean distance between the two points
    return point1.distanceTo(point2);
};


/***/ }),

/***/ 59524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IW": function() { return /* binding */ PolygonActionAction; },
/* harmony export */   "fD": function() { return /* binding */ PolygonAction; },
/* harmony export */   "l3": function() { return /* binding */ PolygonActionMode; },
/* harmony export */   "mg": function() { return /* binding */ Polygon; },
/* harmony export */   "zS": function() { return /* binding */ PolygonActionType; }
/* harmony export */ });
/* unused harmony export PolygonActionRes */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _VSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15864);


var PolygonActionType;
(function(PolygonActionType) {
    PolygonActionType["None"] = "none";
    PolygonActionType["Text"] = "text";
    PolygonActionType["Image"] = "image";
    PolygonActionType["Music"] = "music";
    PolygonActionType["Video"] = "video";
    PolygonActionType["Iframe"] = "iframe";
    PolygonActionType["Tab"] = "tab";
    PolygonActionType["Panorama"] = "panorama";
    PolygonActionType["Menu"] = "menu";
    PolygonActionType["Treedis"] = "treedis";
    PolygonActionType["Matterport"] = "matterport";
    PolygonActionType["MatterportInstant"] = "matterport-instant";
    PolygonActionType["ExperiencePopUp"] = "experiencePopUp";
    PolygonActionType["Flow"] = "flow";
})(PolygonActionType || (PolygonActionType = {}));
var PolygonActionAction;
(function(PolygonActionAction) {
    PolygonActionAction["Click"] = "click";
    PolygonActionAction["Hover"] = "hover";
})(PolygonActionAction || (PolygonActionAction = {}));
var PolygonActionRes;
(function(PolygonActionRes) {
    PolygonActionRes["Percentage"] = "percentage";
    PolygonActionRes["Pixels"] = "pixels";
})(PolygonActionRes || (PolygonActionRes = {}));
var PolygonActionMode;
(function(PolygonActionMode) {
    PolygonActionMode["Ecommerce"] = "ecommerce";
    PolygonActionMode["Game"] = "game";
    PolygonActionMode["VS"] = "vs";
})(PolygonActionMode || (PolygonActionMode = {}));
var PolygonAction = function PolygonAction() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, PolygonAction);
    this.id = model.id;
    this.polygonId = model.polygonId || "";
    this.mode = model.mode || PolygonActionMode.VS;
    this.type = model.type || PolygonActionType.None;
    this.action = model.action || PolygonActionAction.Click;
    this.url = model.url || "";
    this.text = model.text || "";
    this.resolution = model.resolution || PolygonActionRes.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 80;
    this.resolutionMobile = model.resolutionMobile || PolygonActionRes.Percentage;
    this.widthMobile = model.widthMobile || 80;
    this.heightMobile = model.heightMobile || 80;
    this.panoramaId = model.panoramaId || null;
    this.menuId = model.menuId || null;
    this.subMenuId = model.subMenuId || null;
    this.subSubMenuId = model.subSubMenuId || null;
    this.gameBackpack = model.gameBackpack || false;
    this.fullscreen = model.fullscreen || false;
    this.autoPlay = model.autoPlay || false;
    this.rotation = (model === null || model === void 0 ? void 0 : model.rotation) || _VSObject__WEBPACK_IMPORTED_MODULE_0__/* .TourVSImageRotation.Vertical */ .GF.Vertical;
    this.actionURL = (model === null || model === void 0 ? void 0 : model.actionURL) || "";
    this.dontInterruptBgAudio = (model === null || model === void 0 ? void 0 : model.dontInterruptBgAudio) || false;
    this.popupTitle = (model === null || model === void 0 ? void 0 : model.popupTitle) || "";
    this.textColor = (model === null || model === void 0 ? void 0 : model.textColor) || "#ffffff";
    this.backgroundColor = (model === null || model === void 0 ? void 0 : model.backgroundColor) || "#000000";
    this.backgroundOpacity = (model === null || model === void 0 ? void 0 : model.backgroundOpacity) || 0.7;
    this.buttonColor = (model === null || model === void 0 ? void 0 : model.buttonColor) || "#ffffff";
    this.flowId = (model === null || model === void 0 ? void 0 : model.flowId) || null;
};
var Polygon = function Polygon() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Polygon);
    var ref;
    this.id = model.id;
    this.title = model.title || "";
    this.tourId = model.tourId;
    this.scaleX = model.scaleX || 1;
    this.scaleY = model.scaleY || 1;
    this.scaleZ = model.scaleZ || 1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.uuid = model.uuid || null;
    this.colorDefault = model.colorDefault || "#ea475c";
    this.colorHover = model.colorHover || "#FFFFFF";
    this.colorClick = model.colorClick || "#ea475c";
    this.opacityDefault = model.opacityDefault >= 0 ? model.opacityDefault : 0.2;
    this.opacityHover = model.opacityHover >= 0 ? model.opacityHover : 0.4;
    this.opacityClick = model.opacityClick >= 0 ? model.opacityClick : 0.5;
    this.edgesOpacityDefault = model.edgesOpacityDefault >= 0 ? model.edgesOpacityDefault : 0.5;
    this.edgesOpacityHover = model.edgesOpacityHover >= 0 ? model.edgesOpacityHover : 0.7;
    this.edgesOpacityClick = model.edgesOpacityClick >= 0 ? model.edgesOpacityClick : 0.8;
    this.sweep_uuid = model.sweep_uuid || null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.products = ((ref = model.products) === null || ref === void 0 ? void 0 : ref.length) > 0 ? model.products.map(function(item) {
        return item.id;
    }) : [];
    this.polygonsActions = model.polygonsActions || [];
    this.hideAfterClick = model.hideAfterClick || false;
    this.isHiddenAfterClick = false;
    this.hiddenFromFlows = false;
};


/***/ }),

/***/ 98472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ SceneComponent; },
/* harmony export */   "td": function() { return /* binding */ ComponentInteractionType; }
/* harmony export */ });
/* unused harmony exports PointerButton, PointerButtonMask, PointerDevice, KeyState, Keys */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* eslint-disable */ // @ts-nocheck file
// noinspection JSDuplicatedDeclaration



/**
 * The base of all `SceneComponent` created with the sdk.
 * All properties of this class are always available to all components generated through the sdk.
 * These properties should all be considered reserved and should not be overwritten by the subclass.
 */ var SceneComponentPrivate = function SceneComponentPrivate() {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponentPrivate);
};
var SceneComponent = /*#__PURE__*/ function(SceneComponentPrivate) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SceneComponent, SceneComponentPrivate);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SceneComponent);
    function SceneComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponent);
        return _super.apply(this, arguments);
    }
    return SceneComponent;
}(SceneComponentPrivate);
var ComponentInteractionType;
(function(ComponentInteractionType) {
    ComponentInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    ComponentInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    ComponentInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    ComponentInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    ComponentInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    ComponentInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    ComponentInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    ComponentInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    ComponentInteractionType["KEY"] = "INTERACTION.KEY";
    ComponentInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    ComponentInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    ComponentInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    ComponentInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    ComponentInteractionType["PINCH"] = "INTERACTION.PINCH";
    ComponentInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    ComponentInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    ComponentInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(ComponentInteractionType || (ComponentInteractionType = {}));
var ComponentOutputReserved = function ComponentOutputReserved() {
    "use strict";
    _class_call_check(this, ComponentOutputReserved);
};
var ComponentOut = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ComponentOutputReserved) {
    "use strict";
    _inherits(ComponentOut, ComponentOutputReserved);
    var _super = _create_super(ComponentOut);
    function ComponentOut() {
        _class_call_check(this, ComponentOut);
        return _super.apply(this, arguments);
    }
    return ComponentOut;
}(ComponentOutputReserved)));
var PointerButton;
(function(PointerButton) {
    PointerButton[PointerButton["PRIMARY"] = 0] = "PRIMARY";
    PointerButton[PointerButton["MIDDLE"] = 1] = "MIDDLE";
    PointerButton[PointerButton["SECONDARY"] = 2] = "SECONDARY";
    PointerButton[PointerButton["BACK"] = 3] = "BACK";
    PointerButton[PointerButton["FORWARD"] = 4] = "FORWARD";
    PointerButton[PointerButton["COUNT"] = 5] = "COUNT";
})(PointerButton || (PointerButton = {}));
var PointerButtonMask;
(function(PointerButtonMask) {
    PointerButtonMask[PointerButtonMask["NONE"] = 0] = "NONE";
    PointerButtonMask[PointerButtonMask["PRIMARY"] = 1 << PointerButton.PRIMARY] = "PRIMARY";
    PointerButtonMask[PointerButtonMask["SECONDARY"] = 1 << PointerButton.SECONDARY] = "SECONDARY";
    PointerButtonMask[PointerButtonMask["MIDDLE"] = 1 << PointerButton.MIDDLE] = "MIDDLE";
    PointerButtonMask[PointerButtonMask["BACK"] = 1 << PointerButton.BACK] = "BACK";
    PointerButtonMask[PointerButtonMask["FORWARD"] = 1 << PointerButton.FORWARD] = "FORWARD";
    PointerButtonMask[PointerButtonMask["ALL"] = (1 << PointerButton.COUNT) - 1] = "ALL";
})(PointerButtonMask || (PointerButtonMask = {}));
var PointerDevice;
(function(PointerDevice) {
    PointerDevice["MOUSE"] = "mouse";
    PointerDevice["TOUCH"] = "touch";
    PointerDevice["PEN"] = "pen";
    PointerDevice["GAMEPAD"] = "gamepad";
})(PointerDevice || (PointerDevice = {}));
var KeyState;
(function(KeyState) {
    KeyState[KeyState["DOWN"] = 0] = "DOWN";
    KeyState[KeyState["PRESSED"] = 1] = "PRESSED";
    KeyState[KeyState["UP"] = 2] = "UP";
})(KeyState || (KeyState = {}));
var Keys;
(function(Keys) {
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["ZERO"] = 48] = "ZERO";
    Keys[Keys["ONE"] = 49] = "ONE";
    Keys[Keys["TWO"] = 50] = "TWO";
    Keys[Keys["THREE"] = 51] = "THREE";
    Keys[Keys["FOUR"] = 52] = "FOUR";
    Keys[Keys["FIVE"] = 53] = "FIVE";
    Keys[Keys["SIX"] = 54] = "SIX";
    Keys[Keys["SEVEN"] = 55] = "SEVEN";
    Keys[Keys["EIGHT"] = 56] = "EIGHT";
    Keys[Keys["NINE"] = 57] = "NINE";
    Keys[Keys["LEFTARROW"] = 37] = "LEFTARROW";
    Keys[Keys["UPARROW"] = 38] = "UPARROW";
    Keys[Keys["RIGHTARROW"] = 39] = "RIGHTARROW";
    Keys[Keys["DOWNARROW"] = 40] = "DOWNARROW";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["A"] = 65] = "A";
    Keys[Keys["B"] = 66] = "B";
    Keys[Keys["C"] = 67] = "C";
    Keys[Keys["D"] = 68] = "D";
    Keys[Keys["E"] = 69] = "E";
    Keys[Keys["F"] = 70] = "F";
    Keys[Keys["G"] = 71] = "G";
    Keys[Keys["H"] = 72] = "H";
    Keys[Keys["I"] = 73] = "I";
    Keys[Keys["J"] = 74] = "J";
    Keys[Keys["K"] = 75] = "K";
    Keys[Keys["L"] = 76] = "L";
    Keys[Keys["M"] = 77] = "M";
    Keys[Keys["N"] = 78] = "N";
    Keys[Keys["O"] = 79] = "O";
    Keys[Keys["P"] = 80] = "P";
    Keys[Keys["Q"] = 81] = "Q";
    Keys[Keys["R"] = 82] = "R";
    Keys[Keys["S"] = 83] = "S";
    Keys[Keys["T"] = 84] = "T";
    Keys[Keys["U"] = 85] = "U";
    Keys[Keys["V"] = 86] = "V";
    Keys[Keys["W"] = 87] = "W";
    Keys[Keys["X"] = 88] = "X";
    Keys[Keys["Y"] = 89] = "Y";
    Keys[Keys["Z"] = 90] = "Z";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["RETURN"] = 13] = "RETURN";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["SEMICOLON"] = 186] = "SEMICOLON";
    Keys[Keys["PLUSEQUALS"] = 187] = "PLUSEQUALS";
    Keys[Keys["DASHUNDERSCORE"] = 189] = "DASHUNDERSCORE";
    Keys[Keys["OPENBRACKET"] = 219] = "OPENBRACKET";
    Keys[Keys["SHIFT"] = 16] = "SHIFT";
    Keys[Keys["ALT"] = 18] = "ALT";
    Keys[Keys["CONTROL"] = 17] = "CONTROL";
})(Keys || (Keys = {}));


/***/ }),

/***/ 15864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GF": function() { return /* binding */ TourVSImageRotation; },
/* harmony export */   "Gu": function() { return /* binding */ LoadingState; },
/* harmony export */   "IG": function() { return /* binding */ VSInteractionType; },
/* harmony export */   "OV": function() { return /* binding */ VSVideoType; },
/* harmony export */   "TU": function() { return /* binding */ TourActionRes; },
/* harmony export */   "Up": function() { return /* binding */ TourVideo; },
/* harmony export */   "b2": function() { return /* binding */ TourAction; },
/* harmony export */   "mI": function() { return /* binding */ TourActionType; },
/* harmony export */   "oP": function() { return /* binding */ TourImage; },
/* harmony export */   "q8": function() { return /* binding */ TourVSHtml; },
/* harmony export */   "zB": function() { return /* binding */ TourObject; }
/* harmony export */ });
/* unused harmony exports VSObject, VSImage, VSHtml, VSVideo */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);
// eslint-disable-next-line max-classes-per-file


var TourActionType;
(function(TourActionType) {
    TourActionType["None"] = "none";
    TourActionType["Text"] = "text";
    TourActionType["Image"] = "image";
    TourActionType["Music"] = "music";
    TourActionType["Video"] = "video";
    TourActionType["Iframe"] = "iframe";
    TourActionType["Tab"] = "tab";
    TourActionType["Panorama"] = "panorama";
    TourActionType["Menu"] = "menu";
    TourActionType["Treedis"] = "treedis";
    TourActionType["NavigationPath"] = "navigationPath";
    TourActionType["ExperiencePopUp"] = "experiencePopUp";
    TourActionType["Matterport"] = "matterport";
    TourActionType["MatterportInstant"] = "matterport-instant";
    TourActionType["IoT"] = "iot";
    TourActionType["Flow"] = "flow";
})(TourActionType || (TourActionType = {}));
var TourVSImageRotation;
(function(TourVSImageRotation) {
    TourVSImageRotation["Vertical"] = "vertical";
    TourVSImageRotation["Horizontal"] = "horizontal";
})(TourVSImageRotation || (TourVSImageRotation = {}));
var TourAction;
(function(TourAction) {
    TourAction["Click"] = "click";
    TourAction["Hover"] = "hover";
})(TourAction || (TourAction = {}));
var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var TourActionRes;
(function(TourActionRes) {
    TourActionRes["Percentage"] = "percentage";
    TourActionRes["Pixels"] = "pixels";
})(TourActionRes || (TourActionRes = {}));
var VSInteractionType;
(function(VSInteractionType) {
    VSInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    VSInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    VSInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    VSInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    VSInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    VSInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    VSInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    VSInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    VSInteractionType["KEY"] = "INTERACTION.KEY";
    VSInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    VSInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    VSInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    VSInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    VSInteractionType["PINCH"] = "INTERACTION.PINCH";
    VSInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    VSInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    VSInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(VSInteractionType || (VSInteractionType = {}));
var VSObject = function VSObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _class_call_check(this, VSObject);
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.materialUrl = model.materialUrl || null;
    this.fileName = model.fileName || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.category = model.category || null;
    this.copyright = model.copyright || null;
    this.isDefault = model.isDefault || false;
    this.updatedAt = model.updatedAt || null;
    this.isGLTF = model.isGLTF || false;
    this.audioSrc = model.audioSrc || null;
};
var TourObject = function TourObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourObject);
    this.id = model.id || null;
    this.vsObjectId = model.vsObjectId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsObject || {});
    this.updatedAt = model.updatedAt || null;
    this.active = typeof model.active === "boolean" ? model.active : true;
    // If the user has enabled the hoverAnimation toggle in Admin or if the object has an actionType, enable hover animation (which will add a collider to the object and make it hoverable/clickable)
    this.enableHoverAnimation = !!model.enableHoverAnimation || model.actionType && model.actionType !== TourActionType.None;
    this.hideOnAnimationFinished = typeof model.hideOnAnimationFinished === "boolean" ? model.hideOnAnimationFinished : false;
    this.enableIdleAnimation = typeof model.enableIdleAnimation === "boolean" ? model.enableIdleAnimation : false;
    this.audioEnabled = typeof model.audioEnabled === "boolean" ? model.audioEnabled : false;
    if (this.details.audioSrc) {
        this.audioSrc = this.details.audioSrc.startsWith("http") ? this.details.audioSrc : "".concat("https://cdn.treedis.com", "/").concat(this.details.audioSrc).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
    } else this.audioSrc = null;
    this.floor = typeof model.floor === "number" ? model.floor : null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.sweepUuid = model.sweep_uuid || null;
    this.animated = model.animated;
    this.loop = model.loop || false;
    this.toursVSImages = model.toursVSImages;
    var _renderRange;
    this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
    var _startAnimationDistance;
    this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
    this.panoramaId = model.panoramaId || null;
    // actions
    this.actionType = model.actionType || TourActionType.None;
    this.action = model.action || TourAction.Click;
    this.actionURL = model.actionURL || null;
    this.actionRes = model.actionRes || TourActionRes.Percentage;
    this.actionWidth = model.actionWidth || 80;
    this.actionHeight = model.actionHeight || 60;
    this.actionResMobile = model.actionResMobile || TourActionRes.Percentage;
    this.actionWidthMobile = model.actionWidthMobile || 82;
    this.actionHeightMobile = model.actionHeightMobile || 47;
    this.hiddenFromFlows = false;
    this.flowId = model.flowId || null;
};
var VSImage = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function VSImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, VSImage);
        this.id = model.id || null;
        this.title = model.title || null;
        this.url = model.url || null;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = true;
    }
    var _proto = VSImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat(getVersion(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    return VSImage;
}()));
var TourImage = /*#__PURE__*/ function() {
    "use strict";
    function TourImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourImage);
        this.id = model.id || null;
        this.vsImageId = model.vsImageId || null;
        this.toursVSObjectId = model.toursVSObjectId || null;
        this.toursVSVideoId = model.toursVSVideoId || null;
        this.toursVSObjectIdAfterAnimation = model.toursVSObjectIdAfterAnimation || null;
        this.toursVSVideoIdAfterAnimation = model.toursVSVideoIdAfterAnimation || null;
        this.uuid = model.uuid || null;
        this.width = model.width;
        this.height = model.height;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = 0;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.autoRotate = model.autoRotate || false;
        this.details = Object.assign(model.vsImage || {});
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = true;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.enableAnimation = typeof model.enableAnimation === "boolean" ? model.enableAnimation : false;
        this.enableHoverAnimation = typeof model.enableHoverAnimation === "boolean" ? model.enableHoverAnimation : false;
        this.animationPulse = typeof model.animationPulse === "boolean" ? model.animationPulse : false;
        this.animationUpDown = typeof model.animationUpDown === "boolean" ? model.animationUpDown : false;
        this.animationFlip = typeof model.animationFlip === "boolean" ? model.animationFlip : false;
        this.effectOpacity = typeof model.effectOpacity === "boolean" ? model.effectOpacity : false;
        this.effectStopAnimation = typeof model.effectStopAnimation === "boolean" ? model.effectStopAnimation : false;
        this.effectHide = typeof model.effectHide === "boolean" ? model.effectHide : false;
        var _renderRange;
        this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
        var _startAnimationDistance;
        this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
        var _delay;
        this.delay = (_delay = model.delay) !== null && _delay !== void 0 ? _delay : 0;
        // actions
        this.actionType = model.actionType || TourActionType.None;
        this.action = model.action || TourAction.Click;
        this.actionURL = model.actionURL || null;
        this.dontInterruptBgAudio = model.dontInterruptBgAudio || false;
        this.text = model.text || null;
        this.popupTitle = model.popupTitle || null;
        this.actionRes = model.actionRes || TourActionRes.Percentage;
        this.actionWidth = model.actionWidth || 80;
        this.actionHeight = model.actionHeight || 60;
        this.actionResMobile = model.actionResMobile || TourActionRes.Percentage;
        this.actionWidthMobile = model.actionWidthMobile || 82;
        this.actionHeightMobile = model.actionHeightMobile || 47;
        this.panoramaId = model.panoramaId || null;
        this.menuId = model.menuId || null;
        this.subMenuId = model.subMenuId || null;
        this.subSubMenuId = model.subSubMenuId || null;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.rotation = model.rotation || TourVSImageRotation.Vertical;
        this.backgroundColor = model.backgroundColor || "#000000";
        this.backgroundOpacity = model.backgroundOpacity || 0.7;
        this.textColor = model.textColor || "#ffffff";
        this.buttonColor = model.buttonColor || "#ffffff";
        this.hiddenFromFlows = false;
        this.flowId = model.flowId || null;
    }
    var _proto = TourImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        // if (this.isVSImage && this.actionType === TourImageActionType.ExperiencePopUp) {
        //   return '/play_experience.svg';
        // }
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    return TourImage;
}();
var VSHtml = function VSHtml() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _class_call_check(this, VSHtml);
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
};
var TourVSHtml = function TourVSHtml() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourVSHtml);
    this.id = model.id || null;
    this.vsHtmlId = model.vsHtmlId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsHtml || {});
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
    this.active = model.active;
    this.floor = typeof model.floor === "number" ? model.floor : null;
    this.sweepUuid = model.sweep_uuid || model.sweepUuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.node = model.node;
    this.renderRange = model.renderRange || null;
    var _delay;
    this.delay = (_delay = model.delay) !== null && _delay !== void 0 ? _delay : 0;
};
var VSVideoType;
(function(VSVideoType) {
    VSVideoType["Local"] = "local";
    VSVideoType["Vimeo"] = "vimeo";
})(VSVideoType || (VSVideoType = {}));
var VSVideo = /*#__PURE__*/ function() {
    "use strict";
    function VSVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, VSVideo);
        this.id = model.id || null;
        this.title = model.title || "";
        this.url = model.url || "";
        this.type = model.type || VSVideoType.Local;
        this.width = model.width || 2;
        this.height = model.height || 2;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.greenScreenEnabled = typeof model.greenScreenEnabled === "boolean" ? model.greenScreenEnabled : false;
        this.greenScreenColor = model.greenScreenColor;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = false;
        this.isVSVideo = true;
    }
    var _proto = VSVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.image.includes("http")) {
            image = this.image;
        }
        return image;
    };
    return VSVideo;
}();
var TourVideo = /*#__PURE__*/ function() {
    "use strict";
    function TourVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourVideo);
        this.id = model.id || null;
        this.vsVideoId = model.vsVideoId || null;
        this.uuid = model.uuid || null;
        this.tourId = model.tourId || null;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.details = Object.assign(model.vsVideo || model.details || new VSVideo());
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = false;
        this.isVSVideo = true;
        this.hideMuteButton = model.hideMuteButton || false;
        this.isDefaultMuted = model.isDefaultMuted || false;
        this.autoRotate = model.autoRotate || false;
        this.enableHoverAnimation = typeof model.enableHoverAnimation === "boolean" ? model.enableHoverAnimation : false;
        this.animationPulse = typeof model.animationPulse === "boolean" ? model.animationPulse : false;
        this.animationUpDown = typeof model.animationUpDown === "boolean" ? model.animationUpDown : false;
        this.animationFlip = typeof model.animationFlip === "boolean" ? model.animationFlip : false;
        this.effectOpacity = typeof model.effectOpacity === "boolean" ? model.effectOpacity : false;
        this.effectStopAnimation = typeof model.effectStopAnimation === "boolean" ? model.effectStopAnimation : false;
        this.effectHide = typeof model.effectHide === "boolean" ? model.effectHide : false;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.sweep_uuid = model.sweep_uuid || null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.autoplay = typeof model.autoplay === "boolean" ? model.autoplay : true;
        this.loop = typeof model.loop === "boolean" ? model.loop : true;
        var _renderRange;
        this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
        var _startAnimationDistance;
        this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
        var _delay;
        this.delay = (_delay = model.delay) !== null && _delay !== void 0 ? _delay : 0;
        this.hideOnAnimationFinished = typeof model.hideOnAnimationFinished === "boolean" ? model.hideOnAnimationFinished : false;
        this.isShowPreLoader = model.isShowPreLoader;
        this.greenScreenStrength = model.greenScreenStrength;
        this.greenScreenSmoothness = model.greenScreenSmoothness;
        this.greenScreenSpill = model.greenScreenSpill;
        this.videoPlayedOnce = false;
        this.hiddenFromFlows = false;
    }
    var _proto = TourVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.details || !this.details.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.details || !this.details.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.details.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.image.includes("http")) {
            image = this.details.image;
        }
        return image;
    };
    return TourVideo;
}();


/***/ }),

/***/ 20594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ VSSettings; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var three_src_math_MathUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69542);


var VSSettings = function VSSettings() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, VSSettings);
    this.id = model.id;
    this.tourId = model.tourId;
    this.ambientLight = model.ambientLight || 9.5;
    this.pointLight = model.pointLight || 33 * 3;
    this.lightHeight = model.lightHeight || 75 * 0.5;
    this.shadowIntensity = model.shadowIntensity >= 0 ? model.shadowIntensity : 0.2;
    this.lightAngle = model.lightAngle || 0;
    this.directionalLightStrength = model.directionalLightStrength || 0;
    this.directionalLightAngleX = model.directionalLightAngleX ? (0,three_src_math_MathUtils__WEBPACK_IMPORTED_MODULE_1__/* .degToRad */ .Id)(model.directionalLightAngleX * 4) / Math.PI : 0;
    this.directionalLightAngleY = model.directionalLightAngleY ? (0,three_src_math_MathUtils__WEBPACK_IMPORTED_MODULE_1__/* .degToRad */ .Id)(model.directionalLightAngleY * 4) / Math.PI : 0;
    this.updatedAt = model.updatedAt;
};


/***/ }),

/***/ 23276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ videoRendererType; }
/* harmony export */ });
/* unused harmony exports VideoRenderer, makeVideoRenderer */
/* harmony import */ var _Scene_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98472);
/* harmony import */ var _components_util_deviceManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99080);









var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var DEFAULT_WIDTH = 1;
// const DEFAULT_RADIUS = 0.1;
var VideoRenderer = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(SceneComponent) {
    "use strict";
    _inherits(VideoRenderer, SceneComponent);
    var _super = _create_super(VideoRenderer);
    function VideoRenderer() {
        _class_call_check(this, VideoRenderer);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.plane = null;
        _this.backSidePlane = null;
        _this.playBtn = null;
        _this.muteBtn = null;
        _this.aspect = 1.77;
        _this.aspectHeight = DEFAULT_WIDTH / _this.aspect;
        _this.hasPlayPermission = false;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        _this.destroyButton = function() {};
        _this.inputs = {
            src: null,
            muted: true,
            loop: true,
            autoplay: true,
            visible: true,
            playsInline: true,
            localRotation: {
                x: 0,
                y: 0,
                z: 0
            },
            skipRender: false,
            width: DEFAULT_WIDTH
        };
        _this.outputs = {
            texture: null,
            loadingState: LoadingState.Idle
        };
        var _obj;
        // setting which events are compatible with the component
        _this.events = (_obj = {}, _define_property(_obj, ComponentInteractionType.CLICK, true), _define_property(_obj, ComponentInteractionType.HOVER, true), _define_property(_obj, ComponentInteractionType.DRAG, false), _obj);
        _this.getSize = function() {
            return [
                _this.inputs.width,
                _this.aspectHeight
            ];
        };
        return _this;
    }
    var _proto = VideoRenderer.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.outputs.objectRoot = this.root;
        if (this.inputs.visible) {
            // setting the collider to add the click event
            this.outputs.collider = this.root;
        }
        this.root.add(this.pivot);
    };
    _proto.onInputsUpdated = function onInputsUpdated() {
        var _this = this;
        try {
            if (this.inputs.skipRender) {
                var localRotation = this.inputs.localRotation;
                this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                return;
            }
            this.releaseTexture();
            var THREE = this.context.three;
            if (!this.inputs.src) {
                this.video.src = "";
                this.outputs.loadingState = LoadingState.Idle;
                return;
            }
            this.outputs.loadingState = LoadingState.Loading;
            if (_instanceof(this.inputs.src, HTMLVideoElement)) {
                this.video = this.inputs.src;
            } else {
                this.video = this.createVideoElement();
                if (typeof this.inputs.src === "string") {
                    this.video.src = this.inputs.src;
                } else {
                    this.video.srcObject = this.inputs.src;
                }
                this.video.load();
            }
            var onCanPlay = function() {
                try {
                    var ref, ref1, ref2;
                    var videoElement = _this.video;
                    var audioDataNotPresented = (videoElement === null || videoElement === void 0 ? void 0 : videoElement.webkitAudioDecodedByteCount) === 0 || (videoElement === null || videoElement === void 0 ? void 0 : videoElement.mozHasAudio) === false || (videoElement === null || videoElement === void 0 ? void 0 : (ref = videoElement.audioTracks) === null || ref === void 0 ? void 0 : ref.length) === 0;
                    if (audioDataNotPresented) {
                        if (_this.destroyButton && typeof _this.destroyButton === "function") {
                            _this.destroyButton();
                        }
                    }
                    _this.video.removeEventListener("canplaythrough", onCanPlay);
                    var _video = _this.video, videoWidth = _video.videoWidth, videoHeight = _video.videoHeight;
                    if (!videoWidth || !videoHeight) {
                        // return console.debug('Unable to get video resolution.');
                        throw new Error("Unable to get video resolution.");
                    }
                    _this.aspect = videoWidth / videoHeight;
                    _this.aspectHeight = _this.inputs.width / _this.aspect;
                    var geometry = new THREE.PlaneGeometry(_this.inputs.width, _this.aspectHeight);
                    // TODO: finish with rounded rectangle
                    // https://threejs.org/examples/#webgl_geometry_shapes - rounded rect shape
                    // const geometry = this.makeRoundedRect(
                    //   0,
                    //   0,
                    //   this.inputs.width,
                    //   this.aspectHeight,
                    //   this.inputs.useRadius ? DEFAULT_RADIUS : 0,
                    // );
                    _this.texture = new THREE.VideoTexture(_this.video);
                    _this.texture.encoding = THREE.sRGBEncoding;
                    _this.texture.minFilter = THREE.LinearFilter;
                    _this.texture.magFilter = THREE.LinearFilter;
                    _this.texture.format = THREE.RGBAFormat;
                    _this.texture.wrapS = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                    _this.texture.wrapT = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                    _this.texture.repeat.set(1, 1);
                    var material = new THREE.MeshBasicMaterial({
                        map: _this.texture,
                        blending: THREE.NormalBlending,
                        transparent: true,
                        visible: _this.inputs.visible
                    });
                    var backSideMaterial = new THREE.MeshBasicMaterial({
                        side: THREE.DoubleSide,
                        color: 0x000000,
                        transparent: false,
                        visible: _this.inputs.visible,
                        polygonOffset: true,
                        polygonOffsetUnits: -4
                    });
                    _this.plane = new THREE.Mesh(geometry, material);
                    (ref1 = _this.pivot) === null || ref1 === void 0 ? void 0 : ref1.add(_this.plane);
                    // fixing plane the position
                    // this.plane.position.set(
                    //   -((this.inputs.width * this.aspect) / 2),
                    //   -(this.aspectHeight / 2),
                    //   0,
                    // );
                    // this.plane.scale.set(
                    //   this.aspect,
                    //   1,
                    //   1,
                    // );
                    _this.backSidePlane = new THREE.Mesh(geometry, backSideMaterial);
                    _this.backSidePlane.position.set(0, 0, -0.01);
                    (ref2 = _this.pivot) === null || ref2 === void 0 ? void 0 : ref2.add(_this.backSidePlane);
                    // fixing plane the position
                    // this.backSidePlane.position.set(
                    //   -((this.inputs.width * this.aspect) / 2),
                    //   -(this.aspectHeight / 2),
                    //   -0.01,
                    // );
                    var localRotation = _this.inputs.localRotation;
                    _this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                    _this.outputs.texture = _this.texture;
                    if (_this.inputs.autoplay) {
                        var _this1 = _this;
                        var interval = setInterval(/*#__PURE__*/ _async_to_generator(function() {
                            var err;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            _this1.video.play()
                                        ];
                                    case 1:
                                        _state.sent();
                                        clearInterval(interval);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        err = _state.sent();
                                        console.error(err);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }), 1000);
                    }
                } catch (e) {
                    console.error("[PUBLIC VideoRenderer]:", e);
                    _this.video.removeEventListener("canplaythrough", onCanPlay);
                    _this.outputs.loadingState = LoadingState.Error;
                }
            };
            var onError = function() {
                _this.video.removeEventListener("error", onError);
                _this.outputs.loadingState = LoadingState.Error;
            };
            this.video.addEventListener("canplaythrough", onCanPlay);
            this.video.addEventListener("error", onError);
            if (DeviceManager.isIOS()) {
                this.video.addEventListener("pause", function() {
                    // mute and play the video in case the browser stopped it
                    // i.e. Safari stops the video if the other one was unmuted
                    if (_this.video.paused && _this.hasPlayPermission) {
                        _this.toggleMute();
                    }
                }, false);
            }
        } catch (e) {
            console.error("[VideoRenderer]:", e);
            this.outputs.loadingState = LoadingState.Error;
        }
    };
    _proto.onDestroy = function onDestroy() {
        this.releaseTexture();
        if (this.playBtn) {
            var ref;
            (ref = this.playBtn.parent) === null || ref === void 0 ? void 0 : ref.remove(this.playBtn);
            this.playBtn.material.dispose();
            this.playBtn.geometry.dispose();
            this.playBtn = null;
        }
        if (this.muteBtn) {
            var ref1;
            (ref1 = this.muteBtn.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.muteBtn);
            this.muteBtn.material.dispose();
            this.muteBtn.geometry.dispose();
            this.muteBtn = null;
        }
    };
    _proto.isMuted = function isMuted() {
        return this.video.muted;
    };
    _proto.toggleMute = function toggleMute(muted) {
        var value = typeof muted === "boolean" ? muted : !this.video.muted;
        if (!this.video) return;
        this.video.muted = value;
        if (DeviceManager.isIOS() && !value && !this.hasPlayPermission) {
            // Safari support the autoplay unmute only after user interacts with Treedis website (not iframe)
            // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
            var overlay = document.createElement("div");
            overlay.setAttribute("id", "video-overlay");
            overlay.style.width = "100vw";
            overlay.style.height = "100vh";
            overlay.style.zIndex = "9999";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            var _this = this;
            var handler = function() {
                var _ref = _async_to_generator(function() {
                    var hasOverlay;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                hasOverlay = document.getElementById("video-overlay");
                                if (!hasOverlay) return [
                                    2
                                ];
                                document.body.removeChild(overlay);
                                overlay.removeEventListener("click", handler);
                                overlay.removeEventListener("mouseup", handler);
                                overlay.removeEventListener("mousemove", handler);
                                overlay.removeEventListener("touchstart", handler);
                                overlay.removeEventListener("touchmove", handler);
                                _this.hasPlayPermission = true;
                                return [
                                    4,
                                    _this.video.play()
                                ];
                            case 1:
                                _state.sent();
                                // in case with iOS Safari browser, the video is muted at the moment (read the link below)
                                // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
                                //
                                // so, we need to unmute it and display the current state
                                _this.video.muted = false;
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function handler() {
                    return _ref.apply(this, arguments);
                };
            }();
            overlay.addEventListener("click", handler);
            overlay.addEventListener("mousedown", handler);
            overlay.addEventListener("mousemove", handler);
            overlay.addEventListener("touchstart", handler);
            overlay.addEventListener("touchmove", handler);
            document.body.append(overlay);
        } else {
            this.video.play().catch(function(e) {
                console.error(e);
            });
        }
    };
    _proto.releaseTexture = function releaseTexture() {
        if (this.texture) {
            this.outputs.texture = null;
            this.outputs.loadingState = LoadingState.Idle;
            this.texture.dispose();
        }
        if (this.video) {
            this.video.pause();
            this.video.src = "";
        }
        if (this.plane) {
            var ref;
            (ref = this.plane.parent) === null || ref === void 0 ? void 0 : ref.remove(this.plane);
            this.plane.material.dispose();
            this.plane.geometry.dispose();
            this.plane = null;
        }
        if (this.backSidePlane) {
            var ref1;
            (ref1 = this.backSidePlane.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.backSidePlane);
            this.backSidePlane.material.dispose();
            this.backSidePlane.geometry.dispose();
            this.backSidePlane = null;
        }
    };
    _proto.createVideoElement = function createVideoElement() {
        var _inputs = this.inputs, muted = _inputs.muted, loop = _inputs.loop, autoplay = _inputs.autoplay, playsInline = _inputs.playsInline;
        var video = document.createElement("video");
        video.crossOrigin = "anonymous";
        video.autoplay = Boolean(autoplay);
        video.muted = Boolean(muted);
        video.loop = Boolean(loop);
        video.playsInline = Boolean(playsInline);
        return video;
    };
    return VideoRenderer;
}(SceneComponent)));
var videoRendererType = "treedis.videoRenderer";
function makeVideoRenderer() {
    return new VideoRenderer();
}


/***/ }),

/***/ 2300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ API; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__);








var API = /*#__PURE__*/ function() {
    "use strict";
    function API(options) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, API);
        this.baseUrl = (options === null || options === void 0 ? void 0 : options.baseUrl) || "";
        var _this = this;
        var _this1 = this;
        var _this2 = this;
        var _this3 = this;
        var _this4 = this;
        this.public = {
            get: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(_param) {
                    var _url, url, rest, results, err, errors;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                if (rest.query) {
                                    url += "?".concat(_this.objectToQueryString(rest.query));
                                }
                                return [
                                    4,
                                    fetch(_this.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        method: "get"
                                    }, rest))
                                ];
                            case 2:
                                results = _state.sent();
                                return [
                                    2,
                                    results.json()
                                ];
                            case 3:
                                err = _state.sent();
                                if (err.code === 422) {
                                    errors = Object.values((err === null || err === void 0 ? void 0 : err.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    console.error(err.message);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }(),
            post: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(_param, parentOptions) {
                    var _url, url, rest, data, isFormData, body, config, headers, results, err, errors;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                data = rest.data ? rest.data : rest;
                                isFormData = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rest.data, FormData);
                                config = rest.config ? rest.config : {};
                                if (isFormData) {
                                    headers = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default()(config.headers || {});
                                    headers["Content-Type"] = "multipart/form-data";
                                    config.headers = headers;
                                    body = rest.data;
                                } else {
                                    body = JSON.stringify(data);
                                }
                                return [
                                    4,
                                    fetch(_this1.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        method: "post"
                                    }, rest), {
                                        body: body
                                    }), config))
                                ];
                            case 2:
                                results = _state.sent();
                                return [
                                    2,
                                    results.json()
                                ];
                            case 3:
                                err = _state.sent();
                                if (!(parentOptions === null || parentOptions === void 0 ? void 0 : parentOptions.turnOffToastError)) {
                                    if (err.code === 422) {
                                        errors = Object.values((err === null || err === void 0 ? void 0 : err.errors) || []);
                                        errors.map(function(error) {
                                            return console.error(error.join(", "));
                                        });
                                    } else {
                                        console.error(err.message);
                                    }
                                } else return [
                                    2,
                                    err
                                ];
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
                return function(_param, parentOptions) {
                    return _ref.apply(this, arguments);
                };
            }(),
            put: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(_param) {
                    var _url, url, rest, results, err, errors;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    fetch(_this2.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        method: "put"
                                    }, rest, rest.data ? {
                                        body: JSON.stringify(rest.data)
                                    } : {
                                        body: JSON.stringify(rest)
                                    }, rest.config ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest.config) : {}))
                                ];
                            case 2:
                                results = _state.sent();
                                return [
                                    2,
                                    results.json()
                                ];
                            case 3:
                                err = _state.sent();
                                if (err.code === 422) {
                                    errors = Object.values((err === null || err === void 0 ? void 0 : err.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    console.error(err.message);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }(),
            patch: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(_param) {
                    var _url, url, rest, results, err;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    fetch(_this3.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        method: "PATCH"
                                    }, rest, rest.data ? {
                                        body: JSON.stringify(rest.data)
                                    } : {
                                        body: JSON.stringify(rest)
                                    }, rest.config ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest.config) : {}))
                                ];
                            case 2:
                                results = _state.sent();
                                return [
                                    2,
                                    results.json()
                                ];
                            case 3:
                                err = _state.sent();
                                return [
                                    2,
                                    err
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }(),
            delete: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(_param) {
                    var _url, url, rest, results, err, errors;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _url = _param.url, url = _url === void 0 ? "" : _url, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                                    "url"
                                ]);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    fetch(_this4.baseUrl.concat(url), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                        method: "delete"
                                    }, rest))
                                ];
                            case 2:
                                results = _state.sent();
                                return [
                                    2,
                                    results.json()
                                ];
                            case 3:
                                err = _state.sent();
                                if (err.code === 422) {
                                    errors = Object.values((err === null || err === void 0 ? void 0 : err.errors) || []);
                                    errors.map(function(error) {
                                        return console.error(error.join(", "));
                                    });
                                } else {
                                    console.error(err.message);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                });
                return function(_param) {
                    return _ref.apply(this, arguments);
                };
            }()
        };
    }
    var _proto = API.prototype;
    // eslint-disable-next-line class-methods-use-this
    _proto.objectToQueryString = function objectToQueryString(obj) {
        return Object.keys(obj).map(function(key) {
            return "".concat(key, "=").concat(obj[key]);
        }).join("&");
    };
    return API;
}();



/***/ }),

/***/ 83680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var _API__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2300);






var API_VERSION = "v1";
var PREFIX = "".concat(API_VERSION, "/admin/tour/");
var ADMIN_PREFIX = "".concat(API_VERSION, "/admin/");
var PUBLIC_PREFIX = "".concat(API_VERSION, "/public");
var GAME_PREFIX = "".concat(API_VERSION, "/admin/game");
var TreedisAdminDAO = /*#__PURE__*/ function(API) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(TreedisAdminDAO, API);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TreedisAdminDAO);
    function TreedisAdminDAO() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, TreedisAdminDAO);
        var _this;
        _this = _super.call(this);
        var parent = _this.public;
        _this.public = {
            /** Virtual Staging */ getTourVSObjects: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vstaging")
                }, options));
            },
            getTourVSImages: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PUBLIC_PREFIX, "/").concat(slug, "/vstaging-images")
                }, options));
            },
            getTourVSHtmls: function(slug) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-html")
                }, options));
            },
            getBarriers: function() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/barriers")
                }, options));
            },
            getVSSettings: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vs-settings")
                }, options));
            },
            getPolygons: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/polygons")
                }, options));
            },
            getTourVSVideos: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-videos")
                }, options));
            },
            getFRFloors: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vs-settings/frfloors")
                }, options));
            },
            getNavigationSweeps: function() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/sweeps")
                }, options));
            },
            /** Game * */ saveAnalytics: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(GAME_PREFIX, "/analytic/save")
                }, options));
            },
            createPaymentSecret: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PUBLIC_PREFIX, "/payment/secret")
                }, options));
            },
            // NAVIGATION
            saveNavigationRating: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/rating")
                }, options));
            },
            sendNavigationLinkSms: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/sms")
                }, options));
            },
            getAllMenuItems: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/menu-items")
                }, options));
            },
            getMenuCategories: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/menu-categories")
                }, options));
            },
            // getMenuFilters: ({ ...options } = {}) => parent.get({ url: `${ADMIN_PREFIX}navigation/menu-filters`, ...options }),
            getNaviationSettings: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/settings")
                }, options));
            },
            getNavigationFinishScreen: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/finish-screen")
                }, options));
            },
            getTeleportGroups: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/teleportGroups")
                }, options));
            },
            getStations: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(ADMIN_PREFIX, "navigation/stations")
                }, options));
            }
        };
        return _this;
    }
    return TreedisAdminDAO;
}(_API__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var DAO = new TreedisAdminDAO().public;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
/* harmony default export */ __webpack_exports__["Z"] = (DAO);


/***/ }),

/***/ 80250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var _API__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2300);







var TreedisPublicDAO = /*#__PURE__*/ function(API) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(TreedisPublicDAO, API);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TreedisPublicDAO);
    function TreedisPublicDAO() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, TreedisPublicDAO);
        var _this;
        _this = _super.call(this);
        var parent = _this.public;
        _this.public = {
            getUser: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "public/getUserIdByDomain"
                }, options));
            },
            getMinimaps: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "public/getMinimaps"
                }, options));
            },
            getMenu: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getMenu"
                }, options));
            },
            sendEmail: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/sendEmail"
                }, options));
            },
            shareExperienceResult: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/shareExperienceResult"
                }, options));
            },
            getGroups: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweepGroups"
                }, options));
            },
            getDuplicates: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getDuplicates/".concat(id)
                }, options));
            },
            getReels: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getReels/".concat(id)
                }, options));
            },
            getTranslations: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTranslations/".concat(id)
                }, options));
            },
            getAgents: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getAgents/".concat(id)
                }, options));
            },
            getEmails: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getEmails/".concat(id)
                }, options));
            },
            getTags: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTags"
                }, options));
            },
            // NOTES
            saveThread: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/saveThread"
                }, options));
            },
            deleteThread: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/deleteThread"
                }, options));
            },
            saveThreadMessage: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/saveThreadMessage"
                }, options));
            },
            deleteThreadMessage: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/deleteThreadMessage"
                }, options));
            },
            getSAPOptions: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSAPOptions/".concat(id)
                }, options));
            },
            getProducts: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products"
                }, options));
            },
            getProduct: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/get"
                }, options));
            },
            getVariantsByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/variants/byTour"
                }, options));
            },
            getMediaByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/medias/byTour"
                }, options));
            },
            getLocationsByTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/locations"
                }, options));
            },
            createHavellsCart: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/havells/cart/create"
                }, options));
            },
            addToHavellsCart: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/havells/cart/add"
                }, options), parentOptions);
            },
            updateHavellsCart: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/havells/cart/update"
                }, options));
            },
            getTwilioToken: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/video/token"
                }, options));
            },
            getGame: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getGame/"
                }, options));
            },
            getTour: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTour"
                }, options));
            },
            getTourBySlug: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTourBySlug"
                }, options));
            },
            getAgentsAndTheirSlotsFromClientId: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getAgentsAndTheirSlotsFromClientId"
                }, options));
            },
            getTicketingDiscount: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getTicketingDiscount"
                }, options));
            },
            finishOrderTickets: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/finishOrderTickets"
                }, options));
            },
            payTickets: function(paymentType) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/payment/".concat(paymentType)
                }, options));
            },
            createTicketOrder: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/createOrder"
                }, options));
            },
            ticketLogin: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticketLogin"
                }, options), parentOptions);
            },
            logoutTicket: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, parentOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticketLogout"
                }, options), parentOptions);
            },
            ticketSettings: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/ticket/settings"
                }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                    query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                        tourId: tourId
                    })
                })));
            },
            getFloorPlans: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getFloorPlans"
                }, options));
            },
            getSweeps: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweeps"
                }, options));
            },
            getSweepIndex: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getSweepIndex"
                }, options));
            },
            getPath: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getPath"
                }, options));
            },
            getVimeoVideo: function(videoId, clientId) {
                return parent.get({
                    url: "v1/public/vimeo",
                    query: {
                        clientId: clientId,
                        path: "/videos/".concat(videoId, "?fields=uri,play,width,height,live,description,title")
                    }
                });
            },
            // @ts-ignore
            getVimeoVideoUrl: function(url) {
                return fetch(url, {
                    method: "HEAD",
                    ignoreInterceptor: true
                }).then(function(res) {
                    return res.url;
                });
            },
            getLockByType: function() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getLockByType"
                }, options));
            },
            getExperienceTopScores: function(id) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/experience/".concat(id, "/topScores")
                }, options));
            },
            getProductsWithPagination: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/productsFilters"
                }, options));
            },
            getProductsByTag: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/getByTagSid"
                }, options));
            },
            getProductsByPolygon: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/getByPolygonId"
                }, options));
            },
            getNearestProducts: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/getNearestProductsByCoordinates"
                }, options));
            },
            getProductsCount: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/eCommerce/products/getProductsCount"
                }, options));
            },
            getTwinMakerConfig: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/tour/".concat(slug, "/twinmaker/config")
                }, options));
            },
            login: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/loginFromPublic"
                }, options));
            },
            refreshOAuth: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/oauth/refresh"
                }, options));
            },
            createAnalyticEvent: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/analytic/event"
                }, options));
            },
            createGameAnalyticEvent: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/analytic/gameEvent"
                }, options));
            },
            createAnalyticUser: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/analytic/user"
                }, options));
            },
            // IOT
            getIoTDevices: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/devices"
                }, options));
            },
            getIoTMSSQLDevicesData: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/tour/".concat(slug, "/mssql/data")
                }, options));
            },
            getIoTTwinmakerDevicesData: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/tour/".concat(slug, "/twinmaker/data")
                }, options));
            },
            getIoTProviders: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/providers"
                }, options));
            },
            getIoTMenu: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/menu"
                }, options));
            },
            unlockIoTDevice: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.patch((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/device/unlock"
                }, options));
            },
            getIoTGroups: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/groups"
                }, options));
            },
            getIoTDevicesTypes: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/devices/types"
                }, options));
            },
            getStream: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/device/getStream"
                }, options));
            },
            loginIoT: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/loginIoT"
                }, options));
            },
            getFavouriteCameras: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/getFavouriteCameras"
                }, options));
            },
            getTraneDemo: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/trane-demo?eqId=902a1839-1f13-47c4-9208-1f01a8d40484"
                }, options));
            },
            getIotTanklogixData: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/iot/tanklogix"
                }, options));
            },
            // Flows
            getFlows: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "v1/public/getFlows"
                }, options));
            }
        };
        return _this;
    }
    return TreedisPublicDAO;
}(_API__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
var DAO = new TreedisPublicDAO().public;
/* harmony default export */ __webpack_exports__["Z"] = (DAO);


/***/ }),

/***/ 79575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ getNavigationSweeps; },
/* harmony export */   "BZ": function() { return /* binding */ getVSItems; },
/* harmony export */   "DW": function() { return /* binding */ getPath; },
/* harmony export */   "EC": function() { return /* binding */ getNavigationData; },
/* harmony export */   "QM": function() { return /* binding */ getSweepIndex; },
/* harmony export */   "Uv": function() { return /* binding */ getSweeps; },
/* harmony export */   "VB": function() { return /* binding */ getDuplicates; },
/* harmony export */   "Y4": function() { return /* binding */ getFlowsData; },
/* harmony export */   "dt": function() { return /* binding */ getBarriers; },
/* harmony export */   "lB": function() { return /* binding */ getFloorPlans; }
/* harmony export */ });
/* unused harmony exports getPolygons, getTourVSObjects, getTourVSImages, getTourVSVideos, getTourVSHtmls, getTourVSSettings, getAllMenuItems, getMenuCategories, getNaviationSettings, getNavigationFinishScreen, getStations, getFlows */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20414);
/* harmony import */ var _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80250);
/* harmony import */ var _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83680);
/* harmony import */ var _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15864);
/* harmony import */ var _models_virtualStaging_VSSettings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20594);
/* harmony import */ var _models_virtualStaging_Polygon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59524);
/* harmony import */ var _components_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97666);
/* harmony import */ var _components_flows_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83065);











var getFloorPlans = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getFloorPlans */ .Z.getFloorPlans({
                            id: id
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : res.floorPlans) || []
                    ];
            }
        });
    });
    return function getFloorPlans(id) {
        return _ref.apply(this, arguments);
    };
}();
var getDuplicates = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getDuplicates */ .Z.getDuplicates(id)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : res.duplicates) || []
                    ];
            }
        });
    });
    return function getDuplicates(id) {
        return _ref.apply(this, arguments);
    };
}();
var getPolygons = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPolygons */ .Z.getPolygons(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.data
                    ];
            }
        });
    });
    return function getPolygons(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getSweeps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(matterId, slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matterId) return [
                        2,
                        []
                    ];
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getSweeps */ .Z.getSweeps({
                            matterId: matterId,
                            slug: slug,
                            auth: (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .getQueryVariable */ .Dv)(window.location.href, "auth")
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : res.sweeps) || []
                    ];
            }
        });
    });
    return function getSweeps(matterId, slug) {
        return _ref.apply(this, arguments);
    };
}();
var getSweepIndex = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(matterId, slug, sweepId) {
        var ref, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matterId || !sweepId) return [
                        2,
                        -1
                    ];
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getSweepIndex */ .Z.getSweepIndex({
                            matterId: matterId,
                            slug: slug,
                            sweepId: sweepId,
                            auth: (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .getQueryVariable */ .Dv)(window.location.href, "auth")
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sweepIndex) + 1 || -1
                    ];
            }
        });
    });
    return function getSweepIndex(matterId, slug, sweepId) {
        return _ref.apply(this, arguments);
    };
}();
var getPath = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(sweeps, startSweep, endSweep, tourId, navigationType) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getPath */ .Z.getPath({
                            sweeps: sweeps,
                            startSweep: startSweep,
                            endSweep: endSweep,
                            tourId: tourId,
                            navigationType: navigationType
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.data
                    ];
            }
        });
    });
    return function getPath(sweeps, startSweep, endSweep, tourId, navigationType) {
        return _ref.apply(this, arguments);
    };
}();
var getNavigationSweeps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getNavigationSweeps */ .Z.getNavigationSweeps({
                            query: {
                                id: id
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.navigationSweeps
                    ];
            }
        });
    });
    return function getNavigationSweeps(id) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSObjects = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSObjects */ .Z.getTourVSObjects(id)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.tourVSObjects
                    ];
            }
        });
    });
    return function getTourVSObjects(id) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSImages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSImages */ .Z.getTourVSImages(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.tourVSImages
                    ];
            }
        });
    });
    return function getTourVSImages(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSVideos = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSVideos */ .Z.getTourVSVideos(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.data
                    ];
            }
        });
    });
    return function getTourVSVideos(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSHtmls = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(slug) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTourVSHtmls */ .Z.getTourVSHtmls(slug)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.data
                    ];
            }
        });
    });
    return function getTourVSHtmls(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getBarriers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getBarriers */ .Z.getBarriers({
                            query: {
                                id: id
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.barriers
                    ];
            }
        });
    });
    return function getBarriers(id) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSSettings = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getVSSettings */ .Z.getVSSettings(id)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res === null || res === void 0 ? void 0 : res.vsSettings
                    ];
            }
        });
    });
    return function getTourVSSettings(id) {
        return _ref.apply(this, arguments);
    };
}();
var getVSItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(isMatterportLink, param) {
        var slug, id, ref, polygons, vsObjectsRes, vsImages, vsSettings, tourVideosData, vsHtmls, tourVideos, tourImages, tourHtmls, vsObjects;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, id = param.id;
                    return [
                        4,
                        Promise.all([
                            !isMatterportLink ? getPolygons(slug) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSObjects(id) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSImages(slug) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSSettings(id) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSVideos(slug) : Promise.resolve(null),
                            !isMatterportLink ? getTourVSHtmls(slug) : Promise.resolve(null)
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        6
                    ]), polygons = ref[0], vsObjectsRes = ref[1], vsImages = ref[2], vsSettings = ref[3], tourVideosData = ref[4], vsHtmls = ref[5];
                    tourVideos = (tourVideosData || []).map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourVideo */ .Up(item);
                    });
                    tourImages = (vsImages === null || vsImages === void 0 ? void 0 : vsImages.map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourImage */ .oP(item);
                    })) || [];
                    tourHtmls = (vsHtmls === null || vsHtmls === void 0 ? void 0 : vsHtmls.map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourVSHtml */ .q8(item);
                    })) || [];
                    vsObjects = (vsObjectsRes || []).map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_2__/* .TourObject */ .zB(item);
                    }).concat(tourImages).concat(tourHtmls).concat(tourVideos);
                    return [
                        2,
                        {
                            polygons: polygons ? polygons.map(function(polygon) {
                                return new _models_virtualStaging_Polygon__WEBPACK_IMPORTED_MODULE_3__/* .Polygon */ .mg(polygon);
                            }) : [],
                            vsSettings: new _models_virtualStaging_VSSettings__WEBPACK_IMPORTED_MODULE_9__/* .VSSettings */ .E(vsSettings || {}),
                            vsObjects: vsObjects
                        }
                    ];
            }
        });
    });
    return function getVSItems(isMatterportLink, _) {
        return _ref.apply(this, arguments);
    };
}();
var getAllMenuItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAllMenuItems */ .Z.getAllMenuItems({
                            query: {
                                id: id
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.navigationItems
                    ];
            }
        });
    });
    return function getAllMenuItems(id) {
        return _ref.apply(this, arguments);
    };
}();
var getMenuCategories = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMenuCategories */ .Z.getMenuCategories({
                            query: {
                                id: id
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.navigationCategories
                    ];
            }
        });
    });
    return function getMenuCategories(id) {
        return _ref.apply(this, arguments);
    };
}();
var getNaviationSettings = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getNaviationSettings */ .Z.getNaviationSettings({
                            query: {
                                id: id
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.navigationSettings
                    ];
            }
        });
    });
    return function getNaviationSettings(id) {
        return _ref.apply(this, arguments);
    };
}();
var getNavigationFinishScreen = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getNavigationFinishScreen */ .Z.getNavigationFinishScreen({
                            query: {
                                id: id
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.finishScreen
                    ];
            }
        });
    });
    return function getNavigationFinishScreen(id) {
        return _ref.apply(this, arguments);
    };
}();
var getStations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStations */ .Z.getStations({
                            query: {
                                id: id
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.navigationStations
                    ];
            }
        });
    });
    return function getStations(id) {
        return _ref.apply(this, arguments);
    };
}();
var getNavigationData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(id) {
        var ref, navigationItems, navigationCategories, navigationSettings, navigationFinishScreen, navigationStations;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            getAllMenuItems(id),
                            getMenuCategories(id),
                            getNaviationSettings(id),
                            getNavigationFinishScreen(id),
                            getStations(id)
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        5
                    ]), navigationItems = ref[0], navigationCategories = ref[1], navigationSettings = ref[2], navigationFinishScreen = ref[3], navigationStations = ref[4];
                    return [
                        2,
                        {
                            navigationItems: navigationItems,
                            navigationCategories: navigationCategories,
                            navigationSettings: navigationSettings,
                            navigationFinishScreen: navigationFinishScreen,
                            navigationStations: navigationStations
                        }
                    ];
            }
        });
    });
    return function getNavigationData(id) {
        return _ref.apply(this, arguments);
    };
}();
var getFlows = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(tourId) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getFlows */ .Z.getFlows({
                            query: {
                                tourId: tourId
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function getFlows(tourId) {
        return _ref.apply(this, arguments);
    };
}();
var getFlowsData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(tourId) {
        var ref, flows, objectsWithClick;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            getFlows(tourId)
                        ])
                    ];
                case 1:
                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), flows = ref[0];
                    objectsWithClick = [];
                    flows.forEach(function(flow) {
                        var ref;
                        var flowId = flow === null || flow === void 0 ? void 0 : flow.id;
                        if (!flowId) return;
                        flow === null || flow === void 0 ? void 0 : (ref = flow.steps) === null || ref === void 0 ? void 0 : ref.forEach(function(step) {
                            if (step === null || step === void 0 ? void 0 : step.conditions) {
                                var _objectsWithClick;
                                var ref;
                                var filteredConditions = (ref = step.conditions) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
                                    return c.action === "click" && (c.asset === _components_flows_types__WEBPACK_IMPORTED_MODULE_5__/* .ClickAssetTypes.VsObject */ .n.VsObject || c.asset === _components_flows_types__WEBPACK_IMPORTED_MODULE_5__/* .ClickAssetTypes.HTML */ .n.HTML);
                                });
                                (_objectsWithClick = objectsWithClick).push.apply(_objectsWithClick, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(filteredConditions));
                            }
                        });
                    });
                    return [
                        2,
                        {
                            flows: flows,
                            objectsWithClick: objectsWithClick
                        }
                    ];
            }
        });
    });
    return function getFlowsData(tourId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 29519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w0": function() { return /* binding */ AudioModule; },
  "nR": function() { return /* reexport */ MusicObj; },
  "NO": function() { return /* reexport */ MusicObjectKey; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./_models/virtualStaging/Polygon.tsx
var Polygon = __webpack_require__(59524);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
;// CONCATENATED MODULE: ./utils/isValidUrl.ts
/**
 * Checks if a URL is valid by sending a HEAD request to it.
 * @param {string} url - The URL to validate.
 * @returns {Promise<boolean>} A promise that resolves to true if the URL is valid, false otherwise.
 */ 

function isValidUrl(url) {
    return _isValidUrl.apply(this, arguments);
}
function _isValidUrl() {
    _isValidUrl = (0,_async_to_generator/* default */.Z)(function(url) {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!url) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        fetch(url, {
                            method: "HEAD"
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _isValidUrl.apply(this, arguments);
}
/* harmony default export */ var utils_isValidUrl = (isValidUrl);

;// CONCATENATED MODULE: ./components-new/common/types.ts

var MusicObjectKey;
(function(MusicObjectKey) {
    MusicObjectKey["GAME_SELECTED_AUDIO"] = "GAME_SELECTED_AUDIO";
    MusicObjectKey["BUTTON"] = "BUTTON";
    MusicObjectKey["TAGS"] = "TAGS";
    MusicObjectKey["POLYGONS"] = "POLYGONS";
    MusicObjectKey["VSIMAGES"] = "VSIMAGES";
    MusicObjectKey["PANORAMAS"] = "PANORAMAS";
    MusicObjectKey["SWEEPGROUPS"] = "SWEEPGROUPS";
    MusicObjectKey["FLOORS"] = "FLOORS";
    MusicObjectKey["TOUR"] = "TOUR";
})(MusicObjectKey || (MusicObjectKey = {}));
var _obj;
var MusicObj = (_obj = {}, (0,_define_property/* default */.Z)(_obj, MusicObjectKey.GAME_SELECTED_AUDIO, {
    name: MusicObjectKey.GAME_SELECTED_AUDIO,
    priority: 1
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.BUTTON, {
    name: MusicObjectKey.BUTTON,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.TAGS, {
    name: MusicObjectKey.TAGS,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.POLYGONS, {
    name: MusicObjectKey.POLYGONS,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.VSIMAGES, {
    name: MusicObjectKey.VSIMAGES,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.PANORAMAS, {
    name: MusicObjectKey.PANORAMAS,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.SWEEPGROUPS, {
    name: MusicObjectKey.SWEEPGROUPS,
    priority: 3
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.FLOORS, {
    name: MusicObjectKey.FLOORS,
    priority: 4
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.TOUR, {
    name: MusicObjectKey.TOUR,
    priority: 5
}), _obj);

// EXTERNAL MODULE: ./events/index.ts + 2 modules
var events = __webpack_require__(31103);
;// CONCATENATED MODULE: ./components-new/common/AudioModule.ts














var AudioModule = /*#__PURE__*/ function() {
    "use strict";
    function AudioModule() {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, AudioModule);
        //@ts-ignore
        this.musicData = {};
        this.videosForSoundControl = [];
        this.volumeValue = 1;
        this.isAllMusicMute = false;
        this.lowestPriotiryLevel = 10;
        this.playList = [];
        this.isGreenScreenPlaying = false;
        this.repeatCount = 3;
        this.isTourAudioPaused = true;
        this.removeAudioFromPlayList = function(type, id) {
            _this.playList = _this.playList.filter(function(el) {
                return el.id !== "".concat(id);
            });
        };
        this.removeDuplicatedAudio = function(id, type) {
            _this.playList.filter(function(audio) {
                return type === audio.type.name || id === audio.id;
            }).forEach(function(param) {
                var audio = param.audio;
                return audio.pause();
            });
            _this.playList = _this.playList.filter(function(audio) {
                return audio.id !== id && (!type || type !== audio.type.name);
            });
        };
        this.sleep = function(ms) {
            return new Promise(function(resolve) {
                return setTimeout(resolve, ms);
            });
        };
        var _this1 = this;
        this.repeatMusicCall = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type, objectId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.startPlay(_this1.getAudio(type, objectId), 0)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(type, objectId) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.repeatNextMusicCall = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(nextAudio) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.startPlay(nextAudio, 0)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(nextAudio) {
                return _ref.apply(this, arguments);
            };
        }();
        this.setVSAudiosVolume = function(value) {
            var ref;
            (ref = _this.videosForSoundControl) === null || ref === void 0 ? void 0 : ref.forEach(function(videoNode) {
                var video = videoNode.video;
                if (value === 0) {
                    video.muted = true;
                } else {
                    var ref;
                    video.volume = value;
                    if (!(videoNode === null || videoNode === void 0 ? void 0 : (ref = videoNode.muteBtn) === null || ref === void 0 ? void 0 : ref.active)) {
                        video.muted = false;
                    }
                }
            });
        };
        var _this3 = this;
        this.startPlay = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(audio, index) {
                var e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (index >= _this3.repeatCount) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                2,
                                ,
                                5
                            ]);
                            // Pause currently playing audio before playing new one
                            _this3.pauseAllMusic();
                            // Mute VS Audios if any are playing
                            _this3.setVSAudiosVolume(0);
                            audio.muted = _this3.isAllMusicMute || _this3.volumeValue === 0;
                            audio === null || audio === void 0 ? void 0 : audio.play();
                            return [
                                3,
                                5
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                4,
                                _this3.sleep(500)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this3.startPlay(audio, index + 1)
                            ];
                        case 4:
                            _state.sent();
                            console.log("NOT PLAYING!");
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(audio, index) {
                return _ref.apply(this, arguments);
            };
        }();
        this.setTourMusic = function(value) {
            _this.isTourAudioPaused = value;
        };
        this.isPlaying = function(id) {
            return _this.playList.some(function(i) {
                return i.id === "".concat(id) && !i.audio.paused;
            });
        };
        this.getVolume = function() {
            return _this.volumeValue;
        };
        this.getAllMusicData = function() {
            return _this.musicData;
        };
        this.isTourMusicPaused = function() {
            return _this.isTourAudioPaused;
        };
        this.getAudioByType = function(type) {
            var ref;
            return (ref = _this.musicData) === null || ref === void 0 ? void 0 : ref[type];
        };
        this.getAudio = function(type, id) {
            var ref, ref1;
            return (ref = _this.musicData) === null || ref === void 0 ? void 0 : (ref1 = ref[type]) === null || ref1 === void 0 ? void 0 : ref1["".concat(id)];
        };
        this.getTourMusic = function() {
            return _this.playList.find(function(el) {
                return el.type.name === MusicObjectKey.TOUR;
            });
        };
        this.setGreenScreenPlaying = function(value) {
            _this.isGreenScreenPlaying = value;
        };
        var _this4 = this;
        this.stopTourMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this4.stopAudioByType(MusicObjectKey.TOUR, false)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this4.stopAudioByType(MusicObjectKey.FLOORS, false)
                        ];
                    case 2:
                        _state.sent();
                        _this4.setTourMusic(true);
                        return [
                            2
                        ];
                }
            });
        });
        this.changeSelectedAudioLoop = function(type, id, value) {
            _this.getAudio(type, id).loop = value;
        };
        this.changeSelectedAudioVolume = function(type, id, value) {
            _this.getAudio(type, id).volume = value;
        };
        this.getFirstMusic = function() {
            return _this.playList[0];
        };
        var _this5 = this;
        this.resumeMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this5.nextMusic()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        var _this6 = this;
        this.pauseAudio = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
                var ref, audio;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            audio = (ref = _this6.playList.find(function(a) {
                                return a.id === "".concat(id);
                            })) === null || ref === void 0 ? void 0 : ref.audio;
                            audio === null || audio === void 0 ? void 0 : audio.pause();
                            if (!(_this6.playList.length > 1)) return [
                                3,
                                2
                            ];
                            _this6.playList.push(_this6.playList.shift());
                            return [
                                4,
                                _this6.nextMusic()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(id) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this7 = this;
        this.resumeAudio = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
                var ref, ref1, ref2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    (ref = _this7.getFirstMusic().audio) === null || ref === void 0 ? void 0 : ref.pause();
                    (ref1 = _this7.playList.find(function(audio) {
                        return audio.id === "".concat(id);
                    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.audio) === null || ref2 === void 0 ? void 0 : ref2.play();
                    return [
                        2
                    ];
                });
            });
            return function(id) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this8 = this;
        this.stopAudioByType = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
                var removeFromPlaylist, skipTourMusic;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            removeFromPlaylist = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                            _this8.setVSAudiosVolume(_this8.volumeValue);
                            _this8.playList.filter(function(el) {
                                return el.type.name === type;
                            }).forEach(function(param) {
                                var audio = param.audio;
                                return audio.pause();
                            });
                            if (removeFromPlaylist) {
                                _this8.playList = _this8.playList.filter(function(el) {
                                    return el.type.name !== type;
                                });
                            }
                            skipTourMusic = type !== MusicObjectKey.SWEEPGROUPS;
                            return [
                                4,
                                _this8.nextMusic(skipTourMusic)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(type) {
                return _ref.apply(this, arguments);
            };
        }();
        this.pauseAllMusic = function() {
            var overridePriority = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            _this.playList.forEach(function(i) {
                if (!i.audio.paused && (i.type.name === MusicObjectKey.TOUR || i.type.name === MusicObjectKey.FLOORS)) {
                    events/* emitter.emit */.u.emit(events/* MittEvents.TOUR_AUDIO_PLAY */.s.TOUR_AUDIO_PLAY, {
                        isTourMusic: false
                    });
                }
                i.audio.pause();
            });
            if (overridePriority) {
                _this.nowPlayingPriorityLevel = _this.lowestPriotiryLevel;
            }
        };
        this.addMusicToVolumeControl = function(el) {
            _this.videosForSoundControl.push(el);
        };
        this.allPlayingVideosAreMuted = function() {
            return !_this.videosForSoundControl.some(function(el) {
                return !el.video.paused && el.video.volume > 0 && !el.video.muted;
            });
        };
        this.muteHandler = function(state) {
            _this.isAllMusicMute = state;
            Object.values(_this.musicData).forEach(function(data) {
                Object.values(data).forEach(function(el) {
                    el.muted = state;
                });
            });
        };
        this.volumeHandler = function(value) {
            if (!value && value !== 0) return;
            _this.volumeValue = value;
            _this.setVSAudiosVolume(value);
            Object.values(_this.musicData).forEach(function(data) {
                Object.values(data).forEach(function(el) {
                    if (value === 0) {
                        el.muted = true;
                    } else {
                        el.volume = value;
                        el.muted = false;
                    }
                });
            });
            clearTimeout(_this.eventDebounceId);
            _this.eventDebounceId = setTimeout(function() {
                events/* emitter.emit */.u.emit(events/* MittEvents.AUDIO_VOLUME */.s.AUDIO_VOLUME, {
                    volumeValue: _this.volumeValue
                });
            }, 500);
        };
        this.tourHasAudio = function() {
            return Object.keys(_this.musicData).length > 0 || _this.videosForSoundControl.length > 0;
        };
        this.clearPlayListQueue = function() {
            _this.playList.forEach(function(el) {
                if (el.type.name !== MusicObjectKey.TOUR && el.type.name !== MusicObjectKey.FLOORS) {
                    var ref;
                    var audio = _this.getAudio(el.type.name, el.id);
                    if (!audio) return;
                    audio.pause();
                    audio.currentTime = 0;
                    _this.removeAudioFromPlayList(el === null || el === void 0 ? void 0 : (ref = el.type) === null || ref === void 0 ? void 0 : ref.name, el === null || el === void 0 ? void 0 : el.id);
                }
            });
        };
        var _this9 = this;
        this.playAudio = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var _type, type, priority, id, audios, audioIdsForOtherTours, playListAudio, isTourMusic, err, index;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _type = data.type, type = _type.name, priority = _type.priority, id = data.id;
                            if (!_this9.getAudio(type, id) || _this9.isPlaying(id)) {
                                return [
                                    2
                                ];
                            }
                            if (type === MusicObjectKey.TOUR) {
                                audios = _this9.getAudioByType(type);
                                audioIdsForOtherTours = Object.keys(audios).filter(function(audioId) {
                                    return audioId !== id;
                                });
                                audioIdsForOtherTours.forEach(function(audioId) {
                                    return _this9.removeAudioFromPlayList(MusicObjectKey.TOUR, audioId);
                                });
                            }
                            playListAudio = {
                                id: "".concat(id),
                                audio: _this9.getAudio(type, id),
                                priority: priority,
                                type: data.type
                            };
                            if (!(_this9.nowPlayingPriorityLevel >= priority || !_this9.nowPlayingPriorityLevel)) return [
                                3,
                                5
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                2,
                                ,
                                4
                            ]);
                            isTourMusic = type === MusicObjectKey.TOUR || type === MusicObjectKey.FLOORS;
                            events/* emitter.emit */.u.emit(events/* MittEvents.TOUR_AUDIO_PLAY */.s.TOUR_AUDIO_PLAY, {
                                isTourMusic: isTourMusic
                            });
                            if (isTourMusic) {
                                _this9.isTourAudioPaused = false;
                            }
                            _this9.nowPlayingPriorityLevel = priority;
                            if (type === MusicObjectKey.SWEEPGROUPS) {
                                _this9.removeDuplicatedAudio(playListAudio.id, MusicObjectKey.SWEEPGROUPS);
                            } else {
                                _this9.removeDuplicatedAudio(playListAudio.id);
                            }
                            _this9.startPlay(_this9.getAudio(type, id), 0);
                            _this9.clearPlayListQueue();
                            _this9.playList.unshift(playListAudio);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            err = _state.sent();
                            return [
                                4,
                                _this9.repeatMusicCall(type, "".concat(id))
                            ];
                        case 3:
                            _state.sent();
                            if (!_this9.getAudio(type, id).paused) {
                                console.error("Can't play ".concat(type, " audio. Message: ").concat(err));
                            } else {
                                _this9.pauseAllMusic();
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                        case 5:
                            index = _this9.playList.findIndex(function(el) {
                                return el.priority > priority;
                            });
                            _this9.removeDuplicatedAudio(playListAudio.id);
                            if (index) {
                                _this9.playList.splice(index - 1, 0, playListAudio);
                            } else {
                                _this9.playList.push(playListAudio);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        this.urlHandling = function(type, data) {
            var src;
            var awsUrl = "https://cdn.treedis.com";
            switch(type){
                case MusicObjectKey.POLYGONS:
                    if (data.url && data.actionType === Polygon/* PolygonActionType.Music */.zS.Music) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/polygons/").concat(data.url);
                    }
                    break;
                case MusicObjectKey.PANORAMAS:
                    if (data.url) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/panoramas/").concat(data.panoramaUrl, "/").concat(data.url);
                    }
                    break;
                case MusicObjectKey.TAGS:
                    if (data.url && data.type === Tag/* TagType.Music */.Qy.Music) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/tags/").concat(data.url);
                    }
                    break;
                case MusicObjectKey.TOUR:
                    src = "".concat(awsUrl, "/tours/").concat(data.id, "/music.mp3").concat(util_all/* getVersion */.bo(data.updatedAt));
                    break;
                case MusicObjectKey.FLOORS:
                    if (data.url) {
                        src = "".concat(data.url);
                    }
                    break;
                case MusicObjectKey.SWEEPGROUPS:
                    if (data.music) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/sweeps/").concat(data.music);
                    }
                    break;
                case MusicObjectKey.VSIMAGES:
                    if (data.actionURL && data.actionType === VSObject/* TourActionType.Music */.mI.Music) {
                        if (data.actionURL.toString().includes("http")) {
                            src = data.actionURL.toString();
                        } else {
                            src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/vsimages/").concat(data.actionURL);
                        }
                    }
                    break;
                case MusicObjectKey.BUTTON:
                    if (data.buttonSoundUrl) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/game/").concat(data.id, "/").concat(data.buttonSoundUrl);
                    }
                    break;
                case MusicObjectKey.GAME_SELECTED_AUDIO:
                    if (data.sound) {
                        src = "".concat("https://cdn.treedis.com", "/games/").concat(data.gameId, "/locks/").concat(data.id, "/").concat(data.sound);
                    }
                    break;
                default:
                    break;
            }
            return src;
        };
        var _this10 = this;
        this.createAudioStream = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type, data) {
                var objectId, src, isValid, audioObject;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            objectId = data.id.toString();
                            if (_this10.getAudio(type, objectId)) return [
                                2
                            ];
                            src = _this10.urlHandling(type, data);
                            return [
                                4,
                                utils_isValidUrl(src)
                            ];
                        case 1:
                            isValid = _state.sent();
                            if (isValid) {
                                audioObject = new Audio(src);
                                audioObject.autoplay = false;
                                audioObject.muted = _this10.isAllMusicMute;
                                audioObject.volume = _this10.volumeValue;
                                if (type !== MusicObjectKey.TAGS && type !== MusicObjectKey.PANORAMAS) {
                                    audioObject.addEventListener("ended", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    audioObject.currentTime = 0;
                                                    _this10.removeAudioFromPlayList(type, objectId);
                                                    return [
                                                        4,
                                                        _this10.nextMusic(false, true)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }));
                                }
                                _this10.musicData[type] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this10.getAudioByType(type)), (0,_define_property/* default */.Z)({}, objectId, audioObject));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(type, data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this11 = this;
        this.importAudioData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type, data) {
                var promises;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    promises = data === null || data === void 0 ? void 0 : data.map(function(element) {
                        return _this11.createAudioStream(type, element);
                    }).filter(Boolean);
                    if (promises) return [
                        2,
                        Promise.all(promises)
                    ];
                    return [
                        2,
                        Promise.resolve()
                    ];
                });
            });
            return function(type, data) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AudioModule.prototype;
    _proto.nextMusic = function nextMusic() {
        var skipTourMusic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, setPriorityLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, firstMusicIsTour, music, isMusicTourPlaying, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this.isGreenScreenPlaying || !_this.playList.length) {
                            if (setPriorityLevel) {
                                _this.nowPlayingPriorityLevel = _this.lowestPriotiryLevel;
                            }
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        firstMusicIsTour = ((ref = _this.playList[0]) === null || ref === void 0 ? void 0 : ref.type.name) === MusicObjectKey.TOUR;
                        music = skipTourMusic && firstMusicIsTour ? _this.playList[1] : _this.playList[0];
                        if (!music) return [
                            2
                        ];
                        return [
                            4,
                            _this.repeatNextMusicCall(music.audio)
                        ];
                    case 2:
                        _state.sent();
                        if (music.type.name === MusicObjectKey.TOUR) {
                            _this.isTourAudioPaused = false;
                            isMusicTourPlaying = !music.audio.paused;
                            if (isMusicTourPlaying) {
                                events/* emitter.emit */.u.emit(events/* MittEvents.TOUR_AUDIO_PLAY */.s.TOUR_AUDIO_PLAY, {
                                    isTourMusic: true
                                });
                            }
                        }
                        _this.nowPlayingPriorityLevel = music.priority;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        console.error("Can't play next music. Message: ".concat(err));
                        _this.playList.shift();
                        return [
                            4,
                            _this.nextMusic()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    AudioModule.getInstance = function getInstance() {
        if (!AudioModule.instance) {
            AudioModule.instance = new AudioModule();
        }
        return AudioModule.instance;
    };
    return AudioModule;
}();


/***/ }),

/***/ 40803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ EBottomBarActiveItem; }
/* harmony export */ });
var EBottomBarActiveItem;
(function(EBottomBarActiveItem) {
    EBottomBarActiveItem["cart"] = "quickCart";
    EBottomBarActiveItem["favourite"] = "favorites";
    EBottomBarActiveItem["nearestProducts"] = "itemNearMe";
    EBottomBarActiveItem["reels"] = "reel";
})(EBottomBarActiveItem || (EBottomBarActiveItem = {}));


/***/ }),

/***/ 18375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _paypal_react_paypal_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75021);
/* harmony import */ var _helpers_renderDebug__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66725);




var PayPalPaymentButton = function(param) {
    var clientPaypalId = param.clientPaypalId, currency = param.currency, onApprove = param.onApprove, createOrder = param.createOrder, onError = param.onError;
    if (!clientPaypalId) return null;
    (0,_helpers_renderDebug__WEBPACK_IMPORTED_MODULE_3__/* .dLog */ .a)("PayPalPaymentButton");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_paypal_react_paypal_js__WEBPACK_IMPORTED_MODULE_2__/* .PayPalScriptProvider */ .Vv, {
        options: {
            clientId: clientPaypalId,
            currency: currency
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_paypal_react_paypal_js__WEBPACK_IMPORTED_MODULE_2__/* .PayPalButtons */ .ch, {
            style: {
                color: "silver"
            },
            createOrder: createOrder,
            onApprove: onApprove,
            onError: onError
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(PayPalPaymentButton));


/***/ }),

/***/ 83065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ActionTypes; },
/* harmony export */   "n": function() { return /* binding */ ClickAssetTypes; }
/* harmony export */ });
var ActionTypes;
(function(ActionTypes) {
    ActionTypes["DELAY"] = "delay";
    ActionTypes["DELAY_FLOWBAR"] = "delay_flowbar";
    ActionTypes["SHOW_ASSET"] = "show_asset";
    ActionTypes["HIDE_ASSET"] = "hide_asset";
    ActionTypes["SHOW_SWEEP"] = "show_sweep";
    ActionTypes["HIDE_SWEEP"] = "hide_sweep";
    ActionTypes["POSITION_TO"] = "position_to";
})(ActionTypes || (ActionTypes = {}));
var ClickAssetTypes;
(function(ClickAssetTypes) {
    ClickAssetTypes["Polygon"] = "polygon";
    ClickAssetTypes["Tag"] = "tag";
    ClickAssetTypes["Image"] = "image";
    ClickAssetTypes["Video"] = "video";
    ClickAssetTypes["HTML"] = "html";
    ClickAssetTypes["VsObject"] = "vsObject";
    ClickAssetTypes["Button"] = "button";
})(ClickAssetTypes || (ClickAssetTypes = {}));


/***/ }),

/***/ 22932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getClosestSweepFromObject; }
/* harmony export */ });
/* harmony import */ var _utils_getDistance__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7926);

var getClosestSweepFromObject = function(param) {
    var allSweeps = param.allSweeps, target = param.target;
    var targetPosition = {
        x: target.positionX,
        y: target.positionY,
        z: target.positionZ
    };
    var closestSweep;
    var closestDistance = Infinity;
    allSweeps.forEach(function(sweep) {
        // We check if sweep floor undefined or target and sweep floor are the same
        if (sweep.floor === undefined || target.floor === undefined || sweep.floor === target.floor) {
            var ref;
            var sweepPosition = {
                x: sweep.positionX,
                y: sweep.positionY,
                z: sweep.positionZ
            };
            var distance = (0,_utils_getDistance__WEBPACK_IMPORTED_MODULE_0__/* .getDistance */ .Sp)(sweepPosition, targetPosition);
            if ((closestDistance === null || distance < closestDistance) && (sweep === null || sweep === void 0 ? void 0 : (ref = sweep.neighbourSweeps) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                closestSweep = sweep;
                closestDistance = distance;
            }
        }
    });
    return {
        closestSweep: closestSweep,
        closestDistance: closestDistance
    };
};


/***/ }),

/***/ 92867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ DetailedRoutes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2804);
/* harmony import */ var _components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25467);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70989);
/* harmony import */ var _components_navigation_search_bar_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9313);







var directionIconsMap = {
    left: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__/* .TurnLeftIcon */ .ep, {}),
    right: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__/* .TurnRightIcon */ .kv, {})
};
var teleportIconsMap = {
    elevator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__/* .ElevatorIcon */ .uz, {}),
    stairway: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__/* .StairsIcon */ .X9, {})
};
var DetailedRoutes = function(param) {
    var setNavigationDestination = param.setNavigationDestination, item = param.item, isPreload = param.isPreload, detailedRoutes = param.detailedRoutes, startingPoint = param.startingPoint, showDetailedRoutesOnly = param.showDetailedRoutesOnly, rtl = param.rtl, navigationType = param.navigationType, showCaseTemp = param.showCaseTemp;
    var ref, ref1, ref2;
    var stackRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var routeRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({});
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOverflowing = ref3[0], setIsOverflowing = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isAtTop = ref4[0], setIsAtTop = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), highlightedItem = ref5[0], setHighlightedItem = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), waitingItem = ref6[0], setWaitingItem = ref6[1];
    var translation = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_4__/* .navigationTranslationState */ .w);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isPreload) {
            var navType = navigationType || "shortest";
            setNavigationDestination(item, navType, isPreload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        item,
        isPreload,
        startingPoint,
        navigationType
    ]);
    var renderRouteDetails = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(route, index) {
        if (index === 0) {
            var ref, ref1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        width: "24px",
                        height: "24px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__/* .RouteStartIcon */ .hr, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        fontFamily: "Inter",
                        whiteSpace: "break-spaces",
                        textOverflow: "ellipsis",
                        sx: {
                            wordBreak: "break-word",
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navStartAt) || "Start at",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: (0,_components_navigation_search_bar_util__WEBPACK_IMPORTED_MODULE_5__/* .trimDescription */ .FR)((route === null || route === void 0 ? void 0 : (ref = route.tag) === null || ref === void 0 ? void 0 : ref.title) || (route === null || route === void 0 ? void 0 : (ref1 = route.station) === null || ref1 === void 0 ? void 0 : ref1.title) || (route === null || route === void 0 ? void 0 : route.title) || (route === null || route === void 0 ? void 0 : route.name), 50)
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (route.turn) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        width: "24px",
                        height: "24px",
                        children: directionIconsMap[route.turn]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        sx: {
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                " ",
                                route.distance,
                                "m ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                (translation === null || translation === void 0 ? void 0 : translation.navThen) || "Then",
                                " ",
                                (translation === null || translation === void 0 ? void 0 : translation.navTurn) || "turn",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: route.turn === "left" ? "".concat((translation === null || translation === void 0 ? void 0 : translation.navLeft) || route.turn) : "".concat((translation === null || translation === void 0 ? void 0 : translation.navRight) || route.turn)
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (!!(route === null || route === void 0 ? void 0 : route.tpGroupStart) && !!(route === null || route === void 0 ? void 0 : route.tpGroupEnd)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        width: "24px",
                        height: "24px",
                        children: teleportIconsMap[route.tpGroupStart.type]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        sx: {
                            direction: rtl ? "rtl" : ""
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                    " ",
                                    route.distance,
                                    "m ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    (translation === null || translation === void 0 ? void 0 : translation.navThen) || "Then",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                        children: [
                                            route.tpGroupStart.type === "elevator" ? (translation === null || translation === void 0 ? void 0 : translation.navEnterToTheElevator) || "enter elevator" : (translation === null || translation === void 0 ? void 0 : translation.navTakeTheStairs) || "take stairs",
                                            ","
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    route.tpGroupStart.type === "elevator" ? (translation === null || translation === void 0 ? void 0 : translation.navSelect) || "Select" : "Go to",
                                    " ",
                                    route.tpGroupEnd.name,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: route.tpGroupEnd.turn && ", ".concat((translation === null || translation === void 0 ? void 0 : translation.navTurn) || "exit", " ").concat(route.tpGroupEnd.turn === "left" ? (translation === null || translation === void 0 ? void 0 : translation.navLeft) || route.tpGroupEnd.turn : (translation === null || translation === void 0 ? void 0 : translation.navRight) || route.tpGroupEnd.turn)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        if (route.isMandatory) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        width: "24px",
                        height: "24px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__/* .StraightArrowIcon */ .U4, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        fontFamily: "Inter",
                        whiteSpace: "break-spaces",
                        textOverflow: "ellipsis",
                        sx: {
                            wordBreak: "break-word",
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                " ",
                                route.distance,
                                "m ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                (translation === null || translation === void 0 ? void 0 : translation.navThen) || "Then",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                    children: [
                                        (translation === null || translation === void 0 ? void 0 : translation.navProceedStraightAt) || "proceed straight at",
                                        " ",
                                        (0,_components_navigation_search_bar_util__WEBPACK_IMPORTED_MODULE_5__/* .trimDescription */ .FR)((route === null || route === void 0 ? void 0 : route.title) || (route === null || route === void 0 ? void 0 : route.name), 50)
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (route.isFinish) {
            var ref2;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        width: "24px",
                        height: "24px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_icons_Icons__WEBPACK_IMPORTED_MODULE_3__/* .DestinationIcon */ .sF, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        fontFamily: "Inter",
                        whiteSpace: "break-spaces",
                        textOverflow: "ellipsis",
                        sx: {
                            wordBreak: "break-word",
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                " ",
                                route.distance,
                                "m ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                    children: [
                                        (translation === null || translation === void 0 ? void 0 : translation.navYouHaveReached) || "You have reached",
                                        " ",
                                        (0,_components_navigation_search_bar_util__WEBPACK_IMPORTED_MODULE_5__/* .trimDescription */ .FR)((route === null || route === void 0 ? void 0 : (ref2 = route.station) === null || ref2 === void 0 ? void 0 : ref2.title) || (route === null || route === void 0 ? void 0 : route.title), 50)
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        }
        return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var checkOverflow = function() {
            if (stackRef.current) {
                var _current = stackRef.current, scrollHeight = _current.scrollHeight, clientHeight = _current.clientHeight;
                setIsOverflowing(scrollHeight > clientHeight);
            }
        };
        if ((detailedRoutes === null || detailedRoutes === void 0 ? void 0 : detailedRoutes.length) > 0 || showDetailedRoutesOnly) {
            setTimeout(function() {
                checkOverflow();
            }, 1000);
        }
        window.addEventListener("resize", checkOverflow);
        return function() {
            return window.removeEventListener("resize", checkOverflow);
        };
    }, [
        detailedRoutes === null || detailedRoutes === void 0 ? void 0 : detailedRoutes.length,
        showDetailedRoutesOnly
    ]);
    var scrollToBottom = function() {
        if (stackRef.current) {
            stackRef.current.scrollTo({
                top: stackRef.current.scrollHeight,
                behavior: "smooth"
            });
        }
    };
    var handleScroll = function() {
        if (stackRef.current) {
            var scrollTop = stackRef.current.scrollTop;
            setIsAtTop(scrollTop === 0);
        }
        if (stackRef.current) {
            clearTimeout(stackRef.current.timeout);
        }
    };
    showCaseTemp === null || showCaseTemp === void 0 ? void 0 : (ref = showCaseTemp.showcase) === null || ref === void 0 ? void 0 : (ref1 = ref.Sweep) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.subscribe(function(currentSweep) {
        if (!(currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || !(detailedRoutes === null || detailedRoutes === void 0 ? void 0 : detailedRoutes.length)) return;
        var foundItem = detailedRoutes.find(function(r) {
            var ref, ref1;
            return r.id === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || (r === null || r === void 0 ? void 0 : (ref = r.tpGroupEnd) === null || ref === void 0 ? void 0 : ref.sweep) === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || (r === null || r === void 0 ? void 0 : (ref1 = r.tpGroupStart) === null || ref1 === void 0 ? void 0 : ref1.sweep) === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id);
        });
        if (foundItem) {
            var foundItemIndex = detailedRoutes.findIndex(function(r) {
                return r.id === foundItem.id;
            });
            var nextWaitingItem = detailedRoutes[foundItemIndex + 1];
            setHighlightedItem(foundItem);
            setWaitingItem(nextWaitingItem);
        } else {
            var highlightedItemIndex = detailedRoutes.findIndex(function(r) {
                return r.id === (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.id);
            });
            var nextItem = detailedRoutes[highlightedItemIndex + 1];
            // Only update if the next item is not already highlighted
            if (nextItem && (nextItem === null || nextItem === void 0 ? void 0 : nextItem.id) === (waitingItem === null || waitingItem === void 0 ? void 0 : waitingItem.id)) {
                setHighlightedItem(nextItem);
            }
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.id) && routeRefs.current[highlightedItem.id]) {
            routeRefs.current[highlightedItem.id].scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    }, [
        highlightedItem
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        id: "detailed-routes-wrapper",
        ref: stackRef,
        onScroll: handleScroll,
        sx: {
            borderTop: "1px solid #EAECF0",
            p: "14px",
            alignItems: "center",
            maxHeight: showDetailedRoutesOnly ? "100%" : "486px",
            overflowY: "auto",
            position: "relative",
            "&::-webkit-scrollbar": {
                background: "transparent"
            },
            "&::-webkit-scrollbar-thumb": {
                width: "0px",
                backgroundColor: "transparent",
                display: "none"
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent"
            },
            direction: rtl ? "rtl" : "ltr"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                fontSize: "16px",
                fontWeight: "400",
                fontFamily: "Inter",
                textAlign: "start",
                width: "100%",
                sx: {
                    mb: "11px",
                    direction: rtl ? "rtl" : ""
                },
                children: translation.navDetailedRoute || "Detailed route"
            }),
            (detailedRoutes === null || detailedRoutes === void 0 ? void 0 : detailedRoutes.length) > 0 ? detailedRoutes.map(function(route, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    ref: function(el) {
                        routeRefs.current[route.id] = el;
                    },
                    direction: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    sx: {
                        mb: "10px",
                        borderRadius: "8px",
                        border: "1px solid #EAECF0",
                        background: (route === null || route === void 0 ? void 0 : route.id) && (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.id) && route.id === highlightedItem.id || !highlightedItem && i === 0 ? "#EAECF0" : "#FFF",
                        p: "14px",
                        width: "100%",
                        gap: "10px"
                    },
                    children: renderRouteDetails(route, i)
                }, i);
            }) : Array.from({
                length: 4
            }).map(function(_, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    sx: {
                        mb: "10px",
                        borderRadius: "8px",
                        border: "1px solid #EAECF0",
                        background: "#FFF",
                        p: "14px",
                        width: "100%",
                        gap: "10px"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        height: 24,
                        width: 311
                    })
                }, i);
            }),
            isOverflowing && isAtTop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                sx: {
                    background: " linear-gradient(180deg, rgba(237, 237, 237, 0.00) 33.33%, #EDEDED 100%)",
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: {
                        xs: "100%",
                        sm: "340px"
                    },
                    height: "88px",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    pb: "10px",
                    borderRadius: "0px 0px 8px 14px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    onClick: scrollToBottom,
                    startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-arrow-down",
                        style: {
                            fontSize: "12px",
                            margin: 0
                        }
                    }),
                    sx: {
                        color: "#344054",
                        p: "4px 10px 4px 12px",
                        borderRadius: "16px",
                        border: "1px solid #EAECF0",
                        background: "#F9FAFB",
                        "&:hover": {
                            background: "#F9FAFB",
                            color: "#344054"
                        }
                    },
                    children: (translation === null || translation === void 0 ? void 0 : translation.navViewMore) || "View more"
                })
            })
        ]
    });
};


/***/ }),

/***/ 96665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BE": function() { return /* binding */ SmartphoneIcon; },
/* harmony export */   "S3": function() { return /* binding */ CornerUpRitghtIcon; },
/* harmony export */   "Sr": function() { return /* binding */ StationIcon; },
/* harmony export */   "U6": function() { return /* binding */ FlagIcon; },
/* harmony export */   "VC": function() { return /* binding */ DefaultTagIcon; },
/* harmony export */   "W1": function() { return /* binding */ SearchIcon; },
/* harmony export */   "X9": function() { return /* binding */ StairsIcon; },
/* harmony export */   "YA": function() { return /* binding */ DotsIcon; },
/* harmony export */   "_t": function() { return /* binding */ LocationIcon; },
/* harmony export */   "aM": function() { return /* binding */ CrossIcon; },
/* harmony export */   "bB": function() { return /* binding */ RedCircleIcon; },
/* harmony export */   "du": function() { return /* binding */ DefaultCategoryIcon; },
/* harmony export */   "fz": function() { return /* binding */ SortIcon; },
/* harmony export */   "jE": function() { return /* binding */ SendIcon; },
/* harmony export */   "k1": function() { return /* binding */ FilterIcon; },
/* harmony export */   "lu": function() { return /* binding */ FinishIcon; },
/* harmony export */   "o1": function() { return /* binding */ PlayIcon; },
/* harmony export */   "qW": function() { return /* binding */ PhoneIcon; },
/* harmony export */   "uz": function() { return /* binding */ ElevatorIcon; },
/* harmony export */   "wy": function() { return /* binding */ ChevronLeftIcon; }
/* harmony export */ });
/* unused harmony exports AccessibleIcon, FootprintIcon, LightningBoltIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var AccessibleIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ _jsx("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.3286 5.83333C13.6583 5.83333 13.9805 5.73559 14.2546 5.55245C14.5287 5.36931 14.7423 5.10902 14.8684 4.80447C14.9946 4.49993 15.0276 4.16482 14.9633 3.84152C14.899 3.51822 14.7402 3.22124 14.5071 2.98816C14.2741 2.75507 13.9771 2.59633 13.6538 2.53203C13.3305 2.46772 12.9954 2.50072 12.6908 2.62687C12.3863 2.75301 12.126 2.96664 11.9428 3.24072C11.7597 3.5148 11.662 3.83703 11.662 4.16667C11.662 4.60869 11.8376 5.03262 12.1501 5.34518C12.4627 5.65774 12.8866 5.83333 13.3286 5.83333ZM10.5786 15.3333C10.2446 15.7707 9.80752 16.1185 9.30636 16.3458C8.80519 16.5731 8.25555 16.6728 7.70648 16.636C7.15741 16.5992 6.62599 16.427 6.15967 16.1348C5.69334 15.8426 5.30661 15.4395 5.03398 14.9615C4.76136 14.4835 4.61132 13.9454 4.59727 13.3953C4.58322 12.8451 4.70558 12.3001 4.95345 11.8088C5.20131 11.3174 5.56696 10.8951 6.01776 10.5795C6.46856 10.2639 6.99049 10.0648 7.53696 10C7.75797 9.97569 7.96028 9.86458 8.09937 9.6911C8.23846 9.51763 8.30294 9.29601 8.27863 9.075C8.25432 8.85399 8.1432 8.65168 7.96973 8.51259C7.79626 8.3735 7.57464 8.30902 7.35363 8.33333C6.02754 8.40737 4.78519 9.00516 3.89986 9.9952C3.01453 10.9852 2.55875 12.2864 2.63279 13.6125C2.70683 14.9386 3.30463 16.1809 4.29466 17.0663C5.2847 17.9516 6.58588 18.4074 7.91196 18.3333C8.68819 18.3333 9.45375 18.1526 10.148 17.8055C10.8423 17.4583 11.4462 16.9543 11.912 16.3333C12.0446 16.1565 12.1015 15.9343 12.0703 15.7155C12.039 15.4967 11.9221 15.2993 11.7453 15.1667C11.5685 15.0341 11.3462 14.9771 11.1274 15.0084C10.9087 15.0396 10.7112 15.1565 10.5786 15.3333ZM16.2453 16.6667H15.412V12.5C15.412 12.279 15.3242 12.067 15.1679 11.9107C15.0116 11.7545 14.7996 11.6667 14.5786 11.6667H10.7703L12.1786 7.78333C12.1786 7.78333 12.1786 7.725 12.1786 7.69167V7.525C12.1827 7.47508 12.1827 7.42492 12.1786 7.375C12.1834 7.32233 12.1834 7.26934 12.1786 7.21667C12.1569 7.16778 12.1318 7.12045 12.1036 7.075C12.0786 7.02955 12.0478 6.98753 12.012 6.95C11.9762 6.90761 11.934 6.87106 11.887 6.84167C11.887 6.84167 11.887 6.79167 11.8203 6.775L8.08696 4.625H7.98696C7.93587 4.6034 7.88286 4.58666 7.82863 4.575H7.49529C7.4374 4.58697 7.38135 4.60659 7.32863 4.63333H7.23696L4.99529 5.94167C4.83598 6.03192 4.71082 6.17214 4.63917 6.34064C4.56751 6.50915 4.55336 6.69657 4.59888 6.87392C4.64441 7.05128 4.74708 7.20871 4.89103 7.32187C5.03498 7.43504 5.2122 7.49764 5.39529 7.5C5.54691 7.50399 5.69673 7.46654 5.82863 7.39167L7.68696 6.30833L10.387 7.875L8.81196 12.2167C8.80791 12.261 8.80791 12.3056 8.81196 12.35C8.80415 12.3997 8.80415 12.4503 8.81196 12.5C8.82732 12.6069 8.84959 12.7127 8.87863 12.8167L8.97029 12.9417C8.993 12.991 9.024 13.0361 9.06196 13.075C9.09758 13.1048 9.13677 13.1299 9.17863 13.15C9.22822 13.1881 9.28122 13.2216 9.33696 13.25C9.42779 13.283 9.52367 13.2999 9.62029 13.3H13.787V17.4667C13.787 17.6877 13.8748 17.8996 14.031 18.0559C14.1873 18.2122 14.3993 18.3 14.6203 18.3H16.287C16.508 18.3 16.7199 18.2122 16.8762 18.0559C17.0325 17.8996 17.1203 17.6877 17.1203 17.4667C17.1203 17.2457 17.0325 17.0337 16.8762 16.8774C16.7199 16.7211 16.508 16.6333 16.287 16.6333L16.2453 16.6667Z",
            fill: "#667085"
        })
    });
};
var FootprintIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_3207_171122)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M3.33854 14.9993H7.92187V16.041C7.92187 16.6488 7.68043 17.2317 7.25066 17.6615C6.82089 18.0912 6.238 18.3327 5.63021 18.3327C5.02242 18.3327 4.43953 18.0912 4.00976 17.6615C3.57998 17.2317 3.33854 16.6488 3.33854 16.041V14.9993ZM6.72021 11.666L6.75771 11.556C7.39687 9.801 7.50521 9.47433 7.50521 9.166C7.50521 8.541 7.33604 7.79683 7.06521 7.27183C6.86354 6.88017 6.72187 6.766 6.67187 6.766C5.60521 6.766 4.58854 7.90267 4.58854 9.166C4.58854 9.96517 4.65104 10.6435 4.77771 11.4643L4.80937 11.666H6.72021ZM6.67187 5.09933C8.33854 5.09933 9.17187 7.49933 9.17187 9.166C9.17187 9.99933 8.75521 10.8327 8.33854 12.0827L7.92187 13.3327H3.33854C3.33854 12.4993 2.92188 11.2493 2.92188 9.166C2.92188 7.08267 4.58687 5.09933 6.67187 5.09933ZM16.7169 11.7477L16.536 12.7735C16.4305 13.3721 16.0915 13.9043 15.5936 14.253C15.0957 14.6016 14.4797 14.7382 13.881 14.6327C13.2824 14.5271 12.7503 14.1881 12.4016 13.6902C12.0529 13.1923 11.9163 12.5763 12.0219 11.9777L12.2035 10.9527L16.7169 11.7477ZM15.8419 8.20933C15.9794 7.79267 16.0927 7.4635 16.0944 7.45933C16.2627 6.911 16.3952 6.3735 16.4985 5.786C16.7177 4.54267 15.9135 3.24683 14.8635 3.061C14.8144 3.05267 14.6552 3.14017 14.3885 3.49017C14.0302 3.961 13.7352 4.66517 13.626 5.27933C13.5777 5.55433 13.5852 5.61683 13.851 7.16517C13.8885 7.3785 13.9194 7.57017 13.9477 7.76267L13.9644 7.87767L15.8419 8.20933ZM15.1535 1.42017C17.2069 1.78183 18.5019 4.0235 18.1402 6.07517C17.7785 8.12767 17.151 9.286 17.0069 10.1068L12.4927 9.311L12.2994 8.00767C12.106 6.70433 11.841 5.811 11.9852 4.991C12.2744 3.34933 13.5119 1.131 15.1535 1.42017Z",
                    fill: "#667085"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_3207_171122",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var LightningBoltIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ _jsx("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.7164 9.397L9.04973 2.73033C9.12032 2.58917 9.26457 2.5 9.4224 2.5H14.198C14.5351 2.5 14.7326 2.87945 14.5393 3.15561L12.5405 6.01106C12.3471 6.28722 12.5447 6.66667 12.8818 6.66667H14.0923C14.4483 6.66667 14.6403 7.08422 14.4086 7.3545L6.63621 16.4223C6.32959 16.7801 5.75801 16.4339 5.93298 15.9964L8.103 10.5714C8.21247 10.2977 8.01092 10 7.71613 10H6.08908C5.77934 10 5.57788 9.674 5.7164 9.397Z",
            stroke: "#2055FF",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            fill: "none"
        })
    });
};
var ChevronLeftIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.6603 17.1704L9.26969 12.5067C9.13546 12.3648 9.06836 12.1827 9.06836 12.0005C9.06836 11.8183 9.13549 11.636 9.26969 11.4942L13.6603 6.8306C13.9402 6.53529 14.4061 6.52286 14.7013 6.80184C14.9985 7.08181 15.009 7.54986 14.7301 7.84318L10.7905 12.0006L14.7301 16.158C15.0091 16.4513 14.9985 16.9173 14.7013 17.1993C14.4089 17.4772 13.9425 17.4649 13.6603 17.1704Z",
            fill: "black"
        })
    });
};
var CrossIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18 6L6 18M6 6L18 18",
            stroke: "#101828",
            strokeWidth: "1.45455",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var CornerUpRitghtIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.5026 11.6673L16.6693 7.50065M16.6693 7.50065L12.5026 3.33398M16.6693 7.50065H6.66927C5.78522 7.50065 4.93737 7.85184 4.31225 8.47696C3.68713 9.10208 3.33594 9.94993 3.33594 10.834V16.6673",
            stroke: "white",
            strokeWidth: "1.92",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var SmartphoneIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.4974 14.9993H10.5057M6.33073 1.66602H14.6641C15.5845 1.66602 16.3307 2.41221 16.3307 3.33268V16.666C16.3307 17.5865 15.5845 18.3327 14.6641 18.3327H6.33073C5.41025 18.3327 4.66406 17.5865 4.66406 16.666V3.33268C4.66406 2.41221 5.41025 1.66602 6.33073 1.66602Z",
            stroke: "#2055FF",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var FlagIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                y: "0.0234375",
                width: "30",
                height: "30",
                rx: "6",
                fill: "#EAF0FF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10 16.8984C10 16.8984 10.625 16.2734 12.5 16.2734C14.375 16.2734 15.625 17.5234 17.5 17.5234C19.375 17.5234 20 16.8984 20 16.8984V9.39844C20 9.39844 19.375 10.0234 17.5 10.0234C15.625 10.0234 14.375 8.77344 12.5 8.77344C10.625 8.77344 10 9.39844 10 9.39844V16.8984ZM10 16.8984V21.2734",
                stroke: "#2055FF",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var RedCircleIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
            cx: "7",
            cy: "7.5",
            r: "5",
            stroke: "#F04438",
            strokeWidth: "4"
        })
    });
};
var DotsIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "2",
                r: "1.5",
                fill: "#70757A"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "1.5",
                fill: "#70757A"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "18",
                r: "1.5",
                fill: "#70757A"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "26",
                r: "1.5",
                fill: "#70757A"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "34",
                r: "1.5",
                fill: "#70757A"
            })
        ]
    });
};
var LocationIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "14",
        height: "19",
        viewBox: "0 0 14 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 7.7C12 9.07161 11.4031 10.451 10.2115 12.0424C9.32895 13.2212 8.23171 14.3774 7 15.6392C5.76829 14.3774 4.67105 13.2212 3.78847 12.0424C2.59688 10.451 2 9.07161 2 7.7C2 4.77464 4.29132 2.5 7 2.5C9.70869 2.5 12 4.77463 12 7.7Z",
            stroke: "#667085",
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var ElevatorIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10 2.5V17.5M10 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H10V2.5ZM10 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H10V2.5Z",
            stroke: "#2055FF",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var StairsIcon = function(param) {
    var style = param.style, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.9506 2.08203C12.3983 2.08203 11.9522 2.52975 11.9522 3.08203V7.08205H7.53553C6.98324 7.08205 6.53553 7.52977 6.53553 8.08205V12.4435C6.53553 12.4435 4.63298 12.4436 1.83662 12.4436C1.28435 12.4436 0.835938 12.8908 0.835938 13.4431C0.835936 14.7835 0.835942 16.8564 0.835942 17.4436L16.9985 17.4435C18.1235 17.4435 19.0355 16.573 19.0355 15.4991V2.08203C14.9834 2.08202 13.5706 2.08202 12.9506 2.08203Z",
            stroke: color,
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var PlayIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.16406 5.43066C4.16406 4.1648 5.56446 3.40025 6.62927 4.08478L13.7371 8.65411C14.7168 9.28393 14.7168 10.7161 13.7371 11.3459L6.62928 15.9152C5.56446 16.5997 4.16406 15.8352 4.16406 14.5693V5.43066Z",
            stroke: "white",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var PhoneIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.4974 15.4993H10.5057M6.33073 2.16602H14.6641C15.5845 2.16602 16.3307 2.91221 16.3307 3.83268V17.166C16.3307 18.0865 15.5845 18.8327 14.6641 18.8327H6.33073C5.41025 18.8327 4.66406 18.0865 4.66406 17.166V3.83268C4.66406 2.91221 5.41025 2.16602 6.33073 2.16602Z",
            stroke: "#2055FF",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var SearchIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19 19L15.1333 15.1333M17.2222 10.1111C17.2222 14.0385 14.0385 17.2222 10.1111 17.2222C6.18375 17.2222 3 14.0385 3 10.1111C3 6.18375 6.18375 3 10.1111 3C14.0385 3 17.2222 6.18375 17.2222 10.1111Z",
            stroke: "#667085",
            strokeWidth: "1.77778",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var FilterIcon = function(param) {
    var style = param.style, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M18.3307 2.5H1.66406L8.33073 10.3833V15.8333L11.6641 17.5V10.3833L18.3307 2.5Z",
            stroke: color,
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var SortIcon = function(param) {
    var style = param.style, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5 10H15M2.5 5H17.5M7.5 15H12.5",
            stroke: color,
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var DefaultTagIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "38",
        height: "39",
        viewBox: "0 0 38 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.791016",
                width: "38",
                height: "38",
                rx: "7.51147",
                fill: "#EAF0FF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.791016",
                width: "38",
                height: "38",
                rx: "7.51147",
                stroke: "#EAF0FF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_7805_13454)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M26.3125 19.291C26.3125 17.3516 25.5421 15.4917 24.1707 14.1203C22.7994 12.7489 20.9394 11.9785 19 11.9785C17.0606 11.9785 15.2006 12.7489 13.8293 14.1203C12.4579 15.4917 11.6875 17.3516 11.6875 19.291C11.6875 21.2304 12.4579 23.0904 13.8293 24.4617C15.2006 25.8331 17.0606 26.6035 19 26.6035C20.9394 26.6035 22.7994 25.8331 24.1707 24.4617C25.5421 23.0904 26.3125 21.2304 26.3125 19.291ZM10 19.291C10 16.9041 10.9482 14.6149 12.636 12.9271C14.3239 11.2392 16.6131 10.291 19 10.291C21.3869 10.291 23.6761 11.2392 25.364 12.9271C27.0518 14.6149 28 16.9041 28 19.291C28 21.678 27.0518 23.9671 25.364 25.655C23.6761 27.3428 21.3869 28.291 19 28.291C16.6131 28.291 14.3239 27.3428 12.636 25.655C10.9482 23.9671 10 21.678 10 19.291ZM19 15.916C19.8951 15.916 20.7536 16.2716 21.3865 16.9045C22.0194 17.5375 22.375 18.3959 22.375 19.291C22.375 20.1861 22.0194 21.0446 21.3865 21.6775C20.7536 22.3104 19.8951 22.666 19 22.666C18.1049 22.666 17.2464 22.3104 16.6135 21.6775C15.9806 21.0446 15.625 20.1861 15.625 19.291C15.625 18.3959 15.9806 17.5375 16.6135 16.9045C17.2464 16.2716 18.1049 15.916 19 15.916Z",
                    fill: "#2055FF"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_7805_13454",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(10 10.291)"
                    })
                })
            })
        ]
    });
};
var StationIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "38",
        height: "38",
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "38",
                height: "38",
                rx: "7.51147",
                fill: "#EAF0FF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "38",
                height: "38",
                rx: "7.51147",
                stroke: "#EAF0FF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.3097 27.0357C24.3097 27.5683 23.878 28 23.3454 28L14.6546 28C14.122 28 13.6903 27.5683 13.6903 27.0357C13.6903 26.5032 14.122 26.0714 14.6546 26.0714L15.9734 26.0714L15.9735 21.2005L12.3628 21.2005C11.0579 21.2005 10 20.2153 10 19L10 12.2005C10 10.9852 11.0579 10 12.3628 10L25.6372 10C26.9421 10 28 10.9852 28 12.2005L28 19C28 20.2153 26.9421 21.2005 25.6372 21.2005L22.0265 21.2005L22.0265 26.0714L23.3454 26.0714C23.878 26.0714 24.3097 26.5032 24.3097 27.0357ZM19.9558 26.0714L19.9558 21.2005L18.0442 21.2005L18.0442 26.0714L19.9558 26.0714ZM25.6372 19.272C25.7985 19.272 25.9292 19.1502 25.9292 19L25.9292 12.2005C25.9292 12.0503 25.7985 11.9286 25.6372 11.9286L12.3628 11.9286C12.2015 11.9286 12.0708 12.0503 12.0708 12.2005L12.0708 19C12.0708 19.1502 12.2015 19.272 12.3628 19.272L25.6372 19.272Z",
                fill: "#2055FF"
            })
        ]
    });
};
var SendIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_8203_23669)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M18.318 8.9668L2.56797 2.21645C2.42523 2.15527 2.27477 2.09375 2.1257 2.09375C1.82255 2.09375 1.52453 2.21676 1.30656 2.44707C0.982482 2.82184 0.907786 3.33125 1.11872 3.75348L4.375 10.0004L1.11883 16.2477C0.907892 16.6702 0.982598 17.1793 1.3067 17.5228C1.52425 17.7529 1.82209 17.8761 2.12514 17.8761C2.27455 17.8761 2.42506 17.8464 2.56776 17.7849L18.318 11.034C18.7321 10.8571 19.0003 10.45 19.0003 10C18.9683 9.55039 18.7328 9.14258 18.318 8.9668ZM3.35265 4.38875L14.4789 9.15664H5.8375L3.35265 4.38875ZM5.8375 10.8441H14.4754L3.35195 15.6113L5.8375 10.8441Z",
                    fill: "#667085"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_8203_23669",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(1 1)"
                    })
                })
            })
        ]
    });
};
var FinishIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "40",
                height: "40",
                rx: "10",
                fill: "#F2F4F7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M29 18C29 25 20 31 20 31C20 31 11 25 11 18C11 15.6131 11.9482 13.3239 13.636 11.636C15.3239 9.94821 17.6131 9 20 9C22.3869 9 24.6761 9.94821 26.364 11.636C28.0518 13.3239 29 15.6131 29 18Z",
                stroke: "#2055FF",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20 21C21.6569 21 23 19.6569 23 18C23 16.3431 21.6569 15 20 15C18.3431 15 17 16.3431 17 18C17 19.6569 18.3431 21 20 21Z",
                stroke: "#2055FF",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var DefaultCategoryIcon = function(param) {
    var style = param.style;
    return(// <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    //   <path d="M18 6L6 18M6 6L18 18" stroke="#101828" strokeWidth="1.45455" strokeLinecap="round" strokeLinejoin="round" />
    // </svg>
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "blood-test-svgrepo-com",
                clipPath: "url(#clip0_7507_32941)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Vector",
                    d: "M10.1989 3.41406H4.33646C4.07732 3.41406 3.82879 3.517 3.64556 3.70024C3.46232 3.88348 3.35938 4.13201 3.35938 4.39114V10.2536C3.35938 10.5128 3.46232 10.7613 3.64556 10.9445C3.82879 11.1278 4.07732 11.2307 4.33646 11.2307H10.1989C10.4581 11.2307 10.7066 11.1278 10.8898 10.9445C11.0731 10.7613 11.176 10.5128 11.176 10.2536V4.39114C11.176 4.13201 11.0731 3.88348 10.8898 3.70024C10.7066 3.517 10.4581 3.41406 10.1989 3.41406ZM9.22187 9.27655H5.31354V5.36823H9.22187V9.27655ZM19.9698 3.41406H14.1073C13.8481 3.41406 13.5996 3.517 13.4164 3.70024C13.2331 3.88348 13.1302 4.13201 13.1302 4.39114V10.2536C13.1302 10.5128 13.2331 10.7613 13.4164 10.9445C13.5996 11.1278 13.8481 11.2307 14.1073 11.2307H19.9698C20.2289 11.2307 20.4774 11.1278 20.6607 10.9445C20.8439 10.7613 20.9468 10.5128 20.9468 10.2536V4.39114C20.9468 4.13201 20.8439 3.88348 20.6607 3.70024C20.4774 3.517 20.2289 3.41406 19.9698 3.41406ZM18.9927 9.27655H15.0844V5.36823H18.9927V9.27655ZM10.1989 13.1849H4.33646C4.07732 13.1849 3.82879 13.2878 3.64556 13.4711C3.46232 13.6543 3.35938 13.9028 3.35938 14.162V20.0245C3.35938 20.2836 3.46232 20.5321 3.64556 20.7154C3.82879 20.8986 4.07732 21.0015 4.33646 21.0015H10.1989C10.4581 21.0015 10.7066 20.8986 10.8898 20.7154C11.0731 20.5321 11.176 20.2836 11.176 20.0245V14.162C11.176 13.9028 11.0731 13.6543 10.8898 13.4711C10.7066 13.2878 10.4581 13.1849 10.1989 13.1849ZM9.22187 19.0474H5.31354V15.139H9.22187V19.0474ZM17.0385 13.1849C14.8831 13.1849 13.1302 14.9378 13.1302 17.0932C13.1302 19.2486 14.8831 21.0015 17.0385 21.0015C19.194 21.0015 20.9468 19.2486 20.9468 17.0932C20.9468 14.9378 19.194 13.1849 17.0385 13.1849ZM17.0385 19.0474C15.9608 19.0474 15.0844 18.1709 15.0844 17.0932C15.0844 16.0155 15.9608 15.139 17.0385 15.139C18.1162 15.139 18.9927 16.0155 18.9927 17.0932C18.9927 18.1709 18.1162 19.0474 17.0385 19.0474Z",
                    fill: style.color || "white"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_7507_32941",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "23.45",
                        height: "23.45",
                        fill: style.color || "white",
                        transform: "translate(0.0859375 0.484375)"
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 32922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ NavigationIntroChoicePopup; },
  "N": function() { return /* binding */ NavigationType; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(67836);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(93481);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./store/atoms/navigation/choicepopup.ts
var choicepopup = __webpack_require__(97514);
// EXTERNAL MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/styles.ts
var styles = __webpack_require__(56101);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/Icons.tsx
var Icons = __webpack_require__(96665);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Menu/Menu.js + 3 modules
var Menu = __webpack_require__(39530);
;// CONCATENATED MODULE: ./components/navigation/search-bar/components/FilterDirectionButton.tsx










var FilterDirectionButton = function(param) {
    var menuItems = param.menuItems, selectedFilters = param.selectedFilters, setSelectedFilters = param.setSelectedFilters;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var open = Boolean(anchorEl);
    var allUniqueFilters = menuItems.reduce(function(acc, item) {
        var filters = item.filters || [];
        if (!filters.length) return acc;
        filters.forEach(function(filter) {
            if (!acc.find(function(accitem) {
                return accitem.id === filter.id;
            })) {
                acc.push(filter);
            }
        });
        return acc;
    }, []);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleToggleSelectedFilters = function(id) {
        setSelectedFilters(function(prevFilters) {
            if (prevFilters.includes(id)) {
                return prevFilters.filter(function(filterId) {
                    return filterId !== id;
                });
            }
            return (0,_to_consumable_array/* default */.Z)(prevFilters).concat([
                id
            ]);
        });
    };
    var resetFilters = function() {
        setSelectedFilters([]);
    };
    return allUniqueFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "filter-button",
                "aria-controls": open ? "filter-menu" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? "true" : undefined,
                variant: "contained",
                disableElevation: true,
                onClick: handleClick,
                sx: {
                    width: "36px",
                    height: "36px",
                    borderRadius: "30px",
                    border: open || selectedFilters.length > 0 ? "1px solid #2055FF" : "1px solid #EAECF0",
                    background: open || selectedFilters.length > 0 ? "rgba(32, 85, 255, 0.06)" : "#FFF",
                    color: open || selectedFilters.length > 0 ? "#2055FF" : "#6B6B6B",
                    minWidth: "0px",
                    "&:hover": {
                        background: "rgba(32, 85, 255, 0.06)",
                        color: open || selectedFilters.length > 0 ? "#2055FF" : "#000"
                    },
                    "&:focus": {
                        border: "1px solid #2055FF",
                        background: "rgba(32, 85, 255, 0.06)"
                    },
                    ".MuiButton-startIcon": {
                        margin: "0px"
                    }
                },
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* FilterIcon */.k1, {
                    style: {
                        width: "20px",
                        height: "20px"
                    },
                    color: "#6B6B6B"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                id: "filter-menu",
                sx: {
                    ".MuiPopover-paper": {
                        width: "404px",
                        borderRadius: "8px",
                        border: "1px solid #EAECF0",
                        mt: "10px"
                    }
                },
                MenuListProps: {
                    "aria-labelledby": "filter-button",
                    sx: {
                        background: "#fff",
                        p: 0
                    }
                },
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    p: "8px 8px 24px 24px",
                    width: "100%",
                    direction: "row",
                    flexWrap: "wrap",
                    sx: {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            width: "100%",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: "16px",
                                    fontWeight: 400,
                                    mb: "10px",
                                    children: (translation === null || translation === void 0 ? void 0 : translation.navFilterBy) || "Filter by"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    gap: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-thin fa-arrow-rotate-left",
                                            onClick: resetFilters,
                                            style: {
                                                cursor: "pointer",
                                                fontSize: "24px",
                                                width: "24px",
                                                height: "24px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-thin fa-xmark",
                                            onClick: handleClose,
                                            style: {
                                                cursor: "pointer",
                                                fontSize: "24px",
                                                width: "24px",
                                                height: "24px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            gap: 1,
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "flexStart",
                            children: allUniqueFilters.map(function(filter) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    disableElevation: true,
                                    sx: {
                                        borderRadius: "8px",
                                        border: selectedFilters.includes(filter.id) ? "1px solid #2055FF" : "1px solid #EAECF0",
                                        color: selectedFilters.includes(filter.id) ? "#2055FF" : "#344054",
                                        background: selectedFilters.includes(filter.id) ? "rgba(32, 85, 255, 0.06)" : "#FFF",
                                        "&:hover": {
                                            background: "rgba(32, 85, 255, 0.06)",
                                            color: selectedFilters.includes(filter.id) ? "#2055FF" : "#344054"
                                        },
                                        "&:focus": {
                                            border: selectedFilters.includes(filter.id) ? "1px solid #2055FF" : "1px solid #EAECF0"
                                        }
                                    },
                                    onClick: function() {
                                        return handleToggleSelectedFilters(filter.id);
                                    },
                                    children: filter.title
                                }, filter.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
;// CONCATENATED MODULE: ./components/navigation/search-bar/components/SortDirrectionButton.tsx








var SortDirectionButton = function(param) {
    var setSortingValue = param.setSortingValue;
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var open = Boolean(anchorEl);
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var sortingValueOptions = (0,react.useMemo)(function() {
        return [
            {
                value: "default",
                label: (translation === null || translation === void 0 ? void 0 : translation.navDefault) || "Default",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-thin fa-sort"
                })
            },
            {
                value: "alphabetical",
                label: (translation === null || translation === void 0 ? void 0 : translation.navAlphabetical) || "A-Z",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-arrow-up-arrow-down",
                    style: {
                        transform: "rotateX(180deg)"
                    }
                })
            },
            {
                value: "reverseAlphabetical",
                label: (translation === null || translation === void 0 ? void 0 : translation.navReverseAlphabetical) || "Z-A",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-arrow-up-arrow-down"
                })
            }, 
        ];
    }, [
        translation === null || translation === void 0 ? void 0 : translation.navAlphabetical,
        translation === null || translation === void 0 ? void 0 : translation.navDefault,
        translation === null || translation === void 0 ? void 0 : translation.navReverseAlphabetical
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "sort-button",
                "aria-controls": open ? "sorting-menu" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? "true" : undefined,
                variant: "contained",
                disableElevation: true,
                onClick: handleClick,
                sx: {
                    width: "36px",
                    height: "36px",
                    borderRadius: "30px",
                    border: open ? "1px solid #2055FF" : "1px solid #EAECF0",
                    background: open ? "rgba(32, 85, 255, 0.06)" : "#FFF",
                    color: open ? "#2055FF" : "#6B6B6B",
                    minWidth: "0px",
                    "&:hover": {
                        background: "rgba(32, 85, 255, 0.06)",
                        color: open ? "#2055FF" : "#000"
                    },
                    "&:focus": {
                        border: "1px solid #2055FF",
                        background: "rgba(32, 85, 255, 0.06)"
                    },
                    ".MuiButton-startIcon": {
                        margin: "0px"
                    }
                },
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SortIcon */.fz, {
                    style: {
                        width: "20px",
                        height: "20px"
                    },
                    color: "#6B6B6B"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                id: "sorting-menu",
                sx: {
                    ".MuiPopover-paper": {
                        width: "203px",
                        borderRadius: "8px",
                        border: "1px solid #EAECF0",
                        mt: "10px"
                    }
                },
                MenuListProps: {
                    "aria-labelledby": "sort-button",
                    sx: {
                        background: "#fff"
                    }
                },
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: sortingValueOptions.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                        onClick: function() {
                            setSortingValue(option.value);
                            handleClose();
                        },
                        sx: {
                            display: "inline-flex",
                            justifyContent: "flex-start",
                            width: "100%",
                            gap: "8px",
                            ":hover": {
                                background: "rgba(32, 85, 255, 0.06)"
                            }
                        },
                        children: [
                            option.icon,
                            option.label
                        ]
                    }, option.value);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/DetailedRoutes.tsx
var DetailedRoutes = __webpack_require__(92867);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(69647);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(91359);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/ActionTooltip.tsx






var ActionTooltip = function(param) {
    var detailedRouteEnabled = param.detailedRouteEnabled, showSearchField = param.showSearchField, sharingPopupOpen = param.sharingPopupOpen, children = param.children, rtl = param.rtl;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    (0,react.useEffect)(function() {
        var timeoutId;
        if (detailedRouteEnabled && !showSearchField && !sharingPopupOpen && !deviceManager/* default.isMobile */.Z.isMobile()) {
            timeoutId = setTimeout(function() {
                setOpen(true);
            }, 3000);
        }
        return function() {
            clearTimeout(timeoutId);
            setOpen(false);
        };
    }, [
        detailedRouteEnabled,
        showSearchField,
        sharingPopupOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        open: open,
        arrow: true,
        placement: "right",
        componentsProps: {
            arrow: {
                sx: {
                    color: "#fff"
                }
            },
            tooltip: {
                sx: {
                    background: "#fff",
                    p: "12px",
                    borderRadius: "8px",
                    gap: "10px",
                    width: "185px"
                }
            }
        },
        PopperProps: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            20
                        ]
                    }
                }
            ]
        },
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            sx: {
                position: "relative",
                background: "#fff"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMedia/* default */.Z, {
                    component: "img",
                    height: "106",
                    image: "/navigation/tooltip.gif" // Replace with your image source
                    ,
                    alt: "Experience your path in 3D"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                    sx: {
                        p: 0,
                        pb: "0 !important",
                        mt: "10px",
                        textAlign: rtl ? "right" : "left",
                        direction: rtl ? "rtl" : "ltr"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#344054",
                                fontSize: "14px",
                                fontWeight: rtl ? 500 : 600,
                                width: "111px",
                                mb: "4px",
                                direction: rtl ? "rtl" : "ltr"
                            },
                            children: translation.navExperience || /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "Experience your ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " path in 3D"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#667085",
                                fontSize: "12px",
                                fontWeight: 400,
                                direction: rtl ? "rtl" : "ltr"
                            },
                            children: translation.navClickStart3DNavigation || "Click start 3D Navigation"
                        })
                    ]
                })
            ]
        }),
        children: children
    });
};

// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
// EXTERNAL MODULE: ./components/navigation/NavigationWrapper.tsx + 29 modules
var NavigationWrapper = __webpack_require__(7984);
// EXTERNAL MODULE: ./components/navigation/search-bar/util.tsx
var search_bar_util = __webpack_require__(9313);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/NavigationIntroChoicePopup.tsx




















var NavigationType;
(function(NavigationType) {
    NavigationType["Shortest"] = "shortest";
    NavigationType["NoElevators"] = "noElevators";
    NavigationType["NoStairs"] = "noStairs";
})(NavigationType || (NavigationType = {}));
var NavigationIntroChoicePopup = function(param) {
    var open = param.open, setOpen = param.setOpen, item = param.item, contentLoaded = param.contentLoaded, loadingProgress = param.loadingProgress, onConfirm = param.onConfirm, onReturn = param.onReturn, rtl = param.rtl, startingPoint = param.startingPoint, onSetFinishPoint = param.onSetFinishPoint, menuItems = param.menuItems, selectedFilters = param.selectedFilters, setSelectedFilters = param.setSelectedFilters, onSetStartingPoint = param.onSetStartingPoint, startSweep = param.startSweep, choicePopupWrapper = param.choicePopupWrapper, choicePopupSearchBar = param.choicePopupSearchBar, choicePopupFilteredBtn = param.choicePopupFilteredBtn, sharingEnabled = param.sharingEnabled, setSharePopupOpen = param.setSharePopupOpen, sharePopupOpen = param.sharePopupOpen, setOpenNavigationSharingPopup = param.setOpenNavigationSharingPopup, setNavigationDestination = param.setNavigationDestination, target = param.target, detailedRoutes = param.detailedRoutes, allSweeps = param.allSweeps, startingPointTitle = param.startingPointTitle, finishPointTitle = param.finishPointTitle, allTags = param.allTags, teleportPoints = param.teleportPoints, selectedNavigationType = param.selectedNavigationType, setSelectedNavigationType = param.setSelectedNavigationType, mobilePosition = param.mobilePosition, navigationType = param.navigationType, filteredItems = param.filteredItems, searchText = param.searchText, setSearchText = param.setSearchText, setSortingValue = param.setSortingValue, setSelectedItem = param.setSelectedItem, setMobilePosition = param.setMobilePosition, tourType = param.tourType;
    var ref = (0,react.useState)(open), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(false), isFinishItems = ref1[0], setIsFinishItems = ref1[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var navigationSettings = (0,recoil/* useRecoilValue */.sJ)(store/* navigationSettingsState */.FZ);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(choicepopup/* showChoicePopupSearchField */.O), 2), showSearchField = ref2[0], setShowSearchField = ref2[1];
    var defaultSorting = navigationSettings.defaultSorting, detailedRouteEnabled = navigationSettings.detailedRouteEnabled;
    var inputRef = (0,react.useRef)(null);
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var elevators = (0,react.useMemo)(function() {
        return teleportPoints.filter(function(tg) {
            var ref;
            return tg.type === NavigationWrapper/* TeleportGroupType.Elevator */.A.Elevator && (tg === null || tg === void 0 ? void 0 : (ref = tg.pointNodes) === null || ref === void 0 ? void 0 : ref.length) > 0;
        }).flatMap(function(tg) {
            return tg.pointNodes;
        });
    }, [
        teleportPoints
    ]);
    var stairs = (0,react.useMemo)(function() {
        return teleportPoints.filter(function(tg) {
            var ref;
            return tg.type === NavigationWrapper/* TeleportGroupType.Stairway */.A.Stairway && (tg === null || tg === void 0 ? void 0 : (ref = tg.pointNodes) === null || ref === void 0 ? void 0 : ref.length) > 0;
        }).flatMap(function(tg) {
            return tg.pointNodes;
        });
    }, [
        teleportPoints
    ]);
    (0,react.useEffect)(function() {
        if (!(elevators === null || elevators === void 0 ? void 0 : elevators.length) && (stairs === null || stairs === void 0 ? void 0 : stairs.length) > 0) {
            setSelectedNavigationType(NavigationType.NoElevators);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        elevators,
        stairs
    ]);
    // eslint-disable-next-line consistent-return
    (0,react.useEffect)(function() {
        if (open) {
            setIsVisible(true);
        } else {
            var timer = setTimeout(function() {
                return setIsVisible(false);
            }, 300);
            return function() {
                return clearTimeout(timer);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    var selectStartItem = function(selectedItem) {
        var startingItem = (0,util/* convertDestinationItemToSweep */.RZ)({
            item: selectedItem,
            allSweeps: Array.from(allSweeps.values()),
            allTags: Array.from(allTags.values())
        });
        onSetStartingPoint(startingItem);
        setShowSearchField(false);
    };
    var selectFinishItem = function(selectedItem) {
        var finishingItem = (0,util/* convertDestinationItemToSweep */.RZ)({
            item: selectedItem,
            allSweeps: Array.from(allSweeps.values()),
            allTags: Array.from(allTags.values())
        });
        onSetFinishPoint(finishingItem);
        setShowSearchField(false);
        setIsFinishItems(false);
    };
    (0,react.useEffect)(function() {
        if (defaultSorting) {
            setSortingValue(defaultSorting);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultSorting
    ]);
    if (!item) return null;
    var handleBackClick = function() {
        if (!showSearchField) {
            setOpen(false);
            setSelectedNavigationType(NavigationType.Shortest);
            setShowSearchField(false);
            onReturn();
        } else {
            setShowSearchField(false);
            setIsFinishItems(false);
        }
        if (isMobile) setMobilePosition(1);
    };
    var handleCloseClick = function() {
        setSelectedItem(null);
        setOpen(false);
        setShowSearchField(false);
        setSelectedNavigationType(NavigationType.Shortest);
    };
    var handleKeyDown = function(event) {
        if (event.key === "Enter") {
            var ref;
            event.preventDefault();
            setSearchText(event.target.value);
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Background */.Aq, {
                open: open,
                isVisible: isVisible,
                style: {
                    background: "none",
                    backdropFilter: "blur(0px)",
                    position: "static",
                    marginTop: deviceManager/* default.isMobile */.Z.isMobile() ? 0 : "",
                    height: "auto",
                    display: open ? "" : "none",
                    width: deviceManager/* default.isMobile */.Z.isMobile() ? "100%" : "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
                    open: open,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    // @ts-ignore
                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, choicePopupWrapper), {
                        display: sharePopupOpen ? "none" : ""
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            sx: {
                                p: {
                                    xs: "0 14px 10px 14px",
                                    sm: "14px"
                                },
                                justifyContent: "space-between",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    sx: {
                                        visibility: {
                                            xs: "hidden",
                                            sm: "visible"
                                        },
                                        borderRadius: "1rem",
                                        padding: "4px",
                                        background: "#EAECF0",
                                        width: "32px",
                                        height: "32px"
                                    },
                                    onClick: handleBackClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronLeftIcon */.wy, {
                                        style: {}
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        direction: rtl ? "rtl" : "ltr"
                                    },
                                    children: (translation === null || translation === void 0 ? void 0 : translation.navDirections) || "Directions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    style: {
                                        borderRadius: "1rem",
                                        padding: "4px",
                                        background: "#EAECF0",
                                        width: "32px",
                                        height: "32px"
                                    },
                                    onClick: isMobile ? handleBackClick : handleCloseClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CrossIcon */.aM, {
                                        style: {
                                            width: "18px",
                                            height: "18px"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Divider */.iz, {
                            style: {
                                margin: "0px -24px"
                            }
                        }),
                        !showSearchField && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            className: !showSearchField ? "show" : "hide",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                padding: "14px 14px 20px 14px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-around",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                width: "100%",
                                                mr: "6px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                        disabled: tourType === Tour/* TourType.Kiosk */.v.Kiosk,
                                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles/* choicePopupPointBtn */.II), {
                                                            direction: rtl ? "rtl" : "ltr"
                                                        }),
                                                        onClick: function() {
                                                            setSearchText(startingPointTitle);
                                                            setShowSearchField(true);
                                                            if (isMobile) setMobilePosition(2);
                                                        },
                                                        children: [
                                                            startingPoint && (0,search_bar_util/* renderIcon */.hY)(startingPoint, 30, 30),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                color: "#101828",
                                                                sx: {
                                                                    direction: rtl ? "rtl" : "ltr"
                                                                },
                                                                children: (0,search_bar_util/* trimDescription */.FR)(startingPointTitle, 25)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                        style: (0,_object_spread/* default */.Z)({
                                                            marginTop: "10px",
                                                            direction: rtl ? "rtl" : "ltr"
                                                        }, styles/* choicePopupPointBtn */.II),
                                                        onClick: function() {
                                                            setSearchText(finishPointTitle);
                                                            setShowSearchField(true);
                                                            setIsFinishItems(true);
                                                            if (isMobile) setMobilePosition(2);
                                                        },
                                                        children: [
                                                            item && (0,search_bar_util/* renderIcon */.hY)(item, 30, 30),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                color: "#101828",
                                                                sx: {
                                                                    direction: rtl ? "rtl" : "ltr"
                                                                },
                                                                children: (0,search_bar_util/* trimDescription */.FR)(finishPointTitle, 25)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                alignItems: "center",
                                                gap: "8px",
                                                height: "110px",
                                                justifyContent: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RedCircleIcon */.bB, {
                                                        style: {
                                                            width: "14px",
                                                            height: "14px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* DotsIcon */.YA, {
                                                        style: {
                                                            width: "18px",
                                                            height: "35px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* LocationIcon */._t, {
                                                        style: {
                                                            width: "14px",
                                                            height: "18px"
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (teleportPoints === null || teleportPoints === void 0 ? void 0 : teleportPoints.length) > 0 && (elevators === null || elevators === void 0 ? void 0 : elevators.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* PathTypeContainer */.yi, {
                                        rtl: rtl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* PathTypeItemsContainer */.js, {
                                            children: contentLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PathTypeItem */.FE, {
                                                        rtl: rtl,
                                                        selected: selectedNavigationType === NavigationType.Shortest,
                                                        onClick: function() {
                                                            setSelectedNavigationType(NavigationType.Shortest);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ElevatorIcon */.uz, {
                                                                style: {
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    margin: "8px 0"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                fontSize: "16px",
                                                                fontWeight: rtl ? 400 : 500,
                                                                sx: {
                                                                    direction: rtl ? "rtl" : "ltr"
                                                                },
                                                                children: (translation === null || translation === void 0 ? void 0 : translation.navElevatorRoute) || "Elevator Route"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PathTypeItem */.FE, {
                                                        rtl: rtl,
                                                        selected: selectedNavigationType === NavigationType.NoElevators || selectedNavigationType === NavigationType.NoStairs,
                                                        onClick: function() {
                                                            var navType = (stairs === null || stairs === void 0 ? void 0 : stairs.length) > 0 ? NavigationType.NoElevators : NavigationType.NoStairs;
                                                            setSelectedNavigationType(navType);
                                                        },
                                                        style: {
                                                            flex: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* StairsIcon */.X9, {
                                                                style: {
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    margin: "8px 0"
                                                                },
                                                                color: selectedNavigationType === NavigationType.NoElevators || selectedNavigationType === NavigationType.NoStairs ? "#2055ff" : "black"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                fontSize: "16px",
                                                                fontWeight: rtl ? 400 : 500,
                                                                sx: {
                                                                    direction: rtl ? "rtl" : "ltr"
                                                                },
                                                                children: (translation === null || translation === void 0 ? void 0 : translation.navStairOnly) || "Stairs Only"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PathTypeSkeletonItem */.Y9, {
                                                        selected: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "circular",
                                                                width: 20,
                                                                height: 20
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "text",
                                                                sx: {
                                                                    fontSize: isMobile ? "14px" : "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "text",
                                                                sx: {
                                                                    fontSize: isMobile ? "14px" : "16px"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PathTypeSkeletonItem */.Y9, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "circular",
                                                                width: 20,
                                                                height: 20
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "text",
                                                                sx: {
                                                                    fontSize: isMobile ? "14px" : "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "text",
                                                                sx: {
                                                                    fontSize: isMobile ? "14px" : "16px"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PathTypeSkeletonItem */.Y9, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "circular",
                                                                width: 20,
                                                                height: 20
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "text",
                                                                sx: {
                                                                    fontSize: isMobile ? "14px" : "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                variant: "text",
                                                                sx: {
                                                                    fontSize: isMobile ? "14px" : "16px"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    !sharePopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            display: isMobile ? "none" : "initial",
                                            marginTop: !(elevators === null || elevators === void 0 ? void 0 : elevators.length) && !(stairs === null || stairs === void 0 ? void 0 : stairs.length) ? "10px" : "0px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionTooltip, {
                                                detailedRouteEnabled: detailedRouteEnabled,
                                                sharingPopupOpen: sharePopupOpen,
                                                showSearchField: showSearchField,
                                                rtl: rtl,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* LoadingButton */.fl, {
                                                    style: {
                                                        direction: rtl ? "rtl" : "ltr",
                                                        fontWeight: rtl ? 500 : 600,
                                                        fontFamily: "Inter, Heebo, sans-serif"
                                                    },
                                                    onClick: function() {
                                                        onConfirm(selectedNavigationType);
                                                        setOpenNavigationSharingPopup(true);
                                                    },
                                                    disabled: loadingProgress < 100,
                                                    loadingProgress: loadingProgress,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* PlayIcon */.o1, {
                                                            style: {
                                                                width: "20px",
                                                                height: "20px"
                                                            }
                                                        }),
                                                        loadingProgress < 100 ? "".concat((translation === null || translation === void 0 ? void 0 : translation.navLoading) || "Loading", " ").concat(loadingProgress, "%") : "".concat((translation === null || translation === void 0 ? void 0 : translation.navStart3DNavigation) || "Start 3D Navigation")
                                                    ]
                                                })
                                            }),
                                            sharingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    width: "100%",
                                                    borderRadius: "8px",
                                                    border: "1px solid #D0D5DD",
                                                    color: "#2055FF",
                                                    gap: "6px",
                                                    background: "#ffff",
                                                    marginTop: "10px",
                                                    "&:hover": {
                                                        background: "#ffff"
                                                    },
                                                    direction: rtl ? "rtl" : "ltr"
                                                },
                                                onClick: function() {
                                                    return setSharePopupOpen(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* PhoneIcon */.qW, {
                                                        style: {
                                                            width: "20px",
                                                            height: "20px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        lineHeight: "21px",
                                                        fontWeight: rtl ? 500 : 600,
                                                        children: translation.navShareToPhone || "Share to your phone"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        showSearchField && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            className: showSearchField ? "show" : "hide",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        padding: "14px 14px 10px 14px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                            inputRef: inputRef,
                                            value: searchText,
                                            onChange: function(e) {
                                                return setSearchText(e.target.value);
                                            },
                                            onKeyDown: handleKeyDown,
                                            autoComplete: "off",
                                            InputProps: {
                                                startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    sx: {
                                                        width: "32px",
                                                        height: "32px",
                                                        padding: "0px",
                                                        "&:hover": {
                                                            background: "#ffff"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SearchIcon */.W1, {
                                                        style: {
                                                            width: "21px",
                                                            height: "21px"
                                                        }
                                                    })
                                                }),
                                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    style: {
                                                        width: "32px",
                                                        height: "32px",
                                                        padding: "0px"
                                                    },
                                                    onClick: function() {
                                                        return setSearchText("");
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CrossIcon */.aM, {
                                                        style: {
                                                            width: "21px",
                                                            height: "21px"
                                                        }
                                                    })
                                                })
                                            },
                                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, choicePopupSearchBar), {
                                                direction: rtl ? "rtl" : "ltr"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        padding: "10px 14px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            sx: {
                                                direction: rtl ? "rtl" : "ltr"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: "10px",
                                                    alignContent: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                            sx: {
                                                                display: {
                                                                    xs: "inline-flex",
                                                                    sm: "none"
                                                                },
                                                                borderRadius: "1rem",
                                                                padding: "4px",
                                                                background: "#EAECF0",
                                                                width: "32px",
                                                                height: "32px"
                                                            },
                                                            onClick: handleBackClick,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronLeftIcon */.wy, {
                                                                style: {}
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            lineHeight: "24px",
                                                            fontSize: "16px",
                                                            color: "#101828",
                                                            children: translation.navResults || "Results"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    direction: "row",
                                                    gap: "10px",
                                                    sx: {
                                                        direction: rtl ? "ltr" : ""
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDirectionButton, {
                                                            menuItems: menuItems,
                                                            selectedFilters: selectedFilters,
                                                            setSelectedFilters: setSelectedFilters
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SortDirectionButton, {
                                                            setSortingValue: setSortingValue
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Divider */.iz, {
                                        style: {
                                            margin: "0px -24px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                        in: (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) !== 0,
                                        sx: (0,styles/* generateCollapseStyle */.E1)({
                                            filteredItems: filteredItems,
                                            mobilePosition: mobilePosition,
                                            rtl: rtl
                                        }),
                                        className: (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) === 1 ? "animateHeight" : "",
                                        children: filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function(filteredItem, i) {
                                            var ref, ref1;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                sx: choicePopupFilteredBtn,
                                                onClick: function() {
                                                    if (!isFinishItems) {
                                                        if (filteredItem.sweepId === startSweep.sweepId) {
                                                            setShowSearchField(false);
                                                        }
                                                        selectStartItem(filteredItem);
                                                    } else selectFinishItem(filteredItem);
                                                },
                                                children: [
                                                    filteredItem && (0,search_bar_util/* renderIcon */.hY)(filteredItem, 38, 38),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        sx: {
                                                            textAlign: "start"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                fontSize: "16px",
                                                                fontWeight: "400",
                                                                children: (0,search_bar_util/* trimDescription */.FR)((filteredItem === null || filteredItem === void 0 ? void 0 : filteredItem.title) || (filteredItem === null || filteredItem === void 0 ? void 0 : (ref = filteredItem.tag) === null || ref === void 0 ? void 0 : ref.title) || (filteredItem === null || filteredItem === void 0 ? void 0 : filteredItem.name), 25)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    fontSize: "14px",
                                                                    fontWeight: 300,
                                                                    lineHeight: "21.5px"
                                                                },
                                                                children: (0,search_bar_util/* trimDescription */.FR)(filteredItem === null || filteredItem === void 0 ? void 0 : (ref1 = filteredItem.category) === null || ref1 === void 0 ? void 0 : ref1.title, 25)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        }),
                        detailedRouteEnabled && !showSearchField && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailedRoutes/* DetailedRoutes */.Q, {
                            item: item || {
                                tag: target
                            },
                            setNavigationDestination: setNavigationDestination,
                            isPreload: true,
                            detailedRoutes: detailedRoutes,
                            startingPoint: startingPoint,
                            rtl: rtl,
                            navigationType: navigationType
                        })
                    ]
                })
            }),
            !showSearchField && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                id: "nav-start-btn-container",
                sx: {
                    position: isMobile ? "absolute" : "initial",
                    bottom: 0,
                    left: isMobile ? 0 : undefined,
                    background: isMobile ? "#fff" : "transparent",
                    width: isMobile ? "100%" : "auto",
                    p: isMobile ? "14px 12px 30px 12px" : "14px",
                    zIndex: isMobile ? 9999 : "initial"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* LoadingButton */.fl, {
                    onClick: function() {
                        onConfirm(selectedNavigationType);
                        setSelectedNavigationType(NavigationType.Shortest);
                        setOpenNavigationSharingPopup(true);
                    },
                    disabled: loadingProgress < 100,
                    loadingProgress: loadingProgress,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* PlayIcon */.o1, {
                            style: {
                                width: "20px",
                                height: "20px"
                            }
                        }),
                        loadingProgress < 100 ? "".concat((translation === null || translation === void 0 ? void 0 : translation.navLoading) || "Loading", " ").concat(loadingProgress, "%") : "".concat(translation.navStart3DNavigation || "Start 3D Navigation")
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 56101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ Background; },
/* harmony export */   "E1": function() { return /* binding */ generateCollapseStyle; },
/* harmony export */   "FE": function() { return /* binding */ PathTypeItem; },
/* harmony export */   "II": function() { return /* binding */ choicePopupPointBtn; },
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "VG": function() { return /* binding */ Name; },
/* harmony export */   "WD": function() { return /* binding */ Category; },
/* harmony export */   "Y9": function() { return /* binding */ PathTypeSkeletonItem; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "fl": function() { return /* binding */ LoadingButton; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "iz": function() { return /* binding */ Divider; },
/* harmony export */   "js": function() { return /* binding */ PathTypeItemsContainer; },
/* harmony export */   "lU": function() { return /* binding */ TextContainer; },
/* harmony export */   "qi": function() { return /* binding */ StyledPhoneInput; },
/* harmony export */   "u8": function() { return /* binding */ RatingImage; },
/* harmony export */   "yi": function() { return /* binding */ PathTypeContainer; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports IconName, IconContainer, Icon */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18533);
/* harmony import */ var _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59603);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    from {\n        transform: translateY(100%);\n    }\n    to {\n        transform: translateY(0);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    from {\n        transform: translateY(0);\n    }\n    to {\n        transform: translateY(100%);\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    from {\n        opacity: 0;\n        transform: translate(-50%, -50%) scale(0.8);\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, -50%) scale(1);\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    from {\n        opacity: 1;\n        transform: translate(-50%, -50%) scale(1);\n    }\n    to {\n        opacity: 0;\n        transform: translate(-50%, -50%) scale(0.8);\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    from {\n        opacity: 1;\n    }\n    to {\n        opacity: 0;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100dvh;\n  backdrop-filter: blur(2px);\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1100;\n  animation: ",
        " 0.3s ease-out forwards;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          animation: ",
        " 0.3s ease-out forwards;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          animation: ",
        " 0.3s ease-out forwards;\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            animation: ",
        " 0.3s ease-out forwards;\n          "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            animation: ",
        " 0.3s ease-out forwards;\n          "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background: white;\n  width: 90vw;\n  max-width: 500px;\n  height: auto;\n  border-radius: 12px;\n  padding: 24px;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transition: transform 0.3s ease-out, opacity 0.3s ease-out;\n  overflow: hidden;\n  ",
        "\n\n  @media (max-width: 768px) {\n    width: 100vw;\n    border-radius: 12px 12px 0 0;\n    padding: 14px;\n    bottom: 0;\n    left: 0;\n    top: auto;\n    transform: none;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% + 48px);\n  height: 1px;\n  background-color: #eaecf0;\n  margin: 24px -24px;\n  @media (max-width: 768px) {\n    width: calc(100% + 28px);\n    margin: 14px -14px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n  direction: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin: 20px 0px;\n  direction: ",
        ";\n  text-align: ",
        ";\n  @media (max-width: 768px) {\n    margin: 14px 0px 10px 0px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  height: 41px;\n  gap: 10px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  display: flex;\n  padding: 10px;\n  gap: 6px;\n  align-items: center;\n  //flex-grow: 1;\n  //flex-basis: 0;\n  cursor: pointer;\n  transition-duration: 0.3s;\n  direction: ",
        ";\n  text-align: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  opacity: ",
        ";\n  svg {\n    color: ",
        ";\n    transition-duration: 0.5s;\n    path {\n      //fill: #101828;\n      fill: ",
        "; //#667085\n      transition-duration: 0.5s;\n    }\n  }\n  &:hover {\n    background-color: ",
        ";\n    color: #2055ff;\n    opacity: 1;\n    svg {\n      color: #2055ff;\n      path {\n        fill: rgba(32, 85, 255, 0.01);\n        stroke: #2055ff;\n      }\n    }\n  }\n  &:first-of-type {\n    svg {\n      path {\n        fill: none;\n        //stroke: #101828;\n        stroke: ",
        ";\n      }\n    }\n    &:hover {\n      svg {\n        path {\n          fill: none;\n          stroke: #2055ff;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 99px;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  flex-basis: 0;\n  padding: 10px;\n  gap: 5px;\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  color: #667085;\n  line-height: 17px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 24px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 44px;\n  height: 44px;\n  border-radius: ",
        ";\n  background: #eaecf0;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  @media (max-width: 768px) {\n    width: 32px;\n    height: 32px;\n    border-radius: 999rem;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  color: #667085;\n  line-height: 19px;\n  direction: ",
        ";\n  text-align: ",
        ";\n  @media (max-width: 768px) {\n    font-size: 14px;\n    line-height: 17px;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  width: 100%;\n  padding: 10px;\n  background-color: #2055ff;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  cursor: pointer;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .country-list {\n    left: 10px;\n    scrollbar-width: thin;\n    width: 274px;\n    text-align: start;\n    position: fixed;\n    left: 34px;\n    .search {\n      padding: 10px 10px 6px 10px;\n    }\n  }\n  .country-list::-webkit-scrollbar {\n    width: 8px;\n  }\n  .country-list::-webkit-scrollbar-thumb {\n    background-color: #bdbdbd !important;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  transition: transform 0.3s ease, filter 0.3s ease;\n  &:hover {\n    transform: translateY(-15px) scale(1.1); /* Jump and enlarge slightly */\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        animation: ",
        " 2s infinite;\n      "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  gap: 6px;\n  overflow: hidden;\n  background-color: ",
        ";\n  color: ",
        ";\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: ",
        "%;\n    background-color: rgba(255, 255, 255, 0.3);\n\n    ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}


var slideInBottom = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var slideOutBottom = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject1());
var fadeIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject2());
var fadeOut = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject3());
var fadeInBackground = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject4());
var fadeOutBackground = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject5());
var Background = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Background",
    componentId: "sc-2c492542-0"
})(_templateObject6(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, function(param) {
    var open = param.open;
    return open ? fadeInBackground : fadeOutBackground;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Wrapper",
    componentId: "sc-2c492542-1"
})(_templateObject11(), function(param) {
    var open = param.open;
    return open ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7(), fadeIn) : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), fadeOut);
}, function(param) {
    var open = param.open;
    return open ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), slideInBottom) : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject10(), slideOutBottom);
});
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__Divider",
    componentId: "sc-2c492542-2"
})(_templateObject12());
var IconName = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__IconName",
    componentId: "sc-2c492542-3"
})(_templateObject13());
var IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__IconContainer",
    componentId: "sc-2c492542-4"
})(_templateObject14());
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    displayName: "styles__Icon",
    componentId: "sc-2c492542-5"
})(_templateObject15());
var TextContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__TextContainer",
    componentId: "sc-2c492542-6"
})(_templateObject16(), function(props) {
    return props.rtl ? "rtl" : "ltr";
}, function(props) {
    return props.rtl ? "right" : "left";
});
var PathTypeContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PathTypeContainer",
    componentId: "sc-2c492542-7"
})(_templateObject17(), function(props) {
    return props.rtl ? "rtl" : "ltr";
}, function(props) {
    return props.rtl ? "right" : "left";
});
var PathTypeItemsContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PathTypeItemsContainer",
    componentId: "sc-2c492542-8"
})(_templateObject18());
var PathTypeItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PathTypeItem",
    componentId: "sc-2c492542-9"
})(_templateObject19(), function(props) {
    return props.rtl ? "rtl" : "ltr";
}, function(props) {
    return props.rtl ? "right" : "left";
}, function(param) {
    var selected = param.selected;
    return selected ? "#2055FF0F" : "";
}, function(param) {
    var selected = param.selected;
    return selected ? "#2055FF" : "black";
}, function(param) {
    var disabled = param.disabled;
    return disabled ? 0.3 : 1;
}, function(props) {
    return props.selected ? "#2055ff" : "#667085";
}, function(props) {
    return props.selected ? "rgba(32, 85, 255, 0.01)" : "#F7F7F7";
}, function(param) {
    var selected = param.selected;
    return selected ? "#2055FF0F" : "rgba(107, 107, 107, 0.08)";
}, function(props) {
    return props.selected ? "#2055ff" : "#667085";
});
PathTypeItem.defaultProps = {
    selected: false,
    disabled: false
};
var PathTypeSkeletonItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__PathTypeSkeletonItem",
    componentId: "sc-2c492542-10"
})(_templateObject20(), function(param) {
    var selected = param.selected;
    return selected ? "#2055FF0F" : "white";
});
PathTypeSkeletonItem.defaultProps = {
    selected: false
};
var Category = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__Category",
    componentId: "sc-2c492542-11"
})(_templateObject21());
var Name = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__Name",
    componentId: "sc-2c492542-12"
})(_templateObject22());
var CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__CloseButton",
    componentId: "sc-2c492542-13"
})(_templateObject23(), function(props) {
    return props.rounded ? "50%" : " 8px";
});
var Description = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "styles__Description",
    componentId: "sc-2c492542-14"
})(_templateObject24(), function(props) {
    return props.rtl ? "rtl" : "ltr";
}, function(props) {
    return props.rtl ? "right" : "left";
});
var Button = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "styles__Button",
    componentId: "sc-2c492542-15"
})(_templateObject25());
var StyledPhoneInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__/* .PhoneInput */ .sb).withConfig({
    displayName: "styles__StyledPhoneInput",
    componentId: "sc-2c492542-16"
})(_templateObject26());
var RatingImage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    displayName: "styles__RatingImage",
    componentId: "sc-2c492542-17"
})(_templateObject27());
var LoadingAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject28());
var LoadingButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Button).withConfig({
    displayName: "styles__LoadingButton",
    componentId: "sc-2c492542-18"
})(_templateObject30(), function(param) {
    var loadingProgress = param.loadingProgress;
    return loadingProgress < 100 ? "#C4CCDB66" : "#2055FF";
}, function(param) {
    var loadingProgress = param.loadingProgress;
    return loadingProgress < 100 ? "#667085" : "white";
}, function(param) {
    var loadingProgress = param.loadingProgress;
    return loadingProgress < 100 ? loadingProgress : 0;
}, function(param) {
    var loadingProgress = param.loadingProgress;
    return loadingProgress < 100 && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject29(), LoadingAnimation);
});
var generateCollapseStyle = function(param) {
    var mobilePosition = param.mobilePosition, rtl = param.rtl, filteredItems = param.filteredItems;
    return {
        maxHeight: {
            xs: mobilePosition < 2 ? "150px" : "".concat(0.95 * window.innerHeight - 250, "px"),
            sm: "612px"
        },
        overflowY: (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 8 ? "scroll" : "none",
        transition: "max-height 0.3s",
        "&::-webkit-scrollbar": {
            width: "8px"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#BDBDBD",
            borderRadius: "4px"
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#fff"
        },
        "&.animateHeight": {
            maxHeight: "74px",
            transition: "max-height 0.3s"
        },
        direction: rtl ? "rtl" : "ltr"
    };
};
var choicePopupPointBtn = {
    background: "#ffff",
    color: "black",
    border: "1px solid #D0D5DD",
    borderRadius: "10px",
    padding: "0px 14px",
    width: "100%",
    height: "50px",
    justifyContent: "flex-start",
    gap: "10px",
    "&:disabled": {
        background: "#EAECF0"
    }
};


/***/ }),

/***/ 7984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ NavigationWrapper; },
  "A": function() { return /* binding */ TeleportGroupType; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack_Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./store/atoms/navigation/choicepopup.ts
var choicepopup = __webpack_require__(97514);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
// EXTERNAL MODULE: ./utils/color.ts
var color = __webpack_require__(8058);
;// CONCATENATED MODULE: ./components/navigation/NavigationBackground.tsx





var NavigationBackground = function(param) {
    var isBackgroundVisible = param.isBackgroundVisible, tour = param.tour;
    var ref = (0,react.useState)(false), isHidden = ref[0], setIsHidden = ref[1];
    (0,react.useEffect)(function() {
        if (isBackgroundVisible) setIsHidden(false);
    }, [
        isBackgroundVisible
    ]);
    return isHidden ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        sx: {
            position: "relative",
            height: "100vh",
            zIndex: 1000,
            backgroundImage: "url('".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/images/").concat(tour.mainImage).concat((0,util/* getVersion */.bo)(tour.updatedAt), "')"),
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            "&::before": {
                content: "''",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: tour.mainImage ? color/* default.hexToRgbA */.Z.hexToRgbA("#F2F4F7", 0.7) : "#EAECF0",
                zIndex: -1
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        },
        className: isBackgroundVisible ? "wrapper-visible" : "wrapper-hidden",
        onAnimationEnd: function(event) {
            if (event.animationName === "kioskWrapperFadeOut") setIsHidden(true);
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button_Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Menu/Menu.js + 3 modules
var Menu = __webpack_require__(39530);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./components/navigation/search-bar/util.tsx
var search_bar_util = __webpack_require__(9313);
// EXTERNAL MODULE: ./components/navigation/icons/Icons.tsx
var Icons = __webpack_require__(25467);
;// CONCATENATED MODULE: ./components/navigation/NavigationHeader.tsx










var NavigationHeader = function(param) {
    var rtl = param.rtl, isBackgroundVisible = param.isBackgroundVisible, tour = param.tour, tourType = param.tourType, // target,
    // kioskIsReset,
    // categories,
    // setSearchText,
    // selectCategory,
    // setIsSearchBarFocused,
    // setBackgroundVisible,
    mobilePosition = param.mobilePosition;
    var navigationSettings = (0,recoil/* useRecoilValue */.sJ)(store/* navigationSettingsState */.FZ);
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var open = Boolean(anchorEl);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
        position: "static",
        sx: {
            background: {
                xs: "transparent",
                sm: isBackgroundVisible ? "#fff" : "transparent"
            },
            borderBottom: {
                xs: "none",
                sm: isBackgroundVisible ? "1px solid #D0D5DD" : "none"
            },
            height: {
                xs: "63px",
                lg: "70px"
            },
            boxShadow: "none",
            visibility: !isBackgroundVisible && tourType === Tour/* TourType.Regular */.v.Regular ? "hidden" : "visible",
            filter: {
                xs: mobilePosition > 1 ? "blur(3px)" : "none",
                sm: "none"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
            sx: {
                width: "100%",
                height: "inherit",
                p: {
                    xs: "10px 14px",
                    lg: "15px 20px"
                },
                display: "flex",
                justifyContent: {
                    xs: "center",
                    lg: "space-between"
                },
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    children: tour.client && tour.client.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        width: deviceManager/* default.isMobile */.Z.isMobile() ? "99px" : "133px",
                        height: deviceManager/* default.isMobile */.Z.isMobile() ? "34px" : "46px",
                        style: {
                            objectFit: "contain"
                        },
                        src: "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)),
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    sx: {
                        display: {
                            xs: "none",
                            sm: "flex"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "20px",
                        mx: "auto",
                        fontWeight: {
                            xs: 500,
                            lg: 600
                        },
                        textAlign: "center",
                        color: "black",
                        sx: {
                            direction: rtl ? "rtl" : "ltr"
                        },
                        children: (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.titleEnabled) && (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.title) ? (0,search_bar_util/* trimDescription */.FR)(navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.title, 60) : ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    id: "lang-button",
                    "aria-controls": open ? "lang-menu" : undefined,
                    "aria-haspopup": "true",
                    "aria-expanded": open ? "true" : undefined,
                    variant: !deviceManager/* default.isMobile */.Z.isMobile() ? "contained" : "text",
                    disableElevation: true,
                    onClick: handleClick,
                    startIcon: deviceManager/* default.isMobile */.Z.isMobile() ? Icons/* EngIconMobile */.$L : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.ZP, {
                        width: 24,
                        height: 15
                    }),
                    endIcon: !deviceManager/* default.isMobile */.Z.isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fa-solid fa-chevron-down",
                        style: {
                            fontSize: "12px",
                            fontWeight: 600
                        }
                    }) : undefined,
                    sx: {
                        // TODO remove visibility: hidden when full language change feature is developed
                        visibility: "hidden",
                        direction: rtl ? "rtl" : "ltr",
                        gap: "8px",
                        marginLeft: {
                            xs: "auto",
                            sm: "unset"
                        },
                        minWidth: {
                            xs: "36px",
                            sm: "64px"
                        },
                        width: {
                            xs: "36px",
                            sm: "130px"
                        },
                        height: {
                            xs: "36px",
                            sm: "47px"
                        },
                        borderRadius: "8px",
                        border: {
                            xs: "none",
                            sm: "1px solid #D0D5DD"
                        },
                        background: {
                            xs: "transparent",
                            sm: "#FFF"
                        },
                        padding: "7px 12px",
                        color: "#000",
                        "&:hover": {
                            background: {
                                xs: "transparent",
                                sm: "#FFF"
                            },
                            color: "#000"
                        },
                        "&:focus": {
                            border: {
                                xs: "none",
                                sm: "1px solid #D0D5DD"
                            }
                        },
                        ".MuiButton-endIcon": {
                            marginRight: "0",
                            marginLeft: "0",
                            width: "38px",
                            height: "inherit",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        ".MuiButton-startIcon": {
                            mx: "0px",
                            width: "24px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "14px",
                            fontWeight: 600,
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        },
                        children: "English"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                    elevation: 0,
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "right"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "right"
                    },
                    id: "lang-menu",
                    MenuListProps: {
                        "aria-labelledby": "lang-button",
                        sx: {
                            background: "#fff"
                        }
                    },
                    anchorEl: anchorEl,
                    open: open,
                    onClose: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        onClick: handleClose,
                        disableRipple: true,
                        children: "Spanish"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(67836);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 146 modules
var dist = __webpack_require__(59603);
;// CONCATENATED MODULE: ./components/navigation/search-bar/components/FilterMenu.tsx










var FilterMenu = function(param) {
    var menuItems = param.menuItems, selectedFilters = param.selectedFilters, setSelectedFilters = param.setSelectedFilters, rtl = param.rtl;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var ref = (0,react.useState)(null), anchorEl = ref[0], setAnchorEl = ref[1];
    var open = Boolean(anchorEl);
    var allUniqueFilters = menuItems.reduce(function(acc, item) {
        var filters = item.filters || [];
        if (!filters.length) return acc;
        filters.forEach(function(filter) {
            if (!acc.find(function(accitem) {
                return accitem.id === filter.id;
            })) {
                acc.push(filter);
            }
        });
        return acc;
    }, []);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleToggleSelectedFilters = function(id) {
        setSelectedFilters(function(prevFilters) {
            if (prevFilters.includes(id)) {
                return prevFilters.filter(function(filterId) {
                    return filterId !== id;
                });
            }
            return (0,_to_consumable_array/* default */.Z)(prevFilters).concat([
                id
            ]);
        });
    };
    var resetFilters = function() {
        setSelectedFilters([]);
    };
    return allUniqueFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                id: "filter-button",
                "aria-controls": open ? "filter-menu" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? "true" : undefined,
                variant: "contained",
                disableElevation: true,
                onClick: handleClick,
                sx: {
                    width: {
                        xs: "36px",
                        lg: "99px"
                    },
                    height: {
                        xs: "36px",
                        lg: "44px"
                    },
                    borderRadius: {
                        xs: "30px",
                        sm: "8px"
                    },
                    border: open || selectedFilters.length > 0 ? "1px solid #2055FF" : "1px solid #EAECF0",
                    background: open || selectedFilters.length > 0 ? "rgba(32, 85, 255, 0.06)" : "#FFF",
                    color: open || selectedFilters.length > 0 ? "#2055FF" : "#000",
                    minWidth: {
                        xs: "36px",
                        sm: "64px"
                    },
                    direction: rtl ? "rtl" : "ltr",
                    gap: "8px",
                    "&:hover": {
                        background: "rgba(32, 85, 255, 0.06)",
                        color: open || selectedFilters.length > 0 ? "#2055FF" : "#000"
                    },
                    "&:focus": {
                        border: "1px solid #2055FF",
                        background: "rgba(32, 85, 255, 0.06)"
                    },
                    ".MuiButton-startIcon": {
                        marginRight: {
                            xs: 0,
                            sm: "8px"
                        },
                        marginLeft: {
                            xs: 0,
                            sm: "-4px"
                        }
                    }
                },
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-solid fa-filter",
                    style: {
                        fontSize: "16px",
                        fontWeight: 400,
                        color: deviceManager/* default.isMobile */.Z.isMobile() ? "#6B6B6B" : "#667085",
                        width: "20px",
                        height: "20px"
                    }
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    fontSize: "16px",
                    sx: {
                        display: {
                            xs: "none",
                            sm: "initial"
                        }
                    },
                    fontWeight: 400,
                    children: (translation === null || translation === void 0 ? void 0 : translation.navFilter) || "Filter"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                id: "filter-menu",
                sx: {
                    ".MuiPopover-paper": {
                        width: "404px",
                        borderRadius: "8px",
                        border: "1px solid #EAECF0",
                        mt: "10px"
                    }
                },
                MenuListProps: {
                    "aria-labelledby": "filter-button",
                    sx: {
                        background: "#fff",
                        p: 0
                    }
                },
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    p: "8px 8px 24px 24px",
                    width: "100%",
                    direction: "row",
                    flexWrap: "wrap",
                    sx: {
                        direction: rtl ? "rtl" : "ltr"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            width: "100%",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: "16px",
                                    fontWeight: 400,
                                    mb: "10px",
                                    children: (translation === null || translation === void 0 ? void 0 : translation.navFilterBy) || "Filter by"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    direction: "row",
                                    gap: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-thin fa-arrow-rotate-left",
                                            onClick: resetFilters,
                                            style: {
                                                cursor: "pointer",
                                                fontSize: "24px",
                                                width: "24px",
                                                height: "24px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-thin fa-xmark",
                                            onClick: handleClose,
                                            style: {
                                                cursor: "pointer",
                                                fontSize: "24px",
                                                width: "24px",
                                                height: "24px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            gap: 1,
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "flexStart",
                            children: allUniqueFilters.map(function(filter) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "contained",
                                    disableElevation: true,
                                    sx: {
                                        borderRadius: "8px",
                                        border: selectedFilters.includes(filter.id) ? "1px solid #2055FF" : "1px solid #EAECF0",
                                        color: selectedFilters.includes(filter.id) ? "#2055FF" : "#344054",
                                        background: selectedFilters.includes(filter.id) ? "rgba(32, 85, 255, 0.06)" : "#FFF",
                                        "&:hover": {
                                            background: "rgba(32, 85, 255, 0.06)",
                                            color: selectedFilters.includes(filter.id) ? "#2055FF" : "#344054"
                                        },
                                        "&:focus": {
                                            border: selectedFilters.includes(filter.id) ? "1px solid #2055FF" : "1px solid #EAECF0"
                                        }
                                    },
                                    onClick: function() {
                                        return handleToggleSelectedFilters(filter.id);
                                    },
                                    children: filter.title
                                }, filter.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/search-bar/components/SortMenu.tsx










var SortMenu = function(param) {
    var rtl = param.rtl, sortingValue = param.sortingValue, setSortingValue = param.setSortingValue;
    var ref;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var open = Boolean(anchorEl);
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var sortingValueOptions = (0,react.useMemo)(function() {
        return [
            {
                value: "default",
                label: (translation === null || translation === void 0 ? void 0 : translation.navDefault) || "Default",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-thin fa-sort"
                })
            },
            {
                value: "alphabetical",
                label: (translation === null || translation === void 0 ? void 0 : translation.navAlphabetical) || "A-Z",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-arrow-up-arrow-down",
                    style: {
                        transform: "rotateX(180deg)"
                    }
                })
            },
            {
                value: "reverseAlphabetical",
                label: (translation === null || translation === void 0 ? void 0 : translation.navReverseAlphabetical) || "Z-A",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-arrow-up-arrow-down"
                })
            }, 
        ];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        rtl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                id: "sort-button",
                "aria-controls": open ? "sorting-menu" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? "true" : undefined,
                variant: "contained",
                disableElevation: true,
                onClick: handleClick,
                sx: {
                    height: {
                        xs: "36px",
                        lg: "44px"
                    },
                    width: {
                        xs: "36px",
                        lg: "auto"
                    },
                    borderRadius: {
                        xs: "30px",
                        sm: "8px"
                    },
                    minWidth: {
                        xs: "36px",
                        sm: "64px"
                    },
                    border: open ? "1px solid #2055FF" : "1px solid #EAECF0",
                    background: open ? "rgba(32, 85, 255, 0.06)" : "#FFF",
                    color: open ? "#2055FF" : "#000",
                    direction: rtl ? "rtl" : "ltr",
                    gap: "8px",
                    "&:hover": {
                        background: "rgba(32, 85, 255, 0.06)",
                        color: open ? "#2055FF" : "#000"
                    },
                    "&:focus": {
                        border: "1px solid #2055FF",
                        background: "rgba(32, 85, 255, 0.06)"
                    },
                    ".MuiButton-startIcon": {
                        marginRight: {
                            xs: 0,
                            sm: "8px"
                        },
                        marginLeft: {
                            xs: 0,
                            sm: "-4px"
                        }
                    }
                },
                startIcon: deviceManager/* default.isMobile */.Z.isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-regular fa-bars-filter",
                    style: {
                        fontSize: "16px",
                        fontWeight: 400,
                        color: "#6B6B6B"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-thin fa-sort",
                    style: {
                        fontSize: "16px",
                        fontWeight: 400,
                        width: "20px",
                        height: "20px",
                        color: "#667085"
                    }
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            fontSize: "16px",
                            fontWeight: 400,
                            sx: {
                                display: {
                                    xs: "none",
                                    sm: "initial"
                                }
                            },
                            children: (translation === null || translation === void 0 ? void 0 : translation.navSortBy) || "Sort By"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            fontSize: "16px",
                            fontWeight: 400,
                            sx: {
                                display: {
                                    xs: "none",
                                    sm: "initial"
                                }
                            },
                            children: [
                                ": ",
                                ((ref = sortingValueOptions.find(function(option) {
                                    return option.value === sortingValue;
                                })) === null || ref === void 0 ? void 0 : ref.label) || (translation === null || translation === void 0 ? void 0 : translation.navDefault) || "Default"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                id: "sorting-menu",
                sx: {
                    ".MuiPopover-paper": {
                        width: "203px",
                        borderRadius: "8px",
                        border: "1px solid #EAECF0",
                        mt: "10px"
                    },
                    direction: rtl ? "rtl" : "ltr"
                },
                MenuListProps: {
                    "aria-labelledby": "sort-button",
                    sx: {
                        background: "#fff"
                    }
                },
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                children: sortingValueOptions.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                        onClick: function() {
                            setSortingValue(option.value);
                            handleClose();
                        },
                        sx: {
                            display: "inline-flex",
                            justifyContent: "flex-start",
                            width: "100%",
                            gap: "8px",
                            ":hover": {
                                background: "rgba(32, 85, 255, 0.06)"
                            }
                        },
                        children: [
                            option.icon,
                            option.label
                        ]
                    }, option.value);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(39477);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./api/TreedisAdminDAO.ts
var TreedisAdminDAO = __webpack_require__(83680);
;// CONCATENATED MODULE: ./components/navigation/search-bar/components/FinishModal.tsx










var FinishModal = function(param) {
    var isOpen = param.isOpen, inputClientRect = param.inputClientRect, target = param.target, popupTitle = param.popupTitle, qrEnabled = param.qrEnabled, qrTitle = param.qrTitle, smsEnabled = param.smsEnabled, smsTitle = param.smsTitle, smsText = param.smsText, ratingClientRect = param.ratingClientRect;
    var palette = (0,useTheme/* default */.Z)().palette;
    var ref = (0,react.useState)(""), phoneNumber = ref[0], setPhoneNumber = ref[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var mobileLink = (0,react.useMemo)(function() {
        return "".concat(window.location.href, "&target=").concat(target.defaultSid);
    }, [
        target
    ]);
    var handleMobileNumberChange = function(value) {
        setPhoneNumber(value);
    };
    var handleSendSms = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var smsResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisAdminDAO/* default.sendNavigationLinkSms */.Z.sendNavigationLinkSms({
                                mobileLink: mobileLink,
                                phoneNumber: phoneNumber,
                                smsText: smsText
                            })
                        ];
                    case 1:
                        smsResult = _state.sent();
                        if ((smsResult === null || smsResult === void 0 ? void 0 : smsResult.message) === "Success.") {
                            react_toastify_esm/* toast.success */.Am.success((translation === null || translation === void 0 ? void 0 : translation.navSmsSent) || "SMS sent successfully");
                        } else {
                            react_toastify_esm/* toast.error */.Am.error((translation === null || translation === void 0 ? void 0 : translation.navSmsError) || "Error sending message");
                        }
                        setPhoneNumber("");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendSms() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        // keepMounted
        open: isOpen,
        hideBackdrop: true,
        sx: {
            maxWidth: "750px",
            height: "fit-content",
            position: "absolute",
            top: (inputClientRect === null || inputClientRect === void 0 ? void 0 : inputClientRect.top) + (inputClientRect === null || inputClientRect === void 0 ? void 0 : inputClientRect.height) + 10 + ((ratingClientRect === null || ratingClientRect === void 0 ? void 0 : ratingClientRect.height) || 0),
            left: 0,
            right: 0,
            mx: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            width: "100%",
            sx: {
                borderRadius: "8px",
                border: "1px solid rgba(0, 0, 0, 0.10)",
                background: "rgba(234, 236, 240, 0.85)",
                backdropFilter: "blur(20px)",
                p: 0
            },
            flexWrap: "wrap",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    sx: {
                        backgroundColor: palette.treedis.blue.main,
                        height: "55px",
                        borderRadius: "8px 8px 0 0"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "#fff",
                        children: popupTitle || (translation === null || translation === void 0 ? void 0 : translation.navGetGuide) || "Want to get the navigation guide to your phone?"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    direction: "row",
                    width: "100%",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    py: "20px",
                    children: [
                        qrEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            sx: {
                                maxWidth: "254px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    height: "60px",
                                    textAlign: "center",
                                    children: qrTitle || (translation === null || translation === void 0 ? void 0 : translation.navScanQr) || "Scan the QR code to view on your phone "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    alignItems: "center",
                                    justifyContent: "center",
                                    sx: {
                                        background: "#FFF",
                                        padding: "10px",
                                        borderRadius: "8px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "qr",
                                        src: "https://api.qrserver.com/v1/create-qr-code/?size=166x166&data=".concat(encodeURIComponent(mobileLink)),
                                        width: "166px",
                                        height: "166px"
                                    })
                                })
                            ]
                        }),
                        qrEnabled && smsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            orientation: "vertical",
                            flexItem: true,
                            sx: {
                                ".MuiDivider-wrapper": {
                                    transform: "rotate(-90deg)"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "span",
                                sx: {
                                    background: "#fff",
                                    borderRadius: "10px",
                                    padding: "3px 10px"
                                },
                                children: (translation === null || translation === void 0 ? void 0 : translation.navOr) || "Or"
                            })
                        }),
                        smsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            sx: {
                                maxWidth: "414px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    height: "60px",
                                    children: smsTitle || (translation === null || translation === void 0 ? void 0 : translation.navFillPhoneNumber) || "Fill your phone number to get link"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        maxWidth: "372px",
                                        width: "100%",
                                        ".form-control": {
                                            width: "100% !important"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* PhoneInput */.sb, {
                                        country: "il",
                                        specialLabel: "",
                                        placeholder: "",
                                        value: phoneNumber,
                                        onChange: handleMobileNumberChange,
                                        // onlyCountries={['gr', 'fr', 'us', 'il', 'am', 'ua']}
                                        inputStyle: {
                                            height: "50px",
                                            borderRadius: "8px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    variant: "contained",
                                    sx: {
                                        maxWidth: "372px",
                                        width: "100%",
                                        height: "50px",
                                        borderRadius: "8px",
                                        background: palette.treedis.blue.main,
                                        ":hover": {
                                            background: palette.treedis.blue.main
                                        },
                                        ":active": {
                                            background: palette.treedis.blue.main
                                        }
                                    },
                                    onClick: handleSendSms,
                                    children: (translation === null || translation === void 0 ? void 0 : translation.navSendLink) || "Send me the link"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/navigation/hooks/useScreenCounter.tsx







var INITIAL_COUTER = 30;
var INNER_COUTNER = 10;
var ToastMsg = function(param) {
    var resetTimer = param.resetTimer, translation = param.translation, rtl = param.rtl;
    var ref = (0,react.useState)(INNER_COUTNER), innerCounter = ref[0], setInnerCounter = ref[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            if (innerCounter === 0) return;
            setInnerCounter(function(prev) {
                return prev - 1;
            });
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        innerCounter
    ]);
    var resetInnerTimer = function() {
        setInnerCounter(INITIAL_COUTER);
        resetTimer();
    };
    (0,react.useEffect)(function() {
        var ref;
        var iframe = document.body.querySelector("iframe");
        var iframeBody = iframe === null || iframe === void 0 ? void 0 : (ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.document.body;
        var iframeCanvas = iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.querySelector("canvas");
        // Add event listeners
        window.addEventListener("mousemove", resetInnerTimer);
        window.addEventListener("click", resetInnerTimer);
        window.addEventListener("touchstart", resetInnerTimer);
        window.addEventListener("keydown", resetInnerTimer);
        iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("mousemove", resetInnerTimer);
        iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("click", resetInnerTimer);
        iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("touchstart", resetInnerTimer);
        // Cleanup function to remove event listeners
        return function() {
            window.removeEventListener("mousemove", resetInnerTimer);
            window.removeEventListener("click", resetInnerTimer);
            window.removeEventListener("touchstart", resetInnerTimer);
            window.removeEventListener("keydown", resetInnerTimer);
            iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("mousemove", resetInnerTimer);
            iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("click", resetInnerTimer);
            iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("touchstart", resetInnerTimer);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        p: 0,
        m: 0,
        sx: {
            direction: rtl ? "rtl" : "ltr"
        },
        children: [
            "".concat((translation === null || translation === void 0 ? void 0 : translation.navResetIn) || "Resetting Kiosk in ", " ").concat(innerCounter, " ").concat((translation === null || translation === void 0 ? void 0 : translation.navSeconds) || " seconds"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "contained",
                color: "primary",
                onClick: resetInnerTimer,
                sx: {
                    width: "44px",
                    height: "44px",
                    minWidth: "unset"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-regular fa-clock"
                })
            })
        ]
    });
};
var useScreenCounter = function(param) {
    var resetNavigation = param.resetNavigation, isBackgroundVisible = param.isBackgroundVisible, inAutoNavigate = param.inAutoNavigate, rtl = param.rtl;
    var ref = (0,react.useState)(INITIAL_COUTER), counter = ref[0], setCounter = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* navigationToastState */.er), 2), showToast = ref1[0], setShowToast = ref1[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var resetTimer = function() {
        setCounter(INITIAL_COUTER);
    };
    (0,react.useEffect)(function() {
        if (showToast) {
            (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastMsg, {
                rtl: rtl,
                resetTimer: resetTimer,
                translation: translation
            }), {
                autoClose: false,
                position: "top-right",
                hideProgressBar: true,
                closeButton: false,
                closeOnClick: false
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showToast
    ]);
    (0,react.useEffect)(function() {
        var interval;
        if (!isBackgroundVisible && !inAutoNavigate) {
            interval = setInterval(function() {
                if (counter === 0) return;
                if (counter <= 10) {
                    setShowToast(true);
                } else {
                    setShowToast(false);
                    react_toastify_esm/* toast.dismiss */.Am.dismiss();
                }
                setCounter(function(prev) {
                    return prev - 1;
                });
            }, 1000);
        }
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        counter,
        isBackgroundVisible,
        inAutoNavigate
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var iframe = document.body.querySelector("iframe");
        var iframeBody = iframe === null || iframe === void 0 ? void 0 : (ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.document.body;
        var iframeCanvas = iframeBody === null || iframeBody === void 0 ? void 0 : iframeBody.querySelector("canvas");
        // Add event listeners
        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("click", resetTimer);
        window.addEventListener("touchstart", resetTimer);
        window.addEventListener("keydown", resetTimer);
        iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("mousemove", resetTimer);
        iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("click", resetTimer);
        iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("touchstart", resetTimer);
        // Cleanup function to remove event listeners
        return function() {
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("click", resetTimer);
            window.removeEventListener("touchstart", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("mousemove", resetTimer);
            iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("click", resetTimer);
            iframeCanvas === null || iframeCanvas === void 0 ? void 0 : iframeCanvas.addEventListener("touchstart", resetTimer);
            react_toastify_esm/* toast.dismiss */.Am.dismiss();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    (0,react.useEffect)(function() {
        if (counter === 0) {
            react_toastify_esm/* toast.dismiss */.Am.dismiss();
            resetNavigation("fromKioskTimer");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        counter
    ]);
    return {
        resetTimer: resetTimer,
        counter: counter
    };
};

;// CONCATENATED MODULE: ./components/navigation/search-bar/components/NavigationCounterWrapper.tsx


var NavigationCounterWrapper = function(param) {
    var resetNavigation = param.resetNavigation, isBackgroundVisible = param.isBackgroundVisible, inAutoNavigate = param.inAutoNavigate, rtl = param.rtl;
    useScreenCounter({
        resetNavigation: resetNavigation,
        rtl: rtl,
        isBackgroundVisible: isBackgroundVisible,
        inAutoNavigate: inAutoNavigate
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/SkeletonPathItem.tsx



var SkeletonPathItem = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        width: "100%",
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: "82px",
        px: "20px",
        sx: {
            borderTop: {
                xs: "none",
                lg: "1px solid #D0D5DD"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        width: "38px",
                        height: "38px",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        sx: {
                            background: "transparent",
                            borderRadius: "8px",
                            p: 0,
                            mr: "14px",
                            ml: "0",
                            border: "1px solid #E8E8E8"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rounded",
                            height: 38,
                            width: 38
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "16px",
                                fontWeight: 500,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "text",
                                    sx: {
                                        fontSize: "16px"
                                    },
                                    width: deviceManager/* default.isMobile */.Z.isMobile() ? 100 : 230
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "14px",
                                fontWeight: 400,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "text",
                                    sx: {
                                        fontSize: "16px"
                                    },
                                    width: deviceManager/* default.isMobile */.Z.isMobile() ? 80 : 180
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    display: {
                        xs: "none",
                        lg: "flex"
                    },
                    ":hover": {
                        background: "rgba(32, 85, 255, 0.06)"
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                direction: "row",
                gap: "10px",
                alignItems: "center",
                width: "128px",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rounded",
                    width: 36,
                    height: 8
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/styles.ts
var styles = __webpack_require__(56101);
// EXTERNAL MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/Icons.tsx
var Popup_Icons = __webpack_require__(96665);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/components/ButtonsContainer.tsx






var ButtonsContainer = function(param) {
    var isMobile = param.isMobile, contentLoaded = param.contentLoaded, onConfirm = param.onConfirm, setSharePopupOpen = param.setSharePopupOpen, sharingEnabled = param.sharingEnabled, rtl = param.rtl;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        id: "buttons-container",
        sx: {
            position: isMobile ? "absolute" : "sticky",
            bottom: 0,
            left: isMobile ? 0 : undefined,
            background: "#fff",
            width: isMobile ? "100%" : "auto",
            p: isMobile ? "14px 12px 30px 12px" : "14px",
            zIndex: 9999
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Button */.zx, {
                disabled: !contentLoaded,
                onClick: onConfirm,
                style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    direction: rtl ? "rtl" : "ltr",
                    height: "40px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* CornerUpRitghtIcon */.S3, {
                        style: {
                            width: "20px",
                            height: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            direction: rtl ? "rtl" : "ltr",
                            fontWeight: rtl ? 500 : 600
                        },
                        children: translation.navGetDirections || "Get directions"
                    })
                ]
            }),
            sharingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Button */.zx, {
                onClick: function() {
                    return setSharePopupOpen(true);
                },
                disabled: !contentLoaded,
                style: {
                    display: isMobile ? "none" : "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    background: "#FFFFFF",
                    color: "#2055FF",
                    marginTop: "10px",
                    border: "1px solid #D0D5DD",
                    direction: rtl ? "rtl" : "ltr",
                    height: "40px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* SmartphoneIcon */.BE, {
                        style: {
                            width: "20px",
                            height: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            direction: rtl ? "rtl" : "ltr",
                            fontWeight: rtl ? 500 : 600
                        },
                        children: translation.navShareToPhone || "Share to your phone"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/components/TextContainer.tsx



var TextContainer = function(param) {
    var rtl = param.rtl, contentLoaded = param.contentLoaded, item = param.item, isMobile = param.isMobile;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextContainer */.lU, {
        rtl: rtl,
        style: {
            padding: "14px",
            marginTop: "0px"
        },
        children: [
            contentLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (item === null || item === void 0 ? void 0 : item.category) && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Category */.WD, {
                        style: {
                            fontFamily: "Inter, Heebo, sans-serif",
                            fontWeight: 400,
                            fontSize: "12px",
                            lineHeight: "29px",
                            direction: rtl ? "rtl" : "ltr"
                        },
                        children: item === null || item === void 0 ? void 0 : (ref = item.category) === null || ref === void 0 ? void 0 : ref.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Name */.VG, {
                        style: {
                            fontFamily: "Inter, Heebo, sans-serif",
                            fontSize: "16px",
                            margin: "6px 0px",
                            fontWeight: rtl ? 500 : 600,
                            direction: rtl ? "rtl" : "ltr"
                        },
                        children: ((ref1 = item[item.type]) === null || ref1 === void 0 ? void 0 : ref1.title) || (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.name)
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            fontSize: isMobile ? "14px" : "16px"
                        },
                        width: 210
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            fontSize: isMobile ? "14px" : "16px"
                        },
                        width: 210
                    })
                ]
            }),
            (item === null || item === void 0 ? void 0 : (ref2 = item.tag) === null || ref2 === void 0 ? void 0 : ref2.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Description */.dk, {
                    rtl: rtl,
                    children: contentLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            lineHeight: "18px",
                            color: "rgba(0, 0, 0, 0.5)",
                            fontSize: "12px",
                            wordBreak: "break-word"
                        },
                        dangerouslySetInnerHTML: {
                            __html: item === null || item === void 0 ? void 0 : (ref3 = item.tag) === null || ref3 === void 0 ? void 0 : ref3.description
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                sx: {
                                    fontSize: isMobile ? "14px" : "16px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                sx: {
                                    fontSize: isMobile ? "14px" : "16px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                sx: {
                                    fontSize: isMobile ? "14px" : "16px"
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/NavigationIntroPopup.tsx










var IMAGE_HEIGHT = 192;
var NavigationIntroPopup = function(param) {
    var open = param.open, handleBack = param.handleBack, item = param.item, contentLoaded = param.contentLoaded, onConfirm = param.onConfirm, rtl = param.rtl, tour = param.tour, setPopupHeight = param.setPopupHeight, setSharePopupOpen = param.setSharePopupOpen, sharePopupOpen = param.sharePopupOpen, sharingEnabled = param.sharingEnabled, mobilePosition = param.mobilePosition;
    var ref = (0,react.useState)(open), isVisible = ref[0], setIsVisible = ref[1];
    var textContainerRef = (0,react.useRef)(null);
    var titleContainerRef = (0,react.useRef)(null);
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    // eslint-disable-next-line consistent-return
    (0,react.useEffect)(function() {
        if (open) {
            setIsVisible(true);
        } else {
            var timer = setTimeout(function() {
                return setIsVisible(false);
            }, 300);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        open
    ]);
    (0,react.useLayoutEffect)(function() {
        var ref, ref1;
        var textHeight = (ref = textContainerRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight;
        var titleHeight = (ref1 = titleContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight;
        var height = textHeight + titleHeight + IMAGE_HEIGHT;
        if (height) setPopupHeight(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isVisible,
        mobilePosition
    ]);
    var renderImage = (0,react.useCallback)(function() {
        var ref, ref1;
        return (item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.webPathThumbnail) && (item === null || item === void 0 ? void 0 : (ref1 = item.tag) === null || ref1 === void 0 ? void 0 : ref1.navigationThumbnail) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: "Thumbnail",
            src: "".concat("https://cdn.treedis.com", "/tours/").concat(item.tourId, "/tags/icons/").concat(item.tag.navigationThumbnail),
            style: {
                width: "100%",
                height: "100%",
                objectFit: "cover"
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: tour.name,
            src: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/images/").concat(tour.mainImage),
            style: {
                width: "100%",
                height: "100%",
                objectFit: "cover"
            }
        });
    }, [
        item,
        tour
    ]);
    if (!item) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Background */.Aq, {
                open: open,
                isVisible: isVisible,
                style: {
                    background: "none",
                    backdropFilter: "blur(0px)",
                    position: isMobile ? "absolute" : "relative",
                    marginTop: isMobile ? "unset" : "",
                    height: isMobile ? "100%" : "auto",
                    display: open ? "" : "none",
                    width: isMobile ? "100%" : "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
                    open: open,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    style: {
                        display: sharePopupOpen ? "none" : "",
                        position: isMobile ? "relative" : "static",
                        padding: "0px",
                        overflow: "hidden",
                        width: isMobile ? "auto" : "340px",
                        height: isMobile ? "100%" : "auto",
                        border: isMobile ? "none" : "1px solid #FFFFFF",
                        transform: "none",
                        animation: "none",
                        marginLeft: isMobile ? "0" : "",
                        background: isMobile ? "none" : "#fff"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            ref: titleContainerRef,
                            sx: {
                                p: "14px",
                                background: "#F7F7F7",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    sx: {
                                        position: "absolute",
                                        left: "14px",
                                        borderRadius: "1rem",
                                        padding: "4px",
                                        background: "#EAECF0",
                                        width: "32px",
                                        height: "32px",
                                        display: {
                                            xs: "none",
                                            sm: "inline-flex"
                                        }
                                    },
                                    onClick: handleBack,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* ChevronLeftIcon */.wy, {
                                        style: {}
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: "16px",
                                    fontWeight: rtl ? 400 : 500,
                                    sx: {
                                        direction: rtl ? "rtl" : "ltr"
                                    },
                                    children: translation.navDestination || "Destination"
                                })
                            ]
                        }),
                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            ref: textContainerRef,
                            p: 0,
                            m: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                                rtl: rtl,
                                contentLoaded: contentLoaded,
                                item: item,
                                isMobile: isMobile
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            style: {
                                width: "100%",
                                height: "".concat(IMAGE_HEIGHT, "px"),
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: rtl ? "row-reverse" : "row",
                                    width: "100%",
                                    height: "100%"
                                },
                                children: contentLoaded ? renderImage() : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rounded",
                                    width: "100%",
                                    height: "100%"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            sx: {
                                p: 0
                            },
                            children: !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                                rtl: rtl,
                                contentLoaded: contentLoaded,
                                item: item,
                                isMobile: isMobile
                            })
                        })
                    ]
                })
            }),
            open && !sharePopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonsContainer, {
                isMobile: isMobile,
                contentLoaded: contentLoaded,
                onConfirm: onConfirm,
                setSharePopupOpen: setSharePopupOpen,
                sharingEnabled: sharingEnabled,
                rtl: rtl
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/NavigationIntroChoicePopup.tsx + 3 modules
var NavigationIntroChoicePopup = __webpack_require__(32922);
;// CONCATENATED MODULE: ./components/navigation/search-bar/styles.tsx




var useSearchbarStyles = function(param) {
    var showSkeleton = param.showSkeleton, wrapperWidth = param.wrapperWidth, isBackgroundVisible = param.isBackgroundVisible, popupOpen = param.popupOpen, mobilePosition = param.mobilePosition, filteredItems = param.filteredItems, rtl = param.rtl, searchText = param.searchText, selectedCategory = param.selectedCategory, navigationSharingPopupOpen = param.navigationSharingPopupOpen, actionPathFinished = param.actionPathFinished;
    var searchWrapperStyle = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: {
                xs: "100%",
                //  `calc(${wrapperWidth} - 28px)`
                lg: showSkeleton ? "calc(".concat(wrapperWidth, " + 30px)") : wrapperWidth
            }
        }, !isBackgroundVisible && {
            position: "absolute",
            top: {
                xs: 43,
                lg: 80
            },
            left: 0,
            right: 0,
            mx: "auto"
        }), {
            mx: "auto",
            transition: "width 0.3s ease-in-out",
            pointerEvents: "auto",
            zIndex: 10
        });
    }, [
        isBackgroundVisible,
        showSkeleton,
        wrapperWidth
    ]);
    var searchTitleWrapperStyle = (0,react.useMemo)(function() {
        return {
            width: "100%",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "center",
            maxHeight: "48px",
            height: "100%",
            minHeight: {
                xs: (!!searchText || !!selectedCategory) && mobilePosition > 1 ? "30px" : "0px",
                sm: "0px"
            }
        };
    }, [
        mobilePosition,
        searchText,
        selectedCategory
    ]);
    var menuButtonStyle = (0,react.useMemo)(function() {
        return {
            minWidth: "unset",
            width: "44px",
            height: "44px",
            background: "#fff",
            borderRadius: "8px",
            display: {
                xs: "none",
                lg: "inline-flex"
            },
            "&:hover": {
                background: "#fff"
            }
        };
    }, []);
    var clearSearchButtonStyle = (0,react.useMemo)(function() {
        return {
            minWidth: "unset",
            width: "44px",
            height: "44px",
            background: "#fff",
            borderRadius: "8px",
            display: {
                xs: "none",
                lg: "inline-flex"
            },
            "&:hover": {
                background: "#fff"
            }
        };
    }, []);
    var searchTextFieldStyle = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: "100%",
            "& .MuiInputBase-input": {
                fontSize: "18px",
                fontFamily: "Inter, Heebo, sans-serif"
            },
            "& .MuiOutlinedInput-notchedOutline legend": {
                display: "none"
            }
        }, deviceManager/* default.isMobile */.Z.isMobile() && {
            input: {
                "&::placeholder": {
                    color: "#98A2B3",
                    fontSize: "18px",
                    fontStyle: "normal",
                    fontWeight: rtl ? 500 : 600,
                    lineHeight: "normal",
                    direction: rtl ? "rtl" : "ltr",
                    fontFamily: "Inter, Heebo, sans-serif"
                }
            }
        }), {
            fieldset: {
                height: "100%",
                top: 0,
                border: "none"
            },
            mb: {
                xs: "10px",
                sm: "10px"
            },
            mt: {
                xs: "10px",
                sm: "48px"
            },
            pointerEvents: "auto"
        });
    }, [
        rtl
    ]);
    var resultsMainWrapperStyle = (0,react.useMemo)(function() {
        return {
            // position: { xs: 'absolute', sm: 'unset' },
            // top: '117px',
            width: {
                xs: wrapperWidth,
                lg: showSkeleton ? "calc(".concat(wrapperWidth, " + 30px)") : wrapperWidth
            },
            flexWrap: "wrap",
            display: {
                xs: mobilePosition === 0 || mobilePosition === 1 && (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 3 || popupOpen ? "none" : "flex",
                sm: "flex"
            },
            visibility: popupOpen ? "hidden" : "visible",
            zIndex: 1000,
            mx: "auto",
            borderRadius: "8px",
            background: {
                xs: "transparent",
                sm: "#fff"
            },
            border: {
                xs: "none",
                lg: "1px solid #D0D5DD"
            },
            animation: "fade-in 0.5s ease-in-out forwards",
            "@keyframes fade-in": {
                "0%": {
                    opacity: 0
                },
                "100%": {
                    opacity: 1
                }
            }
        };
    }, [
        wrapperWidth,
        showSkeleton,
        mobilePosition,
        filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length,
        popupOpen
    ]);
    var resultsSecondWrapperStyle = (0,react.useMemo)(function() {
        return {
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: "72px",
            px: {
                xs: "0px",
                sm: "20px"
            },
            display: {
                xs: !(searchText === null || searchText === void 0 ? void 0 : searchText.length) && !selectedCategory ? "none" : "flex",
                sm: "flex"
            }
        };
    }, [
        searchText === null || searchText === void 0 ? void 0 : searchText.length,
        selectedCategory
    ]);
    var chevronWrapperStyle = (0,react.useMemo)(function() {
        return {
            display: {
                xs: "none",
                sm: "flex"
            },
            width: "44px",
            height: "44px",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "8px",
            background: "#FFF",
            cursor: "pointer",
            border: "1px solid #EAECF0"
        };
    }, []);
    var calculateHeight = function() {
        return "".concat(0.95 * window.innerHeight - 250, "px");
    };
    var ref = (0,react.useState)(calculateHeight), dynamicHeight = ref[0], setDynamicHeight = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setDynamicHeight(calculateHeight());
        };
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var itemsWrapperStyle = (0,react.useMemo)(function() {
        return {
            gap: {
                xs: mobilePosition > 1 ? 0 : "10px",
                sm: 0
            },
            width: {
                xs: mobilePosition > 1 ? "100vw" : "100%",
                sm: "100%"
            },
            flexDirection: "row",
            flexWrap: {
                xs: mobilePosition > 1 ? "wrap" : "nowrap",
                sm: "wrap"
            },
            background: "transparent",
            maxHeight: {
                xs: dynamicHeight,
                sm: "410px"
            },
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
                backgroundColor: "transparent"
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "transparent",
                borderRadius: "4px"
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent"
            },
            "&:hover": {
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#BDBDBD"
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "#fff"
                }
            },
            overflowX: {
                xs: (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 3 && mobilePosition < 2 ? "auto" : "hidden",
                sm: "hidden"
            },
            justifyContent: {
                xs: (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 3 && mobilePosition < 2 ? "flex-start" : "center",
                sm: "center"
            },
            marginLeft: {
                xs: mobilePosition > 1 ? "-14px" : "unset",
                sm: "unset"
            }
        };
    }, [
        mobilePosition,
        filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length,
        dynamicHeight
    ]);
    var itemStyle = (0,react.useMemo)(function() {
        return {
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: {
                xs: mobilePosition < 2 ? "117px" : "auto",
                sm: "auto"
            },
            px: {
                xs: "14px",
                sm: "20px"
            },
            py: {
                xs: mobilePosition > 1 ? "14px" : "unset",
                sm: "18.145px"
            },
            display: "flex !important",
            borderTop: {
                xs: mobilePosition > 1 ? "1px solid #EAECF0 !important" : "none",
                lg: "1px solid #D0D5DD"
            },
            borderBottom: {
                xs: mobilePosition > 1 ? "1px solid #EAECF0 !important" : "none",
                lg: "none"
            },
            cursor: "pointer",
            border: {
                xs: mobilePosition < 2 ? "1px solid #EAECF0" : "none",
                sm: "none"
            },
            borderRadius: {
                xs: mobilePosition < 2 ? "8px" : "0px",
                sm: "0px"
            },
            background: "#FFF",
            // minWidth: { xs: '114px', sm: 'unset' },
            maxWidth: {
                xs: (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 3 && mobilePosition < 2 ? "114px" : "unset",
                sm: "unset"
            },
            "&:hover": {
                background: "rgba(32, 85, 255, 0.06)"
            }
        };
    }, [
        filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length,
        mobilePosition
    ]);
    var itemInnerStyle = (0,react.useMemo)(function() {
        return {
            flexDirection: {
                xs: mobilePosition < 2 ? "column" : "row",
                sm: "row"
            },
            alignItems: "center",
            flex: 1,
            boxSizing: "border-box",
            gap: {
                xs: "10px",
                sm: "unset"
            }
        };
    }, [
        mobilePosition
    ]);
    var itemIconStyle = (0,react.useMemo)(function() {
        return {
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            background: "transparent",
            borderRadius: "8px",
            p: 0,
            mr: {
                xs: 0,
                sm: rtl ? "0" : "14px"
            },
            ml: {
                xs: 0,
                sm: rtl ? "14px" : "0"
            },
            border: "1px solid #E8E8E8",
            flexShrink: 0
        };
    }, [
        rtl
    ]);
    var itemChevronStyle = (0,react.useMemo)(function() {
        return {
            display: {
                xs: "none",
                sm: "flex"
            },
            flexDirection: "row",
            gap: "10px",
            alignItems: "center",
            width: "128px",
            justifyContent: "flex-end",
            flex: 1,
            boxSizing: "border-box"
        };
    }, []);
    var choicePopupWrapper = (0,react.useMemo)(function() {
        return {
            padding: "0px",
            width: deviceManager/* default.isMobile */.Z.isMobile() ? "100%" : "340px",
            overflow: "hidden",
            background: "#F7F7F7",
            transform: "none",
            position: "static",
            animation: "none",
            marginLeft: deviceManager/* default.isMobile */.Z.isMobile() ? 0 : ""
        };
    }, []);
    var choicePopupSearchBar = (0,react.useMemo)(function() {
        return {
            width: "100%",
            height: "50px",
            justifyContent: "center",
            gap: "10px",
            background: "#ffffff",
            borderRadius: "10px",
            border: "1px solid #D0D5DD",
            fieldset: {
                border: "none"
            },
            "& .MuiInputBase-input": {
                fontSize: "16px",
                fontWeight: 400
            }
        };
    }, []);
    var choicePopupFilteredBtn = (0,react.useMemo)(function() {
        return {
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            height: "74px",
            padding: "18px 14px",
            gap: "10px",
            borderBottom: "1px solid #E8E8E8",
            color: "#101828"
        };
    }, []);
    var popupsContainerStyle = (0,react.useMemo)(function() {
        return {
            position: deviceManager/* default.isMobile */.Z.isMobile() ? "unset" : "fixed",
            maxHeight: "calc(95vh - ".concat(deviceManager/* default.isMobile */.Z.isMobile() ? 63 : 70, "px - 20px)"),
            height: {
                xs: navigationSharingPopupOpen && actionPathFinished ? "30dvh" : "100dvh",
                sm: "fit-content"
            },
            overflow: "auto",
            width: {
                xs: "100%",
                sm: "fit-content"
            },
            marginTop: {
                xs: "0",
                sm: "20px"
            },
            marginLeft: {
                xs: "0",
                sm: "20px"
            },
            backgroundColor: "#fff",
            borderRadius: "14px",
            zIndex: 100,
            "&::-webkit-scrollbar": {
                background: "transparent"
            },
            "&::-webkit-scrollbar-thumb": {
                width: "6px",
                backgroundColor: "#BDBDBD",
                borderRadius: "4px"
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "#F7F7F7"
            }
        };
    }, [
        navigationSharingPopupOpen,
        actionPathFinished
    ]);
    return {
        searchWrapperStyle: searchWrapperStyle,
        searchTitleWrapperStyle: searchTitleWrapperStyle,
        menuButtonStyle: menuButtonStyle,
        clearSearchButtonStyle: clearSearchButtonStyle,
        searchTextFieldStyle: searchTextFieldStyle,
        resultsMainWrapperStyle: resultsMainWrapperStyle,
        resultsSecondWrapperStyle: resultsSecondWrapperStyle,
        chevronWrapperStyle: chevronWrapperStyle,
        itemsWrapperStyle: itemsWrapperStyle,
        itemStyle: itemStyle,
        itemIconStyle: itemIconStyle,
        itemChevronStyle: itemChevronStyle,
        itemInnerStyle: itemInnerStyle,
        choicePopupWrapper: choicePopupWrapper,
        choicePopupSearchBar: choicePopupSearchBar,
        choicePopupFilteredBtn: choicePopupFilteredBtn,
        popupsContainerStyle: popupsContainerStyle
    };
};
var mobileCloseButtonStyle = {
    position: "absolute",
    top: {
        xs: "14px",
        sm: "10px"
    },
    right: {
        xs: "14px",
        sm: "10px"
    },
    width: {
        xs: "32px",
        sm: "30px"
    },
    height: {
        xs: "32px",
        sm: "30px"
    },
    borderRadius: "80px",
    background: "#EAECF0",
    boxShadow: "0px 0.727px 1.455px 0px rgba(16, 24, 40, 0.05)",
    minWidth: "unset",
    zIndex: 9999,
    "&>i": {
        color: "black"
    }
};

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./utils/removeHTMLTagsFromString.ts
var removeHTMLTagsFromString = __webpack_require__(98765);
;// CONCATENATED MODULE: ./components/navigation/search-bar/components/NavItemsSlider.tsx







var settings = {
    dots: true,
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    appendDots: function(dots) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                marginTop: "20px"
            },
            children: dots.map(function(dot, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        width: index === dots.findIndex(function(d) {
                            return d.props.className.includes("slick-active");
                        }) ? 16 : 10,
                        height: 6,
                        borderRadius: "26px",
                        backgroundColor: index === dots.findIndex(function(d) {
                            return d.props.className.includes("slick-active");
                        }) ? "#3b82f6" : "#94a3b8",
                        margin: "0 6px",
                        transition: "all 0.3s ease"
                    }
                }, index);
            })
        });
    }
};
var NavItemsSlider = function(param) {
    var filteredItems = param.filteredItems, categories = param.categories, itemStyle = param.itemStyle, handleItemSelect = param.handleItemSelect, itemInnerStyle = param.itemInnerStyle, itemIconStyle = param.itemIconStyle, rtl = param.rtl, navigationSettings = param.navigationSettings, itemChevronStyle = param.itemChevronStyle, showSkeleton = param.showSkeleton, renderCategoryIcon = param.renderCategoryIcon;
    return showSkeleton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        variant: "rounded",
        height: 117,
        width: "100%"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            maxWidth: "100vw",
            width: "100%",
            zIndex: 10
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: "nav-slider"
        }, settings), {
            children: [
                (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 0 && filteredItems.map(function(item) {
                    var ref, ref1, ref2, ref3, ref4;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        id: item.id,
                        sx: itemStyle,
                        onClick: function() {
                            return handleItemSelect(item);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                sx: itemInnerStyle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: itemIconStyle,
                                        children: (item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.webPathThumbnail) && (item === null || item === void 0 ? void 0 : (ref1 = item.tag) === null || ref1 === void 0 ? void 0 : ref1.navigationThumbnail) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            alt: "Thumbnail",
                                            src: "".concat("https://cdn.treedis.com", "/tours/").concat(item.tourId, "/tags/icons/").concat(item.tag.navigationThumbnail),
                                            style: {
                                                width: "38px",
                                                height: "38px"
                                            }
                                        }) : (0,search_bar_util/* renderIcon */.hY)(item[item.type], 38, 38)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            textAlign: rtl ? "right" : "center",
                                            direction: rtl ? "rtl" : "ltr"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                fontSize: {
                                                    xs: "14px",
                                                    sm: "16px"
                                                },
                                                fontWeight: {
                                                    xs: 400,
                                                    sm: 500
                                                },
                                                children: (0,search_bar_util/* trimDescription */.FR)(((ref2 = item[item.type]) === null || ref2 === void 0 ? void 0 : ref2.title) || (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.name), 15)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                sx: {
                                                    display: {
                                                        xs: "none",
                                                        sm: "block"
                                                    }
                                                },
                                                children: (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.descriptionEnabled) && (0,search_bar_util/* trimDescription */.FR)((0,removeHTMLTagsFromString/* removeHTMLTagsFromString */.d)((ref3 = item[item.type]) === null || ref3 === void 0 ? void 0 : ref3.description), 100)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                flex: 1,
                                boxSizing: "border-box",
                                sx: {
                                    display: {
                                        xs: "none",
                                        lg: "flex"
                                    },
                                    ":hover": {
                                        background: "rgba(32, 85, 255, 0.06)"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    textAlign: "start",
                                    fontSize: "16px",
                                    sx: {
                                        color: "#667085"
                                    },
                                    children: item === null || item === void 0 ? void 0 : (ref4 = item.category) === null || ref4 === void 0 ? void 0 : ref4.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: itemChevronStyle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-solid fa-chevron-".concat(rtl ? "left" : "right")
                                })
                            })
                        ]
                    }, item.id);
                }),
                (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && categories.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        width: {
                            xs: "100%",
                            lg: "154px"
                        },
                        height: {
                            xs: "114px",
                            lg: "94px"
                        },
                        gap: "6px",
                        alignItems: "center",
                        justifyContent: "center",
                        p: {
                            xs: "10px",
                            lg: "14px"
                        },
                        overflow: "hidden",
                        sx: {
                            display: "flex !important",
                            borderRadius: "8px",
                            border: "1px solid #EAECF0",
                            background: "#FFF",
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return handleItemSelect(category);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                width: "30px",
                                height: "30px",
                                sx: {
                                    background: category.backgroundColor || "#2055FF",
                                    borderRadius: "8px",
                                    p: "6px 5px"
                                },
                                children: renderCategoryIcon(category)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "14px",
                                fontWeight: {
                                    xs: 400,
                                    sm: 500
                                },
                                textAlign: "center",
                                whiteSpace: "break-spaces",
                                width: "inherit",
                                textOverflow: "ellipsis",
                                p: {
                                    xs: "0 10px",
                                    lg: "0 14px"
                                },
                                lineHeight: 1,
                                children: (0,search_bar_util/* trimDescription */.FR)(category.title, 15)
                            })
                        ]
                    }, category.id);
                })
            ]
        }))
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/RatingTooltip.tsx












var ratings = [
    {
        value: 1,
        icon: "/navigation/emoji_1.svg",
        iconHover: "/navigation/emoji_1_hover.svg"
    },
    {
        value: 2,
        icon: "/navigation/emoji_2.svg",
        iconHover: "/navigation/emoji_2_hover.svg"
    },
    {
        value: 3,
        icon: "/navigation/emoji_3.svg",
        iconHover: "/navigation/emoji_3_hover.svg"
    },
    {
        value: 4,
        icon: "/navigation/emoji_4.svg",
        iconHover: "/navigation/emoji_4_hover.svg"
    },
    {
        value: 5,
        icon: "/navigation/emoji_5.svg",
        iconHover: "/navigation/emoji_5_hover.svg"
    }, 
];
var RatingTooltip = function(param) {
    var children = param.children, tour = param.tour, target = param.target, actionPathFinished = param.actionPathFinished, ratingEnabled = param.ratingEnabled, isShare = param.isShare, tooltipContainerRef = param.tooltipContainerRef, rtl = param.rtl;
    var ref;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(null), selectedRating = ref2[0], setSelectedRating = ref2[1];
    var rect = tooltipContainerRef === null || tooltipContainerRef === void 0 ? void 0 : (ref = tooltipContainerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    (0,react.useEffect)(function() {
        var openTimeoutId;
        var closeTimeoutId;
        var autoCloseIfNoRatingTimeoutId;
        if (actionPathFinished && ratingEnabled) {
            // Delay opening the popup
            openTimeoutId = setTimeout(function() {
                setOpen(true);
                // If no rating after 5s, close automatically
                if (!selectedRating) {
                    autoCloseIfNoRatingTimeoutId = setTimeout(function() {
                        setOpen(false);
                    }, 5000);
                }
            }, isShare ? 500 : 3000);
            // If rating is already chosen, we still close after 3s
            if (selectedRating) {
                closeTimeoutId = setTimeout(function() {
                    setOpen(false);
                }, 3000);
            }
        }
        return function() {
            clearTimeout(openTimeoutId);
            clearTimeout(closeTimeoutId);
            clearTimeout(autoCloseIfNoRatingTimeoutId);
        };
    }, [
        actionPathFinished,
        isShare,
        ratingEnabled,
        selectedRating
    ]);
    var handleSelectRating = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(rating) {
            var dataToSave;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (selectedRating) return [
                            2
                        ];
                        setSelectedRating(rating);
                        dataToSave = typeof target.id === "number" ? {
                            rating: rating.value,
                            tourId: tour.id,
                            targetId: target.id,
                            targetTitle: target.title || target.name
                        } : {
                            rating: rating.value,
                            tourId: tour.id,
                            sweepId: target.id,
                            targetTitle: target.title || target.name
                        };
                        return [
                            4,
                            TreedisAdminDAO/* default.saveNavigationRating */.Z.saveNavigationRating(dataToSave)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectRating(rating) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        open: open,
        arrow: !deviceManager/* default.isMobile */.Z.isMobile(),
        placement: deviceManager/* default.isMobile */.Z.isMobile() ? "top" : "right",
        componentsProps: {
            arrow: {
                sx: {
                    color: "#fff"
                }
            },
            tooltip: {
                sx: {
                    background: "#fff",
                    p: "12px",
                    borderRadius: "8px",
                    margin: 0,
                    marginLeft: {
                        xs: 0,
                        sm: isShare ? "50px !important" : "14px !important"
                    },
                    marginTop: {
                        xs: 0,
                        sm: isShare ? "45px" : ""
                    },
                    maxWidth: {
                        xs: "100%",
                        sm: "300px"
                    }
                }
            }
        },
        PopperProps: {
            sx: deviceManager/* default.isMobile */.Z.isMobile() ? {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff",
                width: "calc(100vw - 28px)",
                borderRadius: "8px"
            } : {},
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: deviceManager/* default.isMobile */.Z.isMobile() && (rect === null || rect === void 0 ? void 0 : rect.top) ? [
                            0,
                            rect.top - 150
                        ] : [
                            0,
                            20
                        ]
                    }
                }
            ]
        },
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    sx: mobileCloseButtonStyle,
                    onClick: function() {
                        setOpen(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* CrossIcon */.aM, {
                        style: {}
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    sx: {
                        padding: "15px 10px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: "#000",
                                textAlign: "center",
                                fontSize: "16px",
                                fontWeight: 400,
                                lineHeight: "24px",
                                direction: rtl ? "rtl" : "ltr"
                            },
                            children: !selectedRating ? "".concat(translation.navDidYouLike || "Did you like the navigation?") : "".concat(translation.navThanksForVote || "Thank you!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            gap: "11.36px",
                            pt: "16px",
                            children: ratings.map(function(rating) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(styles/* RatingImage */.u8, {
                                    onMouseEnter: function(e) {
                                        if (!selectedRating || selectedRating.value !== rating.value) {
                                            e.currentTarget.src = rating.iconHover;
                                        }
                                    },
                                    onMouseLeave: function(e) {
                                        if (!selectedRating || selectedRating.value !== rating.value) {
                                            e.currentTarget.src = rating.icon;
                                        }
                                    },
                                    onClick: function() {
                                        return handleSelectRating(rating);
                                    },
                                    width: "41px",
                                    height: "41px",
                                    src: (selectedRating === null || selectedRating === void 0 ? void 0 : selectedRating.value) === rating.value ? rating.iconHover : rating.icon,
                                    alt: "rating-".concat(rating.value)
                                }, rating.value);
                            })
                        })
                    ]
                })
            ]
        }),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/components/ShareContainer.tsx












var ShareContainer = function(props) {
    var popupTitle = props.popupTitle, qrEnabled = props.qrEnabled, qrTitle = props.qrTitle, smsEnabled = props.smsEnabled, smsTitle = props.smsTitle, smsText = props.smsText, target = props.target, tour = props.tour, actionPathFinished = props.actionPathFinished, ratingEnabled = props.ratingEnabled, startingPoint = props.startingPoint, rtl = props.rtl, country = props.country, policy = props.policy;
    var ref = (0,react.useState)(""), phoneNumber = ref[0], setPhoneNumber = ref[1];
    var ref1 = (0,react.useState)(), countryCode = ref1[0], setCountryCode = ref1[1];
    var ref2 = (0,react.useState)(false), isValid = ref2[0], setIsValid = ref2[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var mobileLink = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var startingPointId = (startingPoint === null || startingPoint === void 0 ? void 0 : (ref = startingPoint.tag) === null || ref === void 0 ? void 0 : ref.defaultSid) || (startingPoint === null || startingPoint === void 0 ? void 0 : (ref1 = startingPoint.station) === null || ref1 === void 0 ? void 0 : ref1.id) || (startingPoint === null || startingPoint === void 0 ? void 0 : startingPoint.id);
        var targetId = (target === null || target === void 0 ? void 0 : (ref2 = target.tag) === null || ref2 === void 0 ? void 0 : ref2.defaultSid) || (target === null || target === void 0 ? void 0 : (ref3 = target.tag) === null || ref3 === void 0 ? void 0 : ref3.sid) || (target === null || target === void 0 ? void 0 : (ref4 = target.station) === null || ref4 === void 0 ? void 0 : ref4.id) || (target === null || target === void 0 ? void 0 : target.id);
        return "".concat(window.location.origin + window.location.pathname.replace("kiosk", "tour"), "?start=").concat(startingPointId, "&target=").concat(targetId);
    }, [
        target,
        startingPoint
    ]);
    var handleMobileNumberChange = function(value, data) {
        setPhoneNumber(value);
        setCountryCode(data.dialCode);
        var isValidNumber = data.format.replace(/[+()\s-]/g, "").length === value.length;
        setIsValid(isValidNumber);
    };
    var handleSendSms = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisAdminDAO/* default.sendNavigationLinkSms */.Z.sendNavigationLinkSms({
                                mobileLink: mobileLink,
                                phoneNumber: phoneNumber,
                                smsText: smsText
                            })
                        ];
                    case 1:
                        _state.sent();
                        react_toastify_esm/* toast.success */.Am.success((translation === null || translation === void 0 ? void 0 : translation.navSmsSent) || "SMS sent successfully");
                        setPhoneNumber(countryCode);
                        setIsValid(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendSms() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            background: "#FFF",
            alignItems: "center",
            padding: "14px 10px",
            gap: "10px",
            textAlign: "center",
            borderRadius: "10px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingTooltip, {
                        tour: tour,
                        target: target,
                        actionPathFinished: !actionPathFinished,
                        ratingEnabled: ratingEnabled,
                        isShare: true,
                        rtl: rtl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            fontSize: "16px",
                            fontWeight: rtl ? 500 : 600,
                            color: "#1E1E1E",
                            sx: {
                                direction: rtl ? "rtl" : "ltr"
                            },
                            children: popupTitle
                        })
                    }),
                    qrEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "12px",
                        fontWeight: rtl ? 400 : 500,
                        color: "#667085",
                        sx: {
                            direction: rtl ? "rtl" : "ltr"
                        },
                        children: qrTitle
                    })
                ]
            }),
            qrEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    borderRadius: "10px",
                    border: "1px solid var(--Gray-200, #EAECF0)",
                    padding: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    alt: "qr",
                    src: "https://api.qrserver.com/v1/create-qr-code/?size=166x166&data=".concat(encodeURIComponent(mobileLink)),
                    width: "166px",
                    height: "166px"
                })
            }),
            smsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    qrEnabled && smsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            background: "#FFF",
                            position: "relative",
                            width: "310px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "12px",
                                fontWeight: rtl ? 400 : 500,
                                mx: "auto",
                                color: "#667085",
                                sx: {
                                    zIndex: 10,
                                    padding: "0px 10px",
                                    width: "max-content",
                                    backgroundColor: "#fff",
                                    direction: rtl ? "rtl" : "ltr"
                                },
                                children: smsTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Divider */.iz, {
                                style: {
                                    margin: 0,
                                    width: "310px",
                                    position: "absolute",
                                    top: "50%"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: {
                            maxWidth: "372px",
                            width: "100%",
                            position: "relative"
                        },
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledPhoneInput */.qi, {
                                country: (country === null || country === void 0 ? void 0 : country.toLowerCase()) || "il",
                                specialLabel: "",
                                placeholder: "",
                                value: phoneNumber,
                                onChange: handleMobileNumberChange,
                                enableSearch: true,
                                searchStyle: {
                                    margin: "0px",
                                    padding: "0px"
                                },
                                inputStyle: {
                                    height: "40px",
                                    borderRadius: "8px",
                                    width: "274px",
                                    marginRight: "auto",
                                    marginLeft: "auto",
                                    fontWeight: "500",
                                    fontSize: "14px"
                                },
                                buttonStyle: {
                                    paddingLeft: "14px"
                                },
                                sx: {
                                    fontSize: "14px",
                                    fontWeight: "500"
                                },
                                countryCodeEditable: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                edge: "end",
                                style: {
                                    width: "36px",
                                    height: "40px",
                                    position: "absolute",
                                    right: "20px",
                                    borderRadius: "8px",
                                    borderLeft: "1px solid var(--Gray-100, #F2F4F7)",
                                    borderTopLeftRadius: "1px",
                                    borderBottomLeftRadius: "1px"
                                },
                                onClick: handleSendSms,
                                disabled: !isValid,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* SendIcon */.jE, {
                                    style: {
                                        width: "20px",
                                        height: "20px",
                                        color: "#667085"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            fontSize: "12px",
                            fontWeight: rtl ? 400 : 500,
                            color: "#667085",
                            sx: {
                                direction: rtl ? "rtl" : "ltr"
                            },
                            children: policy
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/NavigationSharePopup.tsx









var NavigationSharePopup_IMAGE_HEIGHT = 192;
var NavigationSharePopup = function(props) {
    var open = props.open, setOpen = props.setOpen, setPopupHeight = props.setPopupHeight, popupTitle = props.popupTitle, qrEnabled = props.qrEnabled, qrTitle = props.qrTitle, smsEnabled = props.smsEnabled, smsTitle = props.smsTitle, smsText = props.smsText, target = props.target, startingPoint = props.startingPoint, rtl = props.rtl, country = props.country, policy = props.policy;
    var ref = (0,react.useState)(open), isVisible = ref[0], setIsVisible = ref[1];
    var textContainerRef = (0,react.useRef)(null);
    var titleContainerRef = (0,react.useRef)(null);
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    // eslint-disable-next-line consistent-return
    (0,react.useEffect)(function() {
        if (open) {
            setIsVisible(true);
        } else {
            var timer = setTimeout(function() {
                return setIsVisible(false);
            }, 300);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        open
    ]);
    (0,react.useLayoutEffect)(function() {
        var ref, ref1;
        var textHeight = (ref = textContainerRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight;
        var titleHeight = (ref1 = titleContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight;
        var height = textHeight + titleHeight + NavigationSharePopup_IMAGE_HEIGHT;
        if (height) setPopupHeight(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Background */.Aq, {
            open: open,
            isVisible: isVisible,
            style: {
                background: "none",
                backdropFilter: "blur(0px)",
                position: "static",
                marginTop: isMobile ? "unset" : "",
                height: isMobile ? "100%" : "auto",
                display: open ? "" : "none",
                width: isMobile ? "100%" : "fit-content"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
                open: open,
                onClick: function(e) {
                    return e.stopPropagation();
                },
                style: {
                    position: isMobile ? "relative" : "static",
                    padding: "0px",
                    width: isMobile ? "auto" : "340px",
                    height: isMobile ? "100%" : "auto",
                    border: isMobile ? "none" : "1px solid #F7F7F7",
                    transform: "none",
                    animation: "none",
                    marginLeft: isMobile ? "0" : "",
                    background: isMobile ? "none" : "#F7F7F7",
                    borderRadius: "14px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        ref: titleContainerRef,
                        sx: {
                            p: "14px",
                            background: "#F7F7F7",
                            alignItems: "center",
                            justifyContent: {
                                xs: "center",
                                sm: "space-between"
                            },
                            borderBottom: "1px solid var(--Gray-300, #D0D5DD)",
                            borderTopLeftRadius: "14px",
                            borderTopRightRadius: "14px"
                        },
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    borderRadius: "1rem",
                                    padding: "4px",
                                    background: "#EAECF0",
                                    width: "32px",
                                    height: "32px",
                                    display: {
                                        xs: "none",
                                        sm: "inline-flex"
                                    }
                                },
                                onClick: function() {
                                    return setOpen(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* ChevronLeftIcon */.wy, {
                                    style: {}
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "16px",
                                fontWeight: rtl ? 400 : 500,
                                lineHeight: "24px",
                                sx: {
                                    direction: rtl ? "rtl" : "ltr"
                                },
                                children: translation.navShareToPhone || "Share to your phone"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    width: "32px",
                                    height: "32px",
                                    color: "black",
                                    fontSize: "16px",
                                    borderRadius: "1rem",
                                    marginRight: "5px",
                                    backgroundColor: "#eaecf0",
                                    visibility: "hidden"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-solid fa-chevron-right"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: {
                            padding: "14px",
                            background: "#F2F4F7",
                            borderTop: "1px solid var(--Gray-200, #EAECF0)",
                            borderBottomLeftRadius: "14px",
                            borderBottomRightRadius: "14px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContainer, {
                            popupTitle: popupTitle,
                            qrEnabled: qrEnabled,
                            qrTitle: qrTitle,
                            smsEnabled: smsEnabled,
                            smsTitle: smsTitle,
                            smsText: smsText,
                            target: target,
                            startingPoint: startingPoint,
                            rtl: rtl,
                            country: country,
                            policy: policy
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/DetailedRoutes.tsx
var DetailedRoutes = __webpack_require__(92867);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/Popup/NavigationTourSharePopup.tsx












var NavigationTourSharePopup_IMAGE_HEIGHT = 192;
var NavigationTourSharePopup = function(props) {
    var open = props.open, setOpen = props.setOpen, setPopupHeight = props.setPopupHeight, popupTitle = props.popupTitle, qrEnabled = props.qrEnabled, qrTitle = props.qrTitle, smsEnabled = props.smsEnabled, smsTitle = props.smsTitle, smsText = props.smsText, startingPoint = props.startingPoint, setBackgroundVisible = props.setBackgroundVisible, setChoicePopupOpen = props.setChoicePopupOpen, setNavigationDestination = props.setNavigationDestination, item = props.item, detailedRouteEnabled = props.detailedRouteEnabled, target = props.target, detailedRoutes = props.detailedRoutes, showDetailedRoutesOnly = props.showDetailedRoutesOnly, closeDetailedRoutesList = props.closeDetailedRoutesList, setActionPathNavbarPlayButtonType = props.setActionPathNavbarPlayButtonType, navigationManager = props.navigationManager, navigationType = props.navigationType, actionPathFinished = props.actionPathFinished, handleBackToSearchBar = props.handleBackToSearchBar, handleReplay = props.handleReplay, tour = props.tour, ratingEnabled = props.ratingEnabled, startingPointTitle = props.startingPointTitle, finishPointTitle = props.finishPointTitle, rtl = props.rtl, country = props.country, showCaseTemp = props.showCaseTemp, policy = props.policy;
    var ref = (0,react.useState)(open), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(false), showShareButton = ref1[0], setShowShareButton = ref1[1];
    var textContainerRef = (0,react.useRef)(null);
    var titleContainerRef = (0,react.useRef)(null);
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var tooltipContainerRef = (0,react.useRef)(null);
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    // eslint-disable-next-line consistent-return
    (0,react.useEffect)(function() {
        if (open) {
            setIsVisible(true);
        } else {
            var timer = setTimeout(function() {
                return setIsVisible(false);
            }, 300);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        open
    ]);
    (0,react.useLayoutEffect)(function() {
        var ref, ref1;
        var textHeight = (ref = textContainerRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight;
        var titleHeight = (ref1 = titleContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight;
        var height = textHeight + titleHeight + NavigationTourSharePopup_IMAGE_HEIGHT;
        if (height) setPopupHeight(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isVisible
    ]);
    (0,react.useEffect)(function() {
        if (actionPathFinished) {
            setShowShareButton(true);
        } else {
            setShowShareButton(false);
        }
    }, [
        actionPathFinished
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Background */.Aq, {
            id: "tour-share-popup",
            open: open,
            isVisible: isVisible,
            style: {
                background: "none",
                backdropFilter: "blur(0px)",
                position: isMobile ? "relative" : "fixed",
                marginTop: isMobile ? "unset" : "20px",
                height: isMobile ? "100%" : "auto",
                display: open ? "" : "none",
                width: isMobile ? "100%" : "fit-content"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* Wrapper */.im, {
                open: open,
                onClick: function(e) {
                    return e.stopPropagation();
                },
                style: {
                    position: isMobile ? "relative" : "static",
                    padding: "0px",
                    width: isMobile ? "auto" : "340px",
                    height: isMobile ? "100%" : "auto",
                    border: isMobile ? "none" : "1px solid #F7F7F7",
                    transform: "none",
                    animation: "none",
                    marginLeft: isMobile ? "0" : "20px",
                    background: isMobile ? "none" : "#F7F7F7",
                    borderRadius: "14px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        id: "titles",
                        ref: titleContainerRef,
                        sx: {
                            display: {
                                xs: actionPathFinished ? "none" : "flex",
                                sm: "flex"
                            },
                            p: "14px",
                            background: "#F7F7F7",
                            alignItems: "center",
                            justifyContent: {
                                xs: showDetailedRoutesOnly ? "space-between" : "center",
                                sm: "space-between"
                            },
                            borderBottom: "1px solid var(--Gray-300, #D0D5DD)",
                            borderTopLeftRadius: "14px",
                            borderTopRightRadius: "14px",
                            fontWeight: rtl ? 500 : 600
                        },
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    borderRadius: "1rem",
                                    padding: "4px",
                                    background: "#EAECF0",
                                    width: "32px",
                                    height: "32px",
                                    display: {
                                        xs: showDetailedRoutesOnly ? "inline-flex" : "none",
                                        sm: "inline-flex"
                                    }
                                },
                                onClick: function() {
                                    if (showDetailedRoutesOnly) {
                                        closeDetailedRoutesList();
                                    } else if (showShareButton && !actionPathFinished) {
                                        setShowShareButton(false);
                                    } else {
                                        setOpen(false);
                                        setBackgroundVisible(true);
                                        setChoicePopupOpen(true);
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* ChevronLeftIcon */.wy, {
                                    style: {}
                                })
                            }),
                            showShareButton && !actionPathFinished && !deviceManager/* default.isMobile */.Z.isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "16px",
                                fontWeight: rtl ? 500 : 600,
                                lineHeight: "24px",
                                sx: {
                                    direction: rtl ? "rtl" : "ltr"
                                },
                                children: translation.navShareToPhone || "Share to your phone"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                textAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        sx: {
                                            direction: rtl ? "rtl" : "ltr"
                                        },
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: "#667085",
                                                fontWeight: rtl ? 400 : 500,
                                                fontSize: "16px",
                                                children: (translation === null || translation === void 0 ? void 0 : translation.navFrom) || "From"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                color: "#667085",
                                                fontWeight: rtl ? 400 : 500,
                                                fontSize: "16px",
                                                children: [
                                                    ": ",
                                                    (0,search_bar_util/* trimDescription */.FR)(startingPointTitle, 20)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        direction: "row",
                                        sx: {
                                            direction: rtl ? "rtl" : "ltr"
                                        },
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                fontSize: "16px",
                                                fontWeight: rtl ? 400 : 500,
                                                lineHeight: "24px",
                                                color: "var(--Black, #000)",
                                                children: (translation === null || translation === void 0 ? void 0 : translation.navTo) || "To"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                fontSize: "16px",
                                                fontWeight: rtl ? 400 : 500,
                                                lineHeight: "24px",
                                                color: "var(--Black, #000)",
                                                children: [
                                                    ": ",
                                                    (0,search_bar_util/* trimDescription */.FR)(finishPointTitle, 20)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    width: "32px",
                                    height: "32px",
                                    color: "black",
                                    fontSize: "16px",
                                    borderRadius: "1rem",
                                    marginRight: "5px",
                                    backgroundColor: "#eaecf0",
                                    visibility: "hidden"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-solid fa-chevron-right"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        ref: tooltipContainerRef,
                        sx: {
                            padding: "14px",
                            background: "#F2F4F7",
                            borderTop: "1px solid var(--Gray-200, #EAECF0)",
                            borderBottomLeftRadius: "14px",
                            borderBottomRightRadius: "14px"
                        },
                        children: [
                            actionPathFinished && /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingTooltip, {
                                tooltipContainerRef: tooltipContainerRef,
                                tour: tour,
                                target: target,
                                actionPathFinished: actionPathFinished,
                                ratingEnabled: ratingEnabled,
                                rtl: rtl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    sx: {
                                        background: "#FFF",
                                        alignItems: "center",
                                        padding: "15px 10px",
                                        gap: "10px",
                                        textAlign: "center",
                                        borderRadius: "10px",
                                        marginBottom: "12px",
                                        maxHeight: "104px",
                                        overflow: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* FinishIcon */.lu, {
                                                style: {}
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                textAlign: "center",
                                                textOverflow: "ellipsis",
                                                fontSize: "16px",
                                                fontWeight: 600,
                                                lineHeight: "24px",
                                                direction: rtl ? "rtl" : "ltr"
                                            },
                                            children: translation.navYouArrived || "You have arrived to destination!"
                                        })
                                    ]
                                })
                            }),
                            showShareButton && (qrEnabled || smsEnabled) && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContainer, {
                                popupTitle: popupTitle,
                                qrEnabled: qrEnabled,
                                qrTitle: qrTitle,
                                smsEnabled: smsEnabled,
                                smsTitle: smsTitle,
                                smsText: smsText,
                                tour: tour,
                                target: target,
                                actionPathFinished: actionPathFinished,
                                ratingEnabled: ratingEnabled,
                                startingPoint: startingPoint,
                                rtl: rtl,
                                country: country,
                                policy: policy
                            }),
                            !showShareButton && (qrEnabled || smsEnabled) && !deviceManager/* default.isMobile */.Z.isMobile() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    width: "100%",
                                    borderRadius: "8px",
                                    border: "1px solid #D0D5DD",
                                    color: "#2055FF",
                                    gap: "6px",
                                    background: "#ffff",
                                    marginTop: "10px",
                                    "&:hover": {
                                        background: "#ffff"
                                    },
                                    direction: rtl ? "rtl" : "ltr"
                                },
                                onClick: function() {
                                    setShowShareButton(true);
                                    setActionPathNavbarPlayButtonType("Play");
                                    navigationManager.inAutoNavigate = false;
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* PhoneIcon */.qW, {
                                        style: {
                                            width: "20px",
                                            height: "20px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        lineHeight: "21px",
                                        fontWeight: "600",
                                        sx: {
                                            direction: rtl ? "rtl" : "ltr"
                                        },
                                        children: translation.navShareToPhone || "Share to your phone"
                                    })
                                ]
                            })
                        ]
                    }),
                    actionPathFinished && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        gap: "6px",
                        padding: "14px",
                        borderTop: "1px solid var(--Gray-200, #EAECF0)",
                        mt: {
                            xs: "auto",
                            sm: "unset"
                        },
                        sx: {
                            direction: rtl ? "rtl" : "ltr"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Button */.zx, {
                                style: {
                                    padding: "0px 18px",
                                    backgroundColor: "#fff",
                                    color: "#344054",
                                    border: "1px solid #D0D5DD",
                                    height: "40px"
                                },
                                onClick: handleBackToSearchBar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        direction: rtl ? "rtl" : "ltr"
                                    },
                                    children: translation.navSearchAgain || "Search Again"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* Button */.zx, {
                                style: {
                                    padding: "0px 18px",
                                    height: "40px"
                                },
                                onClick: handleReplay,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        lineHeight: "21px",
                                        direction: rtl ? "rtl" : "ltr"
                                    },
                                    children: translation.navReplay || "Replay"
                                })
                            })
                        ]
                    }),
                    detailedRouteEnabled && !actionPathFinished && !showShareButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailedRoutes/* DetailedRoutes */.Q, {
                        item: item || {
                            tag: target
                        },
                        setNavigationDestination: setNavigationDestination,
                        isPreload: false,
                        detailedRoutes: detailedRoutes,
                        startingPoint: startingPoint,
                        showDetailedRoutesOnly: showDetailedRoutesOnly,
                        rtl: rtl,
                        navigationType: navigationType,
                        showCaseTemp: showCaseTemp
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/navigation/search-bar/NavigationSearchBar.tsx
/* eslint-disable no-nested-ternary */ 


























var NavigationSearchBar = function(param) {
    var setDestination = param.setDestination, menuItems = param.menuItems, isBackgroundVisible = param.isBackgroundVisible, setBackgroundVisible = param.setBackgroundVisible, actionPathFinished = param.actionPathFinished, tour = param.tour, target = param.target, categories = param.categories, moveToStartingPoint = param.moveToStartingPoint, filtersEnabled = param.filtersEnabled, sortingEnabled = param.sortingEnabled, defaultSorting = param.defaultSorting, navigationFinishScreen = param.navigationFinishScreen, navigationStations = param.navigationStations, tourType = param.tourType, selectedCategory = param.selectedCategory, selectCategory = param.selectCategory, appState = param.appState, setActionPathFinished = param.setActionPathFinished, isSearchBarFocused = param.isSearchBarFocused, setIsSearchBarFocused = param.setIsSearchBarFocused, rtl = param.rtl, inAutoNavigate = param.inAutoNavigate, kioskIsReset = param.kioskIsReset, setKioskIsReset = param.setKioskIsReset, searchText = param.searchText, setSearchText = param.setSearchText, hiddenFromLink = param.hiddenFromLink, showSkeleton = param.showSkeleton, pathFinderLine = param.pathFinderLine, setDescriptionEnabled = param.setDescriptionEnabled, mobilePosition = param.mobilePosition, setMobilePosition = param.setMobilePosition, popupOpen = param.popupOpen, setPopupOpen = param.setPopupOpen, setPopupHeight = param.setPopupHeight, startingPoint = param.startingPoint, allSweeps = param.allSweeps, onSetStartingPoint = param.onSetStartingPoint, currentSweep = param.currentSweep, setNavigationSharingPopupOpen = param.setNavigationSharingPopupOpen, navigationSharingPopupOpen = param.navigationSharingPopupOpen, detailedRoutes = param.detailedRoutes, choicePopupOpen = param.choicePopupOpen, setChoicePopupOpen = param.setChoicePopupOpen, showDetailedRoutesOnly = param.showDetailedRoutesOnly, closeDetailedRoutesList = param.closeDetailedRoutesList, setActionPathNavbarPlayButtonType = param.setActionPathNavbarPlayButtonType, resetDetailedRoutes = param.resetDetailedRoutes, allTags = param.allTags, teleportPoints = param.teleportPoints, navType = param.navType, setNavType = param.setNavType, selectedItem = param.selectedItem, setSelectedItem = param.setSelectedItem, setStartingPoint = param.setStartingPoint, resetNavigationByCloseButton = param.resetNavigationByCloseButton, shouldNavReset = param.shouldNavReset, showCaseTemp = param.showCaseTemp;
    var sharingEnabled = navigationFinishScreen.sharingEnabled, popupTitle = navigationFinishScreen.popupTitle, qrEnabled = navigationFinishScreen.qrEnabled, qrTitle = navigationFinishScreen.qrTitle, smsEnabled = navigationFinishScreen.smsEnabled, smsTitle = navigationFinishScreen.smsTitle, smsText = navigationFinishScreen.smsText, policy = navigationFinishScreen.policy, country = navigationFinishScreen.country;
    var inputRef = (0,react.useRef)(null);
    var ratingBoardRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), inputClientRect = ref[0], setInputClientRect = ref[1];
    var ref1 = (0,react.useState)(null), ratingClientRect = ref1[0], setRatingClientRect = ref1[1];
    var ref2 = (0,react.useState)(false), showModal = ref2[0], setShowModal = ref2[1];
    var ref3 = (0,react.useState)(false), showLoader = ref3[0], setShowLoader = ref3[1];
    var ref4 = (0,react.useState)(false), isRatingBoardVisible = ref4[0], setIsRatingBoardVisible = ref4[1];
    var ref5 = (0,react.useState)(false), loadingFinished = ref5[0], setLoadingFinished = ref5[1];
    var ref6 = (0,react.useState)([]), selectedFilters = ref6[0], setSelectedFilters = ref6[1];
    var ref7 = (0,react.useState)("default"), sortingValue = ref7[0], setSortingValue = ref7[1];
    var ref8 = (0,react.useState)(null), startSweep = ref8[0], setStartSweep = ref8[1];
    var ref9 = (0,react.useState)(false), sharePopupOpen = ref9[0], setSharePopupOpen = ref9[1];
    var navigationSettings = (0,recoil/* useRecoilValue */.sJ)(store/* navigationSettingsState */.FZ);
    var setSliderValue = (0,recoil/* useSetRecoilState */.Zl)(store/* sliderValueState */.Yb);
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var ref10 = (0,react.useState)(false), popupContentLoaded = ref10[0], setPopupContentLoaded = ref10[1];
    var ref11 = (0,react.useState)(false), choicePopupContentLoaded = ref11[0], setChoicePopupContentLoaded = ref11[1];
    var ref12 = (0,react.useState)(0), choiceButtonLoadingProgress = ref12[0], setChoiceButtonLoadingProgress = ref12[1];
    var ref13 = (0,react.useState)(null), startPointId = ref13[0], setStartPointId = ref13[1];
    var choiceButtonLoadingProgressRef = (0,react.useRef)();
    var appStateRef = (0,react.useRef)(appState);
    var intervalIdRef = (0,react.useRef)();
    var startPointTitleRef = (0,react.useRef)("");
    var finishTitleRef = (0,react.useRef)("");
    var combineNavigationItems = (0,react.useMemo)(function() {
        if (tourType === Tour/* TourType.Kiosk */.v.Kiosk) {
            var foundStation = navigationStations === null || navigationStations === void 0 ? void 0 : navigationStations.find(function(kiosk) {
                return kiosk === null || kiosk === void 0 ? void 0 : kiosk.url.includes(startSweep === null || startSweep === void 0 ? void 0 : startSweep.id);
            });
            if (foundStation) {
                var filteredStations = navigationStations === null || navigationStations === void 0 ? void 0 : navigationStations.filter(function(kiosk) {
                    return kiosk.url !== foundStation.url;
                });
                var array = [
                    foundStation
                ].concat((0,_to_consumable_array/* default */.Z)(filteredStations));
                return array;
            }
        }
        var combineArray = [
            startSweep
        ].concat((0,_to_consumable_array/* default */.Z)(navigationStations));
        return combineArray;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        navigationStations,
        startSweep
    ]);
    var filteredItems = (0,react.useMemo)(function() {
        var ref;
        var searchTextLower = searchText.toLowerCase();
        var filtered = (ref = combineNavigationItems === null || combineNavigationItems === void 0 ? void 0 : combineNavigationItems.concat(menuItems)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            var ref11;
            var titleMatch = (ref11 = (ref2 = item === null || item === void 0 ? void 0 : (ref = item[item === null || item === void 0 ? void 0 : item.type]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.includes(searchTextLower)) !== null && ref11 !== void 0 ? ref11 : false;
            var keywordMatch = item === null || item === void 0 ? void 0 : (ref3 = item.tag) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.keywords) === null || ref4 === void 0 ? void 0 : ref4.some(function(keyword) {
                return keyword.toLowerCase().includes(searchTextLower);
            });
            var descriptionMatch = item === null || item === void 0 ? void 0 : (ref5 = item.tag) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.description) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase().includes(searchTextLower);
            var filterMatch = item === null || item === void 0 ? void 0 : (ref7 = item.filters) === null || ref7 === void 0 ? void 0 : ref7.some(function(filter) {
                var ref;
                return filter === null || filter === void 0 ? void 0 : (ref = filter.title) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(searchTextLower);
            });
            var titleKioskMatch = item === null || item === void 0 ? void 0 : (ref8 = item.title) === null || ref8 === void 0 ? void 0 : ref8.toLowerCase().includes(searchTextLower);
            var titleSweepMatch = (item === null || item === void 0 ? void 0 : (ref9 = item.title) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase().includes(searchTextLower)) || (item === null || item === void 0 ? void 0 : (ref10 = item.name) === null || ref10 === void 0 ? void 0 : ref10.toLowerCase().includes(searchTextLower));
            var matchesSearchText = titleMatch || keywordMatch || filterMatch || descriptionMatch || titleKioskMatch || titleSweepMatch;
            if (selectedCategory && selectedFilters.length) {
                var ref12;
                return (item === null || item === void 0 ? void 0 : item.categoryId) === (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id) && matchesSearchText && (item === null || item === void 0 ? void 0 : (ref12 = item.filters) === null || ref12 === void 0 ? void 0 : ref12.some(function(filter) {
                    return selectedFilters.includes(filter.id);
                }));
            }
            if (choicePopupOpen) {
                selectCategory(null);
            }
            if (selectedCategory) {
                return (item === null || item === void 0 ? void 0 : item.categoryId) === (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id) && matchesSearchText;
            }
            if (selectedFilters.length) {
                var ref13;
                return matchesSearchText && (item === null || item === void 0 ? void 0 : (ref13 = item.filters) === null || ref13 === void 0 ? void 0 : ref13.some(function(filter) {
                    return selectedFilters.includes(filter.id);
                }));
            }
            return matchesSearchText;
        });
        return filtered.sort(function(a, b) {
            // Alphabetical sorting
            if (sortingValue === "alphabetical") {
                var ref, ref1, ref2, ref3, ref4;
                return ((ref = a[a.type]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.localeCompare((ref2 = b[b.type]) === null || ref2 === void 0 ? void 0 : ref2.title)) || (a === null || a === void 0 ? void 0 : (ref3 = a.title) === null || ref3 === void 0 ? void 0 : ref3.localeCompare(b === null || b === void 0 ? void 0 : b.title)) || (a === null || a === void 0 ? void 0 : (ref4 = a.name) === null || ref4 === void 0 ? void 0 : ref4.localeCompare(b === null || b === void 0 ? void 0 : b.name));
            }
            // Reverse alphabetical sorting
            if (sortingValue === "reverseAlphabetical") {
                var ref5, ref6, ref7, ref8, ref9;
                return ((ref5 = b[b.type]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.title) === null || ref6 === void 0 ? void 0 : ref6.localeCompare((ref7 = a[a.type]) === null || ref7 === void 0 ? void 0 : ref7.title)) || (b === null || b === void 0 ? void 0 : (ref8 = b.title) === null || ref8 === void 0 ? void 0 : ref8.localeCompare(a === null || a === void 0 ? void 0 : a.title)) || (b === null || b === void 0 ? void 0 : (ref9 = b.name) === null || ref9 === void 0 ? void 0 : ref9.localeCompare(a === null || a === void 0 ? void 0 : a.name));
            }
            // No sorting for 'default'
            return 0;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchText,
        combineNavigationItems,
        menuItems,
        selectedCategory,
        selectedFilters,
        choicePopupOpen,
        sortingValue
    ]);
    var wrapperWidth = (0,react.useMemo)(function() {
        if (deviceManager/* default.isMobile */.Z.isMobile()) {
            return "100%";
        }
        return "1138px";
    }, []);
    var setNavigationDestination = function(item, navigationType) {
        var preLoad = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        resetDetailedRoutes();
        setSliderValue(0);
        setKioskIsReset(false);
        // setHiddenFromLink(false);
        setDestination({
            navigationSettings: navigationSettings,
            setSliderValue: setSliderValue,
            navigationType: navigationType,
            preLoad: preLoad,
            finishingLocation: item,
            startingLocation: startingPoint
        });
    };
    var processItem = function(item, navigationType) {
        var ref;
        setShowLoader(false);
        setIsSearchBarFocused(false);
        setShowModal(false);
        var itemTitle = (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.name) || ((ref = item[item.type]) === null || ref === void 0 ? void 0 : ref.title);
        setSearchText(itemTitle);
        setIsRatingBoardVisible(false);
        setActionPathFinished(false);
        setLoadingFinished(false);
        setSliderValue(0);
        setPopupOpen(false);
        if ((item === null || item === void 0 ? void 0 : item.type) === "tag") {
            var ref1, ref2;
            (0,util/* sendToGA */.o$)("event", {
                eventCategory: "Mattertag",
                eventAction: "click",
                eventLabel: item === null || item === void 0 ? void 0 : (ref1 = item.tag) === null || ref1 === void 0 ? void 0 : ref1.title,
                eventType: item === null || item === void 0 ? void 0 : (ref2 = item.tag) === null || ref2 === void 0 ? void 0 : ref2.type
            });
        }
        setNavigationDestination(item, navigationType);
    };
    var handleItemSelect = function(item) {
        setSelectedItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            descriptionEnabled: navigationSettings.descriptionEnabled
        }));
        setPopupOpen(true);
        setActionPathFinished(false);
        if (appState === "playing") {
            setPopupContentLoaded(true);
        } else setTimeout(function() {
            setPopupContentLoaded(true);
        }, 2000);
    };
    var handleItemConfirmed = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item, navigationType) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                processItem(item, navigationType);
                return [
                    2
                ];
            });
        });
        return function handleItemConfirmed(item, navigationType) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetNavigation = function(caller) {
        setSearchText("");
        setShowModal(false);
        setIsRatingBoardVisible(false);
        setBackgroundVisible(caller !== "fromRegularTour");
        setIsSearchBarFocused(caller !== "fromRegularTour");
        moveToStartingPoint();
        if (caller === "fromKioskTimer") {
            setKioskIsReset(true);
            selectCategory(null);
            setSelectedItem(null);
            setPopupOpen(false);
            setChoicePopupOpen(false);
            setSharePopupOpen(false);
            setNavigationSharingPopupOpen(false);
        }
    };
    var clearSearch = function(event) {
        event.stopPropagation();
        setSearchText("");
        if (selectedCategory) {
            selectCategory(null);
        }
        if (selectedItem) {
            setSelectedItem(null);
        }
        setBackgroundVisible(true);
        setShowModal(false);
        setIsRatingBoardVisible(false);
        setIsSearchBarFocused(false);
    };
    (0,react.useEffect)(function() {
        if (defaultSorting) {
            setSortingValue(defaultSorting);
        }
    }, [
        defaultSorting
    ]);
    (0,react.useEffect)(function() {
        if (isRatingBoardVisible) {
            var ref;
            setRatingClientRect(ratingBoardRef === null || ratingBoardRef === void 0 ? void 0 : (ref = ratingBoardRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect());
        }
    }, [
        isRatingBoardVisible
    ]);
    (0,react.useEffect)(function() {
        if (inputRef.current) {
            setInputClientRect(inputRef.current.getBoundingClientRect());
        }
    }, [
        isBackgroundVisible
    ]);
    (0,react.useEffect)(function() {
        // Check if the search bar should be focused and if the ref is attached to an element
        if (isSearchBarFocused && inputRef.current && mobilePosition < 2) {
            inputRef.current.blur();
        }
    }, [
        isSearchBarFocused,
        mobilePosition
    ]);
    (0,react.useEffect)(function() {
        if (isBackgroundVisible) {
            setShowModal(false);
            setIsRatingBoardVisible(false);
        }
    }, [
        isBackgroundVisible
    ]);
    (0,react.useEffect)(function() {
        if (loadingFinished && (tourType === Tour/* TourType.Kiosk */.v.Kiosk || tourType === Tour/* TourType.Regular */.v.Regular)) {
            setShowModal(true);
            if (tourType === Tour/* TourType.Regular */.v.Regular) resetNavigation("fromRegularTour");
        }
        if (loadingFinished && tourType === Tour/* TourType.Kiosk */.v.Kiosk && !sharingEnabled) {
            resetNavigation();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loadingFinished,
        tourType,
        sharingEnabled
    ]);
    (0,react.useEffect)(function() {
        if ((selectedCategory || categories.length === 1) && !deviceManager/* default.isMobile */.Z.isMobile()) {
            setIsSearchBarFocused(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedCategory,
        categories
    ]);
    (0,react.useEffect)(function() {
        if (choicePopupOpen) {
            if (appState !== "playing") {
                setTimeout(function() {
                    setChoicePopupContentLoaded(true);
                }, 2000);
                var targetProgress = 85;
                var duration = 50000;
                var startTime = Date.now();
                // eslint-disable-next-line no-restricted-properties
                var easeOutExpo = function(t) {
                    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
                };
                if (!intervalIdRef.current) {
                    intervalIdRef.current = setInterval(function() {
                        if (appStateRef.current === "playing" || choiceButtonLoadingProgressRef.current === 100) {
                            setChoiceButtonLoadingProgress(100);
                            clearInterval(intervalIdRef.current);
                            return;
                        }
                        var elapsedTime = Date.now() - startTime;
                        var normalizedTime = Math.min(elapsedTime / duration, 1);
                        var easedProgress = easeOutExpo(normalizedTime) * targetProgress;
                        var newProgress = Math.floor(easedProgress);
                        setChoiceButtonLoadingProgress(newProgress);
                    }, 100);
                }
            } else {
                setChoicePopupContentLoaded(true);
                setChoiceButtonLoadingProgress(100);
            }
        }
    }, [
        choicePopupOpen,
        appState
    ]);
    (0,react.useEffect)(function() {
        choiceButtonLoadingProgressRef.current = choiceButtonLoadingProgress;
    }, [
        choiceButtonLoadingProgress
    ]);
    (0,react.useEffect)(function() {
        appStateRef.current = appState;
    }, [
        appState
    ]);
    (0,react.useEffect)(function() {
        var targetQueryParam = (0,util/* getQueryVariable */.Dv)(window.location.href, "target");
        var startQueryParam = (0,util/* getQueryVariable */.Dv)(window.location.href, "start");
        // // this is for loading in mobile from qr or sms link
        if (!target && targetQueryParam && startQueryParam && tourType === Tour/* TourType.Regular */.v.Regular && !showSkeleton && allSweeps && allTags) {
            var targetTag = filteredItems.find(function(item) {
                return item.tagSid === targetQueryParam;
            });
            var targetStation = navigationStations.find(function(station) {
                return Number(targetQueryParam) === (station === null || station === void 0 ? void 0 : station.id);
            });
            var targetSweep = Array.from(allSweeps === null || allSweeps === void 0 ? void 0 : allSweeps.values()).find(function(s) {
                return s.sweep_uuid === targetQueryParam;
            });
            var startTag = filteredItems.find(function(item) {
                var foundTag = Array.from(allTags === null || allTags === void 0 ? void 0 : allTags.values()).find(function(tag) {
                    return tag.sid === startQueryParam || tag.defaultSid === startQueryParam;
                });
                return foundTag ? foundTag.sid === item.tagSid || foundTag.defaultSid === item.tagSid : null;
            });
            var startStation = filteredItems.find(function(item) {
                var foundStation = navigationStations.find(function(station) {
                    return Number(startQueryParam) === (station === null || station === void 0 ? void 0 : station.id);
                });
                return foundStation ? foundStation.id === item.id : null;
            });
            var startingSweep = startQueryParam ? Array.from(allSweeps === null || allSweeps === void 0 ? void 0 : allSweeps.values()).find(function(s) {
                return s.sweep_uuid === startQueryParam;
            }) : Array.from(allSweeps.values()).find(function(s) {
                return s.sweep_uuid === currentSweep.uuid || s.id === currentSweep.id;
            });
            var newTarget = targetTag || targetStation || targetSweep;
            var newStart = startTag || startStation || startingSweep;
            var startingItem = (0,util/* convertDestinationItemToSweep */.RZ)({
                item: newStart,
                allSweeps: Array.from(allSweeps.values()),
                allTags: Array.from(allTags.values())
            });
            handleItemSelect(newTarget);
            setStartingPoint(startingItem);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        appState,
        target,
        pathFinderLine,
        showSkeleton
    ]);
    (0,react.useEffect)(function() {
        setDescriptionEnabled(navigationSettings.descriptionEnabled);
    }, [
        navigationSettings,
        setDescriptionEnabled
    ]);
    var ref14 = useSearchbarStyles({
        showSkeleton: showSkeleton,
        wrapperWidth: wrapperWidth,
        isBackgroundVisible: isBackgroundVisible,
        mobilePosition: mobilePosition,
        popupOpen: popupOpen,
        filteredItems: filteredItems,
        rtl: rtl,
        searchText: searchText,
        selectedCategory: selectedCategory,
        navigationSharingPopupOpen: navigationSharingPopupOpen,
        actionPathFinished: actionPathFinished
    }), searchWrapperStyle = ref14.searchWrapperStyle, searchTitleWrapperStyle = ref14.searchTitleWrapperStyle, menuButtonStyle = ref14.menuButtonStyle, clearSearchButtonStyle = ref14.clearSearchButtonStyle, searchTextFieldStyle = ref14.searchTextFieldStyle, resultsMainWrapperStyle = ref14.resultsMainWrapperStyle, resultsSecondWrapperStyle = ref14.resultsSecondWrapperStyle, chevronWrapperStyle = ref14.chevronWrapperStyle, itemsWrapperStyle = ref14.itemsWrapperStyle, itemStyle = ref14.itemStyle, itemIconStyle = ref14.itemIconStyle, itemChevronStyle = ref14.itemChevronStyle, itemInnerStyle = ref14.itemInnerStyle, choicePopupWrapper = ref14.choicePopupWrapper, choicePopupSearchBar = ref14.choicePopupSearchBar, choicePopupFilteredBtn = ref14.choicePopupFilteredBtn, popupsContainerStyle = ref14.popupsContainerStyle;
    (0,react.useEffect)(function() {
        if (!startPointId) {
            setStartPointId(currentSweep);
        }
    }, [
        tour.id,
        currentSweep,
        startPointId
    ]);
    (0,react.useEffect)(function() {
        if (startPointId && allSweeps) {
            var foundSweep = Array.from(allSweeps === null || allSweeps === void 0 ? void 0 : allSweeps.values()).find(function(s) {
                return s.sweep_uuid === (startPointId === null || startPointId === void 0 ? void 0 : startPointId.uuid) || s.sweepId === (startPointId === null || startPointId === void 0 ? void 0 : startPointId.id);
            });
            setStartSweep(foundSweep);
        }
    }, [
        allSweeps,
        startPointId,
        tour === null || tour === void 0 ? void 0 : tour.ss
    ]);
    var handleReplay = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setNavigationDestination(target, navType);
                setActionPathFinished(false);
                return [
                    2
                ];
            });
        });
        return function handleReplay() {
            return _ref.apply(this, arguments);
        };
    }();
    startPointTitleRef.current = (0,react.useMemo)(function() {
        var ref, ref1;
        return (startingPoint === null || startingPoint === void 0 ? void 0 : (ref = startingPoint.tag) === null || ref === void 0 ? void 0 : ref.title) || (startingPoint === null || startingPoint === void 0 ? void 0 : (ref1 = startingPoint.station) === null || ref1 === void 0 ? void 0 : ref1.title) || (startingPoint === null || startingPoint === void 0 ? void 0 : startingPoint.title) || (startingPoint === null || startingPoint === void 0 ? void 0 : startingPoint.name) || "Title";
    }, [
        startingPoint
    ]);
    finishTitleRef.current = (0,react.useMemo)(function() {
        var ref, ref1;
        var finishItem = selectedItem || target;
        return (finishItem === null || finishItem === void 0 ? void 0 : (ref = finishItem.tag) === null || ref === void 0 ? void 0 : ref.title) || (finishItem === null || finishItem === void 0 ? void 0 : (ref1 = finishItem.station) === null || ref1 === void 0 ? void 0 : ref1.title) || (finishItem === null || finishItem === void 0 ? void 0 : finishItem.title) || (finishItem === null || finishItem === void 0 ? void 0 : finishItem.name) || "Title";
    }, [
        target,
        selectedItem
    ]);
    var handleBackToSearchBar = function() {
        setPopupOpen(false);
        setChoicePopupOpen(false);
        setSharePopupOpen(false);
        setNavigationSharingPopupOpen(false);
        setBackgroundVisible(true);
        setSearchText("");
        setSelectedItem(null);
    };
    var handleCloseOrBack = function() {
        selectCategory(null);
        setIsSearchBarFocused(false);
        setSearchText("");
        setMobilePosition(1);
        if (selectedItem) {
            setSelectedItem(null);
        }
        if (popupOpen) {
            setPopupOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        if (shouldNavReset) {
            handleBackToSearchBar();
            resetNavigationByCloseButton(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldNavReset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            width: {
                xs: "100%",
                sm: "100vw"
            }
        },
        children: [
            deviceManager/* default.isMobile */.Z.isMobile() && (// !actionPathFinished &&
            mobilePosition > 1 && !choicePopupOpen && !showDetailedRoutesOnly && !popupOpen && (!!searchText || !!selectedCategory) || popupOpen) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                sx: mobileCloseButtonStyle,
                onClick: handleCloseOrBack,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* CrossIcon */.aM, {
                    style: {}
                })
            }),
            (popupOpen || choicePopupOpen && startSweep || sharePopupOpen || navigationSharingPopupOpen) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                id: "popups-container",
                sx: popupsContainerStyle,
                children: [
                    popupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationIntroPopup, {
                        open: popupOpen,
                        handleBack: function() {
                            setPopupOpen(false);
                            setSelectedItem(null);
                        },
                        item: selectedItem,
                        contentLoaded: popupContentLoaded,
                        rtl: rtl,
                        onConfirm: function() {
                            setPopupOpen(false);
                            setChoicePopupOpen(true);
                            setMobilePosition(1);
                        },
                        tour: tour,
                        setPopupHeight: setPopupHeight,
                        setSharePopupOpen: setSharePopupOpen,
                        sharePopupOpen: sharePopupOpen,
                        sharingEnabled: sharingEnabled,
                        mobilePosition: mobilePosition
                    }),
                    choicePopupOpen && startSweep && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationIntroChoicePopup/* NavigationIntroChoicePopup */.Y, {
                        open: choicePopupOpen,
                        setOpen: setChoicePopupOpen,
                        item: selectedItem,
                        contentLoaded: choicePopupContentLoaded,
                        loadingProgress: choiceButtonLoadingProgress,
                        rtl: rtl,
                        onConfirm: function(navigationType) {
                            setChoicePopupOpen(false);
                            handleItemConfirmed(selectedItem, navigationType);
                            setNavType(navigationType);
                        },
                        onReturn: function() {
                            setPopupOpen(true);
                        },
                        startingPoint: startingPoint,
                        onSetStartingPoint: function(item) {
                            onSetStartingPoint(item);
                        },
                        onSetFinishPoint: function(finishItem) {
                            resetDetailedRoutes();
                            setSelectedItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, finishItem), {
                                descriptionEnabled: navigationSettings.descriptionEnabled
                            }));
                        },
                        menuItems: menuItems,
                        tour: tour,
                        selectedFilters: selectedFilters,
                        setSelectedFilters: setSelectedFilters,
                        startSweep: startSweep,
                        choicePopupWrapper: choicePopupWrapper,
                        choicePopupSearchBar: choicePopupSearchBar,
                        choicePopupFilteredBtn: choicePopupFilteredBtn,
                        sharingEnabled: sharingEnabled,
                        setSharePopupOpen: setSharePopupOpen,
                        sharePopupOpen: sharePopupOpen,
                        setOpenNavigationSharingPopup: setNavigationSharingPopupOpen,
                        setNavigationDestination: setNavigationDestination,
                        target: target,
                        detailedRoutes: detailedRoutes,
                        allSweeps: allSweeps,
                        startingPointTitle: startPointTitleRef.current,
                        finishPointTitle: finishTitleRef.current,
                        allTags: allTags,
                        filteredItems: filteredItems,
                        searchText: searchText,
                        setSearchText: setSearchText,
                        setSortingValue: setSortingValue,
                        mobilePosition: mobilePosition,
                        navigationType: navType,
                        teleportPoints: teleportPoints,
                        selectedNavigationType: navType,
                        setSelectedNavigationType: setNavType,
                        setSelectedItem: setSelectedItem,
                        setMobilePosition: setMobilePosition,
                        tourType: tourType
                    }),
                    sharePopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationSharePopup, {
                        open: sharePopupOpen,
                        setOpen: setSharePopupOpen,
                        setPopupHeight: setPopupHeight,
                        popupTitle: popupTitle,
                        qrEnabled: qrEnabled,
                        qrTitle: qrTitle,
                        smsEnabled: smsEnabled,
                        smsTitle: smsTitle,
                        smsText: smsText,
                        target: selectedItem || target,
                        startingPoint: startingPoint,
                        rtl: rtl,
                        country: country,
                        policy: policy
                    }),
                    navigationSharingPopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        id: "tour-share-wrapper",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchWrapperStyle), {
                            width: {
                                xs: "100%",
                                sm: "fit-content"
                            },
                            marginLeft: 0,
                            top: 0,
                            left: 0,
                            position: "absolute"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationTourSharePopup, {
                                open: navigationSharingPopupOpen,
                                setOpen: setNavigationSharingPopupOpen,
                                setPopupHeight: setPopupHeight,
                                popupTitle: popupTitle,
                                qrEnabled: qrEnabled,
                                qrTitle: qrTitle,
                                smsEnabled: smsEnabled,
                                smsTitle: smsTitle,
                                smsText: smsText,
                                target: selectedItem || target,
                                startingPoint: startingPoint,
                                setBackgroundVisible: setBackgroundVisible,
                                setChoicePopupOpen: setChoicePopupOpen,
                                setNavigationDestination: setNavigationDestination,
                                item: selectedItem,
                                detailedRouteEnabled: navigationSettings.detailedRouteEnabled,
                                detailedRoutes: detailedRoutes,
                                setActionPathNavbarPlayButtonType: setActionPathNavbarPlayButtonType,
                                navigationManager: pathFinderLine,
                                navigationType: navType,
                                actionPathFinished: actionPathFinished,
                                handleBackToSearchBar: handleBackToSearchBar,
                                handleReplay: handleReplay,
                                tour: tour,
                                ratingEnabled: navigationFinishScreen.ratingEnabled,
                                startingPointTitle: startPointTitleRef.current,
                                finishPointTitle: finishTitleRef.current,
                                closeDetailedRoutesList: closeDetailedRoutesList,
                                showDetailedRoutesOnly: showDetailedRoutesOnly,
                                rtl: rtl,
                                country: country,
                                showCaseTemp: showCaseTemp,
                                policy: policy
                            })
                        })
                    })
                ]
            }),
            !popupOpen && !choicePopupOpen && !sharePopupOpen && !navigationSharingPopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                id: "search-wrapper",
                sx: searchWrapperStyle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !!isBackgroundVisible && deviceManager/* default.isMobile */.Z.isMobile() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            id: "title-wrapper",
                            sx: searchTitleWrapperStyle,
                            children: [
                                !!target && !kioskIsReset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    sx: menuButtonStyle,
                                    variant: "contained",
                                    onClick: function() {
                                        setSearchText("");
                                        if ((categories === null || categories === void 0 ? void 0 : categories.length) > 1) selectCategory(null);
                                        setIsSearchBarFocused(true);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-solid fa-bars",
                                        style: {
                                            color: "#000"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: {
                                        xs: "20px",
                                        lg: "32px"
                                    },
                                    mx: "auto",
                                    px: {
                                        xs: "32px",
                                        sm: "unset"
                                    },
                                    fontWeight: 600,
                                    textAlign: "center",
                                    sx: {
                                        display: mobilePosition > 1 && searchText.length > 0 ? "none" : "block",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 2,
                                        wordBreak: "break-word",
                                        maxHeight: "48px",
                                        lineHeight: "24px",
                                        direction: rtl ? "rtl" : "ltr"
                                    },
                                    children: (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.titleEnabled) && (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.title) ? navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.title : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    fontSize: {
                                        xs: "20px",
                                        lg: "32px"
                                    },
                                    mx: "auto",
                                    fontWeight: {
                                        xs: 500,
                                        lg: 600
                                    },
                                    textAlign: "center",
                                    sx: {
                                        display: mobilePosition > 1 && searchText.length > 0 ? "block" : "none",
                                        direction: rtl ? "rtl" : "ltr"
                                    },
                                    children: (translation === null || translation === void 0 ? void 0 : translation.navDirections) || "Directions"
                                }),
                                !!target && !kioskIsReset && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    sx: clearSearchButtonStyle,
                                    variant: "contained",
                                    onClick: function() {
                                        return setBackgroundVisible(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-solid fa-xmark",
                                        style: {
                                            color: "#000"
                                        }
                                    })
                                })
                            ]
                        }),
                        showSkeleton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rounded",
                            height: 76,
                            sx: {
                                marginTop: "21px",
                                marginBottom: "17px"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            disabled: false,
                            autoComplete: "off",
                            value: searchText,
                            onChange: function(e) {
                                return setSearchText(e.target.value);
                            },
                            inputRef: inputRef,
                            InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,search_bar_util/* createInputProps */.T5)({
                                clearSearch: clearSearch,
                                isSearchBarFocused: isSearchBarFocused,
                                actionPathFinished: actionPathFinished,
                                loadingFinished: loadingFinished
                            })), {
                                readOnly: deviceManager/* default.isMobile */.Z.isMobile() && mobilePosition < 2 && !isSearchBarFocused
                            }),
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchTextFieldStyle), {
                                direction: rtl ? "rtl" : ""
                            }),
                            placeholder: (translation === null || translation === void 0 ? void 0 : translation.navSearchingQuestion) || "What are you searching for?",
                            onClick: function(event) {
                                if (deviceManager/* default.isMobile */.Z.isMobile()) {
                                    if (mobilePosition < 2) {
                                        event.preventDefault();
                                        inputRef.current.blur();
                                    }
                                    setMobilePosition(2);
                                }
                                if (!isBackgroundVisible) {
                                    setBackgroundVisible(true);
                                }
                                setIsSearchBarFocused(true);
                            }
                        })
                    ]
                })
            }),
            !popupOpen && !choicePopupOpen && !navigationSharingPopupOpen && (hiddenFromLink || showSkeleton && !(categories === null || categories === void 0 ? void 0 : categories.length) || (!!searchText.length || !!selectedCategory || !categories.length) && isBackgroundVisible) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                id: "results-wrapper",
                sx: resultsMainWrapperStyle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        id: "results-wrapper-2",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resultsSecondWrapperStyle), {
                            direction: rtl ? "rtl" : ""
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                gap: 1,
                                alignItems: "center",
                                children: [
                                    deviceManager/* default.isMobile */.Z.isMobile() && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        sx: {
                                            borderRadius: "1rem",
                                            padding: "4px",
                                            background: "#EAECF0",
                                            width: "32px",
                                            height: "32px"
                                        },
                                        onClick: handleCloseOrBack,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* ChevronLeftIcon */.wy, {
                                            style: {}
                                        })
                                    }),
                                    selectedCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: chevronWrapperStyle,
                                        onClick: function() {
                                            selectCategory(null);
                                            setSelectedItem(null);
                                            setIsSearchBarFocused(false);
                                            setSearchText("");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-solid fa-chevron-".concat(rtl ? "right" : "left"),
                                            style: {
                                                cursor: "pointer"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        fontSize: "16px",
                                        fontWeight: rtl ? 400 : 500,
                                        sx: {
                                            direction: rtl ? "rtl" : "ltr"
                                        },
                                        children: categories.length === 1 && !searchText ? translation.navLocations || "Locations" : translation.navResults || "Results"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                gap: 1,
                                children: showSkeleton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            variant: "rounded",
                                            height: 44,
                                            width: 91
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            variant: "rounded",
                                            height: 44,
                                            width: 138
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        filtersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterMenu, {
                                            rtl: rtl,
                                            menuItems: menuItems,
                                            selectedFilters: selectedFilters,
                                            setSelectedFilters: setSelectedFilters
                                        }),
                                        sortingEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SortMenu, {
                                            rtl: rtl,
                                            sortingValue: sortingValue,
                                            setSortingValue: setSortingValue
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        id: "items-wrapper",
                        sx: itemsWrapperStyle,
                        children: [
                            showSkeleton && (!(categories === null || categories === void 0 ? void 0 : categories.length) || hiddenFromLink) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathItem, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathItem, {})
                                ]
                            }),
                            !showLoader && !showSkeleton && filteredItems.sort(function(a, b) {
                                return a.order - b.order;
                            }).map(function(item, i) {
                                var ref, ref1, ref2, ref3;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    id: item === null || item === void 0 ? void 0 : item.id,
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemStyle), {
                                        direction: rtl ? "rtl" : ""
                                    }),
                                    onClick: function() {
                                        return handleItemSelect(item);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            sx: itemInnerStyle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                    sx: itemIconStyle,
                                                    children: (item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.webPathThumbnail) && (item === null || item === void 0 ? void 0 : (ref1 = item.tag) === null || ref1 === void 0 ? void 0 : ref1.navigationThumbnail) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        alt: "Thumbnail",
                                                        src: "".concat("https://cdn.treedis.com", "/tours/").concat(item.tourId, "/tags/icons/").concat(item.tag.navigationThumbnail),
                                                        style: {
                                                            width: "38px",
                                                            height: "38px"
                                                        }
                                                    }) : (0,search_bar_util/* renderIcon */.hY)(item[item === null || item === void 0 ? void 0 : item.type] || item, 38, 38)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                                    sx: {
                                                        textAlign: rtl ? "right" : "left",
                                                        direction: rtl ? "rtl" : "ltr"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                display: "-webkit-box",
                                                                width: {
                                                                    xs: "unset",
                                                                    sm: "600px"
                                                                },
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                WebkitBoxOrient: "vertical",
                                                                WebkitLineClamp: 2,
                                                                lineHeight: "21.531px",
                                                                fontStyle: "normal",
                                                                color: "#101828",
                                                                fontWeight: rtl ? 400 : 500,
                                                                fontSize: {
                                                                    xs: "14px",
                                                                    sm: "16px"
                                                                },
                                                                wordBreak: "break-word",
                                                                textAlign: {
                                                                    xs: mobilePosition < 2 ? "center" : "unset",
                                                                    sm: "unset"
                                                                },
                                                                direction: rtl ? "rtl" : "ltr"
                                                            },
                                                            children: ((ref2 = item[item.type]) === null || ref2 === void 0 ? void 0 : ref2.title) || (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.name)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            fontSize: "15px",
                                                            fontWeight: 400,
                                                            color: "#667085",
                                                            lineHeight: "21.531px",
                                                            fontStyle: "normal",
                                                            sx: {
                                                                direction: rtl ? "rtl" : "ltr"
                                                            },
                                                            children: (0,search_bar_util/* trimDescription */.FR)(item === null || item === void 0 ? void 0 : (ref3 = item.category) === null || ref3 === void 0 ? void 0 : ref3.title, 25)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            sx: itemChevronStyle,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa-solid fa-chevron-".concat(rtl ? "left" : "right")
                                            })
                                        })
                                    ]
                                }, i);
                            }),
                            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                alignItems: "center",
                                sx: {
                                    mb: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Loader */.aN, {
                                        color: "#2055FF",
                                        className: "mx-4 my-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        textAlign: "center",
                                        sx: {
                                            color: "#2055FF",
                                            direction: rtl ? "rtl" : "ltr"
                                        },
                                        children: (translation === null || translation === void 0 ? void 0 : translation.navCalculatingPath10sec) || "Calculating path... this may take 10 seconds"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            deviceManager/* default.isMobile */.Z.isMobile() && (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) > 3 && !selectedCategory && mobilePosition === 1 && !popupOpen && !choicePopupOpen && !(categories === null || categories === void 0 ? void 0 : categories.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemsSlider, {
                filteredItems: filteredItems,
                handleItemSelect: handleItemSelect,
                itemChevronStyle: itemChevronStyle,
                itemIconStyle: itemIconStyle,
                itemInnerStyle: itemInnerStyle,
                itemStyle: itemStyle,
                rtl: rtl,
                navigationSettings: navigationSettings,
                showSkeleton: showSkeleton
            }),
            showModal && sharingEnabled && tourType === Tour/* TourType.Kiosk */.v.Kiosk && !isBackgroundVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishModal, {
                isOpen: showModal,
                inputClientRect: inputClientRect,
                ratingClientRect: ratingClientRect,
                target: target,
                popupTitle: popupTitle,
                qrEnabled: qrEnabled,
                qrTitle: qrTitle,
                smsEnabled: smsEnabled,
                smsTitle: smsTitle,
                smsText: smsText
            }),
            tourType === Tour/* TourType.Kiosk */.v.Kiosk && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationCounterWrapper, {
                rtl: rtl,
                resetNavigation: resetNavigation,
                isBackgroundVisible: isBackgroundVisible,
                inAutoNavigate: inAutoNavigate
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/SkeletonPathCategory.tsx





var SkeletonPathCategory = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 4,
        lg: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            width: {
                xs: "114px",
                lg: "154px"
            },
            height: {
                xs: "114px",
                lg: "154px"
            },
            gap: 2,
            alignItems: "center",
            justifyContent: "center",
            p: {
                xs: "10px",
                lg: "14px"
            },
            overflow: "hidden",
            sx: {
                borderRadius: "8px",
                border: "1px solid #D0D5DD",
                background: "#FFF"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    width: "38px",
                    height: "38px",
                    sx: {
                        background: "white",
                        borderRadius: "8px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rounded",
                        height: 38,
                        width: 38
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "text",
                    width: 98,
                    sx: {
                        fontSize: deviceManager/* default.isMobile */.Z.isMobile() ? "13px" : "16px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "text",
                    width: 64
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/navigation/styles.tsx

var getHeight = function(param) {
    var mobilePosition = param.mobilePosition, popupOpen = param.popupOpen, popupHeight = param.popupHeight, choicePopupOpen = param.choicePopupOpen, navigationSettings = param.navigationSettings, navigationSharingPopupOpen = param.navigationSharingPopupOpen, actionPathFinished = param.actionPathFinished;
    if (mobilePosition > 1) {
        var maxPixels = popupHeight + 102;
        return popupOpen && popupHeight && maxPixels < window.innerHeight ? "".concat(maxPixels, "px") : "95%";
    }
    if (mobilePosition < 1) {
        if (!popupOpen && !choicePopupOpen) {
            return "15%";
        }
        return "31%";
    }
    if (choicePopupOpen && mobilePosition === 1) {
        return "calc(31% + 88px)";
    }
    if (choicePopupOpen && (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.detailedRouteEnabled)) {
        return "50%";
    }
    if (navigationSharingPopupOpen && actionPathFinished) {
        return "31%";
    }
    return "40%";
};
var useStyles = function(param) {
    var isBackgroundVisible = param.isBackgroundVisible, navigationSharingPopupOpen = param.navigationSharingPopupOpen, actionPathFinished = param.actionPathFinished, choicePopupOpen = param.choicePopupOpen, mobilePosition = param.mobilePosition, popupHeight = param.popupHeight, navigationSettings = param.navigationSettings, popupOpen = param.popupOpen;
    var mobileHeight = (0,react.useMemo)(function() {
        return getHeight({
            actionPathFinished: actionPathFinished,
            choicePopupOpen: choicePopupOpen,
            mobilePosition: mobilePosition,
            navigationSettings: navigationSettings,
            navigationSharingPopupOpen: navigationSharingPopupOpen,
            popupHeight: popupHeight,
            popupOpen: popupOpen
        });
    }, [
        actionPathFinished,
        choicePopupOpen,
        mobilePosition,
        navigationSettings,
        navigationSharingPopupOpen,
        popupHeight,
        popupOpen
    ]);
    var presentationStyle = (0,react.useMemo)(function() {
        return {
            width: {
                xs: "100%",
                lg: "100%"
            },
            height: {
                xs: isBackgroundVisible || navigationSharingPopupOpen && actionPathFinished ? mobileHeight : "0px",
                sm: "100%"
            },
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: "76px",
            alignSelf: "center",
            position: {
                xs: "fixed",
                sm: "relative"
            },
            bottom: {
                xs: isBackgroundVisible || navigationSharingPopupOpen && actionPathFinished ? 0 : "-100px",
                sm: 0
            },
            borderRadius: {
                xs: "20px 20px 0 0",
                sm: 0
            },
            background: {
                xs: "#F7F7F7",
                sm: "transparent"
            },
            padding: {
                xs: "14px",
                sm: 0
            },
            marginBottom: {
                sm: "110px"
            },
            overflowY: {
                sm: "hidden"
            },
            visibility: {
                xs: isBackgroundVisible || navigationSharingPopupOpen && actionPathFinished ? "visible" : "hidden",
                sm: "unset"
            },
            maxHeight: {
                xs: "95%",
                sm: "100%"
            },
            transition: "height 0.3s"
        };
    }, [
        actionPathFinished,
        isBackgroundVisible,
        mobileHeight,
        navigationSharingPopupOpen
    ]);
    var mainWrapperStyle = (0,react.useMemo)(function() {
        return {
            position: "absolute",
            width: "100%",
            height: "100dvh",
            background: "transparent",
            zIndex: 1200,
            top: 0,
            pointerEvents: isBackgroundVisible ? "auto" : "none !important",
            overflowY: {
                xs: "hidden",
                sm: mobilePosition === 0 || popupOpen ? "hidden" : ""
            },
            overflowX: "hidden",
            justifyContent: "space-between"
        };
    }, [
        isBackgroundVisible,
        mobilePosition,
        popupOpen
    ]);
    var whiteLineStyle = (0,react.useMemo)(function() {
        return {
            background: "#fff",
            width: "47px",
            height: "6px",
            borderRadius: "26px",
            display: {
                xs: "flex",
                sm: "none"
            }
        };
    }, []);
    var whiteLineWrapperStyle = (0,react.useMemo)(function() {
        return {
            background: "transparent",
            width: "57px",
            height: "24px",
            // borderRadius: '26px',
            position: "absolute",
            top: "-20px",
            alignItems: "center",
            justifyContent: "center",
            display: {
                xs: "flex",
                sm: "none"
            },
            zIndex: 9999
        };
    }, []);
    return {
        presentationStyle: presentationStyle,
        mainWrapperStyle: mainWrapperStyle,
        whiteLineStyle: whiteLineStyle,
        whiteLineWrapperStyle: whiteLineWrapperStyle
    };
};
var useCategoriesStyles = function() {
    var calculateHeight = function() {
        return "".concat(0.95 * window.innerHeight - 250, "px");
    };
    var ref = (0,react.useState)(calculateHeight), dynamicHeight = ref[0], setDynamicHeight = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setDynamicHeight(calculateHeight());
        };
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var categoriesGridWrapperStyle = (0,react.useMemo)(function() {
        return {
            // gap: '10px',
            maxHeight: {
                xs: dynamicHeight,
                sm: "618px"
            },
            overflowY: "auto",
            zIndex: 10,
            "&::-webkit-scrollbar": {
                width: "4px",
                backgroundColor: "transparent"
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "transparent",
                borderRadius: "4px"
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent"
            },
            "&:hover": {
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#BDBDBD"
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "#fff"
                }
            }
        };
    }, [
        dynamicHeight
    ]);
    var gridItemInnerStyle = (0,react.useMemo)(function() {
        return {
            overflow: "hidden",
            gap: "6px",
            alignItems: "center",
            justifyContent: "start",
            p: {
                xs: "10px",
                lg: "14px 14px 0px 14px"
            },
            maxWidth: {
                sm: "154px !important"
            },
            width: {
                sm: "154px"
            },
            height: "94px",
            display: "flex !important",
            borderRadius: "8px",
            border: "1px solid #EAECF0",
            background: "#FFF",
            cursor: "pointer",
            flexDirection: "column"
        };
    }, []);
    var gridItemTitleStyle = (0,react.useMemo)(function() {
        return {
            fontSize: "14px",
            fontWeight: {
                xs: 400,
                sm: 500
            },
            fontFamily: "Inter, Heebo, sans-serif",
            textAlign: "center",
            whiteSpace: "break-spaces",
            width: "inherit",
            textOverflow: "ellipsis",
            p: {
                xs: "0 10px",
                lg: "0px"
            },
            lineHeight: "normal",
            wordBreak: "break-word",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2
        };
    }, []);
    return {
        categoriesGridWrapperStyle: categoriesGridWrapperStyle,
        gridItemInnerStyle: gridItemInnerStyle,
        gridItemTitleStyle: gridItemTitleStyle
    };
};
var ZoomButtonStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    whiteSpace: "nowrap",
    fontWeight: 500,
    transition: "all 0.2s ease-in-out",
    outline: "none",
    "&:focus-visible": {
        outline: "none"
    },
    "&:disabled": {
        pointerEvents: "none",
        opacity: 0.5
    },
    "& svg": {
        pointerEvents: "none",
        width: 16,
        height: 16,
        flexShrink: 0
    },
    backgroundColor: "#fff",
    height: 40,
    width: 40
};

;// CONCATENATED MODULE: ./components/navigation/NavigationCategories.tsx












var NavigationCategories = function(param) {
    var categories = param.categories, handleSelectCategory = param.handleSelectCategory, rtl = param.rtl, showSkeleton = param.showSkeleton, mobilePosition = param.mobilePosition;
    var renderIcon = function(param) {
        var icon = param.icon, iconColor = param.iconColor, title = param.title, tourId = param.tourId;
        if (!icon) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup_Icons/* DefaultCategoryIcon */.du, {
                style: {
                    width: "20px",
                    height: "20px",
                    color: iconColor
                }
            });
        }
        if (icon.endsWith(".webp")) {
            var iconSrc = "".concat("https://cdn.treedis.com", "/tours/").concat(tourId, "/navigation/icons/").concat(icon);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                width: "20px",
                height: "20px",
                src: iconSrc,
                alt: title
            });
        }
        var iconSrc1 = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(icon, "?hex=").concat(encodeURIComponent(iconColor));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            width: "20px",
            height: "20px",
            src: iconSrc1,
            alt: title
        });
    };
    var filteredCategories = (0,react.useMemo)(function() {
        return categories === null || categories === void 0 ? void 0 : categories.filter(function(c) {
            var ref;
            return !!(c === null || c === void 0 ? void 0 : (ref = c.items) === null || ref === void 0 ? void 0 : ref.length);
        }).sort(function(a, b) {
            return a.order - b.order;
        });
    }, [
        categories
    ]);
    var ref = useCategoriesStyles(), categoriesGridWrapperStyle = ref.categoriesGridWrapperStyle, gridItemInnerStyle = ref.gridItemInnerStyle, gridItemTitleStyle = ref.gridItemTitleStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (deviceManager/* default.isDesktop */.Z.isDesktop() || deviceManager/* default.isMobile */.Z.isMobile() && (filteredCategories.length <= 3 || mobilePosition > 1)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                id: "categories-grid-container",
                container: true,
                spacing: "10px",
                justifyContent: {
                    lg: rtl ? "end" : "start"
                },
                sx: (0,_object_spread/* default */.Z)({}, categoriesGridWrapperStyle),
                children: showSkeleton ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathCategory, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathCategory, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathCategory, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathCategory, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathCategory, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPathCategory, {})
                    ]
                }) : filteredCategories.map(function(category) {
                    var ref;
                    var hasItems = ((ref = category.items) === null || ref === void 0 ? void 0 : ref.length) > 0;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        // eslint-disable-next-line no-nested-ternary
                        xs: deviceManager/* default.isMobile */.Z.isMobile() ? (filteredCategories === null || filteredCategories === void 0 ? void 0 : filteredCategories.length) === 1 ? 12 : (filteredCategories === null || filteredCategories === void 0 ? void 0 : filteredCategories.length) === 2 ? 6 : 4 : undefined,
                        onClick: function() {
                            return handleSelectCategory(category);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gridItemInnerStyle), {
                                visibility: hasItems ? "visibility" : "hidden"
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    width: "30px",
                                    height: "30px",
                                    sx: {
                                        background: category.backgroundColor || "#2055FF",
                                        borderRadius: "8px",
                                        p: "6px 5px"
                                    },
                                    children: renderIcon(category)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                    overflow: "hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, gridItemTitleStyle), {
                                            direction: rtl ? "rtl" : "ltr"
                                        }),
                                        children: category.title
                                    })
                                })
                            ]
                        })
                    }, category.id);
                })
            }),
            deviceManager/* default.isMobile */.Z.isMobile() && filteredCategories.length > 3 && mobilePosition === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemsSlider, {
                categories: filteredCategories,
                showSkeleton: showSkeleton,
                handleItemSelect: handleSelectCategory,
                rtl: rtl,
                renderCategoryIcon: renderIcon
            })
        ]
    });
};

// EXTERNAL MODULE: ./api/queries.ts
var queries = __webpack_require__(79575);
// EXTERNAL MODULE: ./utils/randomNumberId.ts
var randomNumberId = __webpack_require__(18066);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
;// CONCATENATED MODULE: ./components/navigation/TeleportButton.tsx





var AnimatedTeleportButton = function(param) {
    var progressValue = param.progressValue, endTpType = param.endTpType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        sx: {
            width: "142.143px",
            height: "142.143px",
            position: "relative",
            "@keyframes fadeInOut": {
                "0%": {
                    opacity: 1
                },
                "50%": {
                    opacity: 0
                },
                "100%": {
                    opacity: 1
                }
            }
        },
        alignItems: "center",
        children: [
            endTpType === TeleportGroupType.Elevator ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/navigation/teleport-vector-1.svg",
                        alt: "nothing",
                        style: {
                            animation: "fadeInOut 2s infinite"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/navigation/teleport-vector-2.svg",
                        alt: "nothing",
                        style: {
                            animation: "fadeInOut 2s infinite",
                            animationDelay: "1s"
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                sx: {
                    width: "130px",
                    height: "130px",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "white",
                    position: "absolute",
                    top: "-30px",
                    borderRadius: "50%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/navigation/stairway_icon.png",
                    alt: "nothing"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                variant: "determinate",
                size: 142,
                value: progressValue,
                sx: {
                    position: "absolute",
                    zIndex: 2,
                    top: -35
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                variant: "determinate",
                size: 142,
                value: 100,
                sx: {
                    position: "absolute",
                    color: "#E4EAFF",
                    zIndex: 1,
                    top: -35
                }
            })
        ]
    });
};
var TeleportButton = function(param) {
    var rtl = param.rtl;
    var translation = useRecoilValue(navigationTranslationState);
    return /*#__PURE__*/ _jsxs(Stack, {
        sx: {
            width: "245.196px",
            height: "280.731px",
            borderRadius: "37.312px",
            background: "#FFF",
            justifyContent: "flex-end",
            alignItems: "center",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ _jsx(AnimatedTeleportButton, {}),
            /*#__PURE__*/ _jsx(Stack, {
                sx: {
                    width: "100%",
                    height: "75.226px",
                    padding: "17.768px",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "17.768px",
                    flexShrink: 0,
                    borderRadius: "0px 0px 35.536px 35.536px",
                    background: "#F4F4F4"
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    sx: {
                        borderRadius: "27.355px",
                        background: "#2055FF",
                        height: "51.974px",
                        width: "100%"
                    },
                    children: (translation === null || translation === void 0 ? void 0 : translation.navClickOnEnter) || "Click to enter"
                })
            }),
            /*#__PURE__*/ _jsx("img", {
                width: "48",
                height: "40",
                src: "/navigation/teleport-button-bottom.svg",
                alt: "nothing",
                style: {
                    position: "absolute",
                    bottom: "-25px",
                    left: 0,
                    right: 0,
                    marginLeft: "auto",
                    marginRight: "auto"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/TeleportOverlay.tsx







var TeleportOverlay = function(param) {
    var setShowTeleportLoading = param.setShowTeleportLoading, endTeleportName = param.endTeleportName, rtl = param.rtl, endTpType = param.endTpType;
    var ref = (0,react.useState)(0), progressValue = ref[0], setProgressValue = ref[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    (0,react.useEffect)(function() {
        var totalTime = 3000; // Total time to fill the progress bar
        var updateInterval = 100; // How often to update the progress (in milliseconds)
        var incrementValue = 100 / (totalTime / updateInterval); // Calculate the increment value per update to reach 100% in 3 seconds
        var interval = setInterval(function() {
            setProgressValue(function(prev) {
                var nextValue = prev + incrementValue;
                if (nextValue >= 100) {
                    clearInterval(interval);
                    // As soon as we reach 100, we might want to hide the progress bar or reset it
                    setTimeout(function() {
                        setShowTeleportLoading(false);
                    }, 500);
                    return 100; // Ensure we don't exceed 100%
                }
                return nextValue;
            });
        }, updateInterval);
        return function() {
            clearInterval(interval);
            setProgressValue(0); // Reset progress bar when the component unmounts or the effect is re-run
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        id: "teleport-overlay",
        position: "relative",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "img",
                src: endTpType === TeleportGroupType.Elevator ? "/navigation/elevator.png" : "/navigation/stairway.png",
                alt: "elevator",
                width: "100vw",
                height: "100vh",
                position: "relative",
                zIndex: 1100
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                position: "absolute",
                width: "100vw",
                height: "100vh",
                sx: {
                    backdropFilter: "blur(8px)"
                },
                zIndex: 1101
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1102
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedTeleportButton, {
                        progressValue: progressValue,
                        endTpType: endTpType
                    }),
                    endTeleportName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "24px",
                                fontWeight: 400,
                                sx: {
                                    color: "#fff",
                                    direction: rtl ? "rtl" : "ltr"
                                },
                                children: (translation === null || translation === void 0 ? void 0 : translation.navMovingTo) || "Moving to"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                fontSize: "35px",
                                fontWeight: 600,
                                sx: {
                                    color: "#fff",
                                    direction: rtl ? "rtl" : "ltr"
                                },
                                children: endTeleportName
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 1000;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition-duration: 0.5s;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    top: 50%;\n    transform: scale(1) translateY(-50%);\n  }\n  to {\n    top: 5%;\n    transform: scale(0.5) translateY(-50%);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 1s ease forwards;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1010;\n  width: 327px;\n  //max-width: 60%;\n  top: 50%;\n  transform: translateY(-50%);\n  transform-origin: top;\n  object-fit: contain;\n  ",
        "\n  @media (max-width: 768px) {\n    width: 60%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Wrapper",
    componentId: "sc-15849a90-0"
})(_templateObject());
var LoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__LoaderContainer",
    componentId: "sc-15849a90-1"
})(_templateObject1());
var slideUp = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var AnimatedImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "styles__AnimatedImage",
    componentId: "sc-15849a90-2"
})(_templateObject4(), function(param) {
    var animate = param.animate;
    return animate && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), slideUp);
});

;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/components/ProgressBar.tsx

function ProgressBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 214px;\n  height: 8px;\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  position: relative;\n"
    ]);
    ProgressBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProgressBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 1;\n    "
    ]);
    ProgressBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProgressBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  background-color: #2055ff;\n  border-radius: 4px;\n  opacity: 0;\n  width: ",
        "%;\n  transition: width 0.5s ease;\n  ",
        "\n"
    ]);
    ProgressBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var LineContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ProgressBar__LineContainer",
    componentId: "sc-1140d326-0"
})(ProgressBar_templateObject());
var FilledLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ProgressBar__FilledLine",
    componentId: "sc-1140d326-1"
})(ProgressBar_templateObject2(), function(param) {
    var progress = param.progress;
    return progress;
}, function(param) {
    var progress = param.progress;
    return progress && (0,styled_components_browser_esm/* css */.iv)(ProgressBar_templateObject1());
});
var ProgressBar = function(param) {
    var progress = param.progress, _sx = param.sx, sx = _sx === void 0 ? {} : _sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LineContainer, {
        style: sx,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilledLine, {
            progress: progress
        })
    });
};

// EXTERNAL MODULE: ./utils/getAsset.ts
var getAsset = __webpack_require__(93175);
;// CONCATENATED MODULE: ./components/navigation/NavigationIntroScreen/NavigationIntroScreen.tsx










var NavigationIntroScreen = function(param) {
    var appState = param.appState, tour = param.tour, _onLoaded = param.onLoaded, onLoaded = _onLoaded === void 0 ? function() {} : _onLoaded, footerLogo = param.logo, rtl = param.rtl;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), animateLogo = ref3[0], setAnimateLogo = ref3[1];
    var ref4 = (0,react.useState)(0), progress = ref4[0], setProgress = ref4[1];
    var ref5 = (0,react.useState)(false), loaderVisible = ref5[0], setLoaderVisible = ref5[1];
    var ref6 = (0,react.useState)(false), popupOpen = ref6[0], setPopupOpen = ref6[1];
    var ref7 = (0,react.useState)(false), choicePopupOpen = ref7[0], setChoicePopupOpen = ref7[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var progressRef = (0,react.useRef)(progress);
    var appStateRef = (0,react.useRef)(appState);
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setAnimateLogo(true);
        }, 1000);
        if (appState === "playing") {
            setLoaderVisible(true);
            setProgress(100);
            onLoaded();
        } else {
            setTimeout(function() {
                setLoaderVisible(true);
                if (appStateRef.current === "playing") {
                    setProgress(100);
                    onLoaded();
                } else {
                    var intervalId = setInterval(function() {
                        if (progressRef.current === 100) {
                            clearInterval(intervalId);
                            onLoaded();
                            return;
                        }
                        setProgress(progressRef.current + 20);
                    }, 1000);
                }
            }, 1200);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        progressRef.current = progress;
    }, [
        progress
    ]);
    (0,react.useEffect)(function() {
        appStateRef.current = appState;
    }, [
        appState
    ]);
    var progressText = (0,react.useMemo)(function() {
        if (progress > 75) return (translation === null || translation === void 0 ? void 0 : translation.navWillStartSoon) || "Your navigation will start soon";
        if (progress > 50) return (translation === null || translation === void 0 ? void 0 : translation.navCalculatingPath) || "Calculating the path";
        if (progress > 25) return (translation === null || translation === void 0 ? void 0 : translation.navLoadingWaypoints) || "Loading waypoints";
        return (translation === null || translation === void 0 ? void 0 : translation.navLoading3dSpace) || "Loading the 3D space";
    }, [
        progress,
        translation
    ]);
    var userLogo = tour.user.whitelabelId ? "".concat("https://cdn.treedis.com", "/users/").concat(tour.user.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.user.updatedAt)) : (0,getAsset/* getAsset */.N)("logo-black.svg");
    var logo = ((ref = tour.client) === null || ref === void 0 ? void 0 : ref.logo) ? "".concat("https://cdn.treedis.com", "/clients/").concat((ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.id, "/logo.png").concat(util_all/* getVersion */.bo((ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.updatedAt)) : userLogo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        style: {
            zIndex: 9999
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedImage, {
                src: logo,
                animate: animateLogo,
                style: {
                    position: "absolute"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoaderContainer, {
                style: {
                    opacity: loaderVisible ? 1 : 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/loading.gif",
                        alt: "",
                        style: {
                            width: isMobile ? "65%" : "300px"
                        },
                        onClick: function() {
                            setPopupOpen(!popupOpen);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                        progress: progress,
                        sx: {
                            marginTop: "16px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        fontWeight: 600,
                        lineHeight: "30px",
                        sx: {
                            marginTop: "16px",
                            direction: rtl ? "rtl" : "ltr"
                        },
                        onClick: function() {
                            setChoicePopupOpen(!choicePopupOpen);
                        },
                        children: progressText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "#667085",
                        lineHeight: "20px",
                        sx: {
                            marginTop: "10px",
                            direction: rtl ? "rtl" : "ltr"
                        },
                        children: (translation === null || translation === void 0 ? void 0 : translation.navWillTakeUp10Sec) || "This will take up to 10 seconds"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
                sx: {
                    width: "100%",
                    gap: "7px",
                    position: "fixed",
                    bottom: 0,
                    // right: '20px',
                    mt: "4px",
                    mb: "20px",
                    display: {
                        xs: "flex",
                        sm: "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "16px",
                        lineHeight: "30px",
                        fontWeight: 400,
                        sx: {
                            direction: rtl ? "rtl" : "ltr"
                        },
                        children: (translation === null || translation === void 0 ? void 0 : translation.navPowerBy) || "Powered by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "watermark",
                        width: "81px",
                        height: "25.5px",
                        alt: "",
                        src: footerLogo
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/navigation/DetailedRoutesMobile.tsx









var directionIconsMap = {
    left: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* TurnLeftIcon */.ep, {
        color: "white"
    }),
    right: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* TurnRightIcon */.kv, {
        color: "white"
    })
};
var teleportIconsMap = {
    elevator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ElevatorIcon */.uz, {
        color: "white"
    }),
    stairway: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* StairsIcon */.X9, {
        color: "white"
    })
};
var iconWrapperStyle = {
    width: "36.406px",
    height: "36.406px",
    padding: "5px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "60px",
    background: " rgba(255, 255, 255, 0.10)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
};
var DetailedRoutesMobile = function(param) {
    var currentSweep = param.currentSweep, detailedRoutes = param.detailedRoutes, openDetailedRoutes = param.openDetailedRoutes, isBackgroundVisible = param.isBackgroundVisible, rtl = param.rtl;
    var ref = (0,react.useState)(null), highlightedItem = ref[0], setHighlightedItem = ref[1];
    var ref1 = (0,react.useState)(null), waitingItem = ref1[0], setWaitingItem = ref1[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* navigationTranslationState */.w);
    var renderRouteDetails = (0,react.useCallback)(function(route, index) {
        if (index === 0) {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: iconWrapperStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* RouteStartIcon */.hr, {
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        fontFamily: "Inter",
                        whiteSpace: "break-spaces",
                        textOverflow: "ellipsis",
                        sx: {
                            wordBreak: "break-word",
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navStartAt) || "Start at",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: (0,search_bar_util/* trimDescription */.FR)((route === null || route === void 0 ? void 0 : (ref = route.tag) === null || ref === void 0 ? void 0 : ref.title) || (route === null || route === void 0 ? void 0 : (ref1 = route.station) === null || ref1 === void 0 ? void 0 : ref1.title) || (route === null || route === void 0 ? void 0 : route.title) || (route === null || route === void 0 ? void 0 : route.name), 50)
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (route.turn) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: iconWrapperStyle,
                        children: directionIconsMap[route.turn]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        sx: {
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                " ",
                                route.distance,
                                "m ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        (translation === null || translation === void 0 ? void 0 : translation.navThen) || "Then",
                                        " ",
                                        (translation === null || translation === void 0 ? void 0 : translation.navTurn) || "turn",
                                        " ",
                                        route.turn === "left" ? "".concat((translation === null || translation === void 0 ? void 0 : translation.navLeft) || route.turn) : "".concat((translation === null || translation === void 0 ? void 0 : translation.navRight) || route.turn)
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (!!(route === null || route === void 0 ? void 0 : route.tpGroupStart) && !!(route === null || route === void 0 ? void 0 : route.tpGroupEnd)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: iconWrapperStyle,
                        children: teleportIconsMap[route.tpGroupStart.type]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        sx: {
                            direction: rtl ? "rtl" : ""
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                    " ",
                                    route.distance,
                                    "m ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    (translation === null || translation === void 0 ? void 0 : translation.navThen) || "Then",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: route.tpGroupStart.type === "elevator" ? (translation === null || translation === void 0 ? void 0 : translation.navEnterTheElevator) || "enter elevator" : (translation === null || translation === void 0 ? void 0 : translation.navTakeTheStairs) || "take stairs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    route.tpGroupStart.type === "elevator" ? (translation === null || translation === void 0 ? void 0 : translation.navSelect) || "Select" : "Go to",
                                    " ",
                                    route.tpGroupEnd.name,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: route.tpGroupEnd.turn && "".concat((translation === null || translation === void 0 ? void 0 : translation.navTurn) || "exit", " ").concat(route.tpGroupEnd.turn === "left" ? (translation === null || translation === void 0 ? void 0 : translation.navLeft) || route.tpGroupEnd.turn : (translation === null || translation === void 0 ? void 0 : translation.navRight) || route.tpGroupEnd.turn)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        if (route.isMandatory) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: iconWrapperStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* StraightArrowIcon */.U4, {
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        sx: {
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                " ",
                                route.distance,
                                "m ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        (translation === null || translation === void 0 ? void 0 : translation.navThen) || "Then",
                                        " ",
                                        (translation === null || translation === void 0 ? void 0 : translation.navThenProceedStraightAt) || "proceed straight at",
                                        " ",
                                        (route === null || route === void 0 ? void 0 : route.title) || (route === null || route === void 0 ? void 0 : route.name)
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        }
        if (route.isFinish) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                        sx: iconWrapperStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* DestinationIcon */.sF, {
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "16px",
                        fontWeight: "400",
                        textAlign: "start",
                        sx: {
                            direction: rtl ? "rtl" : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (translation === null || translation === void 0 ? void 0 : translation.navWalk) || "Walk",
                                " ",
                                route.distance,
                                "m ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        (translation === null || translation === void 0 ? void 0 : translation.navYouHaveReached) || "You have reached",
                                        " ",
                                        route === null || route === void 0 ? void 0 : route.title
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        }
        return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var foundItem = detailedRoutes.find(function(r) {
            return r.id === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id);
        });
        if (!foundItem && !highlightedItem && !waitingItem) {
            setHighlightedItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detailedRoutes[0]), {
                routeIndex: 0
            }));
            return;
        }
        if (foundItem) {
            var foundItemIndex = detailedRoutes.findIndex(function(r) {
                return r.id === foundItem.id;
            });
            var nextWaitingItem = detailedRoutes[foundItemIndex + 1];
            setHighlightedItem((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, foundItem), {
                routeIndex: foundItemIndex
            }));
            setWaitingItem(nextWaitingItem);
        } else {
            var highlightedItemIndex = detailedRoutes.findIndex(function(r) {
                return r.id === (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.id);
            });
            var nextItem = detailedRoutes[highlightedItemIndex + 1];
            // Only update if the next item is not already highlighted
            if (nextItem && waitingItem && nextItem.id === waitingItem.id) {
                setHighlightedItem(nextItem);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id,
        detailedRoutes === null || detailedRoutes === void 0 ? void 0 : detailedRoutes.length,
        waitingItem
    ]);
    return !isBackgroundVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        id: "detailed-routes-mobile",
        sx: {
            p: "10.611px 9px",
            alignItems: "center",
            position: "absolute",
            width: "calc(100vw - 20%)",
            left: "10%",
            right: "10%",
            top: "50px",
            borderRadius: "28.651px",
            background: "rgba(0, 0, 0, 0.60)",
            backdropFilter: "blur(7.5px)",
            color: "#fff"
        },
        children: highlightedItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            direction: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            sx: {
                width: "100%",
                gap: "10px"
            },
            children: [
                renderRouteDetails(highlightedItem, highlightedItem.routeIndex),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: openDetailedRoutes,
                    "aria-label": "expand",
                    size: "small",
                    sx: {
                        marginLeft: "auto"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fa-solid fa-chevron-down",
                        style: {
                            color: "white"
                        }
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/flows/utils/getClosestSweep.ts
var getClosestSweep = __webpack_require__(22932);
// EXTERNAL MODULE: ./utils/getDistance.ts
var getDistance = __webpack_require__(7926);
;// CONCATENATED MODULE: ./components/navigation/hooks/useDetailedRoutes.tsx







var useDetailedRoutes = function(param) {
    var pathFinderLine = param.pathFinderLine, navigationSettings = param.navigationSettings, startingPoint = param.startingPoint, targetLocation = param.targetLocation, allSweeps = param.allSweeps, THREE = param.THREE, navType = param.navType;
    var detailedRoutesRef = (0,react.useRef)([]);
    var detailedRoutes = detailedRoutesRef.current;
    var resetDetailedRoutes = function() {
        detailedRoutesRef.current = [];
        pathFinderLine === null || pathFinderLine === void 0 ? void 0 : pathFinderLine.reset();
    };
    pathFinderLine === null || pathFinderLine === void 0 ? void 0 : pathFinderLine.on(dist/* NodeEventsTypes.NAVIGATION_PATH_RENDER_COMPLETE */.cA.NAVIGATION_PATH_RENDER_COMPLETE, function(data) {
        var ref, ref1;
        var detailedRouteEnabled = navigationSettings.detailedRouteEnabled;
        var path = data.path;
        if (detailedRouteEnabled && !detailedRoutes.length && !!path.length && startingPoint && targetLocation || startingPoint && targetLocation && ((ref = detailedRoutes[(detailedRoutes === null || detailedRoutes === void 0 ? void 0 : detailedRoutes.length) - 1]) === null || ref === void 0 ? void 0 : ref.id) !== (targetLocation === null || targetLocation === void 0 ? void 0 : targetLocation.id) || startingPoint && targetLocation && ((ref1 = detailedRoutes[0]) === null || ref1 === void 0 ? void 0 : ref1.id) !== (startingPoint === null || startingPoint === void 0 ? void 0 : startingPoint.id)) {
            var pathDirectionSigns = pathFinderLine.getPathDirectionSigns();
            var teleportPoints = pathFinderLine.getTeleportPoints();
            var foundTpGroupsIds = [];
            path.forEach(function(p, i) {
                var foundPathSign = pathDirectionSigns.find(function(d) {
                    return d.id === p.data.id;
                });
                if (i === 0) {
                    var detail = null;
                    if (startingPoint.tag) {
                        var closestSweep = (0,getClosestSweep/* getClosestSweepFromObject */.e)({
                            allSweeps: allSweeps,
                            target: startingPoint.tag
                        }).closestSweep;
                        detail = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, closestSweep), {
                            tag: startingPoint.tag
                        });
                    } else {
                        detail = startingPoint;
                    }
                    detailedRoutes.push((0,_object_spread/* default */.Z)({}, detail));
                }
                if (foundPathSign) {
                    var foundTpGroup = teleportPoints.find(function(tp) {
                        var ref;
                        return (ref = tp.pointNodes) === null || ref === void 0 ? void 0 : ref.find(function(tpn) {
                            return (tpn === null || tpn === void 0 ? void 0 : tpn.sweep) === p.data.id;
                        });
                    });
                    // const foundTpGroupByEnd = teleportPoints.find((tp) => tp.pointNodes[1]?.sweep === p.data.id);
                    var latestItem = detailedRoutes[detailedRoutes.length - 1];
                    var startIndex = path.findIndex(function(item) {
                        return item.data.id === latestItem.id;
                    });
                    var endIndex = path.findIndex(function(item) {
                        return item.data.id === foundPathSign.id;
                    });
                    var resultArray = path.slice(startIndex, endIndex + 1);
                    var distance = (0,getDistance/* getDetailedRouteDistance */.TB)(resultArray, THREE);
                    // if (!foundTpGroupByStart && !foundTpGroupByEnd) {
                    if (!foundTpGroup) {
                        detailedRoutes.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, foundPathSign), {
                            distance: distance.toFixed(1)
                        }));
                    }
                }
                if (teleportPoints.length > 0 && navType !== NavigationIntroChoicePopup/* NavigationType.NoStairs */.N.NoStairs) {
                    var foundTpGroup1 = teleportPoints.filter(function(tp) {
                        return tp.type === "elevator" && navType === NavigationIntroChoicePopup/* NavigationType.Shortest */.N.Shortest || tp.type === "stairway" && navType === NavigationIntroChoicePopup/* NavigationType.NoElevators */.N.NoElevators;
                    }).find(function(tp) {
                        var ref;
                        // return tp.pointNodes[0]?.sweep === p.data.id || tp.pointNodes[1]?.sweep === p.data.id;
                        return (ref = tp.pointNodes) === null || ref === void 0 ? void 0 : ref.find(function(tpn) {
                            return (tpn === null || tpn === void 0 ? void 0 : tpn.sweep) === p.data.id;
                        });
                    });
                    if (foundTpGroup1 && !foundTpGroupsIds.includes(foundTpGroup1.id)) {
                        foundTpGroupsIds.push(foundTpGroup1.id);
                        var startingTpNode = foundTpGroup1.pointNodes.filter(function(tp) {
                            return tp.sweep === p.data.id;
                        });
                        var endTpNode = foundTpGroup1.pointNodes.filter(function(tp) {
                            var ref;
                            return tp.sweep === ((ref = path[i + 1]) === null || ref === void 0 ? void 0 : ref.data.id);
                        });
                        var endTpTurnSign = pathDirectionSigns.find(function(d) {
                            var ref;
                            return d.id === ((ref = endTpNode[0]) === null || ref === void 0 ? void 0 : ref.sweep);
                        });
                        if (!!(startingTpNode === null || startingTpNode === void 0 ? void 0 : startingTpNode.length) && !!(endTpNode === null || endTpNode === void 0 ? void 0 : endTpNode.length)) {
                            var ref;
                            var latestItem1 = detailedRoutes[detailedRoutes.length - 1];
                            var startIndex1 = path.findIndex(function(item) {
                                return item.data.id === latestItem1.id;
                            });
                            var endIndex1 = path.findIndex(function(item) {
                                return item.data.id === p.data.id;
                            });
                            var resultArray1 = path.slice(startIndex1, endIndex1 + 1);
                            var distance1 = (0,getDistance/* getDetailedRouteDistance */.TB)(resultArray1, THREE);
                            detailedRoutes.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref = path[i + 1]) === null || ref === void 0 ? void 0 : ref.data), {
                                tpGroupStart: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, startingTpNode[0]), {
                                    type: foundTpGroup1.type
                                }),
                                distance: distance1.toFixed(1),
                                tpGroupEnd: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, endTpNode[0]), {
                                    type: foundTpGroup1.type,
                                    turn: endTpTurnSign === null || endTpTurnSign === void 0 ? void 0 : endTpTurnSign.turn
                                })
                            }));
                        // detailedRoutes.push({ ...path[i + 1]?.data, tpGroupEnd: { ...endTpNode, type: foundTpGroup.type, turn: endTpTurnSign?.turn } });
                        }
                    }
                }
                if (p.data.isMandatory) {
                    var latestItem2 = detailedRoutes[detailedRoutes.length - 1];
                    var startIndex2 = path.findIndex(function(item) {
                        return item.data.id === latestItem2.id;
                    });
                    var endIndex2 = path.findIndex(function(item) {
                        return item.data.id === p.data.id;
                    });
                    var resultArray2 = path.slice(startIndex2, endIndex2 + 1);
                    var distance2 = (0,getDistance/* getDetailedRouteDistance */.TB)(resultArray2, THREE);
                    detailedRoutes.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p.data), {
                        distance: distance2.toFixed(1)
                    }));
                }
                if (i === path.length - 1) {
                    var latestItem3 = detailedRoutes[detailedRoutes.length - 1];
                    var startIndex3 = path.findIndex(function(item) {
                        return item.data.id === latestItem3.id;
                    });
                    var endIndex3 = path.findIndex(function(item) {
                        return item.data.id === p.data.id;
                    });
                    var resultArray3 = path.slice(startIndex3, endIndex3 + 1);
                    var distance3 = (0,getDistance/* getDetailedRouteDistance */.TB)(resultArray3, THREE);
                    detailedRoutes.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, targetLocation), {
                        distance: distance3.toFixed(1),
                        isFinish: true
                    }));
                }
            });
        }
    });
    pathFinderLine === null || pathFinderLine === void 0 ? void 0 : pathFinderLine.on(dist/* NodeEventsTypes.NAVIGATION_COMPLETE */.cA.NAVIGATION_COMPLETE, function() {
        resetDetailedRoutes();
    });
    return {
        detailedRoutes: detailedRoutes,
        resetDetailedRoutes: resetDetailedRoutes
    };
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonGroup/ButtonGroup.js + 1 modules
var ButtonGroup = __webpack_require__(62135);
;// CONCATENATED MODULE: ./components/navigation/ZoomableMap.tsx







var floorButtons = [
    {
        key: "up",
        icon: Icons/* ZoomUpIcon */.zs
    },
    {
        key: "3",
        color: "#676767"
    },
    {
        key: "2",
        color: "#667085"
    },
    {
        key: "1",
        color: "#676767"
    },
    {
        key: "0",
        color: "#fff",
        background: "#2055FF"
    },
    {
        key: "-1",
        color: "#646464"
    },
    {
        key: "-2",
        color: "#646464"
    },
    {
        key: "down",
        icon: Icons/* ZoomDownIcon */.At
    }, 
];
var initialScale = 0.58; // Updated scale to 0.58
var initialPosition = {
    x: -213,
    y: -175
}; // Updated position
function ZoomableMap(param) {
    var selectedItem = param.selectedItem;
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), focusOnMarker = ref[0], setFocusOnMarker = ref[1];
    var ref1 = (0,react.useState)(initialScale), scale = ref1[0], setScale = ref1[1];
    var ref2 = (0,react.useState)({
        x: initialPosition.x || 0,
        y: initialPosition.y || 0
    }), position = ref2[0], setPosition = ref2[1];
    var ref3 = (0,react.useState)(false), isDragging = ref3[0], setIsDragging = ref3[1];
    var ref4 = (0,react.useState)({
        x: 0,
        y: 0
    }), startPos = ref4[0], setStartPos = ref4[1];
    var ref5 = (0,react.useState)(false), loaded = ref5[0], setLoaded = ref5[1];
    var ref6 = (0,react.useState)(null), touchDistance = ref6[0], setTouchDistance = ref6[1];
    var ref7 = (0,react.useState)(false), initialLoadComplete = ref7[0], setInitialLoadComplete = ref7[1];
    // Marker positioning
    var ref8 = (0,react.useState)({
        top: 1414,
        left: 2035
    }), markerPosition = ref8[0], setMarkerPosition = ref8[1];
    (0,react.useEffect)(function() {
        if (selectedItem) {
            setFocusOnMarker(true);
        } else {
            setFocusOnMarker(false);
        }
    }, [
        selectedItem
    ]);
    // Update scale when initialScale prop changes
    (0,react.useEffect)(function() {
        if (!focusOnMarker) {
            setScale(initialScale);
        }
    }, [
        focusOnMarker
    ]);
    // Update position when initialPosition prop changes
    (0,react.useEffect)(function() {
        if (!focusOnMarker) {
            // Only update from control panel if not focusing on marker
            setPosition({
                x: initialPosition.x || 0,
                y: initialPosition.y || 0
            });
        }
        // Mark initial load as complete once the image is loaded
        if (loaded && !initialLoadComplete) {
            setInitialLoadComplete(true);
        }
    }, [
        loaded,
        initialLoadComplete,
        focusOnMarker
    ]);
    // Focus on marker when focusOnMarker prop changes
    (0,react.useEffect)(function() {
        if (focusOnMarker && containerRef.current && loaded) {
            var containerWidth = containerRef.current.clientWidth;
            var containerHeight = containerRef.current.clientHeight;
            // Use a higher zoom level for the marker focus
            var markerZoom = 0.8;
            // Calculate position to center the marker in the viewport
            var markerX = containerWidth / 2 - markerPosition.left * markerZoom;
            var markerY = containerHeight / 2 - markerPosition.top * markerZoom;
            // Set the marker position immediately without animation
            setScale(markerZoom);
            setPosition({
                x: markerX,
                y: markerY
            });
        }
    }, [
        focusOnMarker,
        loaded,
        markerPosition
    ]);
    // Handle mouse down to start dragging or place marker
    var handleMouseDown = function(e) {
        setIsDragging(true);
        setStartPos({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    };
    // Calculate distance between two touch points
    var getDistanceBetweenTouches = function(e) {
        if (e.touches.length < 2) return null;
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
    };
    // Handle touch start for mobile
    var handleTouchStart = function(e) {
        if (e.touches.length === 1) {
            var ref;
            // Place marker at touch position
            var containerRect = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
            if (!containerRect) return;
            // Calculate the point on the image where the touch happened
            var imageX = (e.touches[0].clientX - containerRect.left - position.x) / scale;
            var imageY = (e.touches[0].clientY - containerRect.top - position.y) / scale;
            // Update marker position
            setMarkerPosition({
                top: Math.round(imageY),
                left: Math.round(imageX)
            });
        } else if (e.touches.length === 1) {
            // Single touch - start dragging
            setIsDragging(true);
            setStartPos({
                x: e.touches[0].clientX - position.x,
                y: e.touches[0].clientY - position.y
            });
            setTouchDistance(null);
        } else if (e.touches.length === 2) {
            // Two touches - prepare for pinch zoom
            setIsDragging(false);
            var dist = getDistanceBetweenTouches(e);
            setTouchDistance(dist);
        }
    };
    // Get center point between two touches
    var getTouchCenter = function(e) {
        if (e.touches.length < 2) return {
            x: 0,
            y: 0
        };
        return {
            x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
            y: (e.touches[0].clientY + e.touches[1].clientY) / 2
        };
    };
    // Handle mouse move to drag the map - optimized for performance
    var handleMouseMove = function(e) {
        if (!isDragging) return;
        // Use requestAnimationFrame for smoother dragging
        requestAnimationFrame(function() {
            setPosition({
                x: e.clientX - startPos.x,
                y: e.clientY - startPos.y
            });
        });
    };
    // Handle touch move for mobile - optimized for performance
    var handleTouchMove = function(e) {
        e.preventDefault(); // Prevent default to avoid browser gestures
        // Use requestAnimationFrame for smoother touch interactions
        requestAnimationFrame(function() {
            if (e.touches.length === 1 && isDragging) {
                // Single touch - drag
                setPosition({
                    x: e.touches[0].clientX - startPos.x,
                    y: e.touches[0].clientY - startPos.y
                });
            } else if (e.touches.length === 2 && touchDistance) {
                var ref;
                // Two touches - pinch zoom
                var newDistance = getDistanceBetweenTouches(e);
                if (!newDistance) return;
                // Calculate new scale based on the change in distance
                var scaleFactor = newDistance / touchDistance;
                var newScale = Math.min(Math.max(scale * scaleFactor, 0.5), 5); // Limit scale between 0.5 and 5
                // Get the center point of the pinch
                var center = getTouchCenter(e);
                // Calculate how much the center point will move after scaling
                var containerRect = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
                if (!containerRect) return;
                // Calculate the point on the image where the pinch center is
                var imageX = (center.x - containerRect.left - position.x) / scale;
                var imageY = (center.y - containerRect.top - position.y) / scale;
                // Calculate new position to keep the pinch center at the same place
                var newX = center.x - containerRect.left - imageX * newScale;
                var newY = center.y - containerRect.top - imageY * newScale;
                setScale(newScale);
                setPosition({
                    x: newX,
                    y: newY
                });
                setTouchDistance(newDistance);
            }
        });
    };
    // Handle mouse up to stop dragging
    var handleMouseUp = function() {
        setIsDragging(false);
        setTouchDistance(null);
    };
    // Handle mouse wheel for zooming - optimized for performance
    var handleWheel = function(e) {
        e.preventDefault();
        // Use requestAnimationFrame for smoother wheel zooming
        requestAnimationFrame(function() {
            var ref;
            // Determine zoom direction
            var zoomIn = e.deltaY < 0;
            // Calculate new scale
            var scaleFactor = zoomIn ? 1.1 : 0.9;
            var newScale = Math.min(Math.max(scale * scaleFactor, 0.5), 5); // Limit scale between 0.5 and 5
            // Get mouse position relative to container
            var containerRect = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
            if (!containerRect) return;
            // Calculate the point on the image where the mouse is
            var mouseX = (e.clientX - containerRect.left - position.x) / scale;
            var mouseY = (e.clientY - containerRect.top - position.y) / scale;
            // Calculate new position to keep the mouse at the same place
            var newX = e.clientX - containerRect.left - mouseX * newScale;
            var newY = e.clientY - containerRect.top - mouseY * newScale;
            setScale(newScale);
            setPosition({
                x: newX,
                y: newY
            });
        });
    };
    // Zoom in function - optimized for performance
    var zoomIn = function() {
        if (!containerRef.current) return;
        // Use requestAnimationFrame for smoother button zooming
        requestAnimationFrame(function() {
            var containerRect = containerRef.current.getBoundingClientRect();
            var containerCenterX = containerRect.width / 2;
            var containerCenterY = containerRect.height / 2;
            // Calculate the point on the image that's currently at the center of the container
            var imageCenterX = (containerCenterX - position.x) / scale;
            var imageCenterY = (containerCenterY - position.y) / scale;
            // Calculate new scale
            var newScale = Math.min(scale + 0.3, 5);
            // Calculate new position to keep the same point at the center
            var newX = containerCenterX - imageCenterX * newScale;
            var newY = containerCenterY - imageCenterY * newScale;
            setScale(newScale);
            setPosition({
                x: newX,
                y: newY
            });
        });
    };
    // Zoom out function - optimized for performance
    var zoomOut = function() {
        if (!containerRef.current) return;
        // Use requestAnimationFrame for smoother button zooming
        requestAnimationFrame(function() {
            var containerRect = containerRef.current.getBoundingClientRect();
            var containerCenterX = containerRect.width / 2;
            var containerCenterY = containerRect.height / 2;
            // Calculate the point on the image that's currently at the center of the container
            var imageCenterX = (containerCenterX - position.x) / scale;
            var imageCenterY = (containerCenterY - position.y) / scale;
            // Calculate new scale
            var newScale = Math.max(scale - 0.3, 0.5);
            // Calculate new position to keep the same point at the center
            var newX = containerCenterX - imageCenterX * newScale;
            var newY = containerCenterY - imageCenterY * newScale;
            setScale(newScale);
            setPosition({
                x: newX,
                y: newY
            });
        });
    };
    // Reset to initial view - centers on marker
    var resetView = function() {
        if (containerRef.current) {
            if (focusOnMarker) {
                // If in marker focus mode, center on marker
                var containerWidth = containerRef.current.clientWidth;
                var containerHeight = containerRef.current.clientHeight;
                // Use a higher zoom level for the marker focus
                var markerZoom = 0.8;
                // Calculate position to center the marker in the viewport
                var markerX = containerWidth / 2 - markerPosition.left * markerZoom;
                var markerY = containerHeight / 2 - markerPosition.top * markerZoom;
                // Set the marker position immediately without animation
                setScale(markerZoom);
                setPosition({
                    x: markerX,
                    y: markerY
                });
            } else {
                // Otherwise, reset to initial position
                setScale(initialScale);
                setPosition({
                    x: initialPosition.x || 0,
                    y: initialPosition.y || 0
                });
            }
        }
    };
    // Add event listeners
    (0,react.useEffect)(function() {
        if (!containerRef.current) return;
        var container = containerRef.current;
        // Mouse and touch events for dragging
        window.addEventListener("mousemove", handleMouseMove, {
            passive: true
        });
        window.addEventListener("mouseup", handleMouseUp, {
            passive: true
        });
        window.addEventListener("touchmove", handleTouchMove, {
            passive: false
        });
        window.addEventListener("touchend", handleMouseUp, {
            passive: true
        });
        // Wheel event for zooming
        container.addEventListener("wheel", handleWheel, {
            passive: false
        });
        // Handle window resize
        var handleResize = function() {
            if (containerRef.current) {
                var containerRect = containerRef.current.getBoundingClientRect();
                var containerCenterX = containerRect.width / 2;
                var containerCenterY = containerRect.height / 2;
                // Calculate the point on the image that's currently at the center of the container
                var imageCenterX = (containerCenterX - position.x) / scale;
                var imageCenterY = (containerCenterY - position.y) / scale;
                // Calculate new position to keep the same point at the center
                var newX = containerCenterX - imageCenterX * scale;
                var newY = containerCenterY - imageCenterY * scale;
                setPosition({
                    x: newX,
                    y: newY
                });
            }
        };
        window.addEventListener("resize", handleResize);
        // eslint-disable-next-line consistent-return
        return function() {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
            window.removeEventListener("touchmove", handleTouchMove);
            window.removeEventListener("touchend", handleMouseUp);
            container.removeEventListener("wheel", handleWheel);
            window.removeEventListener("resize", handleResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDragging,
        startPos,
        scale,
        position,
        touchDistance
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
        id: "zoom-container",
        sx: {
            position: "absolute",
            flex: 1,
            overflow: "hidden",
            top: 69,
            left: 0,
            width: "100dvw",
            height: "calc(100dvh - 69px)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
            id: "map-container",
            position: "relative",
            flex: 1,
            overflow: "hidden",
            sx: {
                background: "#101828"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                    ref: containerRef,
                    sx: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        position: "absolute",
                        cursor: "grab",
                        "&:active": {
                            cursor: "grabbing"
                        }
                    },
                    onMouseDown: handleMouseDown,
                    onTouchStart: handleTouchStart,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            transform: "translate3d(".concat(position.x, "px, ").concat(position.y, "px, 0) scale(").concat(scale, ")"),
                            transformOrigin: "0 0",
                            opacity: loaded ? 1 : 0,
                            willChange: "transform"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/background.png",
                                alt: "Interactive floor map",
                                className: "max-w-none",
                                onLoad: function() {
                                    setLoaded(true);
                                },
                                draggable: "false"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                id: "marker",
                                position: "absolute",
                                style: {
                                    top: "".concat(markerPosition.top, "px"),
                                    left: "".concat(markerPosition.left, "px"),
                                    transform: "translate(-50%, -50%)",
                                    zIndex: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                        position: "relative",
                                        mb: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    backgroundColor: "#0F1A30",
                                                    color: "white",
                                                    px: 4,
                                                    py: 1,
                                                    borderRadius: "9999px",
                                                    fontWeight: 500,
                                                    fontSize: "0.875rem",
                                                    whiteSpace: "nowrap",
                                                    fontFamily: "Heebo, sans-serif"
                                                },
                                                children: "אתה כאן"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                sx: {
                                                    position: "absolute",
                                                    left: "50%",
                                                    bottom: 0,
                                                    width: 0,
                                                    height: 0,
                                                    transform: "translateX(-50%) translateY(50%)",
                                                    borderLeft: "8px solid transparent",
                                                    borderRight: "8px solid transparent",
                                                    borderTop: "8px solid #0F1A30"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                        sx: {
                                            width: 32,
                                            height: 32,
                                            borderRadius: "50%",
                                            backgroundColor: "#2563EB",
                                            border: "2px solid white",
                                            boxShadow: 3,
                                            position: "relative",
                                            alignSelf: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                position: "absolute",
                                                inset: 0,
                                                borderRadius: "50%",
                                                backgroundColor: "#2563EB",
                                                opacity: 0.7,
                                                animation: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
                                                "@keyframes ping": {
                                                    "0%": {
                                                        transform: "scale(1)",
                                                        opacity: 0.7
                                                    },
                                                    "75%, 100%": {
                                                        transform: "scale(2)",
                                                        opacity: 0
                                                    }
                                                }
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                    id: "zoom-controls",
                    sx: {
                        position: "absolute",
                        bottom: "50%",
                        right: 16,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        zIndex: 20,
                        transform: "translateY(50%)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* default */.Z, {
                            orientation: "vertical",
                            variant: "contained",
                            sx: {
                                background: "linear-gradient(180deg, #E6E6E6 0%, rgba(230, 230, 230, 0.80) 42.5%, #E6E6E6 100%)",
                                pointerEvents: "none",
                                cursor: "pointer"
                            },
                            children: floorButtons.map(function(fb) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ZoomButtonStyle), {
                                        color: fb === null || fb === void 0 ? void 0 : fb.color,
                                        background: fb === null || fb === void 0 ? void 0 : fb.background
                                    }),
                                    children: (fb === null || fb === void 0 ? void 0 : fb.icon) || fb.key
                                }, fb.key);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                            orientation: "vertical",
                            variant: "contained",
                            sx: {
                                background: "#fff",
                                "& .MuiButton-root:hover": {
                                    backgroundColor: "#fff",
                                    "& svg path": {
                                        stroke: "#98A2B3"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    onClick: zoomIn,
                                    sx: ZoomButtonStyle,
                                    disabled: scale === 5,
                                    children: Icons/* ZoomInIcon */.Sd
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    onClick: zoomOut,
                                    sx: ZoomButtonStyle,
                                    disabled: scale === 0.5,
                                    children: Icons/* ZoomOutIcon */.xL
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: resetView,
                            sx: ZoomButtonStyle,
                            children: Icons/* ZoomExpandIcon */["if"]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/navigation/NavigationWrapper.tsx
/* eslint-disable no-nested-ternary */ 



























var TeleportGroupType;
(function(TeleportGroupType) {
    TeleportGroupType["Elevator"] = "elevator";
    TeleportGroupType["Stairway"] = "stairway";
})(TeleportGroupType || (TeleportGroupType = {}));
var NavigationWrapper = function(param) {
    var isBackgroundVisible = param.isBackgroundVisible, setBackgroundVisible = param.setBackgroundVisible, setDestination = param.setDestination, actionPathFinished = param.actionPathFinished, tour = param.tour, targetLocation = param.targetLocation, moveToStartingPoint = param.moveToStartingPoint, tourType = param.tourType, appState = param.appState, setActionPathFinished = param.setActionPathFinished, pathFinderLine = param.pathFinderLine, rtl = param.rtl, showTeleportLoading = param.showTeleportLoading, setShowTeleportLoading = param.setShowTeleportLoading, endTeleportName = param.endTeleportName, translation = param.translation, endTpType = param.endTpType, setDescriptionEnabled = param.setDescriptionEnabled, allSweeps = param.allSweeps, currentSweep = param.currentSweep, THREE = param.THREE, setActionPathNavbarPlayButtonType = param.setActionPathNavbarPlayButtonType, showcaseLoaded = param.showcaseLoaded, allTags = param.allTags, teleportPointsProp = param.teleportPoints, showActionPathBar = param.showActionPathBar, navigationStartPosition = param.navigationStartPosition, resetNavigationByCloseButton = param.resetNavigationByCloseButton, shouldNavReset = param.shouldNavReset, showCaseTemp = param.showCaseTemp;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(null), selectedCategory = ref5[0], setSelectedCategory = ref5[1];
    var ref6 = (0,react.useState)([]), navigationItems = ref6[0], setNavigationItems = ref6[1];
    var ref7 = (0,react.useState)([]), navigationCategories = ref7[0], setNavigationCategories = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* navigationSettingsState */.FZ), 2), navigationSettings = ref8[0], setNavigationSettings = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* navigationFinishScreenState */.vM), 2), navigationFinishScreen = ref9[0], setNavigationFinishScreen = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* navigationTranslationState */.w), 2), setNavigationTranslation = ref10[1];
    var ref11 = (0,react.useState)([]), navigationStations = ref11[0], setNavigationStations = ref11[1];
    var filtersEnabled = navigationSettings.filtersEnabled, sortingEnabled = navigationSettings.sortingEnabled, defaultSorting = navigationSettings.defaultSorting;
    var ref12 = (0,react.useState)(false), isSearchBarFocused = ref12[0], setIsSearchBarFocused = ref12[1];
    var ref13 = (0,react.useState)(false), isTagsOverlayHidden = ref13[0], setIsTagsOverlayHidden = ref13[1];
    var ref14 = (0,react.useState)(false), hiddenFromLink = ref14[0], setHiddenFromLink = ref14[1];
    var ref15 = (0,react.useState)(false), kioskIsReset = ref15[0], setKioskIsReset = ref15[1];
    var ref16 = (0,react.useState)(""), searchText = ref16[0], setSearchText = ref16[1];
    var ref17 = (0,react.useState)(true), showLoader = ref17[0], setShowLoader = ref17[1];
    var ref18 = (0,react.useState)(true), showSkeleton = ref18[0], setShowSkeleton = ref18[1];
    var ref19 = (0,react.useState)(null), touchStart = ref19[0], setTouchStart = ref19[1];
    var ref20 = (0,react.useState)(1), mobilePosition = ref20[0], setMobilePosition = ref20[1];
    var ref21 = (0,react.useState)(false), popupOpen = ref21[0], setPopupOpen = ref21[1];
    var ref22 = (0,react.useState)(0), popupHeight = ref22[0], setPopupHeight = ref22[1];
    var ref23 = (0,react.useState)(null), startingPoint = ref23[0], setStartingPoint = ref23[1];
    var ref24 = (0,react.useState)(false), navigationSharingPopupOpen = ref24[0], setNavigationSharingPopupOpen = ref24[1];
    var ref25 = (0,react.useState)(false), choicePopupOpen = ref25[0], setChoicePopupOpen = ref25[1];
    var ref26 = (0,react.useState)(false), showDetailedRoutesOnly = ref26[0], setShowDetailedRoutesOnly = ref26[1];
    var ref27 = (0,react.useState)(null), selectedItem = ref27[0], setSelectedItem = ref27[1];
    var appStateRef = (0,react.useRef)(appState);
    var ref28 = (0,react.useState)(NavigationIntroChoicePopup/* NavigationType.Shortest */.N.Shortest), navType = ref28[0], setNavType = ref28[1];
    var choicePopupSearchOpen = (0,recoil/* useRecoilValue */.sJ)(choicepopup/* showChoicePopupSearchField */.O);
    var userLogo = (tour === null || tour === void 0 ? void 0 : (ref = tour.user) === null || ref === void 0 ? void 0 : ref.whitelabelId) ? "".concat("https://cdn.treedis.com", "/users/").concat(tour.user.id, "/logo.png").concat((0,util/* getVersion */.bo)(tour.user.updatedAt)) : "/images/logo-black.svg";
    var logo = ((ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.logo) ? "".concat("https://cdn.treedis.com", "/clients/").concat((ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.id, "/logo.png").concat((0,util/* getVersion */.bo)((ref3 = tour.client) === null || ref3 === void 0 ? void 0 : ref3.updatedAt)) : userLogo;
    var mapEnabled = tour.slug === "78911a0a" && isBackgroundVisible && tourType === Tour/* TourType.Kiosk */.v.Kiosk && (startingPoint === null || startingPoint === void 0 ? void 0 : (ref4 = startingPoint.station) === null || ref4 === void 0 ? void 0 : ref4.title) === "Sourasky entrance (Piano)";
    (0,react.useEffect)(function() {
        setNavigationTranslation(translation);
    }, [
        setNavigationTranslation,
        translation
    ]);
    (0,react.useEffect)(function() {
        function fetchData() {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,_async_to_generator/* default */.Z)(function() {
                var ref, fetchedItems, fetchedCategories, fetchedFinishScreen, fetchedSettings, fetchedStations, otherCategoryId, itemsWithoutCategory;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,queries/* getNavigationData */.EC)(tour.id)
                            ];
                        case 1:
                            ref = _state.sent(), fetchedItems = ref.navigationItems, fetchedCategories = ref.navigationCategories, fetchedFinishScreen = ref.navigationFinishScreen, fetchedSettings = ref.navigationSettings, fetchedStations = ref.navigationStations;
                            otherCategoryId = (0,randomNumberId/* randomNumberId */._)();
                            itemsWithoutCategory = fetchedItems.filter(function(item) {
                                return !item.category || !item.categoryId;
                            });
                            setNavigationItems(fetchedItems.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    categoryId: item.categoryId || otherCategoryId
                                });
                            }));
                            setNavigationCategories((0,_to_consumable_array/* default */.Z)(fetchedCategories.filter(function(category) {
                                return category.items.length;
                            })).concat([
                                {
                                    id: otherCategoryId,
                                    title: (translation === null || translation === void 0 ? void 0 : translation.navOther) || "Other",
                                    items: itemsWithoutCategory,
                                    isOther: true
                                }
                            ]));
                            if (fetchedSettings) setNavigationSettings(fetchedSettings);
                            if (fetchedFinishScreen) setNavigationFinishScreen(fetchedFinishScreen);
                            if (fetchedStations) setNavigationStations(fetchedStations);
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tour.id,
        translation
    ]);
    var selectCategory = function(category) {
        setSelectedCategory(category);
    };
    (0,react.useEffect)(function() {
        var target = (0,util/* getQueryVariable */.Dv)(window.location.href, "target");
        setHiddenFromLink(!!target);
    }, []);
    (0,react.useEffect)(function() {
        if (isBackgroundVisible && pathFinderLine) {
            pathFinderLine.inAutoNavigate = false;
        }
    }, [
        isBackgroundVisible,
        pathFinderLine
    ]);
    // eslint-disable-next-line consistent-return
    (0,react.useEffect)(function() {
        // Function to find and remove the tags overlay
        var findAndRemoveTagsOverlay = function() {
            var ref;
            var iframe = document.body.querySelector("iframe");
            var tagsNavigationOverlay = iframe === null || iframe === void 0 ? void 0 : (ref = iframe.contentWindow) === null || ref === void 0 ? void 0 : ref.document.body.querySelector(".tags-overlay");
            if (tagsNavigationOverlay) {
                tagsNavigationOverlay.remove();
                setIsTagsOverlayHidden(true); // Update state to indicate the overlay is hidden
                return true; // Overlay found and removed
            }
            return false; // Overlay not found
        };
        if (!isTagsOverlayHidden) {
            var interval = setInterval(function() {
                var foundAndRemoved = findAndRemoveTagsOverlay();
                if (foundAndRemoved) {
                    clearInterval(interval);
                }
            }, 1000);
            return function() {
                return clearInterval(interval);
            };
        }
    }, [
        isTagsOverlayHidden
    ]);
    (0,react.useEffect)(function() {
        appStateRef.current = appState;
    }, [
        appState
    ]);
    // Function to detect swipe direction
    var handleTouchStart = function(e) {
        setTouchStart(e.targetTouches[0].clientY);
    };
    var handleTouchMove = function(e) {
        if (!touchStart) {
            return;
        }
        var distance = touchStart - e.targetTouches[0].clientY;
        var isSwipeDown = distance < 0;
        var isSwipeUp = distance > 0;
        if (isSwipeDown) {
            if (showDetailedRoutesOnly) {
                setMobilePosition(1);
                setBackgroundVisible(false);
                setShowDetailedRoutesOnly(false);
                setTouchStart(null);
                return;
            }
            if ((choicePopupOpen && choicePopupSearchOpen || !popupOpen && !choicePopupOpen && (selectedCategory && !selectedItem || !!searchText)) && mobilePosition > 1) {
                setTouchStart(null);
                return;
            }
            // Handle swipe down
            setMobilePosition(function(prev) {
                return prev > 0 ? prev - 1 : prev;
            });
        }
        if (isSwipeUp) {
            // Handle swipe up
            setMobilePosition(function(prev) {
                return prev < 2 ? prev + 1 : prev;
            });
        }
        setTouchStart(null);
    };
    (0,react.useEffect)(function() {
        if (selectedCategory && deviceManager/* default.isMobile */.Z.isMobile()) {
            setMobilePosition(2);
        }
    }, [
        selectedCategory
    ]);
    (0,react.useEffect)(function() {
        if (allSweeps && currentSweep) {
            if (tourType === Tour/* TourType.Regular */.v.Regular) {
                var foundSweep = Array.from(allSweeps.values()).find(function(s) {
                    return s.sweep_uuid === currentSweep.uuid || s.id === currentSweep.id;
                });
                if (foundSweep) setStartingPoint(foundSweep);
            }
            if (tourType === Tour/* TourType.Kiosk */.v.Kiosk && navigationStartPosition) {
                var s = navigationStartPosition.s, x = navigationStartPosition.x, y = navigationStartPosition.y;
                var foundStation = navigationStations === null || navigationStations === void 0 ? void 0 : navigationStations.find(function(station) {
                    var stationS = (0,util/* getQueryVariable */.Dv)(station.url, "s");
                    var stationX = (0,util/* getQueryVariable */.Dv)(station.url, "x");
                    var stationY = (0,util/* getQueryVariable */.Dv)(station.url, "y");
                    return stationS === s && stationX === x && stationY === y;
                });
                if (foundStation) {
                    var foundSweep1 = Array.from(allSweeps.values()).find(function(sweep) {
                        return sweep.sweep_uuid === s || sweep.id === s;
                    });
                    if (foundSweep1) setStartingPoint((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, foundSweep1), {
                        station: foundStation
                    }));
                }
            }
        }
    }, [
        allSweeps,
        allTags,
        currentSweep,
        tourType,
        navigationStartPosition,
        navigationStations
    ]);
    var ref29 = useDetailedRoutes({
        pathFinderLine: pathFinderLine,
        navigationSettings: navigationSettings,
        targetLocation: targetLocation,
        startingPoint: startingPoint,
        allSweeps: allSweeps,
        THREE: THREE,
        navType: navType
    }), detailedRoutes = ref29.detailedRoutes, resetDetailedRoutes = ref29.resetDetailedRoutes;
    var openDetailedRoutes = function() {
        setBackgroundVisible(true);
        setShowDetailedRoutesOnly(true);
        setMobilePosition(2);
    };
    var closeDetailedRoutesList = function() {
        setMobilePosition(1);
        setBackgroundVisible(false);
        setTimeout(function() {
            setShowDetailedRoutesOnly(false);
        }, 300);
    };
    var ref30 = useStyles({
        isBackgroundVisible: isBackgroundVisible,
        navigationSharingPopupOpen: navigationSharingPopupOpen,
        actionPathFinished: actionPathFinished,
        choicePopupOpen: choicePopupOpen,
        mobilePosition: mobilePosition,
        popupHeight: popupHeight,
        navigationSettings: navigationSettings,
        popupOpen: popupOpen
    }), presentationStyle = ref30.presentationStyle, mainWrapperStyle = ref30.mainWrapperStyle, whiteLineStyle = ref30.whiteLineStyle, whiteLineWrapperStyle = ref30.whiteLineWrapperStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showTeleportLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(TeleportOverlay, {
                rtl: rtl,
                setShowTeleportLoading: setShowTeleportLoading,
                endTeleportName: endTeleportName,
                endTpType: endTpType
            }),
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationIntroScreen, {
                logo: logo,
                appState: appState,
                tour: tour,
                rtl: rtl,
                onLoaded: function() {
                    setShowLoader(false);
                    if (appStateRef.current === "playing") {
                        setShowSkeleton(false);
                    } else {
                        setTimeout(function() {
                            setShowSkeleton(false);
                        }, 3000);
                    }
                }
            }),
            showcaseLoaded && !mapEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBackground, {
                isBackgroundVisible: isBackgroundVisible,
                tour: tour
            }),
            !showLoader && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showActionPathBar && (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.detailedRouteEnabled) && deviceManager/* default.isMobile */.Z.isMobile() && !actionPathFinished && (detailedRoutes === null || detailedRoutes === void 0 ? void 0 : detailedRoutes.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailedRoutesMobile, {
                        currentSweep: currentSweep,
                        detailedRoutes: detailedRoutes,
                        openDetailedRoutes: openDetailedRoutes,
                        isBackgroundVisible: isBackgroundVisible,
                        rtl: rtl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        sx: mainWrapperStyle,
                        children: [
                            !navigationSharingPopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationHeader, {
                                rtl: rtl,
                                isBackgroundVisible: isBackgroundVisible,
                                tour: tour,
                                tourType: tourType,
                                mobilePosition: mobilePosition
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                                onClickAway: function() {
                                    setIsSearchBarFocused(false);
                                    if (!mapEnabled) setSelectedCategory(null);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                    role: "presentation",
                                    sx: presentationStyle,
                                    children: [
                                        !(navigationSharingPopupOpen && actionPathFinished) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                            onTouchStart: handleTouchStart,
                                            onTouchMove: handleTouchMove,
                                            sx: whiteLineWrapperStyle,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                                id: "white-line",
                                                sx: whiteLineStyle
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: {
                                                xs: "100%",
                                                sm: "1142px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationSearchBar, {
                                                    appState: appState,
                                                    isBackgroundVisible: isBackgroundVisible,
                                                    menuItems: navigationItems,
                                                    setDestination: setDestination,
                                                    setBackgroundVisible: function(val) {
                                                        return setBackgroundVisible(val);
                                                    },
                                                    actionPathFinished: actionPathFinished,
                                                    selectedCategory: selectedCategory,
                                                    selectedItem: selectedItem,
                                                    setSelectedItem: setSelectedItem,
                                                    tour: tour,
                                                    target: targetLocation,
                                                    selectCategory: selectCategory,
                                                    categories: navigationCategories === null || navigationCategories === void 0 ? void 0 : navigationCategories.filter(function(c) {
                                                        return !c.isOther;
                                                    }),
                                                    moveToStartingPoint: moveToStartingPoint,
                                                    filtersEnabled: filtersEnabled,
                                                    sortingEnabled: sortingEnabled,
                                                    defaultSorting: defaultSorting,
                                                    navigationFinishScreen: navigationFinishScreen,
                                                    navigationStations: navigationStations,
                                                    tourType: tourType,
                                                    setActionPathFinished: setActionPathFinished,
                                                    isSearchBarFocused: isSearchBarFocused,
                                                    setIsSearchBarFocused: setIsSearchBarFocused,
                                                    rtl: rtl,
                                                    inAutoNavigate: pathFinderLine === null || pathFinderLine === void 0 ? void 0 : pathFinderLine.inAutoNavigate,
                                                    kioskIsReset: kioskIsReset,
                                                    setKioskIsReset: setKioskIsReset,
                                                    searchText: searchText,
                                                    setSearchText: setSearchText,
                                                    hiddenFromLink: hiddenFromLink,
                                                    showSkeleton: showSkeleton,
                                                    pathFinderLine: pathFinderLine,
                                                    setDescriptionEnabled: function(val) {
                                                        return setDescriptionEnabled(val);
                                                    },
                                                    mobilePosition: mobilePosition,
                                                    setMobilePosition: setMobilePosition,
                                                    popupOpen: popupOpen,
                                                    setPopupOpen: setPopupOpen,
                                                    setPopupHeight: setPopupHeight,
                                                    startingPoint: startingPoint,
                                                    onSetStartingPoint: function(item) {
                                                        setStartingPoint(item);
                                                    },
                                                    allSweeps: allSweeps,
                                                    currentSweep: currentSweep,
                                                    setNavigationSharingPopupOpen: setNavigationSharingPopupOpen,
                                                    navigationSharingPopupOpen: navigationSharingPopupOpen,
                                                    detailedRoutes: detailedRoutes,
                                                    choicePopupOpen: choicePopupOpen,
                                                    setChoicePopupOpen: setChoicePopupOpen,
                                                    showDetailedRoutesOnly: showDetailedRoutesOnly,
                                                    closeDetailedRoutesList: closeDetailedRoutesList,
                                                    setActionPathNavbarPlayButtonType: setActionPathNavbarPlayButtonType,
                                                    resetDetailedRoutes: resetDetailedRoutes,
                                                    allTags: allTags,
                                                    teleportPoints: teleportPointsProp,
                                                    navType: navType,
                                                    setNavType: setNavType,
                                                    setStartingPoint: setStartingPoint,
                                                    resetNavigationByCloseButton: resetNavigationByCloseButton,
                                                    shouldNavReset: shouldNavReset,
                                                    showCaseTemp: showCaseTemp
                                                }),
                                                isBackgroundVisible && !selectedItem && (navigationCategories === null || navigationCategories === void 0 ? void 0 : navigationCategories.length) > 1 && !selectedCategory && !searchText.length && !hiddenFromLink && !showDetailedRoutesOnly && mobilePosition > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationCategories, {
                                                    rtl: rtl,
                                                    categories: navigationCategories,
                                                    handleSelectCategory: selectCategory,
                                                    showSkeleton: showSkeleton,
                                                    mobilePosition: mobilePosition
                                                })
                                            ]
                                        }),
                                        isBackgroundVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                            direction: "row",
                                            alignItems: "center",
                                            justifyContent: "start",
                                            alignSelf: "center",
                                            sx: {
                                                width: "194px",
                                                gap: "7px",
                                                position: "fixed",
                                                bottom: 0,
                                                right: "20px",
                                                mt: "4px",
                                                mb: "20px",
                                                display: {
                                                    xs: "none",
                                                    sm: "flex"
                                                },
                                                direction: rtl ? "rtl" : "ltr"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    fontSize: "16px",
                                                    fontWeight: rtl ? 400 : 500,
                                                    fontStyle: "normal",
                                                    lineHeight: "28.873px",
                                                    sx: {
                                                        direction: rtl ? "rtl" : "ltr"
                                                    },
                                                    children: (translation === null || translation === void 0 ? void 0 : translation.navPowerBy) || "Powered by"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "watermark",
                                                    width: "81px",
                                                    alt: "logo",
                                                    src: logo,
                                                    style: {
                                                        flexShrink: 0
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            mapEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomableMap, {
                                selectedItem: selectedItem
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 25467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ EngIconMobile; },
/* harmony export */   "At": function() { return /* binding */ ZoomDownIcon; },
/* harmony export */   "Sd": function() { return /* binding */ ZoomInIcon; },
/* harmony export */   "U4": function() { return /* binding */ StraightArrowIcon; },
/* harmony export */   "X9": function() { return /* binding */ StairsIcon; },
/* harmony export */   "ep": function() { return /* binding */ TurnLeftIcon; },
/* harmony export */   "hr": function() { return /* binding */ RouteStartIcon; },
/* harmony export */   "if": function() { return /* binding */ ZoomExpandIcon; },
/* harmony export */   "kv": function() { return /* binding */ TurnRightIcon; },
/* harmony export */   "sF": function() { return /* binding */ DestinationIcon; },
/* harmony export */   "uz": function() { return /* binding */ ElevatorIcon; },
/* harmony export */   "xL": function() { return /* binding */ ZoomOutIcon; },
/* harmony export */   "zs": function() { return /* binding */ ZoomUpIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var EnSvgIcon = function(param) {
    var width = param.width, height = param.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 23 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_7277_21487)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0.0859375",
                        y: "0.111328",
                        width: "22.0877",
                        height: "15.7769",
                        rx: "3.15539",
                        fill: "#1A47B8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.43562 0.111328H0.0859375V2.74082L19.8112 15.8883L22.1737 15.8883V13.2588L2.43562 0.111328Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0.869629 0.111328L22.1737 14.3478V15.8883H21.4083L0.0859375 1.63702V0.111328H0.869629Z",
                        fill: "#F93939"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.0701 0.111328H22.1737V2.74082C22.1737 2.74082 8.51062 11.5002 2.18953 15.8883H0.0859375V13.2588L20.0701 0.111328Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M22.1737 0.111328H21.4603L0.0859375 14.3601V15.8883H0.869629L22.1737 1.64854V0.111328Z",
                        fill: "#F93939"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.11858 0.111328H14.1594V4.9778H22.1737V11.0186H14.1594V15.8883H8.11858V11.0186H0.0859375V4.9778H8.11858V0.111328Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.38603 0.111328H12.8736V6.17938H22.1737V9.82021H12.8736V15.8883H9.38603V9.82021H0.0859375V6.17938H9.38603V0.111328Z",
                        fill: "#F93939"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_7277_21487",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0.0859375",
                        y: "0.111328",
                        width: "22.0877",
                        height: "15.7769",
                        rx: "3.15539",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var EngIconMobile = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            clipPath: "url(#clip0_7758_2029)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.4813 4.69531C1.53869 5.9217 0.827922 7.33522 0.414062 8.8708H6.65678L2.4813 4.69531Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M23.5864 8.87075C23.1725 7.33522 22.4617 5.9217 21.5191 4.69531L17.3438 8.87075H23.5864Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M0.414062 15.1328C0.827969 16.6683 1.53873 18.0819 2.4813 19.3082L6.65664 15.1328H0.414062Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M19.3083 2.48135C18.0819 1.53874 16.6684 0.827969 15.1328 0.414062V6.65674L19.3083 2.48135Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.69531 21.5191C5.9217 22.4617 7.33522 23.1725 8.87075 23.5864V17.3438L4.69531 21.5191Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.8707 0.414062C7.33517 0.827968 5.92166 1.53873 4.69531 2.4813L8.8707 6.65668V0.414062Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.1328 23.5864C16.6683 23.1725 18.0819 22.4617 19.3082 21.5191L15.1328 17.3438V23.5864Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M17.3438 15.1328L21.5191 19.3082C22.4617 18.0819 23.1725 16.6683 23.5864 15.1328H17.3438Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.1328 15.1329L20.4876 20.4877C20.7339 20.2415 20.9688 19.9841 21.193 19.7173L16.6085 15.1328H15.1328V15.1329Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.87048 15.1328H8.87039L3.51562 20.4876C3.76181 20.7339 4.0192 20.9688 4.28602 21.193L8.87048 16.6084V15.1328Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8.87269 8.87058V8.87048L3.51788 3.51562C3.27159 3.76181 3.03666 4.0192 2.8125 4.28602L7.39702 8.87053H8.87269V8.87058Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M15.1328 8.86883L20.4877 3.51392C20.2415 3.26764 19.9841 3.0327 19.7173 2.80859L15.1328 7.39311V8.86883Z",
                    fill: "#D80027"
                })
            ]
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                id: "clip0_7758_2029",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "white"
                })
            })
        })
    ]
});
var RouteStartIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Icon_2",
                d: "M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22",
                stroke: color || "#2055FF",
                strokeWidth: "2.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var TurnLeftIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Icon_2",
                d: "M9 14L4 9M4 9L9 4M4 9H16C17.0609 9 18.0783 9.42143 18.8284 10.1716C19.5786 10.9217 20 11.9391 20 13V20",
                stroke: color || "#101828",
                strokeWidth: "2.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var TurnRightIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Icon_2",
                d: "M15 14L20 9M20 9L15 4M20 9H8C6.93913 9 5.92172 9.42143 5.17157 10.1716C4.42143 10.9217 4 11.9391 4 13V20",
                stroke: color || "#101828",
                strokeWidth: "2.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var DestinationIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                id: "Icon_2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z",
                        stroke: color || "#2055FF",
                        strokeWidth: "1.92",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
                        stroke: color || "#2055FF",
                        strokeWidth: "1.92",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
var ElevatorIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Icon",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Icon_2",
                d: "M12 3V21M12 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H12V3ZM12 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H12V3Z",
                stroke: color || "#101828",
                strokeWidth: "2.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};
var StairsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Icon",
                clipPath: "url(#clip0_7582_69392)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Icon_2",
                    d: "M15.5376 2.49999C14.8748 2.5 14.3395 3.03726 14.3395 3.7V8.50003H9.03951C8.37677 8.50003 7.83951 9.03729 7.83951 9.70003V14.9338C7.83951 14.9338 5.55645 14.9338 2.20082 14.9339C1.53809 14.9339 1 15.4705 1 16.1333C0.999998 17.7418 1.00001 20.2293 1.00001 20.9339L20.3951 20.9338C21.7451 20.9338 22.8395 19.8892 22.8395 18.6005V2.5C17.977 2.49999 16.2816 2.49999 15.5376 2.49999Z",
                    stroke: color || "#101828",
                    strokeWidth: "2.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_7582_69392",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var StraightArrowIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 19V5M12 5L19 12M12 5L5 12",
            stroke: color || "#101828",
            strokeWidth: "2.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var ZoomInIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M12 5.33325L12 19.3333M5 12.3333L19 12.3333",
        stroke: "#101828",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
var ZoomOutIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M19 12.3333L5 12.3333",
        stroke: "#101828",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
var ZoomExpandIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M0.00395432 11.9117H1.54092L1.54092 12.2273L1.53974 16.7109C1.535 16.7613 1.54152 16.7832 1.55573 16.7991C1.55632 16.7997 1.56342 16.8021 1.65401 16.7926H6.42181V18.3302L0.768295 18.3296C0.53029 18.3474 0.325439 18.2846 0.183346 18.1253C0.0643438 17.9921 -0.000782081 17.84 0.0045464 17.6748L0.0045464 11.9117H0.00395432ZM0.176242 0.548468C0.321887 0.390388 0.527921 0.324671 0.751718 0.337696H6.42181V1.87111L1.60783 1.86993C1.56401 1.86579 1.55217 1.86993 1.54507 1.87704C1.53974 1.88236 1.53382 1.90368 1.54092 1.99426L1.54092 6.75614H0.00395432L0.00395432 6.44058L0.00573049 1.1417C-0.0185437 0.908436 0.033557 0.702993 0.176242 0.548468ZM17.9941 1.13815L17.9941 6.75674H16.4583L16.4583 1.95163C16.4595 1.89184 16.453 1.87289 16.4553 1.87467C16.4577 1.87644 16.4376 1.87111 16.3624 1.87407L11.5768 1.87407V0.337696L17.1238 0.338287C17.4091 0.318157 17.6353 0.367298 17.7957 0.517088C17.9615 0.672205 18.0189 0.896593 17.9947 1.13756L17.9941 1.13815ZM17.2889 18.3308L11.5762 18.3308V16.7873L16.4133 16.7879C16.4352 16.7891 16.4405 16.7873 16.4512 16.7755C16.4518 16.7749 16.4607 16.7364 16.4512 16.6144V11.9123H17.9935V12.2279L17.9929 17.5907C18.0041 17.8133 17.9432 18.0063 17.7981 18.1461C17.659 18.2805 17.476 18.3409 17.2884 18.3308H17.2889Z",
        fill: "#101828"
    })
});
var ZoomUpIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M18 15L12 9L6 15",
        stroke: "#101828",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
var ZoomDownIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M6 9L12 15L18 9",
        stroke: "#98A2B3",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
/* harmony default export */ __webpack_exports__["ZP"] = (EnSvgIcon);


/***/ }),

/***/ 9313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FR": function() { return /* binding */ trimDescription; },
/* harmony export */   "T5": function() { return /* binding */ createInputProps; },
/* harmony export */   "hY": function() { return /* binding */ renderIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_navigation_NavigationIntroScreen_components_Popup_Icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96665);
/* harmony import */ var _components_navigation_NavigationIntroScreen_components_Popup_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56101);
/* harmony import */ var _components_util_deviceManager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99080);




var renderIcon = function(location, width, height) {
    if (location === null || location === void 0 ? void 0 : location.iconFile) {
        var tagIconUrl;
        if (location.iconFile.startsWith("http")) {
            tagIconUrl = "".concat(location.iconFile);
        } else {
            tagIconUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(location.tourId, "/tags/icons/").concat(location.iconFile);
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            width: width || "38px",
            height: height || "38px",
            src: tagIconUrl,
            alt: location.title
        });
    }
    if ((location === null || location === void 0 ? void 0 : location.custom) && (location === null || location === void 0 ? void 0 : location.customIcon)) {
        var tagIconUrl1 = location.iconColor ? "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(location.customIcon, "?hex=").concat(encodeURIComponent(location.iconColor), "&circle=").concat(location.whiteCircle) : "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(location.customIcon);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            width: "27px",
            height: "27px",
            src: tagIconUrl1,
            alt: location.title
        });
    }
    if ((location === null || location === void 0 ? void 0 : location.url) || (location === null || location === void 0 ? void 0 : location.station)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_NavigationIntroScreen_components_Popup_Icons__WEBPACK_IMPORTED_MODULE_1__/* .StationIcon */ .Sr, {
            style: {
                width: width || "38px",
                height: height || "38px",
                borderRadius: "8px"
            }
        });
    }
    if (location === null || location === void 0 ? void 0 : location.sweepId) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_NavigationIntroScreen_components_Popup_Icons__WEBPACK_IMPORTED_MODULE_1__/* .FlagIcon */ .U6, {
            style: {
                width: width,
                height: height,
                borderRadius: "8px"
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_NavigationIntroScreen_components_Popup_Icons__WEBPACK_IMPORTED_MODULE_1__/* .DefaultTagIcon */ .VC, {
        style: {
            width: width,
            height: height,
            borderRadius: "8px"
        }
    });
};
var createInputProps = function(param) {
    var clearSearch = param.clearSearch, isSearchBarFocused = param.isSearchBarFocused, actionPathFinished = param.actionPathFinished, loadingFinished = param.loadingFinished;
    return {
        startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/navigation/search.svg",
            alt: ""
        }),
        endAdornment: isSearchBarFocused && !_components_util_deviceManager__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isMobile */ .Z.isMobile() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                width: "50px"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_NavigationIntroScreen_components_Popup_styles__WEBPACK_IMPORTED_MODULE_2__/* .CloseButton */ .PZ, {
                rounded: true,
                onClick: clearSearch,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navigation_NavigationIntroScreen_components_Popup_Icons__WEBPACK_IMPORTED_MODULE_1__/* .CrossIcon */ .aM, {
                    style: {}
                })
            })
        }) : null,
        sx: {
            background: "#fff",
            height: {
                xs: "57px",
                md: "76px"
            },
            borderRadius: actionPathFinished && !loadingFinished ? "8px 8px 0 0" : "8px",
            border: "1px solid #D0D5DD",
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.05)",
            backdropFilter: "blur(20.649999618530273px)",
            color: "#101828",
            paddingRight: {
                xs: "10px",
                lg: "14px"
            },
            "& input": {
                fontSize: {
                    xs: "18px",
                    lg: "20px"
                },
                fontWeight: {
                    xs: "500 !important",
                    lg: "600 !important"
                }
            }
        }
    };
};
function trimDescription(description, maxLength) {
    if ((description === null || description === void 0 ? void 0 : description.length) > maxLength) {
        return "".concat(description.substring(0, maxLength), "...");
    }
    return description;
}


/***/ }),

/***/ 7710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70989);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 27px;\n  color: #ea475c;\n  position: relative;\n  margin-top: 41px;\n  margin-left: 40px;\n  margin-right: 40px;\n  cursor: pointer;\n  z-index: 1;\n  direction: initial;\n\n  @media screen and (max-width: 760px) {\n    display: inline-block;\n    float: initial;\n    width: 100%;\n    margin: 0;\n    padding: 15px 22px 0 22px;\n    position: relative;\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "BackButton__MainWrap",
    componentId: "sc-59361543-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align:right;" : "");
});
var BackButton = function(props) {
    var backFunction = props.backFunction, location = props.location;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _back = ref.back, back = _back === void 0 ? "back" : _back;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .tourConfigsState */ .Uq).rtl;
    var history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .useHistory */ .k6)();
    var pushBack = function() {
        if (backFunction) {
            backFunction();
        } else {
            var paths = location.pathname.split("/");
            if (paths[paths.length - 1] === "") paths.pop();
            paths.pop();
            history.push(paths.join("/"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        onClick: pushBack,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                className: "fas fa-chevron-left"
            }),
            " ",
            back
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .withRouter */ .EN)(BackButton));


/***/ }),

/***/ 73491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TourLanguageSelect.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  padding: 0 5px;\n  line-height: 1.1;\n  font-size: 15px;\n\n  @media screen and (max-width: 760px) {\n    width: 33.33%;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  color: white;\n  text-transform: uppercase;\n  position: relative;\n  margin: 0 5px;\n\n  div.mainItem {\n    cursor: pointer;\n  }\n\n  div.optionItem {\n    line-height: 1.3;\n    background: transparent;\n    cursor: pointer;\n\n    display: flex;\n    color: white;\n    align-items: center;\n    justify-content: start;\n    margin-bottom: 10px;\n\n    i {\n      font-size: 5px;\n      margin: 5px;\n      text-decoration: initial !important;\n    }\n\n    span {\n      display: block !important;\n    }\n\n    &.active {\n      text-decoration: underline;\n    }\n  }\n\n  div.optionsWrap {\n    position: absolute;\n    //padding: 16px 0 11px 27px;\n    background-color: rgba(44, 44, 44, 0.9);\n    border-radius: 12px;\n    //margin-left: -40px;\n    width: calc(100% + 51px);\n\n    //padding: 20px 3px 10px 10px;\n    padding: 10px 3px 5px 10px;\n    ",
        ";\n\n    left: 0;\n    margin-left: 0;\n    margin-top: 21px;\n  }\n\n  @media screen and (max-width: 760px) {\n    div.optionsWrap {\n      margin-top: 9px;\n      width: 100vw;\n      position: absolute;\n      left: -20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CustomSelectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelectWrap",
    componentId: "sc-81eec9ae-0"
})(_templateObject());
var CustomSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TourLanguageSelect__CustomSelect",
    componentId: "sc-81eec9ae-1"
})(_templateObject1(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 10px 10px 5px 3px;right: 0;left: initial;right: -20px;" : "");
});
var TourLanguageSelect = function(props) {
    var tourId = props.tourId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _current_tour_has_no_language = ref.current_tour_has_no_language, current_tour_has_no_language = _current_tour_has_no_language === void 0 ? "Current tour has no language" : _current_tour_has_no_language, _no_language = ref.no_language, no_language = _no_language === void 0 ? "no language" : _no_language;
    var ref1 = (0,react.useState)(null), duplicates = ref1[0], setDuplicates = ref1[1];
    var ref2 = (0,react.useState)(false), duplicatesIsOpen = ref2[0], setDuplicatesIsOpen = ref2[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var initialDuplicatesRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tourId)
                        ];
                    case 1:
                        initialDuplicatesRes = _state.sent();
                        if (initialDuplicatesRes && initialDuplicatesRes.message.includes("Success")) {
                            setDuplicates(initialDuplicatesRes.duplicates);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var getCurrentLanguage = function() {
        var pathnameSplitted = window.location.pathname.split("/");
        return (duplicates || []).find(function(duplicate) {
            return pathnameSplitted.includes(duplicate.slug);
        });
    };
    var isLanguageActive = function(slug) {
        var pathnameSplitted = window.location.pathname.split("/");
        return pathnameSplitted.find(function(p) {
            return p === slug;
        });
    };
    var handleLanguageClick = function(slug) {
        return function() {
            if (!isLanguageActive(slug)) {
                replaceSlug(slug);
                setDuplicatesIsOpen(false);
            }
        };
    };
    var replaceSlug = function(slug) {
        var pathnames = window.location.pathname.split("/");
        pathnames.shift();
        var targetLink = "/".concat(pathnames[0], "/").concat(pathnames[0] === "experience" ? pathnames[1] : slug).concat(pathnames[0] === "experience" ? "/".concat(slug) : "");
        location.replace(window.location.origin + targetLink);
    };
    var currentLanguageObj = getCurrentLanguage();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return duplicates && duplicates.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelectWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "far fa-globe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomSelect, {
                rtl: rtl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mainItem",
                        onClick: function() {
                            return setDuplicatesIsOpen(!duplicatesIsOpen);
                        },
                        children: (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.language) || (currentLanguageObj === null || currentLanguageObj === void 0 ? void 0 : currentLanguageObj.languageEn) || current_tour_has_no_language
                    }),
                    duplicatesIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "optionsWrap",
                        children: duplicates.map(function(duplicate, num) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("optionItem", isLanguageActive(duplicate.slug) && "active"),
                                onClick: handleLanguageClick(duplicate.slug),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-circle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (duplicate === null || duplicate === void 0 ? void 0 : duplicate.language) || (duplicate === null || duplicate === void 0 ? void 0 : duplicate.languageEn) || "".concat(no_language, " / ").concat(duplicate.slug)
                                    })
                                ]
                            }, num);
                        })
                    })
                ]
            }),
            duplicatesIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-up"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "fas fa-chevron-down"
            })
        ]
    }) : null;
};
/* harmony default export */ var components_TourLanguageSelect = (TourLanguageSelect);

;// CONCATENATED MODULE: ./components/ticketingNew/components/BaseLayout.tsx




function BaseLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  background-color: ",
        ";\n  //background: conic-gradient(from 193.61deg at 46.18% 51.15%, #000000 -139.17deg, #eeeeee 10.44deg, #ffffff 157.82deg, #000000 220.83deg, #eeeeee 370.44deg);\n  ",
        ";\n  overflow-y: auto;\n  max-height: 100vh;\n\n  header {\n    height: 58px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    display: flex;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    z-index: 1;\n\n    .bl-header-clientPic {\n      //left: 15px;\n      //position: absolute;\n      //background: #ccadad;\n      width: 100px;\n      height: 100%;\n      margin-right: 15px;\n\n      &.forMobile {\n        display: none;\n      }\n      object-fit: contain;\n\n      @media screen and (max-width: 760px) {\n        display: none;\n        &.forMobile {\n          display: block;\n          order: 2;\n          width: 33.33%;\n          margin: 0;\n        }\n      }\n    }\n\n    .bl-header-block {\n      font-size: 16px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      margin: auto;\n      justify-content: center;\n      height: 100%;\n      width: auto;\n      left: ",
        ";\n      right: ",
        ";\n\n      @media screen and (max-width: 760px) {\n        width: 100%;\n        right: 0;\n        //right: auto;\n        span {\n          display: none;\n        }\n      }\n\n      & > * {\n        line-height: 1;\n      }\n\n      .bl-header-lang {\n        display: flex;\n        align-items: center;\n\n        i {\n          font-size: 16px;\n        }\n\n        select {\n          line-height: 1;\n          background: transparent;\n          color: white;\n          font-size: 16px;\n          padding: 0;\n          min-width: 43px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 1;\n          width: 33.33%;\n          padding-left: 15px;\n        }\n      }\n\n      .loginButton-wrap {\n        .signButton {\n          border: 1.5px solid #ffffff;\n          box-sizing: border-box;\n          filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n          border-radius: 6px;\n          width: 83px;\n          height: 31px;\n          background: transparent;\n          color: white;\n          margin: 0 15px;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          margin: 0;\n          text-align: right;\n          width: 33.33%;\n          padding-right: 15px;\n          button {\n            margin: 0 !important;\n          }\n        }\n      }\n\n      .buyNowLink {\n        margin: 0 15px;\n        text-decoration: underline;\n\n        &:hover,\n        &:active {\n          color: white;\n        }\n\n        @media screen and (max-width: 760px) {\n          order: 3;\n          width: 33.33%;\n          text-align: right;\n          margin: 0;\n          padding-right: 15px;\n        }\n      }\n    }\n  }\n\n  .bl-inner-content {\n    min-height: calc(100vh - 155px);\n    overflow: hidden;\n  }\n\n  footer {\n    height: 97px;\n    width: 100%;\n    background-color: #282828;\n    color: white;\n    margin-top: 35px;\n\n    .bl-footer-copyright {\n      height: 45px;\n      margin: 30px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      font-size: 22px;\n\n      span {\n        margin: 0 15px 0 5px;\n      }\n\n      img {\n        margin-top: 3px;\n        margin-left: 5px;\n        width: 101px;\n        object-fit: contain;\n        height: 46px;\n\n        &[alt='treedis'] {\n          filter: brightness(0) saturate(100%) invert(45%) sepia(15%) saturate(3730%) hue-rotate(311deg) brightness(90%) contrast(105%);\n        }\n      }\n    }\n  }\n"
    ]);
    BaseLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BaseLayoutStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BaseLayout__BaseLayoutStyled",
    componentId: "sc-6c1cf33c-0"
})(BaseLayout_templateObject(), function(p) {
    return p.transparentBg ? "#E5E5E528" : "#e5e5e5";
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "direction: rtl; text-align: right;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "50px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "50px");
});
var ClientPic = function(param) {
    var _forMobile = param.forMobile, forMobile = _forMobile === void 0 ? false : _forMobile, _src = param.src, src = _src === void 0 ? "" : _src;
    return src ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: src,
        alt: "client_logo",
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("bl-header-clientPic", forMobile && "forMobile")
    });
};
var BaseLayout = function(props) {
    var ref, ref1;
    var location = props.location, children = props.children, _tourId = props.tourId, tourId = _tourId === void 0 ? 0 : _tourId, _whiteLabelData = props.whiteLabelData, whiteLabelData = _whiteLabelData === void 0 ? {} : _whiteLabelData, _transparentBg = props.transparentBg, transparentBg = _transparentBg === void 0 ? false : _transparentBg;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var ref2 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _log_in = ref2.log_in, log_in = _log_in === void 0 ? "log in" : _log_in, _buy_now = ref2.buy_now, buy_now = _buy_now === void 0 ? "Buy now" : _buy_now, _poweredBy = ref2.poweredBy, poweredBy = _poweredBy === void 0 ? "Powered by" : _poweredBy, _already_have_a_ticket = ref2.already_have_a_ticket, already_have_a_ticket = _already_have_a_ticket === void 0 ? "Already have a ticket?" : _already_have_a_ticket, _dont_have_a_tour_ticket = ref2.dont_have_a_tour_ticket, dont_have_a_tour_ticket = _dont_have_a_tour_ticket === void 0 ? "Don't have a tour ticket?" : _dont_have_a_tour_ticket;
    var isLoginPage = location.pathname.includes("login");
    var pathnames = location.pathname.split("/");
    pathnames.shift();
    var homeLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/book");
    var loginLink = "/".concat(pathnames[0], "/").concat(pathnames[1]).concat(pathnames[0] === "experience" ? "/".concat(pathnames[2]) : "", "/login");
    var clietnLogoSrc = whiteLabelData.logo && (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref = whiteLabelData.logo) === null || ref === void 0 ? void 0 : ref.includes("clients")) ? whiteLabelData.logo : "";
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref3[0], setInfoModalData = ref3[1];
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayoutStyled, {
        transparentBg: transparentBg,
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                        src: clietnLogoSrc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-header-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientPic, {
                                forMobile: true,
                                src: clietnLogoSrc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: !isLoginPage ? already_have_a_ticket : dont_have_a_tour_ticket
                            }),
                            isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: homeLink,
                                className: "buyNowLink",
                                onClick: closeInfoModal,
                                children: buy_now
                            }),
                            !isLoginPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginLink,
                                className: "loginButton-wrap",
                                onClick: closeInfoModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "signButton",
                                    children: log_in
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TourLanguageSelect, {
                                tourId: tourId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-inner-content",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bl-footer-copyright",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-copyright"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: poweredBy
                        }),
                        whiteLabelData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : (ref1 = whiteLabelData.domainUrl) === null || ref1 === void 0 ? void 0 : ref1.includes("http")) ? whiteLabelData.domainUrl : "http://" + whiteLabelData.domainUrl,
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: whiteLabelData.logo,
                                alt: "whitelabel logo"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://treedis.com/",
                            rel: "noreferrer",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "treedis",
                                src: "/logo.png",
                                alt: "treedis logo"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_BaseLayout = ((0,react_router/* withRouter */.EN)(BaseLayout));


/***/ }),

/***/ 47887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ EInfoModal; },
  "Z": function() { return /* binding */ components_InfoModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./components/ticketingNew/components/BaseLayout.tsx + 1 modules
var BaseLayout = __webpack_require__(73491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TicketItemMobile.tsx
var TicketItemMobile = __webpack_require__(47238);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx + 1 modules
var OrderSuccess = __webpack_require__(99931);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderTicketFromTour/index.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 20px;\n  width: 1162px;\n  max-width: 100%;\n  margin: 44px auto 43px auto;\n  background: rgba(79, 79, 79, 0.6);\n  backdrop-filter: blur(150px);\n  padding: 54px 180px;\n  color: white;\n  position: relative;\n  text-align: center;\n\n  .otft-home {\n    font-weight: 600;\n    font-size: 18px;\n    color: white;\n    text-decoration: none;\n    position: absolute;\n    left: 65px;\n    top: 69px;\n\n    i {\n      margin-right: 5px;\n    }\n  }\n\n  .otft-header {\n    font-weight: 400;\n    font-size: 60px;\n    line-height: 90px;\n    margin-bottom: 10px;\n  }\n\n  .otft-title {\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 33px;\n    margin-bottom: 10px;\n  }\n\n  .otft-message {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    margin-bottom: 40px;\n  }\n\n  .otft-content {\n    display: flex;\n  }\n\n  .otft-tickets {\n    color: black;\n    width: 50%;\n\n    max-height: 435px;\n    overflow-y: scroll;\n    padding-right: 5px;\n  }\n  .otft-payment {\n    text-align: initial;\n    width: 50%;\n\n    .bl-ticket-order {\n      width: 100%;\n      padding: 28px;\n      color: black;\n      margin-left: 15px;\n    }\n\n    .bl-ticket-order-pay-btn {\n      padding: 8px 15px;\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderTicketFromTour__MainWrap",
    componentId: "sc-3101faca-0"
})(_templateObject());
var OrderTicketFromTour = function(props) {
    var location = props.location, _message = props.message, message = _message === void 0 ? "Your ticket time is expired.. but you can buy a new ticket" : _message, match = props.match;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    console.log("infoModalData", infoModalData);
    var ref1 = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.ticketLoginData, ticketing = ref1.ticketing, ticketingOrderedTicket = ref1.ticketingOrderedTicket, ticketingTourTicket = ref1.ticketingTourTicket, tour = ref1.tour;
    var participants = [
        {
            id: Date.now(),
            fullName: ticketingOrderedTicket.name,
            email: ticketingOrderedTicket.email,
            isGift: ticketingOrderedTicket.isGift
        }, 
    ];
    var ref2 = (0,react.useState)(null), pickedTicketId = ref2[0], setPickedTicketId = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var ref4 = (0,react.useState)(Order/* OrderStageEnum.order */.t9.order), orderStage = ref4[0], setOrderStage = ref4[1];
    var homePage = location.pathname.replace(/book.+|book/g, "");
    var closeInfoModal = function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var getTicketList = function() {
        //get current orderedTicket data & return tickets of same type (guided, ys, experience)
        //for restriction, return tours that have access to restricted sweep
        if (ticketingOrderedTicket.ticketType === "gameTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if (ticketingOrderedTicket.ticketType === "tourByYourself") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if (ticketingOrderedTicket.ticketType === "guidedTour") return ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        return [];
    };
    //@ts-ignore
    var handlePaymentSuccess = function() {
    //close modal
    //go to login page with inserted ticket id
    };
    var tickets = getTicketList();
    console.log("tickets", tickets);
    console.log("infoModalData", infoModalData);
    if (!tickets || !infoModalData) {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            mode: EInfoModal.error,
            message: infoModalData.mode === EInfoModal.timeIsUp ? "Ticket time is up" : "Area is restricted for this tour"
        }));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "closing..."
        });
    }
    console.log("ticketingOrderedTicket", ticketingOrderedTicket);
    console.log("ticketingTourTicket", ticketingTourTicket);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        children: [
            orderStage === Order/* OrderStageEnum.order */.t9.order && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
                        to: homePage,
                        className: "otft-home",
                        onClick: closeInfoModal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            "Home Page"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-header",
                        children: "Oops!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-title",
                        children: message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "otft-message",
                        children: "Pick your new ticket"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "otft-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-tickets",
                                children: tickets === null || tickets === void 0 ? void 0 : tickets.map(function(e) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TicketItemMobile/* default */.Z, {
                                        ticket: e,
                                        currencyId: 3,
                                        onPick: function(id) {
                                            return setPickedTicketId(id);
                                        },
                                        pickedId: pickedTicketId
                                    }, e === null || e === void 0 ? void 0 : e.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "otft-payment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    gameId: tour === null || tour === void 0 ? void 0 : tour.gameId,
                                    matterId: tour === null || tour === void 0 ? void 0 : tour.matterId,
                                    setOrderStage: setOrderStage,
                                    participants: participants,
                                    handlePaymentSuccess: function() {
                                        return setOrderStage(Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess);
                                    },
                                    match: match,
                                    setOrderLink: setOrderLink,
                                    initialTourType: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.ticketType,
                                    initialTicketId: pickedTicketId
                                })
                            })
                        ]
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.payment */.t9.payment && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "otft-order-frame",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-chevron-left"
                            }),
                            " back"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Payment"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Please enter your payment details"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: orderLink
                    })
                ]
            }),
            orderStage === Order/* OrderStageEnum.tourOrderOnlySuccess */.t9.tourOrderOnlySuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSuccess/* default */.Z, {
                minimized: true,
                onLinkClick: closeInfoModal
            })
        ]
    });
};
/* harmony default export */ var components_OrderTicketFromTour = ((0,react_router/* withRouter */.EN)(OrderTicketFromTour));

;// CONCATENATED MODULE: ./components/ticketingNew/components/InfoModal.tsx




function InfoModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  max-width: 100%;\n\n  .im-inner-wrap {\n    background: rgba(79, 79, 79, 0.6);\n    color: white;\n    backdrop-filter: blur(150px);\n    border-radius: 20px;\n    padding: 54px 71px;\n    text-align: center;\n\n    .im-inner-warn {\n      font-weight: 400;\n      font-size: 60px;\n      line-height: 90px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-title {\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      margin-bottom: 10px;\n    }\n\n    .im-inner-message {\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 22px;\n      margin-bottom: 60px;\n    }\n\n    .im-inner-ok_btn {\n      background-color: #ea475c;\n      border-radius: 12px;\n      color: white;\n      font-weight: 600;\n      font-size: 18px;\n      padding: 15px 34px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n\n      &:active {\n        opacity: 0.8;\n      }\n\n      i {\n        margin-left: 5px;\n      }\n    }\n  }\n\n  & > .cVideo-modal-videoWrap {\n    width: 100%;\n    height: 100%;\n\n    & > iframe {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .im-redirect-btn {\n    margin-right: 15px;\n  }\n"
    ]);
    InfoModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledModal = (0,styled_components_browser_esm/* default */.ZP)((lib_default())).withConfig({
    displayName: "InfoModal__StyledModal",
    componentId: "sc-d467fa-0"
})(InfoModal_templateObject(), function(props) {
    return props.mode !== EInfoModal.error ? "100%" : "746px";
}, function(props) {
    return props.mode !== EInfoModal.error ? "auto" : "421px";
});
var EInfoModal;
(function(EInfoModal) {
    EInfoModal[EInfoModal["error"] = 0] = "error";
    EInfoModal[EInfoModal["timeIsUp"] = 1] = "timeIsUp";
    EInfoModal[EInfoModal["restrictedArea"] = 2] = "restrictedArea";
})(EInfoModal || (EInfoModal = {}));
var InfoModal = function(props) {
    var root = props.root;
    var ref = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref[0], setInfoModalData = ref[1];
    var ref1 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _oops = ref1.oops, oops = _oops === void 0 ? "Oops!" : _oops, _proceedToPage = ref1.proceedToPage, proceedToPage = _proceedToPage === void 0 ? "Proceed to needed page" : _proceedToPage, _gotIt = ref1.gotIt, gotIt = _gotIt === void 0 ? "Got it" : _gotIt;
    var handleClose = infoModalData.onRequestClose ? infoModalData.onRequestClose : function() {
        return setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: false
        }));
    };
    var handleCloseRedirect = function() {
        window.location.href = infoModalData === null || infoModalData === void 0 ? void 0 : infoModalData.redirectLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        isOpen: infoModalData.isOpen,
        onRequestClose: handleClose,
        mode: infoModalData.mode,
        appElement: root,
        children: [
            infoModalData.mode === EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "im-inner-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-warn",
                        children: oops
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-title",
                        children: infoModalData.message || "Ticket not found"
                    }),
                    !infoModalData.message && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "im-inner-message",
                        children: "You can find your customer code number on the purchase confirmation Email"
                    }),
                    infoModalData.redirectLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleCloseRedirect,
                        children: proceedToPage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "im-inner-ok_btn",
                        onClick: handleClose,
                        children: [
                            gotIt,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-check"
                            })
                        ]
                    })
                ]
            }),
            infoModalData.mode !== EInfoModal.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseLayout/* default */.Z, {
                transparentBg: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "im-inner-wrap-order",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OrderTicketFromTour, {})
                })
            })
        ]
    });
};
/* harmony default export */ var components_InfoModal = ((0,react_router/* withRouter */.EN)(InfoModal));


/***/ }),

/***/ 72225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70989);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  //margin-top: 18px;\n\n  @media screen and (max-width: 760px) {\n    margin-top: 9px;\n    max-width: 100%;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-top: 5px;\n  text-align: center;\n\n  .bl-card-btn {\n    background: #ffffff;\n    border: 1px solid #000000;\n    box-sizing: border-box;\n    box-shadow: -4px 4px 0px rgba(255, 255, 255, 0.25);\n    border-radius: 12px;\n    padding: 8px 22px;\n\n    &:active {\n      opacity: 0.9;\n    }\n  }\n\n  .bl-btn-hr {\n    width: 65px;\n    top: 0px;\n    border-color: black;\n    position: absolute;\n\n    &.bl-hr-left {\n      left: 20px;\n    }\n\n    &.bl-hr-right {\n      right: 20px;\n    }\n\n    @media screen and (max-width: 760px) {\n      width: 20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var BlCardBarcode = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBarcode",
    componentId: "sc-1aecdbc6-0"
})(_templateObject());
var BlCardBtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MoreInfoBtn__BlCardBtnWrap",
    componentId: "sc-1aecdbc6-1"
})(_templateObject1());
var MoreInfoBtn = function(param) {
    var ticketInfoUlr = param.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv), _more_info = ref.more_info, more_info = _more_info === void 0 ? "More Info" : _more_info;
    return ticketInfoUlr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBtnWrap, {
        className: "bl-card-btn-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
            href: ticketInfoUlr.includes("http") ? ticketInfoUlr : "http://".concat(ticketInfoUlr),
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "bl-card-btn",
                    children: more_info
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-left"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                    className: "bl-btn-hr bl-hr-right"
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlCardBarcode, {
        className: "bl-card-barcode",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            src: "/ticketing/barcode.png",
            alt: "ticket_barcode"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreInfoBtn);


/***/ }),

/***/ 61749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_OrderDetailsBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./components/ticketingNew/components/DiscountField.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order-discount {\n    margin-top: 13px;\n    cursor: pointer;\n\n    .bl-ticket-order-discount-text {\n      .fa-ticket-alt {\n        margin-right: 5px;\n      }\n\n      .fa-chevron-down {\n        margin-left: 5px;\n      }\n    }\n\n    .bl-ticket-order-discount-input-activate {\n      display: flex;\n      height: 35px;\n      position: relative;\n\n      .bl-discount-input-wrap {\n        display: flex;\n        position: relative;\n        width: 100%;\n\n        .bl-discount-error-icon {\n          background: #ea475c;\n          width: 14px;\n          height: 14px;\n          position: absolute;\n          right: 10px;\n          border-radius: 50%;\n          color: white;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          top: 10px;\n          font-weight: 300;\n          font-size: 12px;\n          ",
        ";\n        }\n\n        .bl-applied-discount-value {\n          position: absolute;\n          font-weight: 300;\n          font-size: 15px;\n          line-height: 21px;\n          display: flex;\n          align-items: center;\n          top: 8px;\n          height: 18px;\n          right: 12px;\n\n          ",
        ";\n\n          .bl-confirmed-icon-wrap {\n            font-weight: 300;\n            line-height: 21px;\n            width: 14px;\n            height: 14px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background: #59df76;\n            border-radius: 50%;\n            margin-left: 6px;\n            color: white;\n            font-size: 8px;\n          }\n        }\n      }\n\n      i.fa-ticket-alt {\n        z-index: 1;\n        position: absolute;\n        top: 10px;\n        left: 8px;\n        ",
        ";\n      }\n\n      input {\n        padding-left: 25px;\n        height: 35px;\n        background: #ffffff;\n        /* Dark/Dark 1 */\n\n        border: 1px solid #b2bcca;\n        box-sizing: border-box;\n        border-radius: 8px;\n        ",
        ";\n\n        &:active,\n        &:focus {\n          outline: 2px solid #b2bcca;\n        }\n\n        &.error {\n          border-color: #ea475c;\n\n          &:active,\n          &:focus {\n            outline: 2px solid #ea475c;\n          }\n        }\n      }\n\n      button {\n        margin-left: 18px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #ea475c;\n        background: transparent;\n        border: 2px solid #ea475c;\n        box-sizing: border-box;\n        border-radius: 12px;\n        padding: 0px 35px;\n        ",
        ";\n\n        &:active {\n          background: rgba(234, 71, 92, 0.1);\n        }\n      }\n\n      &.applied {\n        button {\n          color: white;\n          border: none;\n          background-color: #21d349bf;\n\n          &:active {\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n\n    .bl-discount-error-message {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      color: #ea475c;\n      margin-top: 4px;\n      ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var DiscountMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DiscountField__DiscountMainWrap",
    componentId: "sc-8ff49289-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;position: absolute;left: 8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: 15px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 9px;left: initial;right:8px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding: 8px 30px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-right: 18px;margin-left: 0;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "text-align: right;direction: rtl;" : "");
});
var DiscountField = function(props) {
    var tourId = props.tourId, ticketId = props.ticketId, ticketingType = props.ticketingType, currencySign = props.currencySign, onDiscountApply = props.onDiscountApply;
    var ref = (0,react.useState)(false), isAbleToSetDiscount = ref[0], setIsAbleToSetDiscount = ref[1];
    var ref1 = (0,react.useState)(""), discountCode = ref1[0], setDiscountCode = ref1[1];
    var ref2 = (0,react.useState)(false), discountLoading = ref2[0], setDiscountLoading = ref2[1];
    var ref3 = (0,react.useState)({}), appliedDiscount = ref3[0], setAppliedDiscount = ref3[1];
    var ref4 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_gift_card_or_discount_code = ref4.add_a_gift_card_or_discount_code, add_a_gift_card_or_discount_code = _add_a_gift_card_or_discount_code === void 0 ? "Add a gift card or discount code" : _add_a_gift_card_or_discount_code, _applyTicket = ref4.applyTicket, applyTicket = _applyTicket === void 0 ? "Apply" : _applyTicket, _confirmed = ref4.confirmed, confirmed = _confirmed === void 0 ? "Confirmed" : _confirmed, _promocode_not_found = ref4.promocode_not_found, promocode_not_found = _promocode_not_found === void 0 ? "promocode not found" : _promocode_not_found;
    var loadPromocode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var promocodeRes, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            4,
                            5
                        ]);
                        if (!(!(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.amount) && tourId)) return [
                            3,
                            2
                        ];
                        setDiscountLoading(true);
                        return [
                            4,
                            TreedisPublicDAO/* default.getTicketingDiscount */.Z.getTicketingDiscount({
                                query: {
                                    tourId: tourId,
                                    codeName: discountCode,
                                    ticketId: ticketId,
                                    ticketingType: ticketingType
                                }
                            })
                        ];
                    case 1:
                        promocodeRes = _state.sent();
                        if (promocodeRes && promocodeRes.message.includes("Success")) {
                            setAppliedDiscount(promocodeRes.data);
                            onDiscountApply(promocodeRes.data);
                        } else {
                            setAppliedDiscount({
                                error: promocode_not_found
                            });
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setAppliedDiscount({
                            error: err.message
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setDiscountLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadPromocode() {
            return _ref.apply(this, arguments);
        };
    }();
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscountMainWrap, {
        className: "bl-ticket-order-discount",
        rtl: rtl,
        children: [
            !isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-discount-text",
                onClick: function() {
                    return setIsAbleToSetDiscount(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    " ",
                    add_a_gift_card_or_discount_code,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-chevron-down"
                    })
                ]
            }),
            isAbleToSetDiscount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("bl-ticket-order-discount-input-activate", appliedDiscount.amount && "applied"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "far fa-ticket-alt"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-discount-input-wrap",
                        children: [
                            appliedDiscount.amount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-applied-discount-value",
                                children: [
                                    "-",
                                    appliedDiscount.amount,
                                    appliedDiscount.discountType === "percent" ? "%" : currencySign,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-confirmed-icon-wrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fal fa-check"
                                        })
                                    })
                                ]
                            }),
                            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-discount-error-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fal fa-times"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: classnames_default()(appliedDiscount.error && "error"),
                                disabled: discountLoading || appliedDiscount.amount,
                                type: "text",
                                value: discountCode,
                                onChange: function(ev) {
                                    return setDiscountCode(ev.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: loadPromocode,
                        children: appliedDiscount.amount ? confirmed : applyTicket
                    })
                ]
            }),
            appliedDiscount.error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-discount-error-message",
                children: [
                    "*",
                    appliedDiscount.error
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DiscountField = (DiscountField);

// EXTERNAL MODULE: ./components/ticketingNew/pages/Order/index.tsx + 2 modules
var Order = __webpack_require__(67020);
// EXTERNAL MODULE: ./components/ticketingNew/types.ts
var types = __webpack_require__(84345);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
// EXTERNAL MODULE: ./components/ticketingNew/static.ts
var ticketingNew_static = __webpack_require__(70712);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-order {\n    width: 50%;\n    display: inline-block;\n    background: #ffffff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);\n    padding: 26px 50px 0 53px;\n    height: auto;\n    padding-bottom: 34px;\n    align-self: flex-start;\n\n    .bl-ticket-order-title {\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 30px;\n      margin-bottom: 8px;\n    }\n\n    .bl-ticket-order-subTitle {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 18px;\n      margin-bottom: 10px;\n      color: #828282;\n    }\n\n    .bl-ticket-order-pills {\n      margin-bottom: 15px;\n      display: flex;\n      flex-wrap: wrap;\n\n      .bl-ticket-order-pill {\n        display: flex;\n        align-items: center;\n        border: 0.5px solid #d7d7d7;\n        box-sizing: border-box;\n        box-shadow: 0 0.5px 0 1px rgba(0, 0, 0, 0.16);\n        border-radius: 16px;\n        padding: 4px 18px;\n        margin-right: 7px;\n        margin-bottom: 7px;\n\n        img {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n\n    .bl-ticket-order-private-note-wrap {\n      border: 1px solid #d7d7d7;\n      box-sizing: border-box;\n      border-radius: 3px;\n      padding: 10px 12px 4px 20px;\n      position: relative;\n      margin-bottom: 16px;\n\n      .bl-ticket-order-pnote-header {\n        display: inline-block;\n        position: absolute;\n        top: -10px;\n        background-color: white;\n        color: #828282;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 20px;\n        ",
        ";\n      }\n\n      .bl-ticket-order-pnote-content {\n        font-weight: 300;\n        font-size: 12px;\n        line-height: 21px;\n      }\n    }\n\n    .bl-ticket-order-price {\n      display: flex;\n\n      .bl-ticket-order-price-title {\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        white-space: nowrap;\n      }\n\n      .bl-ticket-order-price-line {\n        border-style: dashed;\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n      }\n\n      .bl-ticket-order-price-cost {\n      }\n    }\n\n    .bl-ticket-order-after-disc-line {\n    }\n\n    .bl-ticket-order-gtotal {\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 19px;\n\n      .bl-ticket-order-gtotal-title {\n      }\n\n      .bl-ticket-order-gtotal-price {\n      }\n    }\n\n    .bl-ticket-order-checkboxes {\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: baseline;\n        margin-bottom: 10px;\n\n        input[type='checkbox'] {\n          margin-right: 8px;\n          line-height: 20px;\n          width: 12px;\n          height: 12px;\n          accent-color: #ea475c;\n          border-radius: 2px;\n          ",
        ";\n        }\n      }\n    }\n\n    .bl-ticket-order-pay-btn {\n      background: linear-gradient(137.27deg, #ea475c 19.41%, #ff6175 65.49%);\n      box-shadow: 0px 4px 4px rgba(14, 53, 191, 0.25);\n      border-radius: 12px;\n      color: #f6f6f6;\n      font-weight: 700;\n      font-size: 16px;\n      line-height: 20px;\n\n      padding: 12px 109px;\n      margin: auto;\n      display: block;\n      margin-top: 29px;\n\n      &:active {\n        opacity: 0.9;\n      }\n\n      &:disabled {\n        background: #8b8b8b;\n      }\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MainWrap",
    componentId: "sc-84e67df1-0"
})(styles_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: 26px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 8px;" : "");
});

// EXTERNAL MODULE: ./components-new/eCommerce/PayPalPaymentButton/index.tsx
var PayPalPaymentButton = __webpack_require__(18375);
;// CONCATENATED MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx





















var StripePaymentButton = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9101), __webpack_require__.e(7838)]).then(__webpack_require__.bind(__webpack_require__, 67838));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67838)
            ];
        }
    },
    ssr: false
});
var OrderDetailsBlock = function(props) {
    var participants = props.participants, setOrderLink = props.setOrderLink, setOrderStage = props.setOrderStage, handlePaymentSuccess = props.handlePaymentSuccess, match = props.match, tourId = props.tourId, matterId = props.matterId, initialTourType = props.initialTourType, initialTicketId = props.initialTicketId, gameId = props.gameId;
    var ticketing = (0,store/* useRecoilValue */.sJ)(store/* ticketingDataState */.$W);
    var ticketingGeneral = ticketing.ticketingGeneral;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _plane_name = ref.plane_name, plane_name = _plane_name === void 0 ? "Plane name" : _plane_name, _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _private_note = ref.private_note, private_note = _private_note === void 0 ? "private Note" : _private_note, _ticket = ref.ticket, ticket = _ticket === void 0 ? "ticket" : _ticket, _grand_total = ref.grand_total, grand_total = _grand_total === void 0 ? "Grand Total" : _grand_total, _legal_checkbox_2 = ref.legal_checkbox_2, legal_checkbox_2 = _legal_checkbox_2 === void 0 ? "Legal checkbox 2" : _legal_checkbox_2, _legal_checkbox_1 = ref.legal_checkbox_1, legal_checkbox_1 = _legal_checkbox_1 === void 0 ? "*I agree terms & conditions" : _legal_checkbox_1, _proceed_to_payment = ref.proceed_to_payment, proceed_to_payment = _proceed_to_payment === void 0 ? "Proceed to payment" : _proceed_to_payment, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language, _wrong_discount_val = ref.wrong_discount_val, wrong_discount_val = _wrong_discount_val === void 0 ? "wrong discount value" : _wrong_discount_val, _user = ref.user, user = _user === void 0 ? "user" : _user, _email = ref.email, email = _email === void 0 ? "email" : _email, _name = ref.name, name = _name === void 0 ? "name" : _name, _is_required = ref.is_required, is_required = _is_required === void 0 ? "is required" : _is_required, _is_not_valid = ref.is_not_valid, is_not_valid = _is_not_valid === void 0 ? "is not valid" : _is_not_valid, _check_out = ref.check_out, check_out = _check_out === void 0 ? "Check Out" : _check_out, _tickets_order_was_cancelled = ref.tickets_order_was_cancelled, tickets_order_was_cancelled = _tickets_order_was_cancelled === void 0 ? "Tickets order was cancelled" : _tickets_order_was_cancelled, _tickets_order_error = ref.tickets_order_error, tickets_order_error = _tickets_order_error === void 0 ? "Tickets order error." : _tickets_order_error;
    var ref1 = (0,react.useState)(null), appliedDiscount = ref1[0], setAppliedDiscount = ref1[1];
    // ----------- order data fields --------------
    var ref2 = (0,react.useState)(false), checkbox1 = ref2[0], setCheckbox1 = ref2[1];
    var ref3 = (0,react.useState)(false), checkbox2 = ref3[0], setCheckbox2 = ref3[1];
    // ----------- order data fields end --------------
    var ref4 = (0,react.useState)(false), ticketOrderSent = ref4[0], setTicketOrderSent = ref4[1];
    // ticketType: "gameTour"
    var tourType = match.params.tourType || (initialTourType === null || initialTourType === void 0 ? void 0 : initialTourType.replace("gameTour", "experienceTour"));
    var ticketId = match.params.ticketId || initialTicketId;
    var tourTypeKey = util/* ticketingTypes */.pb === null || util/* ticketingTypes */.pb === void 0 ? void 0 : util/* ticketingTypes.find */.pb.find(function(tt) {
        return tt.tourType === tourType;
    });
    var ticketingType = tourTypeKey.key;
    var currentTicket = ticketId ? ticketing[tourTypeKey === null || tourTypeKey === void 0 ? void 0 : tourTypeKey.key].find(function(ticket) {
        return ticket.id === parseInt(ticketId);
    }) : null;
    var currencySymbol = ticketingNew_static/* initialCurrency.find */.Z.find(function(cur) {
        return cur.id === ticketingGeneral.currencyId;
    });
    var orderId = (0,react.useRef)(null);
    var orderBtn = (0,react.useRef)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* infoModalDataState */.uP), 2), infoModalData = ref5[0], setInfoModalData = ref5[1];
    var setTicketOrderResult = (0,store/* useSetRecoilState */.Zl)(store/* orderedTicketsState */.jF);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* redirectTicketsState */.Sy), 2), redirectTickets = ref6[0], setRedirectTickets = ref6[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var finishOrderRes, ticketsString, tickets;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!redirectTickets) return [
                            3,
                            2
                        ];
                        console.log("redirectTickets", redirectTickets);
                        return [
                            4,
                            TreedisPublicDAO/* default.finishOrderTickets */.Z.finishOrderTickets({
                                /// TODO add transaction to validate
                                orderCode: redirectTickets.orderCode,
                                status: redirectTickets.status,
                                pelecardStatusCode: redirectTickets.PelecardStatusCode,
                                matterId: matterId
                            })
                        ];
                    case 1:
                        finishOrderRes = _state.sent();
                        if (finishOrderRes && finishOrderRes.message.includes("Success")) {
                            if (finishOrderRes.status === "success") {
                                ticketsString = redirectTickets.data;
                                if (ticketsString) {
                                    (0,analytic/* sendToGA */.o$)("event", {
                                        eventCategory: "Ticketing",
                                        eventAction: "purchase",
                                        eventLabel: tourType
                                    });
                                    tickets = JSON.parse(ticketsString);
                                    setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, finishOrderRes === null || finishOrderRes === void 0 ? void 0 : finishOrderRes.order), {
                                        tickets: tickets
                                    }));
                                    handlePaymentSuccess();
                                }
                            } else if (finishOrderRes.status === "cancel") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: tickets_order_was_cancelled,
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            } else if (finishOrderRes.status === "error") {
                                setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                    isOpen: true,
                                    message: "".concat(tickets_order_error, " ").concat(redirectTickets.PelecardStatusCode ? "PelecardStatusCode - ".concat(redirectTickets.PelecardStatusCode) : ""),
                                    mode: InfoModal/* EInfoModal.error */.Y.error
                                }));
                            }
                        }
                        _state.label = 2;
                    case 2:
                        setRedirectTickets(null);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        redirectTickets
    ]);
    (0,react.useEffect)(function() {
        if (!(ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.paymentType)) {
            setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: "Looks like ticketing payment method not set or missing. Please check ticketing -> Payment API on admin panel"
            }));
        }
    }, []);
    var applyDiscounts = function(value) {
        var result = value;
        if (!appliedDiscount) return result;
        if (appliedDiscount.discountType === "currency") {
            if (appliedDiscount.amount > 0) result -= appliedDiscount.amount;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        } else if (appliedDiscount.discountType === "percent") {
            if (appliedDiscount.amount > 0 && appliedDiscount.amount <= 100) result -= result * appliedDiscount.amount / 100;
            else setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                isOpen: true,
                message: wrong_discount_val,
                mode: InfoModal/* EInfoModal.error */.Y.error
            }));
        }
        if (result < 0) return 0;
        return result;
    };
    var totalPrice = currentTicket ? parseFloat(applyDiscounts(participants.length * currentTicket.ticketPrice).toFixed(2)) : 0;
    var _validateUsers = function() {
        var noToast = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var errors = [];
        if (ticketingGeneral.legalCheckbox1Required && !checkbox1) errors.push("".concat(legal_checkbox_1, " ").concat(is_required));
        if (ticketingGeneral.legalCheckbox2Required && !checkbox2) errors.push("".concat(legal_checkbox_2, " ").concat(is_required));
        participants.forEach(function(ticket, num) {
            if (!ticket.email.length) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_required));
            } else if (!(0,util_all/* validateEmail */.oH)(ticket.email)) {
                errors.push("".concat(user, " ").concat(num + 1, " ").concat(email, " ").concat(is_not_valid));
            }
            if (!ticket.fullName) errors.push("".concat(user, " ").concat(num + 1, " ").concat(name, " ").concat(is_required));
        });
        if (errors.length) {
            if (!noToast) react_toastify_esm/* toast.error */.Am.error(errors.join("\n"));
            return 1;
        }
        return 0;
    };
    var handleProceedPayment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, body, data, order, ticketPayRes, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            5,
                            6
                        ]);
                        if (orderBtn === null || orderBtn === void 0 ? void 0 : (ref = orderBtn.current) === null || ref === void 0 ? void 0 : ref.disabled) return [
                            2
                        ];
                        // validation here
                        if (_validateUsers()) return [
                            2
                        ];
                        setTicketOrderSent(true);
                        body = {
                            paymentType: ticketingGeneral.paymentType,
                            ticketType: tourType.replace("experienceTour", "gameTour"),
                            tourId: tourId,
                            matterId: matterId,
                            participants: participants.map(function(participant) {
                                // fullName: '', email: '', isGift: false
                                var fullName = participant.fullName, email = participant.email, isGift = participant.isGift;
                                if (!fullName && !email && !isGift && participants[0]) {
                                    fullName = participants[0].fullName;
                                    email = participants[0].email;
                                    isGift = participants[0].isGift;
                                }
                                return {
                                    name: fullName,
                                    email: email,
                                    gift: isGift
                                };
                            }),
                            selectedTicketId: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.id,
                            discountCode: appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.codeName,
                            goodUrl: location.origin,
                            cancelUrl: location.origin,
                            errorUrl: location.origin,
                            amount: totalPrice,
                            // notificationGoodMail,
                            // notificationErrorMail,
                            // notificationFailMail,
                            currency: (currencySymbol === null || currencySymbol === void 0 ? void 0 : currencySymbol.code) || "USD"
                        };
                        return [
                            4,
                            TreedisPublicDAO/* default.createTicketOrder */.Z.createTicketOrder(body)
                        ];
                    case 1:
                        data = _state.sent().data;
                        order = data.order;
                        orderId.current = order === null || order === void 0 ? void 0 : order.id;
                        if (!(ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || Number(totalPrice) === 0)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType || Order/* TicketPaymentType.NoPayment */.fx.NoPayment, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, body), {
                                orderId: order.id
                            }))
                        ];
                    case 2:
                        ticketPayRes = _state.sent();
                        if (ticketPayRes && ticketPayRes.message.includes("Success")) {
                            if (ticketPayRes.ticketsWithoutCost) {
                                console.log("ticketPayRes", ticketPayRes);
                                setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                                    gameId: gameId
                                }));
                                handlePaymentSuccess();
                            } else {
                                setOrderLink(ticketPayRes.url);
                                setOrderStage(Order/* OrderStageEnum.payment */.t9.payment);
                            }
                        }
                        _state.label = 3;
                    case 3:
                        setTicketOrderSent(false);
                        return [
                            2,
                            {
                                ticketOrderId: order.id,
                                name: participants[0].fullName,
                                email: participants[0].email
                            }
                        ];
                    case 4:
                        err = _state.sent();
                        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                            isOpen: true,
                            message: err.message,
                            mode: InfoModal/* EInfoModal.error */.Y.error
                        }));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setTicketOrderSent(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleProceedPayment() {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelOrder = function() {
        setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
            isOpen: true,
            message: "Error paypal payment",
            mode: InfoModal/* EInfoModal.error */.Y.error
        }));
    };
    var paypalCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data, actions) {
            var ticketOrderId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleProceedPayment()
                        ];
                    case 1:
                        ticketOrderId = _state.sent().ticketOrderId;
                        console.log("ticketOrderId", ticketOrderId);
                        if (!ticketOrderId) throw new Error("No order ID");
                        orderId.current = ticketOrderId;
                        return [
                            2,
                            actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            value: totalPrice,
                                            currency_code: currencySymbol.code
                                        }
                                    }
                                ]
                            })
                        ];
                }
            });
        });
        return function paypalCreateOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var paypalApproveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data, actions) {
            var ticketPayRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                                data: {
                                    orderId: orderId.current,
                                    paymentId: data.orderID
                                }
                            })
                        ];
                    case 1:
                        ticketPayRes = _state.sent();
                        if (!ticketPayRes) return [
                            2,
                            setInfoModalData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, infoModalData), {
                                isOpen: true,
                                message: "Error paypal payment - orderId: ".concat(data.orderID),
                                mode: InfoModal/* EInfoModal.error */.Y.error
                            }))
                        ];
                        console.log("ticketPayRes", ticketPayRes);
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function paypalApproveOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var stripeCreateOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ticketOrderId, name, email, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            handleProceedPayment()
                        ];
                    case 1:
                        ref = _state.sent(), ticketOrderId = ref.ticketOrderId, name = ref.name, email = ref.email;
                        if (!ticketOrderId) throw new Error();
                        return [
                            2,
                            {
                                id: ticketOrderId,
                                totalPrice: totalPrice,
                                currency: currencySymbol.code,
                                name: name,
                                email: email,
                                tourId: tourId
                            }
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function stripeCreateOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var approveOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ticketPayRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.payTickets */.Z.payTickets(ticketingGeneral.paymentType, {
                                data: {
                                    orderId: orderId.current
                                }
                            })
                        ];
                    case 1:
                        ticketPayRes = _state.sent();
                        console.log("ticketPayRes", ticketPayRes);
                        if (!ticketPayRes) return [
                            2
                        ];
                        setTicketOrderResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticketPayRes), {
                            gameId: gameId
                        }));
                        handlePaymentSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function approveOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var ref7 = currentTicket || {}, durationType = ref7.durationType, limitDevices = ref7.limitDevices, duration = ref7.duration, maxParticipants = ref7.maxParticipants, tourLanguage = ref7.tourLanguage, ticketPrice = ref7.ticketPrice;
    var pillsList = [];
    if (durationType) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === types/* DurationType.from_purchase */.q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType"));
    }
    if (limitDevices) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices"));
    }
    if (maxParticipants) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants"));
    }
    if (tourLanguage) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage"));
    }
    if (ticketPrice) {
        pillsList.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bl-ticket-order-pill",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fal fa-tag"
                }),
                ticketPrice,
                currencySymbol.symbol
            ]
        }, "ticketPrice"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        className: "bl-ticket-order",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-title",
                children: plane_name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-subTitle",
                children: [
                    available_for,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-ticket-order-pills",
                children: pillsList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-private-note-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-header",
                        children: private_note
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-pnote-content",
                        dangerouslySetInnerHTML: {
                            __html: currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-price",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-title",
                        children: [
                            participants.length,
                            " ",
                            ticket,
                            " X ",
                            currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice,
                            " ",
                            currencySymbol.code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "bl-ticket-order-price-line"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-price-cost",
                        children: [
                            participants.length * (currentTicket === null || currentTicket === void 0 ? void 0 : currentTicket.ticketPrice) || 0,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            currentTicket && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DiscountField, {
                tourId: tourId,
                ticketId: ticketId,
                ticketingType: ticketingType,
                currencySign: currencySymbol.symbol,
                onDiscountApply: setAppliedDiscount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "bl-ticket-order-after-disc-line"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-gtotal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-order-gtotal-title",
                        children: grand_total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-order-gtotal-price",
                        children: [
                            totalPrice,
                            currencySymbol.symbol
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-order-checkboxes",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox1,
                                onChange: function() {
                                    return setCheckbox1(!checkbox1);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: ticketingGeneral.termsAndConditionsUrl,
                                target: "_blank",
                                rel: "noreferrer",
                                children: legal_checkbox_1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                checked: checkbox2,
                                onChange: function() {
                                    return setCheckbox2(!checkbox2);
                                }
                            }),
                            legal_checkbox_2
                        ]
                    })
                ]
            }),
            ticketingGeneral && currentTicket && (ticketingGeneral.paymentType === Order/* TicketPaymentType.Pelecard */.fx.Pelecard || !ticketingGeneral.paid || totalPrice === 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: orderBtn,
                disabled: ticketOrderSent,
                className: "bl-ticket-order-pay-btn",
                onClick: handleProceedPayment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas icon"
                    }),
                    proceed_to_payment
                ]
            }),
            !_validateUsers(true) && ticketingGeneral && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Stripe */.fx.Stripe && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StripePaymentButton, {
                translation: {
                    check_out: check_out
                },
                createOrder: stripeCreateOrder,
                settings: ticketingGeneral,
                approveOrder: approveOrder
            }),
            !_validateUsers(true) && (ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername) && currencySymbol.code && currentTicket && ticketingGeneral.paymentType === Order/* TicketPaymentType.Paypal */.fx.Paypal && totalPrice !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ch-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayPalPaymentButton/* default */.Z, {
                    currency: currencySymbol.code,
                    clientPaypalId: ticketingGeneral === null || ticketingGeneral === void 0 ? void 0 : ticketingGeneral.apiUsername,
                    createOrder: paypalCreateOrder,
                    onApprove: paypalApproveOrder,
                    onError: cancelOrder
                })
            })
        ]
    });
};
/* harmony default export */ var components_OrderDetailsBlock = (OrderDetailsBlock);


/***/ }),

/***/ 30510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 38px;\n\n  .bl-steps-wrap {\n    width: 202px;\n    display: flex;\n    justify-content: space-between;\n\n    .step {\n      color: white;\n      width: 48px;\n      height: 48px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #bbbbbb;\n      font-weight: 400;\n      font-size: 32px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      border-radius: 50%;\n      z-index: 2;\n\n      &.active {\n        background-color: #4b4b4b;\n      }\n\n      &.done {\n        background-color: #ea475c;\n      }\n    }\n  }\n\n  hr {\n    position: absolute;\n    top: 10px;\n    width: 172px;\n    border: 1px solid #8e8e8e;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "StepsBlock__MainWrap",
    componentId: "sc-78f40250-0"
})(_templateObject());
var StepsBlock = function(props) {
    var count = props.count, active = props.active, _done = props.done, done = _done === void 0 ? [] : _done;
    var steps = [];
    for(var i = 0; i < count; i++)steps.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("step", active === i + 1 && "active", done.includes(i + 1) && "done"),
        children: done.includes(i + 1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
            className: "fas fa-check"
        }) : i + 1
    }, i));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        className: "bl-steps-widget",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-steps-wrap",
                children: steps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepsBlock);


/***/ }),

/***/ 47238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16592);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98592);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18533);
/* harmony import */ var _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84345);
/* harmony import */ var _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70712);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70989);
/* harmony import */ var _utils_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14045);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72225);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 15px;\n  min-height: 134px;\n\n  .bl-tm-first {\n    background: #ffffff;\n    border-radius: 0 10px 10px 0;\n    width: 108px;\n    min-width: 108px;\n    padding: 5px;\n    text-align: center;\n    ",
        ";\n\n    .bl-tm-first-title {\n      margin-top: 6px;\n      margin-bottom: 9px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n    }\n\n    .bl-tm-first-price {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 10px;\n    }\n\n    .bl-tm-first-start-btn {\n      background: #ea475c;\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);\n      border-radius: 6px;\n      color: white;\n      width: 89px;\n      height: 28px;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 18px;\n\n      i {\n        margin-left: 7px;\n      }\n\n      &:active {\n        opacity: 0.9;\n      }\n    }\n\n    .tim-radio-pick-wrap {\n      display: flex;\n      height: 23px;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      color: #a5a5a5;\n      font-weight: 600;\n      font-size: 15px;\n\n      &.picked {\n        color: #ea475c;\n      }\n\n      input {\n        width: 17px;\n        height: 17px;\n        margin-left: 5px;\n      }\n    }\n  }\n\n  .bl-tm-second {\n    overflow: hidden;\n    width: 100%;\n    margin-left: 1px;\n    padding: 5px;\n    background: #ffffff;\n    border-radius: 10px 0 0 10px;\n    position: relative;\n    ",
        ";\n\n    .bl-tm-second-desc {\n      min-height: 36px;\n      padding: 8px 10px 0 10px;\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      max-height: 65px;\n\n      text-align: left;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .bl-tm-second-info-title {\n      font-weight: 300;\n      font-size: 12px;\n      line-height: 18px;\n      text-decoration-line: underline;\n      color: #969595;\n      margin-left: 10px;\n      margin-top: 7px;\n    }\n\n    .bl-tm-second-info-wrap {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: left;\n      margin-top: 7px;\n      padding: 0 2px;\n\n      .bl-tm-second-info-item {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #333333;\n        display: flex;\n        align-items: center;\n\n        img {\n          width: 18px;\n          height: 18px;\n          margin-right: 3px;\n        }\n      }\n\n      hr {\n        margin: 0 10px;\n        height: 13px;\n        border: none;\n        border-left: 1px solid black;\n\n        &:last-child {\n          display: none;\n        }\n      }\n    }\n\n    .bl-ticket-ending {\n      position: absolute;\n      height: 134px;\n      right: 0;\n      top: 0;\n      ",
        ";\n\n      .bl-ticket-end-rect {\n        width: 12px;\n        height: 16px;\n        background: #e5e5e5;\n        border-radius: 12px 0 0 12px;\n\n        &.bl-rect-1 {\n          margin-top: 27px;\n        }\n\n        &.bl-rect-2 {\n          margin-top: 15px;\n        }\n\n        &.bl-rect-3 {\n          margin-top: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TicketItemMobile__MainWrap",
    componentId: "sc-6a7035b7-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 10px 0 0 10px;margin-left: 3px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 10px 10px 0;padding-left: 13px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "left: 0;right: initial;transform: scale(-1, 1);" : "");
});
var TicketItemMobile = function(props) {
    var ticket = props.ticket, currencyId = props.currencyId, match = props.match, onPick = props.onPick, pickedId = props.pickedId;
    var durationType = ticket.durationType, limitDevices = ticket.limitDevices, duration = ticket.duration, maxParticipants = ticket.maxParticipants, tourLanguage = ticket.tourLanguage, ticketInfoUlr = ticket.ticketInfoUlr;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .translationDataState */ .Jv), _available_for = ref.available_for, available_for = _available_for === void 0 ? "Available for" : _available_for, _start = ref.start, start = _start === void 0 ? "start" : _start, _devices = ref.devices, devices = _devices === void 0 ? "devices" : _devices, _day = ref.day, day = _day === void 0 ? "day" : _day, _days = ref.days, days = _days === void 0 ? "days" : _days, _hour = ref.hour, hour = _hour === void 0 ? "hour" : _hour, _hours = ref.hours, hours = _hours === void 0 ? "hours" : _hours, _min = ref.min, min = _min === void 0 ? "min" : _min, _mins = ref.mins, mins = _mins === void 0 ? "mins" : _mins, _from_purchase = ref.from_purchase, from_purchase = _from_purchase === void 0 ? "from purchase" : _from_purchase, _from_login = ref.from_login, from_login = _from_login === void 0 ? "from login" : _from_login, _max_participants = ref.max_participants, max_participants = _max_participants === void 0 ? "Max. participants" : _max_participants, _tour_language = ref.tour_language, tour_language = _tour_language === void 0 ? "Tour language" : _tour_language, _picked = ref.picked, picked = _picked === void 0 ? "Picked" : _picked, _pick = ref.pick, pick = _pick === void 0 ? "Pick" : _pick;
    var rtl = (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_5__/* .tourConfigsState */ .Uq).rtl;
    var tourType = match.params.tourType;
    var durationLabels = [
        [
            [
                day
            ],
            [
                days
            ]
        ],
        [
            [
                hour
            ],
            [
                hours
            ]
        ],
        [
            [
                min
            ],
            [
                mins
            ]
        ], 
    ];
    var formatTicketTime = function(duration) {
        var durtionMinLeft = duration;
        var durationDays = parseInt(String(durtionMinLeft / (24 * 60)), 10);
        durtionMinLeft -= durationDays * 60 * 24;
        var durationHours = parseInt(String(durtionMinLeft / 60), 10);
        durtionMinLeft -= durationHours * 60;
        return [
            durationDays,
            durationHours,
            durtionMinLeft
        ];
    };
    var currencySymbol = _components_ticketingNew_static__WEBPACK_IMPORTED_MODULE_4__/* .initialCurrency.find */ .Z.find(function(cur) {
        return cur.id === currencyId;
    });
    var infoItems = [];
    if (durationType) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/clock.svg",
                    alt: "clock-icon"
                }),
                formatTicketTime(duration).map(function(durationPart, num) {
                    if (durationPart) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                durationPart,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    children: durationPart === 1 ? durationLabels[num][0] : durationLabels[num][1]
                                }),
                                "\xa0"
                            ]
                        }, num);
                    }
                    return null;
                }),
                " ",
                durationType === _components_ticketingNew_types__WEBPACK_IMPORTED_MODULE_3__/* .DurationType.from_purchase */ .q.from_purchase ? from_purchase : from_login
            ]
        }, "durationType_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "durationType_hr"));
    }
    if (limitDevices) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/ticketing/desktopMobile.svg",
                    alt: "desktop-mobile-icon"
                }),
                " ",
                limitDevices,
                " ",
                devices
            ]
        }, "limitDevices_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "limitDevices_hr"));
    }
    if (maxParticipants) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fas fa-user-friends"
                }),
                max_participants,
                " ",
                maxParticipants
            ]
        }, "maxParticipants_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "maxParticipants_hr"));
    }
    if (tourLanguage) {
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "bl-tm-second-info-item",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                    className: "fal fa-globe"
                }),
                tour_language,
                " ",
                tourLanguage
            ]
        }, "tourLanguage_icon"));
        infoItems.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {}, "tourLanguage_hr"));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-first",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-first-title",
                        children: ticket.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-first-price",
                        children: [
                            ticket.ticketPrice,
                            currencySymbol.symbol
                        ]
                    }),
                    !onPick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .rU, {
                        to: "".concat(tourType, "/").concat(ticket.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                            className: "bl-tm-first-start-btn",
                            children: [
                                (0,_utils_string__WEBPACK_IMPORTED_MODULE_6__/* .capitalize */ .kC)(start),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "fas fa-chevron-right"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()("tim-radio-pick-wrap", ticket.id === pickedId && "picked"),
                        children: [
                            ticket.id === pickedId ? picked : pick,
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                type: "radio",
                                onChange: function() {
                                    return onPick(ticket.id);
                                },
                                checked: ticket.id === pickedId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bl-tm-second",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-desc",
                        dangerouslySetInnerHTML: {
                            __html: ticket.description
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-tm-second-info-title",
                        children: [
                            available_for,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bl-tm-second-info-wrap",
                        children: infoItems
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ticketingNew_components_MoreInfoBtn__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        ticketInfoUlr: ticketInfoUlr
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_router_dom__WEBPACK_IMPORTED_MODULE_11__/* .withRouter */ .EN)(TicketItemMobile));


/***/ }),

/***/ 70883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18533);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70989);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 133px;\n  background-color: #282828;\n  position: relative;\n\n  .bl-minimized-vector {\n    width: 0;\n    height: 0;\n    right: 0;\n    top: 0;\n    position: absolute;\n    border-bottom: 133px solid #ea475c;\n    border-left: 241px solid transparent;\n  }\n\n  .bl-minimized-title {\n    margin: 0;\n    height: 100%;\n    padding: 0 300px 0 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    //margin-top: 38px;\n    //margin-left: 80px;\n    font-weight: 400;\n    font-size: 40px;\n    line-height: 60px;\n    color: white;\n    position: absolute;\n    //max-height: calc(100% - 38px);\n    overflow: hidden;\n\n    @media screen and (max-width: 760px) {\n      width: 100%;\n      text-align: center;\n      margin-left: 0;\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    height: 77px;\n    .bl-minimized-title {\n      padding: inherit;\n      margin: 0;\n\n      text-align: left;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 22px;\n      line-height: 33px;\n      //margin-top: 20px;\n      //padding-left: 24px;\n      //max-height: calc(100% - 20px);\n    }\n    .bl-minimized-vector {\n      border-right: 84px solid #ea475c;\n      border-bottom: 77px solid transparent;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MainWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TourImageDescriptionMinized__MainWrap",
    componentId: "sc-255bc9f8-0"
})(_templateObject());
var TourImageDescriptionMinized = function() {
    var ticketingGeneral = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_2__/* .ticketingDataState */ .$W).ticketingGeneral;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MainWrap, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-vector"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "bl-minimized-title",
                dangerouslySetInnerHTML: {
                    __html: ticketingGeneral.title
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TourImageDescriptionMinized);


/***/ }),

/***/ 67020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t9": function() { return /* binding */ OrderStageEnum; },
  "fx": function() { return /* binding */ TicketPaymentType; },
  "ZP": function() { return /* binding */ pages_Order; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/react-switch/dist/index.prod.mjs
var index_prod = __webpack_require__(45810);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/ticketingNew/components/UserCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.bl-ticket-item {\n    height: 141px;\n    display: flex;\n    margin-bottom: 11px;\n\n    .bl-ticket-desc {\n      width: 108px;\n      min-width: 108px;\n      background: #ffffff;\n      border-radius: 0 12px 12px 0;\n      margin-right: 3px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      text-align: center;\n      position: relative;\n      ",
        ";\n\n      .bl-ticket-number-text {\n        margin-top: 17px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 21px;\n      }\n\n      .bl-ticket-number {\n        font-weight: 400;\n        font-size: 60px;\n        line-height: 90px;\n      }\n\n      .bl-ticket-triangle {\n        width: 0;\n        height: 0;\n        border-bottom: 29px solid #ea475c;\n        border-right: 49px solid transparent;\n        position: absolute;\n        bottom: 0;\n        ",
        ";\n      }\n    }\n\n    .bl-ticket-data {\n      padding-top: 29px;\n      padding-left: 20px;\n      padding-right: 54px;\n      width: 100%;\n      background: #ffffff;\n      border-radius: 12px 0 0 12px;\n      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));\n      ",
        ";\n\n      label {\n        display: flex;\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 22px;\n        margin-bottom: 19px;\n        justify-content: space-between;\n\n        span {\n          ",
        ";\n        }\n\n        .bl-text-input {\n          height: 23px;\n          width: 251px;\n          border: 1px solid #c4c4c4;\n          box-sizing: border-box;\n          border-radius: 4px;\n\n          &:active,\n          &:focus {\n            outline-color: #c4c4c4;\n          }\n        }\n      }\n\n      .bl-field-2 {\n        label {\n          margin-bottom: 15px;\n        }\n      }\n\n      .bl-field-3 {\n        label {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 20px;\n          justify-content: space-between;\n          width: 117px;\n          float: right;\n        }\n\n        .bl-field-close {\n          float: left;\n          display: flex;\n          align-items: baseline;\n          cursor: pointer;\n          color: #ea475c;\n          //line-height: 13px;\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 15px;\n\n          .bl-close-circle {\n            width: 13px;\n            height: 13px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: #ea475c;\n            margin: 6px;\n            color: white;\n            border-radius: 50%;\n\n            i {\n              font-weight: normal;\n              font-size: 10px;\n            }\n          }\n        }\n      }\n\n      .bl-ticket-ending {\n        position: absolute;\n        height: 141px;\n        right: 0;\n        top: 0;\n        ",
        ";\n\n        .bl-ticket-end-rect {\n          width: 18px;\n          height: 21px;\n          background: #e5e5e5;\n          border-radius: 12px 0 0 12px;\n\n          &.bl-rect-1 {\n            margin-top: 20px;\n          }\n\n          &.bl-rect-2 {\n            margin-top: 19px;\n          }\n\n          &.bl-rect-3 {\n            margin-top: 19px;\n          }\n        }\n      }\n\n      @media screen and (max-width: 760px) {\n        ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var TicketItemMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "UserCard__TicketItemMainWrap",
    componentId: "sc-a68a85b2-0"
})(_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin-left: 3px; margin-right: 0; border-radius: 12px 0 0 12px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "transform: scale(-1, 1); right: -1px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "border-radius: 0 12px 12px 0; padding: 29px 20px 0 54px;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right:12px;left:initial!important;" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "right: initial;left: -2px;transform: scale(-1,1);" : "");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "padding-left:20px!important;padding-right: 10px!important;" : "");
});
var UserCard = function(props) {
    var ticket = props.ticket, ticketNum = props.ticketNum, setTicketData = props.setTicketData, removeTicket = props.removeTicket;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _user = ref.user, user = _user === void 0 ? "User" : _user, _full_name = ref.full_name, full_name = _full_name === void 0 ? "Full name" : _full_name, _email = ref.email, email = _email === void 0 ? "Email" : _email, _closeTicket = ref.closeTicket, closeTicket = _closeTicket === void 0 ? "Close" : _closeTicket, _send_as_gift = ref.send_as_gift, send_as_gift = _send_as_gift === void 0 ? "Send as gift" : _send_as_gift;
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TicketItemMainWrap, {
        className: "bl-ticket-item",
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-desc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-number-text",
                        children: [
                            user,
                            " ",
                            ticketNum + 1
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-number",
                        children: ticketNum + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-ticket-triangle"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-data",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(full_name)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "fullName",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-field-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "*",
                                        (0,string/* capitalize */.kC)(email)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: "bl-text-input",
                                    onChange: function(ev) {
                                        return setTicketData({
                                            id: ticket.id,
                                            target: "email",
                                            value: ev.target.value
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-field-3",
                        children: [
                            ticketNum > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-field-close",
                                onClick: function() {
                                    return removeTicket(ticket.id);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-close-circle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-times"
                                        })
                                    }),
                                    (0,string/* capitalize */.kC)(closeTicket)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    send_as_gift,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_prod/* default */.Z, {
                                        onColor: "#ea475c",
                                        checked: ticket.isGift,
                                        onChange: function(newIsGift) {
                                            return setTicketData({
                                                id: ticket.id,
                                                target: "isGift",
                                                value: newIsGift
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-ticket-ending",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-ticket-end-rect bl-rect-3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_UserCard = (UserCard);

// EXTERNAL MODULE: ./components/ticketingNew/components/BackButton.tsx
var BackButton = __webpack_require__(7710);
// EXTERNAL MODULE: ./components/ticketingNew/components/OrderDetailsBlock/index.tsx + 2 modules
var OrderDetailsBlock = __webpack_require__(61749);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .bl-signUp-text {\n    text-align: center;\n    font-weight: 500;\n    font-size: 30px;\n    line-height: 45px;\n    margin-top: 20px;\n    margin-bottom: 88px;\n  }\n\n  .bl-ticket-main-wrap {\n    margin-left: 163px;\n    margin-right: 220px;\n    display: flex;\n\n    .bl-tickets-wrap {\n      margin-right: ",
        ";\n      margin-left: ",
        ";\n      width: calc(50% - 16px);\n      display: inline-block;\n\n      .bl-add-ticket-wrap {\n        margin-top: 15px;\n        display: flex;\n        align-items: baseline;\n        cursor: pointer;\n\n        &:active {\n          opacity: 0.8;\n        }\n\n        .bl-add-plus {\n          width: 21px;\n          height: 21px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: #ea475c;\n          border-radius: 2px;\n          color: white;\n        }\n\n        .bl-add-text {\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 18px;\n          margin-left: 10px;\n          ",
        ";\n        }\n      }\n    }\n  }\n\n  .bl-payment-wrap {\n    height: 466px;\n    width: 582px;\n    margin: auto;\n    cursor: pointer;\n  }\n\n  .ch-btn {\n    text-align: center;\n    margin-top: 37px;\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-steps-widget {\n      margin-top: 0;\n    }\n\n    .bl-signUp-text {\n      margin-bottom: 0;\n    }\n\n    .bl-ticket-main-wrap {\n      display: flex;\n      flex-direction: column;\n      margin: 15px 22px;\n\n      .bl-ticket-order {\n        width: 100%;\n        padding: 15px;\n\n        .bl-ticket-order-pills {\n          margin-bottom: 14px;\n\n          .bl-ticket-order-pill {\n            margin-bottom: 8px;\n          }\n        }\n\n        .bl-ticket-order-pay-btn {\n          padding: 12px;\n          width: 100%;\n        }\n      }\n\n      .bl-tickets-wrap {\n        width: 100%;\n        margin-bottom: 20px;\n        margin-right: 0;\n\n        .bl-ticket-item {\n          position: relative;\n          display: flex;\n          width: 100%;\n\n          .bl-ticket-desc {\n            width: 83px;\n            min-width: 83px;\n          }\n\n          .bl-ticket-data {\n            padding: 9px 17px 18px 14px;\n            overflow: hidden;\n            //width: auto;\n            width: 100%;\n            padding-right: 27px;\n\n            .bl-field-1 {\n              margin-top: 12px;\n            }\n\n            .bl-field-2 {\n              margin-top: 21px;\n            }\n\n            .bl-field-1,\n            .bl-field-2 {\n              label {\n                position: relative;\n              }\n\n              span {\n                line-height: 1;\n                position: absolute;\n                background: white;\n                top: -12px;\n                left: 12px;\n              }\n\n              input {\n                height: 30px;\n                width: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .bl-payment-wrap {\n      max-width: 100%;\n\n      img {\n        max-width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n\n  @media screen and (min-width: 1057px) and (max-width: 1440px) {\n    .bl-ticket-main-wrap {\n      width: 1057px;\n      margin: auto;\n    }\n  }\n  @media screen and (min-width: 760px) and (max-width: 1057px) {\n    .bl-ticket-main-wrap {\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      width: 519px;\n      margin: auto;\n\n      .bl-tickets-wrap {\n        width: 100%;\n      }\n\n      .bl-ticket-order {\n        width: 100%;\n      }\n    }\n  }\n  @media screen and (min-width: 1440px) {\n    .bl-ticket-main-wrap {\n      max-width: 1080px;\n      margin: auto;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OrderMainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__OrderMainWrap",
    componentId: "sc-88f0c1f1-0"
})(styled_templateObject(), function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "initial" : "16px");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "16px" : "initial");
}, function(param) {
    var rtl = param.rtl;
    return "".concat(rtl ? "margin: 0 10px;" : "");
});

;// CONCATENATED MODULE: ./components/ticketingNew/pages/Order/index.tsx














var getInitialTicketData = function() {
    return {
        id: Date.now(),
        fullName: "",
        email: "",
        isGift: false
    };
};
var OrderStageEnum;
(function(OrderStageEnum) {
    OrderStageEnum[OrderStageEnum["order"] = 2] = "order";
    OrderStageEnum[OrderStageEnum["payment"] = 3] = "payment";
    OrderStageEnum[OrderStageEnum["tourOrderOnlySuccess"] = 4] = "tourOrderOnlySuccess";
})(OrderStageEnum || (OrderStageEnum = {}));
var TicketPaymentType;
(function(TicketPaymentType) {
    TicketPaymentType["NoPayment"] = "noPayment";
    TicketPaymentType["Paypal"] = "paypal";
    TicketPaymentType["Stripe"] = "stripe";
    TicketPaymentType["Pelecard"] = "pelecard";
})(TicketPaymentType || (TicketPaymentType = {}));
var Order = function(props) {
    var match = props.match, matterId = props.matterId, tourId = props.tourId, gameId = props.gameId;
    var ref = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _add_a_ticket = ref.add_a_ticket, add_a_ticket = _add_a_ticket === void 0 ? "Add a ticket" : _add_a_ticket, _sign_up_process = ref.sign_up_process, sign_up_process = _sign_up_process === void 0 ? "Sign up process" : _sign_up_process, _payment = ref.payment, payment = _payment === void 0 ? "Payment" : _payment;
    var history = (0,react_router/* useHistory */.k6)();
    var ref1 = (0,react.useState)(OrderStageEnum.order), orderStage = ref1[0], setOrderStage = ref1[1];
    var ref2 = (0,react.useState)([
        getInitialTicketData()
    ]), participants = ref2[0], setParticipants = ref2[1];
    var ref3 = (0,react.useState)(""), orderLink = ref3[0], setOrderLink = ref3[1];
    var rtl = (0,store/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).rtl;
    var handleAddTicket = function() {
        return setParticipants((0,_to_consumable_array/* default */.Z)(participants).concat([
            getInitialTicketData()
        ]));
    };
    var handleSetTicketData = function(props) {
        setParticipants(participants.map(function(ticket) {
            if (ticket.id === props.id) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ticket), (0,_define_property/* default */.Z)({}, props.target, props.value));
            return ticket;
        }));
    };
    var handleRemoveTicket = function(id) {
        setParticipants(participants.filter(function(ticket) {
            return ticket.id !== id;
        }));
    };
    var handlePaymentSuccess = function() {
        var ref, ref1;
        if (match === null || match === void 0 ? void 0 : (ref = match.params) === null || ref === void 0 ? void 0 : ref.ticketId) history.push("".concat(match === null || match === void 0 ? void 0 : (ref1 = match.params) === null || ref1 === void 0 ? void 0 : ref1.ticketId, "/success"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderMainWrap, {
        rtl: rtl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                backFunction: orderStage === OrderStageEnum.order ? null : function() {
                    setOrderStage(OrderStageEnum.order);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: orderStage,
                done: orderStage === OrderStageEnum.order ? [
                    1
                ] : [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-signUp-text",
                children: orderStage === OrderStageEnum.order ? sign_up_process : payment
            }),
            orderStage === OrderStageEnum.order ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-ticket-main-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-tickets-wrap",
                        children: [
                            participants.map(function(ticket, ticketNum) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserCard, {
                                    ticket: ticket,
                                    ticketNum: ticketNum,
                                    setTicketData: handleSetTicketData,
                                    removeTicket: handleRemoveTicket
                                }, ticket.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bl-add-ticket-wrap",
                                onClick: handleAddTicket,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-plus",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-plus"
                                        })
                                    }),
                                    participants.length < 50 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bl-add-text",
                                        children: add_a_ticket
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetailsBlock/* default */.Z, {
                        matterId: matterId,
                        match: match,
                        handlePaymentSuccess: handlePaymentSuccess,
                        participants: participants,
                        setOrderStage: setOrderStage,
                        tourId: tourId,
                        gameId: gameId,
                        setOrderLink: setOrderLink
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bl-payment-wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: orderLink
                })
            })
        ]
    });
};
/* harmony default export */ var pages_Order = ((0,react_router/* withRouter */.EN)(Order));


/***/ }),

/***/ 99931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_OrderSuccess; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(98592);
// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 1 modules
var react_router_dom = __webpack_require__(16592);
// EXTERNAL MODULE: ./components/ticketingNew/components/TourImageDescriptionMinized.tsx
var TourImageDescriptionMinized = __webpack_require__(70883);
// EXTERNAL MODULE: ./components/ticketingNew/components/StepsBlock.tsx
var StepsBlock = __webpack_require__(30510);
;// CONCATENATED MODULE: ./components/ticketingNew/components/TicketingButton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border: ",
        ";\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n  border-radius: 12px;\n  padding: 16px 30px;\n  font-weight: 600;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: initial;\n\n  &:active {\n    ",
        "\n  }\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ETickBtnType;
(function(ETickBtnType) {
    ETickBtnType[ETickBtnType["white"] = 0] = "white";
    ETickBtnType[ETickBtnType["red"] = 1] = "red";
})(ETickBtnType || (ETickBtnType = {}));
var MainWrap = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "TicketingButton__MainWrap",
    componentId: "sc-cf052c43-0"
})(_templateObject(), function(p) {
    return p.type == ETickBtnType.red ? "white" : "#EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "#EA475C" : "white";
}, function(p) {
    return p.type == ETickBtnType.red ? "none" : "2px solid #EA475C";
}, function(p) {
    return p.type == ETickBtnType.red ? "opacity:0.8;" : "background-color:rgba(234,71,92,0.2);";
}, function(p) {
    return p.type == ETickBtnType.red ? "" : "border:2px solid #EA475C;";
});
var TicketingButton = function(props) {
    var text = props.text, _type = props.type, type = _type === void 0 ? ETickBtnType.red : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainWrap, {
        type: type,
        children: text
    });
};
/* harmony default export */ var components_TicketingButton = (TicketingButton);

// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
;// CONCATENATED MODULE: ./components/ticketingNew/pages/OrderSuccess.tsx

function OrderSuccess_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  .bl-success-block-wrap {\n    background: #ffffff;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);\n    border-radius: 4px;\n    width: 570px;\n    margin: auto;\n    margin-top: 48px;\n    padding: 71px 37px 38px 37px;\n    position: relative;\n    text-align: center;\n\n    .bl-success-block-triangle {\n      width: 0;\n      height: 0;\n      border-top: 108px solid #ea475c;\n      border-right: 171px solid transparent;\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    .bl-success-block-ok-sign {\n      width: 71px;\n      height: 71px;\n      background-color: #ea475c;\n      border-radius: 50%;\n      margin: auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      font-size: 45px;\n      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-title {\n      font-weight: 500;\n      font-size: 30px;\n      line-height: 45px;\n      margin-bottom: 20px;\n    }\n\n    .bl-success-block-text {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 130.3%;\n      margin-bottom: 38px;\n    }\n\n    .bl-success-btns {\n      justify-content: space-between;\n      display: flex;\n      margin: auto;\n      margin-bottom: 40px;\n      width: 426px;\n\n      a {\n        text-decoration: initial;\n      }\n\n      button {\n        min-width: 202px;\n      }\n    }\n\n    .bl-success-block-safety {\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 20px;\n      display: flex;\n      align-items: baseline;\n\n      .bl-success-block-safety-icon {\n        margin: 0 10px;\n        border: 1px solid black;\n        border-radius: 50%;\n        width: 28px;\n        height: 28px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  @media screen and (max-width: 760px) {\n    .bl-success-block-wrap {\n      display: flex;\n      flex-direction: column;\n      max-width: calc(100% - 30px);\n      margin-left: 15px;\n      margin-right: 15px;\n      padding-top: 36px;\n      padding-bottom: 28px;\n\n      .bl-success-block-triangle {\n        border-top: 73px solid #ea475c;\n        border-right: 116px solid transparent;\n      }\n\n      .bl-success-block-ok-sign {\n        order: 1;\n      }\n\n      .bl-success-block-title {\n        order: 0;\n      }\n\n      .bl-success-block-text {\n        order: 3;\n      }\n\n      .bl-success-block-safety {\n        order: 4;\n      }\n\n      .bl-success-block-safety-icon {\n        min-width: 28px;\n      }\n\n      .bl-success-btns {\n        order: 4;\n        flex-wrap: wrap;\n        justify-content: center;\n\n        button {\n          width: 100%;\n        }\n\n        button:first-child {\n          margin-bottom: 15px;\n        }\n      }\n    }\n  }\n"
    ]);
    OrderSuccess_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var OrderSuccess_MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSuccess__MainWrap",
    componentId: "sc-d2df32b8-0"
})(OrderSuccess_templateObject(), function(p) {
    return p.minimized ? "color:initial;" : "";
});
var OrderSuccess = function(props) {
    var location = props.location, _minimized = props.minimized, minimized = _minimized === void 0 ? false : _minimized, _onLinkClick = props.onLinkClick, onLinkClick = _onLinkClick === void 0 ? function() {} : _onLinkClick;
    var ticketsRes = (0,store/* useRecoilValue */.sJ)(store/* orderedTicketsState */.jF);
    var history = (0,react_router/* useHistory */.k6)();
    console.log("ticketsRes success page", ticketsRes);
    var firstTicket;
    var firstTicketCode;
    if (ticketsRes) {
        var ref;
        firstTicket = ticketsRes === null || ticketsRes === void 0 ? void 0 : (ref = ticketsRes.tickets) === null || ref === void 0 ? void 0 : ref.find(function(t) {
            return t.code;
        });
        firstTicketCode = firstTicket === null || firstTicket === void 0 ? void 0 : firstTicket.code;
    }
    var bookPage = location.pathname.replace(/book.+|book/g, "") + "book";
    if (!firstTicket) {
        react_toastify_esm/* toast.error */.Am.error("No ticket found, redirecting to home page");
        history.push(bookPage);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "redirect"
        });
    }
    var loginPage = location.pathname.replace(/book.+|book/g, "") + "login?ticket=".concat(firstTicketCode);
    if (firstTicket.type === "gameTour" && ticketsRes.gameId) loginPage.replace("/tour/", "/experience/".concat(ticketsRes.gameId, "/"));
    var ref1 = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv), _payment_confirmed = ref1.payment_confirmed, payment_confirmed = _payment_confirmed === void 0 ? "Payment cofirmed" : _payment_confirmed, _full_transaction_details = ref1.full_transaction_details, full_transaction_details = _full_transaction_details === void 0 ? "The full transaction details will be sending to your Email" : _full_transaction_details, _protect_message = ref1.protect_message, protect_message = _protect_message === void 0 ? "We protect your payment information using encryption to provide bank-level security." : _protect_message, _book_more_tours = ref1.book_more_tours, book_more_tours = _book_more_tours === void 0 ? "Book More Tours" : _book_more_tours, _startTourNow = ref1.startTourNow, startTourNow = _startTourNow === void 0 ? "Start Tour Now" : _startTourNow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderSuccess_MainWrap, {
        minimized: minimized,
        children: [
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourImageDescriptionMinized/* default */.Z, {}),
            !minimized && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsBlock/* default */.Z, {
                count: 3,
                active: 3,
                done: [
                    1,
                    2
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bl-success-block-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-triangle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-ok-sign",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "far fa-check"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-title",
                        children: payment_confirmed
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bl-success-block-text",
                        children: full_transaction_details
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-btns",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: bookPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: book_more_tours,
                                    type: ETickBtnType.white
                                })
                            }),
                            firstTicketCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
                                to: loginPage,
                                onClick: onLinkClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TicketingButton, {
                                    text: startTourNow
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bl-success-block-safety",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bl-success-block-safety-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-lock"
                                })
                            }),
                            protect_message
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_OrderSuccess = ((0,react_router/* withRouter */.EN)(OrderSuccess));


/***/ }),

/***/ 70712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getTicketingTypeFromOrderedTicket; },
/* harmony export */   "Z": function() { return /* binding */ initialCurrency; }
/* harmony export */ });
var initialCurrency = [
    {
        id: 1,
        name: "Euro",
        code: "EUR",
        symbol: "€"
    },
    {
        id: 3,
        name: "US Dollar",
        code: "USD",
        symbol: "$"
    },
    {
        id: 9,
        name: "Israeli New Sheqel",
        code: "ILS",
        symbol: "₪"
    }, 
];
var getTicketingTypeFromOrderedTicket = function(ticketingOrderedTicket) {
    switch(ticketingOrderedTicket.ticketType){
        case "gameTour":
            return "ticketingGameTour";
        case "guidedTour":
            return "ticketingGuidedTour";
        // 'tourByYourself'
        default:
            return "ticketingToursByYourself";
    }
};


/***/ }),

/***/ 84345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DurationType; }
/* harmony export */ });
var DurationType;
(function(DurationType) {
    DurationType["from_login"] = "from_login";
    DurationType["from_purchase"] = "from_purchase";
})(DurationType || (DurationType = {}));


/***/ }),

/***/ 81389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GameBookLocationType; }
/* harmony export */ });
var GameBookLocationType;
(function(GameBookLocationType) {
    GameBookLocationType["sweep"] = "sweep";
    GameBookLocationType["tourLink"] = "tourLink";
})(GameBookLocationType || (GameBookLocationType = {}));


/***/ }),

/***/ 40488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ getBaseURL; },
/* harmony export */   "DF": function() { return /* binding */ buildLink; },
/* harmony export */   "Dv": function() { return /* binding */ getQueryVariable; },
/* harmony export */   "Jw": function() { return /* binding */ setWhiteLabel; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "R6": function() { return /* binding */ getTicketTypeCount; },
/* harmony export */   "bo": function() { return /* binding */ getVersion; },
/* harmony export */   "fg": function() { return /* binding */ downloadFloorPlan; },
/* harmony export */   "gb": function() { return /* binding */ getBucketLink; },
/* harmony export */   "i1": function() { return /* binding */ getAllQueryVariables; },
/* harmony export */   "k": function() { return /* binding */ updatePanoRotation; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "pb": function() { return /* binding */ ticketingTypes; },
/* harmony export */   "rQ": function() { return /* binding */ fetchData; },
/* harmony export */   "rp": function() { return /* binding */ getVideoLink; },
/* harmony export */   "tG": function() { return /* binding */ openLinkInNewTab; },
/* harmony export */   "vQ": function() { return /* binding */ copyToClipboard; }
/* harmony export */ });
/* unused harmony exports getICEServers, getPanoramaIndex, getYoutubeVideoQueryVariable, isVimeoUrl */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72132);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65290);
/* harmony import */ var _axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54453);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46021);
/* provided dependency */ var process = __webpack_require__(34155);







function getVersion(date) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()().diff(date, "days") === 0 ? "?v=".concat(moment__WEBPACK_IMPORTED_MODULE_0___default()(date).format("HHmmss")) : "";
}
function setWhiteLabel(tour) {
    var ref;
    if (!tour || !tour.user) return;
    var client = tour.client;
    var u = tour.user;
    // eslint-disable-next-line no-nested-ternary
    var user = ((ref = u.admin) === null || ref === void 0 ? void 0 : ref.id) === 1 ? u : u.admin && !(u.domainUrl && u.whitelabelId) ? u.admin : u;
    var whitelabelActive = user.whitelabelId;
    var clientLogoActive = client && client.whitelabelId && client.whitelabelLogo;
    var w = client && client.whitelabelId && clientLogoActive ? client : user;
    var c = client && client.whitelabelId ? client : user;
    var website = whitelabelActive && w.website ? w.website : "https://treedis.com";
    var logoUrl = "".concat("https://cdn.treedis.com", "/").concat(clientLogoActive ? "clients" : "users", "/").concat(clientLogoActive ? client.id : user.id, "/logo.png").concat(getVersion(clientLogoActive ? client.updatedAt : user.updatedAt));
    var whiteLabelData = {
        primaryColor: whitelabelActive ? c.primaryColor || "#292929" : "#292929",
        secondaryColor: whitelabelActive ? c.secondaryColor || "#2055ff" : "#2055ff",
        logo: whitelabelActive ? logoUrl : (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .getAsset */ .Nh)("logo-white.svg"),
        website: website.includes("https://") ? website : "https://".concat(website.replace("http://", "")),
        domainUrl: whitelabelActive ? user.domainUrl || "my.treedis.com" : "my.treedis.com",
        active: whitelabelActive
    };
    document.documentElement.style.setProperty("--color-primary", "".concat(whiteLabelData.primaryColor));
    document.documentElement.style.setProperty("--color-secondary", "".concat(whiteLabelData.secondaryColor));
    this.setState({
        whiteLabelData: whiteLabelData
    });
}
function getICEServers() {
    return _getICEServers.apply(this, arguments);
}
function _getICEServers() {
    _getICEServers = _async_to_generator(function() {
        var username, secret, res, response, servers;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    username = process.env.NEXT_PUBLIC_XIRSYS_USERNAME;
                    secret = process.env.NEXT_PUBLIC_XIRSYS_SECRET;
                    return [
                        4,
                        axios.put("https://global.xirsys.net/_turn/crm", {
                            format: "urls",
                            expire: 40
                        }, {
                            headers: {
                                Authorization: "Basic ".concat(btoa("".concat(username, ":").concat(secret)))
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    response = res.data;
                    if (!response) throw new Error("ICE failed to respond, please retry");
                    servers = response.v;
                    if (response.s === "ok" && servers.iceServers) {
                        return [
                            2,
                            [
                                servers.iceServers
                            ]
                        ];
                    }
                    throw new Error("ICE failed to respond, please retry: ".concat(response.v));
            }
        });
    });
    return _getICEServers.apply(this, arguments);
}
function fetchData() {
    return _fetchData.apply(this, arguments);
}
function _fetchData() {
    _fetchData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var _url, method, body, config, url, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", method = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "get", body = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null, config = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                    url = "v1/".concat(_url);
                    if (_url.includes("https://")) url = _url;
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[method.toLowerCase()](url, body, config)
                    ];
                case 1:
                    response = _state.sent();
                    if (response.status === 200) {
                        return [
                            2,
                            response.data
                        ];
                    }
                    if (response.data) react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .Am.error(response.data.message);
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _fetchData.apply(this, arguments);
}
function getPanoramaIndex(panoramas, id) {
    return panoramas.findIndex(function(p) {
        return p.id === id;
    });
}
function getQueryVariable(query, variable) {
    if (!query || !variable) return false;
    query = decodeURIComponent(query.split("?")[1]);
    var vars = query.split("&");
    for(var i = 0; i < vars.length; i += 1){
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}
function getAllQueryVariables(query) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&";
    if (!query) return "";
    return "".concat(prefix).concat(query.split("?").pop());
}
function getYoutubeVideoQueryVariable(query, variable) {
    if (!query || !variable) return "";
    if (getQueryVariable(query, variable)) {
        return getQueryVariable(query, variable);
    }
    return query.split("/").pop();
}
function getVideoLink(url, settings) {
    if (!url) return "";
    var autoplay;
    if (settings && typeof settings.autoplay === "boolean") {
        autoplay = settings.autoplay ? 1 : 0;
    } else {
        autoplay = (settings === null || settings === void 0 ? void 0 : settings.autoplay) === undefined ? 1 : settings === null || settings === void 0 ? void 0 : settings.autoplay;
    }
    var mute = (settings === null || settings === void 0 ? void 0 : settings.mute) === undefined ? false : settings === null || settings === void 0 ? void 0 : settings.mute;
    var muteQueryParam = mute ? "&mute=1" : "";
    var urlC = [];
    if (url.includes("https://vimeo.com/")) {
        urlC = url.split("https://vimeo.com/");
    } else if (url.includes("https://player.vimeo.com/video/")) {
        urlC = url.split("https://player.vimeo.com/video/");
    }
    if (urlC.length > 1) {
        muteQueryParam = mute ? "&&muted=1" : "";
        var subtitlesParam = (settings === null || settings === void 0 ? void 0 : settings.subtitles) ? "&&texttrack=".concat(settings === null || settings === void 0 ? void 0 : settings.subtitles) : "";
        var link = "https://player.vimeo.com/video/".concat(urlC[1], "?autoplay=").concat(autoplay, "&title=0&byline=0&portrait=0").concat(muteQueryParam).concat(subtitlesParam, "&dnt=").concat((settings === null || settings === void 0 ? void 0 : settings.dnt) ? 1 : 0, "&fullscreen=").concat((settings === null || settings === void 0 ? void 0 : settings.fullscreen) ? 1 : 0);
        if (urlC[1].includes("/")) {
            var videoId = urlC[1].split("/")[0];
            var videoKey = urlC[1].split("/")[1].split("?")[0];
            link = "https://player.vimeo.com/video/".concat(videoId, "?h=").concat(videoKey, "&autoplay=").concat(autoplay, "&title=0&byline=0&portrait=0").concat(muteQueryParam).concat(subtitlesParam, "&dnt=").concat((settings === null || settings === void 0 ? void 0 : settings.dnt) ? 1 : 0);
        }
        return link;
    }
    var subtitlesParam1 = (settings === null || settings === void 0 ? void 0 : settings.subtitles) ? "&&hl=".concat(settings === null || settings === void 0 ? void 0 : settings.subtitles) : "";
    return "https://www.youtube.com/embed/".concat(getYoutubeVideoQueryVariable(url, "v"), "?autoplay=").concat(autoplay).concat(muteQueryParam).concat(subtitlesParam1, "&dnt=").concat((settings === null || settings === void 0 ? void 0 : settings.dnt) ? 1 : 0);
}
function isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
function getBaseURL() {
    return window.location.href.split("?")[0];
}
function buildLink(s, rotation) {
    var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, target = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var link = "".concat(getBaseURL(), "?s=").concat(s, "&x=").concat(rotation.x, "&y=").concat(rotation.y);
    if (m) link += "&m=".concat(m);
    if (target) link += "&target=".concat(target);
    var ticket = new URLSearchParams(window.location.search).get("ticket");
    if (ticket && ticket.length > 0) link += "&ticket=".concat(ticket);
    return link;
}
function hexToRgb() {
    var hex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_TAG_COLOR.hex */ .K.hex;
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_TAG_COLOR.rgb */ .K.rgb;
}
function copyToClipboard(text) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
        return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
    } finally{
        document.body.removeChild(textarea);
    }
}
function updatePanoRotation(north, pos) {
    var _state = this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
    this.panoPose = pos;
    if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
    var mapNorth = minimaps[selectedMinimap].north || 0;
    var y = pos.yaw > 0 ? 360 - pos.yaw : -1 * pos.yaw;
    var diff = north - y;
    var mapWalkerRotation = mapNorth + diff;
    this.setState({
        mapWalkerRotation: mapWalkerRotation
    });
}
var downloadFloorPlan = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(url, plan) {
        var pdfName, pdfType, response, blob, urlTwo, link, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pdfName = (plan === null || plan === void 0 ? void 0 : plan.name) || "";
                    pdfType = (plan === null || plan === void 0 ? void 0 : plan.type) || "pdf";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch("v1/public/downloadPdf", {
                            method: "POST",
                            body: JSON.stringify({
                                url: url,
                                pdfName: pdfName
                            })
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.blob()
                    ];
                case 3:
                    blob = _state.sent();
                    urlTwo = window.URL.createObjectURL(new Blob([
                        blob
                    ]));
                    link = document.createElement("a");
                    link.href = urlTwo;
                    link.setAttribute("download", "".concat(pdfName, ".").concat(pdfType));
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    console.error(err.message);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function downloadFloorPlan(url, plan) {
        return _ref.apply(this, arguments);
    };
}();
var validateEmail = function(email) {
    var regex = /^([\w-.]+@([\w-]+\.)+[\w-]{2,})+?$/;
    return regex.test(email);
};
var round = function(value, decimals) {
    return Number("".concat(Math.round(Number("".concat(value, "e").concat(decimals))), "e-").concat(decimals));
};
var openLinkInNewTab = function(linkText) {
    var link = document.createElement("a");
    link.href = linkText;
    link.target = "_blanc";
    document.body.appendChild(link);
    link.click();
    link.remove();
};
var getBucketLink = function(append) {
    return "".concat("https://cdn.treedis.com", "/ticketing/").concat(append);
};
var ticketingTypes = [
    {
        key: "ticketingToursByYourself",
        tourType: "tourByYourself",
        title: "Tour by yourself",
        genDeskKey: "tourByYourselfDescription"
    },
    {
        key: "ticketingGameTour",
        tourType: "experienceTour",
        title: "Experience tour",
        genDeskKey: "experienceTourDescription"
    },
    {
        key: "ticketingGuidedTour",
        tourType: "guidedTour",
        title: "Guided tour",
        genDeskKey: "guidedTourDescription"
    }, 
];
var getTicketTypeCount = function(ticketing) {
    return ticketingTypes.reduce(function(acc, ticketTypeObject) {
        var ref;
        if ((ref = ticketing[ticketTypeObject.key]) === null || ref === void 0 ? void 0 : ref.length) {
            acc.num += 1;
            acc.types.push(ticketTypeObject.tourType);
        }
        return acc;
    }, {
        num: 0,
        types: []
    });
};


/***/ }),

/***/ 54453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50196);

var baseURL = "https://api.treedis.com" || 0;
var instance = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .ZP.create({
    baseURL: baseURL
});
// Add a request interceptor
instance.interceptors.request.use(function(config) {
    // Do something before request is sent
    if (!(config === null || config === void 0 ? void 0 : config.headers) || !(config === null || config === void 0 ? void 0 : config.headers["Content-Type"])) {
        config.headers.Accept = "application/json";
        config.headers["Content-Type"] = "application/json";
    }
    if ((config === null || config === void 0 ? void 0 : config.url.indexOf("http")) >= 0) {
        config.baseURL = null;
    }
    return config;
}, // Do something with request error
function(error) {
    return Promise.reject(error);
});
// Add a response interceptor
instance.interceptors.response.use(// Any status code that lie within the range of 2xx cause this function to trigger
// Do something with response data
function(response) {
    return response;
}, // Any status codes that falls outside the range of 2xx cause this function to trigger
// Do something with response error
function(error) {
    return Promise.reject(error);
});
/* harmony default export */ __webpack_exports__["Z"] = (instance);


/***/ }),

/***/ 46021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ DEFAULT_TAG_COLOR; }
/* harmony export */ });
/* unused harmony export TAG_DEFAULT */
/* harmony import */ var _models_Tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42725);

var DEFAULT_TAG_COLOR = {
    hex: "#EA475C",
    rgb: {
        r: 234,
        g: 71,
        b: 92
    }
};
var TAG_DEFAULT = {
    custom: true,
    title: null,
    description: null,
    positionX: null,
    positionY: null,
    positionZ: null,
    iconColor: DEFAULT_TAG_COLOR.hex,
    icon: null,
    opacity: 100,
    sid: null,
    enabled: true,
    type: _models_Tag__WEBPACK_IMPORTED_MODULE_0__/* .TagType.None */ .Qy.None,
    text: null,
    res: "pixels",
    whiteCircle: false,
    transparentBackground: false,
    tooltip: true
};


/***/ }),

/***/ 97666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hH": function() { return /* reexport */ closeTagEmbedTagObserver; },
  "zx": function() { return /* reexport */ closeTagPanelObserver; },
  "RZ": function() { return /* reexport */ navigation/* convertDestinationItemToSweep */.RZ; },
  "vQ": function() { return /* reexport */ util_all/* copyToClipboard */.vQ; },
  "fg": function() { return /* reexport */ util_all/* downloadFloorPlan */.fg; },
  "rQ": function() { return /* reexport */ util_all/* fetchData */.rQ; },
  "BS": function() { return /* reexport */ util_all/* getBaseURL */.BS; },
  "Dv": function() { return /* reexport */ util_all/* getQueryVariable */.Dv; },
  "u6": function() { return /* reexport */ getSweepsPath; },
  "R6": function() { return /* reexport */ util_all/* getTicketTypeCount */.R6; },
  "bo": function() { return /* reexport */ util_all/* getVersion */.bo; },
  "rp": function() { return /* reexport */ util_all/* getVideoLink */.rp; },
  "oo": function() { return /* reexport */ util_all/* hexToRgb */.oo; },
  "o$": function() { return /* reexport */ analytic/* sendToGA */.o$; },
  "D2": function() { return /* reexport */ errorObserver; },
  "v2": function() { return /* reexport */ mpPasswordFormObserver; },
  "p$": function() { return /* reexport */ setTagPanelObserver; },
  "pb": function() { return /* reexport */ util_all/* ticketingTypes */.pb; }
});

// UNUSED EXPORTS: DEFAULT_TAG_COLOR, TAG_DEFAULT, buildLink, calculateMobileHeight, createGA, customSelectStyles, ecommerceDefaultColorBlackSelect, getAllQueryVariables, getBucketLink, getCurrency, getICEServers, getLocation, getPanoramaIndex, getSymbolFromCurrency, getYoutubeVideoQueryVariable, isVimeoUrl, loadModel, moveToMPLabels, moveToStartingPoint, navigateToTag, newEcommerceStyles, openLinkInNewTab, openTagIframe, openVsImageIframe, openVsObjectIframe, openVsVideoIframe, openedPanoHotspot, preventTagAction, round, sendToGoogleAnalytics, setNavigationDestination, setWhiteLabel, startGA, takePano, takeScreenshot, toggleContactPopup, toggleExternalPopup, updatePanoRotation, validateEmail

// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/axios.ts
var axios = __webpack_require__(54453);
// EXTERNAL MODULE: ./components/util/constants.ts
var constants = __webpack_require__(46021);
;// CONCATENATED MODULE: ./components/util/currency.ts
var currency = {
    DE: {
        ISO: "EUR",
        SYM: "€"
    },
    FR: {
        ISO: "EUR",
        SYM: "€"
    },
    AT: {
        ISO: "EUR",
        SYM: "€"
    },
    BE: {
        ISO: "EUR",
        SYM: "€"
    },
    CY: {
        ISO: "EUR",
        SYM: "€"
    },
    EE: {
        ISO: "EUR",
        SYM: "€"
    },
    FI: {
        ISO: "EUR",
        SYM: "€"
    },
    GR: {
        ISO: "EUR",
        SYM: "€"
    },
    IE: {
        ISO: "EUR",
        SYM: "€"
    },
    IT: {
        ISO: "EUR",
        SYM: "€"
    },
    LV: {
        ISO: "EUR",
        SYM: "€"
    },
    LT: {
        ISO: "EUR",
        SYM: "€"
    },
    LU: {
        ISO: "EUR",
        SYM: "€"
    },
    MT: {
        ISO: "EUR",
        SYM: "€"
    },
    NL: {
        ISO: "EUR",
        SYM: "€"
    },
    PT: {
        ISO: "EUR",
        SYM: "€"
    },
    SK: {
        ISO: "EUR",
        SYM: "€"
    },
    SI: {
        ISO: "EUR",
        SYM: "€"
    },
    ES: {
        ISO: "EUR",
        SYM: "€"
    },
    EZ: {
        ISO: "EUR",
        SYM: "€"
    },
    GB: {
        ISO: "GBP",
        SYM: "\xa3"
    },
    US: {
        ISO: "USD",
        SYM: "$"
    }
};
var defaultCur = {
    ISO: "USD",
    SYM: "$"
};
function getCurrency(country) {
    var cur = defaultCur;
    if (currency[country]) cur = currency[country];
    return cur;
}
function getSymbolFromCurrency(cur) {
    var ex = Object.values(currency).find(function(x) {
        return x.ISO === cur;
    });
    ex = ex || defaultCur;
    return ex.SYM;
}

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 146 modules
var dist = __webpack_require__(59603);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./components/util/pathFinder.ts






var PathNode = /*#__PURE__*/ function() {
    "use strict";
    function PathNode(sweep, pathLengthFromStart, cameFrom, estimatePathLength) {
        (0,_class_call_check/* default */.Z)(this, PathNode);
        this.sweep = sweep;
        this.pathLengthFromStart = pathLengthFromStart;
        this.cameFrom = cameFrom;
        this.estimatePathLength = estimatePathLength;
    }
    var _proto = PathNode.prototype;
    _proto.estimateFullPathLength = function estimateFullPathLength() {
        return this.pathLengthFromStart + this.estimatePathLength;
    };
    return PathNode;
}();
var getPathLength = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(from, to) {
        var THREE, vector1, vector2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state.sent();
                    vector1 = new THREE.Vector3(from.x, from.y, from.z);
                    vector2 = new THREE.Vector3(to.x, to.y, to.z);
                    return [
                        2,
                        vector1.distanceTo(vector2)
                    ];
            }
        });
    });
    return function getPathLength(from, to) {
        return _ref.apply(this, arguments);
    };
}();
var getNeighbours = function(neighbours, currentNode, endSweep, sweeps) {
    return neighbours.reduce(function(acc, neighborIndex) {
        var sweep = sweeps.find(function(s) {
            return s.index === neighborIndex;
        });
        if (sweep) {
            acc.push(new PathNode(sweep, getPathLength(currentNode.sweep.position, sweep.position), currentNode, getPathLength(sweep.position, endSweep.position)));
        }
        return acc;
    }, []);
};
var getSweepsPath = function(allSweeps, start, end) {
    var _loop = function() {
        var currentNode = sortBy_default()(openSet, [
            function(o) {
                return o.estimateFullPathLength();
            }
        ])[0];
        if (currentNode.sweep.uuid === end) {
            closedSet.push(currentNode);
            var path = [];
            for(var i = 0; i < closedSet.length; i += 1){
                var node = closedSet[i];
                var nextNode = closedSet[i + 1];
                path.push({
                    id: node.sweep.uuid,
                    position: node.sweep.position,
                    rotation: node.sweep.rotation,
                    next: nextNode ? {
                        id: nextNode.sweep.uuid,
                        position: nextNode.sweep.position,
                        rotation: nextNode.sweep.rotation
                    } : null
                });
            }
            return {
                v: path
            };
        }
        openSet = openSet.filter(function(set) {
            return set.sweep.uuid !== currentNode.sweep.uuid;
        });
        closedSet.push(currentNode);
        var neighbors = getNeighbours(currentNode.sweep.neighbors, currentNode, endSweep, sweeps);
        // eslint-disable-next-line no-loop-func
        neighbors.forEach(function(neighbor) {
            if (closedSet.some(function(set) {
                return set.sweep.index === neighbor.sweep.index;
            })) {
                return;
            }
            var openNode = openSet.find(function(set) {
                return set.sweep.index === neighbor.sweep.index;
            });
            if (!openNode) {
                openSet.push(neighbor);
            } else if (openNode.pathLengthFromStart > neighbor.pathLengthFromStart) {
                openNode.cameFrom = currentNode;
                openNode.pathLengthFromStart = neighbor.pathLengthFromStart;
            }
        });
    };
    var sweeps = allSweeps.filter(function(s) {
        return s.tags.indexOf("showcase") || s.uuid === start || s.uuid === end;
    });
    var startSweep = sweeps.find(function(s) {
        return s.uuid === start;
    });
    var endSweep = sweeps.find(function(s) {
        return s.uuid === end;
    });
    var closedSet = [];
    var openSet = [];
    var startNode = new PathNode(startSweep, 0, null, getPathLength(startSweep.position, endSweep.position));
    openSet.push(startNode);
    while(openSet.length > 0){
        var _ret = _loop();
        if ((0,_type_of/* default */.Z)(_ret) === "object") return _ret.v;
    }
    return null;
};

// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/sdk.ts + 2 modules
var sdk = __webpack_require__(68687);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/styles.ts
var styles = __webpack_require__(24069);
;// CONCATENATED MODULE: ./components/util/observers/errorObserver.ts
function setErrorObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var pageCrashed = !mutation.target.classList.contains("hidden");
                    callback(pageCrashed, observer);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}
/* harmony default export */ var errorObserver = (setErrorObserver);

;// CONCATENATED MODULE: ./components/util/observers/mpPasswordFormObserver.ts
function setMPPasswordFormObserver(element, onShow, onHide) {
    if (!element) return null;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "childList") {
                    if (mutation.target.id === "showcase-password-container") {
                        var showForm = !!mutation.target.querySelector(".sc-password-ui");
                        if (showForm) {
                            onShow();
                        } else {
                            onHide();
                            observer.disconnect();
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        childList: true,
        subtree: true
    });
    return observer;
}
/* harmony default export */ var mpPasswordFormObserver = (setMPPasswordFormObserver);

;// CONCATENATED MODULE: ./components/util/observers/mpTagPanelObserver.ts
function closeTagPanelObserver(element) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var panelOpens = mutation.target.classList.contains("panel-collapsed") || mutation.target.classList.contains("panel-open");
                    if (panelOpens) {
                        setTimeout(function() {
                            var closeButton = mutation.target.querySelector("button");
                            closeButton.click();
                        }, 100);
                        observer.disconnect();
                    }
                }
            };
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}
function setTagPanelObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var panelOpens = mutation.target.classList.contains("panel-collapsed") || mutation.target.classList.contains("panel-open");
                    callback(panelOpens, observer);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}


;// CONCATENATED MODULE: ./components/util/observers/mpTagEmbedContentObserver.ts
function closeTagEmbedTagObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var mutation = _step.value;
                if (mutation.type === "childList") {
                    var tagPreviewRemoved = false;
                    mutation.removedNodes.forEach(function(node) {
                        var hasTagPreview = node.classList.contains("tag-preview");
                        if (hasTagPreview) {
                            tagPreviewRemoved = hasTagPreview;
                            return false;
                        }
                    });
                    if (tagPreviewRemoved) {
                        callback();
                        observer.disconnect();
                        return "break";
                    }
                }
            };
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _ret = _loop();
                if (_ret === "break") break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        childList: true,
        subtree: true
    });
}


;// CONCATENATED MODULE: ./components/util/observers/index.ts





// EXTERNAL MODULE: ./components/util/navigation.ts
var navigation = __webpack_require__(64915);
;// CONCATENATED MODULE: ./components/util/index.ts















/***/ }),

/***/ 64915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "No": function() { return /* binding */ setNavigationDestination; },
/* harmony export */   "RZ": function() { return /* binding */ convertDestinationItemToSweep; },
/* harmony export */   "bO": function() { return /* binding */ moveToStartingPoint; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var _components_navigation_NavigationIntroScreen_components_Popup_NavigationIntroChoicePopup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32922);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40488);
/* harmony import */ var _flows_utils_getClosestSweep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22932);
/* eslint-disable no-nested-ternary */ 







var convertDestinationItemToSweep = function(param) {
    var item = param.item, allSweeps = param.allSweeps, allTags = param.allTags;
    var updated = null;
    if (item.tag) {
        var closestSweep = (0,_flows_utils_getClosestSweep__WEBPACK_IMPORTED_MODULE_2__/* .getClosestSweepFromObject */ .e)({
            allSweeps: allSweeps,
            target: item.tag
        }).closestSweep;
        var foundTag = allTags === null || allTags === void 0 ? void 0 : allTags.find(function(t) {
            var ref, ref1;
            return t.sid === (item === null || item === void 0 ? void 0 : (ref = item.tag) === null || ref === void 0 ? void 0 : ref.sid) || t.defaultSid === (item === null || item === void 0 ? void 0 : (ref1 = item.tag) === null || ref1 === void 0 ? void 0 : ref1.sid);
        });
        updated = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, closestSweep), {
            tag: foundTag || item.tag,
            isTag: true,
            enableNavBar: foundTag.enableNavBar || item.tag.enableNavBar,
            autoNavigation: foundTag.autoNavigation || item.tag.autoNavigation,
            navigationAutoPlay: foundTag.navigationAutoPlay || item.tag.navigationAutoPlay
        });
    } else if (item === null || item === void 0 ? void 0 : item.url) {
        var queryParams = new URLSearchParams(item === null || item === void 0 ? void 0 : item.url.split("?")[1]);
        // Extract the value of 's'
        var sValue = queryParams.get("s");
        var foundSweep = allSweeps === null || allSweeps === void 0 ? void 0 : allSweeps.find(function(s) {
            return s.sweep_uuid === sValue || s.sweepId === sValue;
        });
        updated = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, foundSweep), {
            station: item,
            enableNavBar: true,
            autoNavigation: true
        });
    } else {
        updated = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, item), {
            enableNavBar: true,
            autoNavigation: true
        });
    }
    return updated;
};
function setNavigationDestination(_) {
    return _setNavigationDestination.apply(this, arguments);
}
function _setNavigationDestination() {
    _setNavigationDestination = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var startingLocation, finishingLocation, navigationSettings, setSliderValue, _navigationType, navigationType, _preLoad, preLoad, _this, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, allTagsArray, allSweepsArray, url, s, navigationTarget, target, startingTarget, currentSID, targetSID, startingTargetSID, targetTitle, enableNavBar, icon, autoNavigation, enableTeleportBtn, navigationAutoPlay, ref16, ref17, ref18;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    startingLocation = param.startingLocation, finishingLocation = param.finishingLocation, navigationSettings = param.navigationSettings, setSliderValue = param.setSliderValue, _navigationType = param.navigationType, navigationType = _navigationType === void 0 ? _components_navigation_NavigationIntroScreen_components_Popup_NavigationIntroChoicePopup__WEBPACK_IMPORTED_MODULE_0__/* .NavigationType.Shortest */ .N.Shortest : _navigationType, _preLoad = param.preLoad, preLoad = _preLoad === void 0 ? false : _preLoad;
                    _this = this;
                    allTagsArray = Array.from(this.state.allTags, function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), value = _param[1];
                        return value;
                    });
                    allSweepsArray = Array.from(this.state.allSweeps, function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), value = _param[1];
                        return value;
                    });
                    url = window.location.href;
                    s = (0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getQueryVariable */ .Dv)(url, "s");
                    if (!s) {
                    // disable for now
                    // await this.showCaseTemp.showcase.Sweep.current.waitUntil((currentSweep) => currentSweep.id !== '');
                    }
                    if (!allTagsArray.length || !this.state.currentSweep) {
                        return [
                            2
                        ];
                    }
                    navigationTarget = this.state.navigationTarget;
                    if (navigationTarget && (finishingLocation === null || finishingLocation === void 0 ? void 0 : finishingLocation.tag) && navigationTarget.sid !== (finishingLocation === null || finishingLocation === void 0 ? void 0 : (ref = finishingLocation.tag) === null || ref === void 0 ? void 0 : ref.sid) && navigationTarget.defaultSid !== (finishingLocation === null || finishingLocation === void 0 ? void 0 : (ref1 = finishingLocation.tag) === null || ref1 === void 0 ? void 0 : ref1.sid)) {
                        this.showcase.Tag.close(navigationTarget.sid);
                    }
                    target = convertDestinationItemToSweep({
                        item: finishingLocation,
                        allSweeps: allSweepsArray,
                        allTags: allTagsArray
                    });
                    startingTarget = convertDestinationItemToSweep({
                        item: startingLocation,
                        allSweeps: allSweepsArray,
                        allTags: allTagsArray
                    });
                    if (!target) {
                        console.error("Target sweep not found");
                        return [
                            2
                        ];
                    }
                    currentSID = this.state.currentSweep.sid || this.state.currentSweep.sweep || ((ref2 = this.defaultSweep) === null || ref2 === void 0 ? void 0 : ref2.sid);
                    if (this.showCaseTemp.navigationManager.currentSID) currentSID = this.showCaseTemp.navigationManager.currentSID;
                    if (startingLocation) currentSID = startingLocation.id;
                    targetSID = target ? target === null || target === void 0 ? void 0 : target.id : null; // closestSweep ? closestSweep.id : null;
                    startingTargetSID = startingTarget ? startingTarget === null || startingTarget === void 0 ? void 0 : startingTarget.id : null; //  closestSweepForStartingTarget ? closestSweepForStartingTarget.id : null;
                    if (!currentSID || !targetSID) {
                        console.error("Current or Target sweep not found");
                        return [
                            2
                        ];
                    }
                    if (!currentSID) {
                        console.error("Current sweep not found");
                        return [
                            2
                        ];
                    }
                    if (!this.showCaseTemp.navigationManager) {
                        console.error("PathFinderLine not found");
                        return [
                            2
                        ];
                    }
                    targetTitle = (target === null || target === void 0 ? void 0 : (ref3 = target.tag) === null || ref3 === void 0 ? void 0 : ref3.title) || (target === null || target === void 0 ? void 0 : (ref4 = target.station) === null || ref4 === void 0 ? void 0 : ref4.title) || (target === null || target === void 0 ? void 0 : target.name);
                    enableNavBar = target === null || target === void 0 ? void 0 : target.enableNavBar;
                    icon = (target === null || target === void 0 ? void 0 : (ref5 = target.tag) === null || ref5 === void 0 ? void 0 : ref5.iconFile) ? "".concat("https://cdn.treedis.com", "/tours/").concat(target === null || target === void 0 ? void 0 : (ref6 = target.tag) === null || ref6 === void 0 ? void 0 : ref6.tourId, "/tags/icons/").concat(target === null || target === void 0 ? void 0 : (ref7 = target.tag) === null || ref7 === void 0 ? void 0 : ref7.iconFile) : (target === null || target === void 0 ? void 0 : (ref8 = target.tag) === null || ref8 === void 0 ? void 0 : ref8.custom) && (target === null || target === void 0 ? void 0 : (ref9 = target.tag) === null || ref9 === void 0 ? void 0 : ref9.customIcon) ? (target === null || target === void 0 ? void 0 : (ref10 = target.tag) === null || ref10 === void 0 ? void 0 : ref10.iconColor) ? "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(target === null || target === void 0 ? void 0 : (ref11 = target.tag) === null || ref11 === void 0 ? void 0 : ref11.customIcon, "?hex=").concat(encodeURIComponent(target === null || target === void 0 ? void 0 : (ref12 = target.tag) === null || ref12 === void 0 ? void 0 : ref12.iconColor), "&circle=").concat(target === null || target === void 0 ? void 0 : (ref13 = target.tag) === null || ref13 === void 0 ? void 0 : ref13.whiteCircle) : "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(target === null || target === void 0 ? void 0 : (ref14 = target.tag) === null || ref14 === void 0 ? void 0 : ref14.customIcon) : null;
                    autoNavigation = !preLoad && (target === null || target === void 0 ? void 0 : target.autoNavigation);
                    enableTeleportBtn = !preLoad && (target === null || target === void 0 ? void 0 : (ref15 = target.tag) === null || ref15 === void 0 ? void 0 : ref15.enableTeleportBtn);
                    navigationAutoPlay = !preLoad && (target.navigationAutoPlay || (navigationSettings === null || navigationSettings === void 0 ? void 0 : navigationSettings.autoPlayEnabled));
                    if (!(startingTarget && !preLoad && autoNavigation && navigationAutoPlay)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        this.moveToSweep(startingTarget.id, {
                            x: 0,
                            y: 0
                        }, "INSTANT", false)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    this.setState({
                        startingTargetSID: startingTargetSID,
                        finishingTargetSID: targetSID,
                        actionPathNavbarData: {
                            enableNavBar: enableNavBar,
                            destinationTitle: targetTitle,
                            icon: icon,
                            autoNavigation: autoNavigation,
                            enableTeleportBtn: enableTeleportBtn
                        },
                        isNavigationBackgroundVisible: !!preLoad,
                        navigationTarget: target
                    });
                    if (preLoad) {
                        this.showCaseTemp.navigationManager.renderPath(currentSID, targetSID, targetTitle, target, navigationType);
                        return [
                            2
                        ];
                    }
                    if (!autoNavigation) return [
                        3,
                        8
                    ];
                    if (!(navigationAutoPlay && ((ref16 = this.showCaseTemp.navigationManager.targetObjectData) === null || ref16 === void 0 ? void 0 : ref16.id) !== (target === null || target === void 0 ? void 0 : target.id))) return [
                        3,
                        3
                    ];
                    if (!this.showCaseTemp.navigationManager.currentSID) {
                        // start automatic navigation after sweep transition is finished
                        this.showCaseTemp.showcase.Sweep.current.waitUntil(function(currentSweep) {
                            return currentSweep.id !== "";
                        }).then(function() {
                            _this.setActionPathNavbarPlayButtonType("Pause");
                            var sweepToStart = _this.showCaseTemp.navigationManager.currentSID || currentSID;
                            _this.showCaseTemp.navigationManager.renderPath(sweepToStart, targetSID, targetTitle, target, navigationType).then(function() {
                                _this.showCaseTemp.navigationManager.autoNavigateCurrentPath(setSliderValue, // eslint-disable-next-line @typescript-eslint/no-empty-function
                                function() {}, function() {
                                    _this.showCaseTemp.navigationManager.inAutoNavigate = false;
                                    _this.setActionPathNavbarPlayButtonType("Play");
                                }).catch(function(e) {
                                    return console.error(e);
                                });
                            });
                        });
                    } else {
                        this.showCaseTemp.navigationManager.reset();
                        this.showCaseTemp.navigationManager.renderPath(currentSID, targetSID, targetTitle, target, navigationType).then(function() {
                            var path = _this.showCaseTemp.navigationManager.getAutonavigationPath();
                            var step = parseFloat((100 / path.length).toFixed(0));
                            var handleSliderValueAutoChange = function() {
                                setSliderValue(function(prevState) {
                                    var nextStep = prevState + step;
                                    return nextStep;
                                });
                            };
                            _this.setActionPathNavbarPlayButtonType("Pause");
                            _this.showCaseTemp.navigationManager.autoNavigateCurrentPath(handleSliderValueAutoChange, // eslint-disable-next-line @typescript-eslint/no-empty-function
                            function() {}, function() {
                                _this.showCaseTemp.navigationManager.inAutoNavigate = false;
                                _this.setActionPathNavbarPlayButtonType("Play");
                            }).catch(function(e) {
                                return console.error(e);
                            });
                        });
                    }
                    return [
                        3,
                        7
                    ];
                case 3:
                    this.setActionPathNavbarPlayButtonType("Play");
                    this.showCaseTemp.navigationManager.reset();
                    if (!startingTargetSID) return [
                        3,
                        6
                    ];
                    if (!(!preLoad && (startingTargetSID !== ((ref17 = this.state.currentSweep) === null || ref17 === void 0 ? void 0 : ref17.sid) || startingTargetSID !== ((ref18 = this.state.currentSweep) === null || ref18 === void 0 ? void 0 : ref18.id)))) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        this.moveToSweep(startingTargetSID, {
                            x: 0,
                            y: 0
                        }, "INSTANT", false)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    this.showCaseTemp.navigationManager.renderPath(startingTargetSID, targetSID, targetTitle, target, navigationType).then(function() {
                        _this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
                    });
                    return [
                        3,
                        7
                    ];
                case 6:
                    this.showCaseTemp.navigationManager.renderPath(currentSID, targetSID, targetTitle, target, navigationType).then(function() {
                        _this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
                    });
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
                case 8:
                    if (this.showCaseTemp.navigationManager) {
                        if (this.showCaseTemp.navigationManager.targetSID !== targetSID || this.showCaseTemp.navigationManager.navigationType !== navigationType) {
                            this.showCaseTemp.navigationManager.renderPath(currentSID, targetSID, targetTitle, target, navigationType);
                        } else {
                            this.showCaseTemp.navigationManager.reset();
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _setNavigationDestination.apply(this, arguments);
}
function moveToStartingPoint() {
    return _moveToStartingPoint.apply(this, arguments);
}
function _moveToStartingPoint() {
    _moveToStartingPoint = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var _this, navigationStartPosition, s, x, y;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    navigationStartPosition = this.state.navigationStartPosition;
                    if (!(navigationStartPosition && this.showCaseTemp.navigationManager.currentSID !== navigationStartPosition.s)) return [
                        3,
                        2
                    ];
                    s = navigationStartPosition.s, x = navigationStartPosition.x, y = navigationStartPosition.y;
                    return [
                        4,
                        this.moveToSweep(s, {
                            x: x,
                            y: y
                        }, "INSTANT")
                    ];
                case 1:
                    _state.sent();
                    if (this.showCaseTemp.navigationManager.legacyIds) {
                        this.showCaseTemp.navigationManager.pathCalculationSweeps.forEach(function(value, key) {
                            if (value.sweep_uuid === s || value.sweep_uuid === s) {
                                _this.showCaseTemp.navigationManager.currentSID = key;
                            }
                        });
                    } else {
                        this.showCaseTemp.navigationManager.currentSID = s;
                    }
                    _state.label = 2;
                case 2:
                    this.setState({
                        actionPathFinished: false,
                        showActionPathBar: false
                    });
                    this.setActionPathNavbarPlayButtonType("Play");
                    this.showCaseTemp.navigationManager.reset();
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return _moveToStartingPoint.apply(this, arguments);
}


/***/ }),

/***/ 62818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ toggleExternalPopup; },
/* harmony export */   "O": function() { return /* binding */ toggleContactPopup; }
/* harmony export */ });
/* harmony import */ var _all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);
/* harmony import */ var _analytic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83784);
/* harmony import */ var _components_util_deviceManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99080);



function toggleExternalPopup(url, iframeSettings) {
    var isMobile = _components_util_deviceManager__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isMobile */ .Z.isMobile();
    var externalPopupUrl = url;
    if (url && (url.includes("youtu.be") || url.includes("youtube.com") || url.includes("vimeo.com"))) {
        externalPopupUrl = (0,_all__WEBPACK_IMPORTED_MODULE_0__/* .getVideoLink */ .rp)(url);
    }
    if (isMobile && url && url.endsWith(".pdf")) {
        externalPopupUrl = "https://smallpdf.com/reader-embedded#url=".concat(encodeURIComponent(url));
    }
    this.setState({
        overlayOn: !this.state.externalPopupOn,
        externalPopupOn: !this.state.externalPopupOn,
        externalPopupUrl: externalPopupUrl,
        markerPopupOn: false,
        iframeSettings: iframeSettings
    });
}
function toggleContactPopup() {
    if (!this.state.contactPopupOn) {
        (0,_analytic__WEBPACK_IMPORTED_MODULE_1__/* .sendToGA */ .o$)("event", {
            eventCategory: "Contact",
            eventAction: "click",
            eventLabel: "open"
        });
        (0,_analytic__WEBPACK_IMPORTED_MODULE_1__/* .sendToGA */ .o$)("event", {
            eventCategory: "Lead",
            eventAction: "open",
            eventLabel: "contact"
        });
    }
    this.setState({
        contactPopupOn: !this.state.contactPopupOn,
        overlayOn: !this.state.contactPopupOn
    });
}


/***/ }),

/***/ 68687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k$": function() { return /* binding */ getLocation; },
  "u7": function() { return /* binding */ loadModel; },
  "QO": function() { return /* binding */ moveToMPLabels; },
  "h_": function() { return /* binding */ navigateToTag; },
  "$O": function() { return /* binding */ openTagIframe; },
  "IW": function() { return /* binding */ openVsImageIframe; },
  "BY": function() { return /* binding */ openVsObjectIframe; },
  "O7": function() { return /* binding */ openVsVideoIframe; },
  "Z4": function() { return /* binding */ openedPanoHotspot; },
  "$v": function() { return /* binding */ preventTagAction; },
  "Zy": function() { return /* binding */ takePano; },
  "ss": function() { return /* binding */ takeScreenshot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(33729);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/watermarkjs/dist/watermark.js
var watermark = __webpack_require__(60832);
var watermark_default = /*#__PURE__*/__webpack_require__.n(watermark);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 146 modules
var dist = __webpack_require__(59603);
// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./_models/Menu.tsx
var Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/game/GameBook.ts
var GameBook = __webpack_require__(97741);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
;// CONCATENATED MODULE: ./components/tour/processNavigationPath.ts





var processNavigationPath = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var url, sweeps, startSweep, cb, THREE, sr, ss, linkDataShort, x, y, z, euler, rotation, endSweep, sweepsPath;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.tagNavigationLink, sweeps = param.sweeps, startSweep = param.startSweep, cb = param.cb;
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state.sent();
                    sr = (0,util/* getQueryVariable */.Dv)(url, "sr");
                    ss = (0,util/* getQueryVariable */.Dv)(url, "ss");
                    linkDataShort = sr && ss ? {
                        sr: sr.split(","),
                        ss: parseInt(String(ss), 10)
                    } : false;
                    if (linkDataShort) {
                        x = parseFloat(linkDataShort.sr[0] || "0");
                        y = parseFloat(linkDataShort.sr[1] || "0");
                        z = parseFloat(linkDataShort.sr[2] || "0");
                        euler = new THREE.Euler().set(x, y, z, "XYZ").reorder("YXZ");
                        rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                        rotation.z = 0;
                        endSweep = sweeps[linkDataShort.ss - 1].uuid;
                        sweepsPath = (0,util/* getSweepsPath */.u6)(sweeps, startSweep, endSweep);
                        cb({
                            sweepsPath: sweepsPath,
                            rotation: rotation
                        });
                    } else {
                        react_toastify_esm/* toast.error */.Am.error("Wrong matterport deep link");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function processNavigationPath(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_iterator.mjs
var _async_iterator = __webpack_require__(2236);
;// CONCATENATED MODULE: ./components/tour/moveToSweeps.ts
/* eslint-disable no-restricted-syntax */ 




var moveToSweeps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var sweepsPath, targetRotation, poseRotation, rotationAngle, rotationSpeed, transitionSpeed, stopAfterSweep, showcaseSweep, iteration, currentRotation, maxSpeed, minSpeed, delay, THREE, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, id, rotation, next, currentSpeed, curQuaternion, nextQuaternion, angle, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sweepsPath = param.sweepsPath, targetRotation = param.targetRotation, poseRotation = param.poseRotation, rotationAngle = param.rotationAngle, rotationSpeed = param.rotationSpeed, transitionSpeed = param.transitionSpeed, stopAfterSweep = param.stopAfterSweep, showcaseSweep = param.showcaseSweep;
                    iteration = 0;
                    currentRotation = poseRotation;
                    maxSpeed = 5000;
                    minSpeed = 500;
                    delay = 5000;
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state.sent();
                    if (!showcaseSweep) return [
                        3,
                        17
                    ];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0,_async_iterator/* default */.Z)(sweepsPath);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    id = _value.id, rotation = _value.rotation, next = _value.next;
                    currentSpeed = transitionSpeed;
                    if (next) {
                        curQuaternion = new THREE.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w);
                        nextQuaternion = new THREE.Quaternion(next.rotation.x, next.rotation.y, next.rotation.z, next.rotation.w);
                        angle = curQuaternion.angleTo(nextQuaternion) * 180 / Math.PI;
                        if (angle > rotationAngle) {
                            currentRotation.y += angle;
                            currentSpeed = rotationSpeed;
                        }
                    } else {
                        currentRotation = targetRotation;
                    }
                    return [
                        4,
                        showcaseSweep.moveTo(id, {
                            rotation: currentRotation,
                            transition: showcaseSweep.Transition.FLY,
                            transitionTime: maxSpeed + minSpeed - maxSpeed * currentSpeed / 100
                        })
                    ];
                case 5:
                    _state.sent();
                    if (!(iteration > 0 && iteration !== sweepsPath.length - 1 && !(iteration % stopAfterSweep))) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, delay);
                        })
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    iteration += 1;
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 17:
                    react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                    return [
                        2,
                        Promise.reject()
                    ];
            }
        });
    });
    return function moveToSweeps(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./_models/Game.tsx
var Game = __webpack_require__(81766);
// EXTERNAL MODULE: ./components-new/common/AudioModule.ts + 2 modules
var AudioModule = __webpack_require__(29519);
// EXTERNAL MODULE: ./_models/virtualStaging/VideoRenderer.component.tsx
var VideoRenderer_component = __webpack_require__(23276);
// EXTERNAL MODULE: ./utils/extractSweepIdFromURL.ts
var extractSweepIdFromURL = __webpack_require__(33797);
// EXTERNAL MODULE: ./utils/getDistance.ts
var getDistance = __webpack_require__(7926);
// EXTERNAL MODULE: ./_models/virtualStaging/BIM/component/data.ts
var data = __webpack_require__(36834);
;// CONCATENATED MODULE: ./components/util/sdk.ts
















// import { sendToGA } from './analytic';








function downloadDirect(url, title) {
    var element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", "".concat(title, ".jpg"));
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
function takePano() {
    var _this = this;
    if (this.showcase) {
        this.setState({
            loading: true
        });
        this.showcase.Renderer.takeEquirectangular().then(function(url) {
            downloadDirect(url, _this.state.tour.title);
            _this.setState({
                loading: false
            });
        });
    }
}
function getLocation() {
    var m = (0,util_all/* getQueryVariable */.Dv)(this.state.iframeUrl, "m");
    if (m) {
        return (0,util_all/* buildLink */.DF)(this.pose.sweep, this.pose.rotation, m);
    }
    return null;
}
var audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
function downloadImage(title, url, clientId, width) {
    var options = {
        init: function init(img) {
            // eslint-disable-next-line no-param-reassign
            img.crossOrigin = "anonymous";
        }
    };
    watermark_default()([
        url,
        "".concat("https://cdn.treedis.com", "/clients/").concat(clientId, "/logo.png").concat((0,util_all/* getVersion */.bo)(new Date()))
    ], options).blob(function(target, _watermark) {
        var context = target.getContext("2d");
        context.save();
        var widthRatio = _watermark.width / width;
        var height = _watermark.height / widthRatio;
        context.drawImage(_watermark, 10, 10, width, height);
        context.restore();
        return target;
    }).then(function(img) {
        return download_default()(img, "".concat(title, ".jpg"), "image/jpg");
    });
}
function takeScreenshot(resolution) {
    var _this = this;
    if (this.showcase) {
        var ref;
        var tour = this.state.tour;
        var width = tour.client && tour.client.widthLogo ? 250 : 150;
        this.setState({
            loading: true
        });
        var sweep = (ref = this.state.sweeps) === null || ref === void 0 ? void 0 : ref.find(function(sweep) {
            return sweep.id === _this.state.currentSweep.sid || sweep.sweep_uuid === _this.state.currentSweep.sid;
        });
        var title = tour.title;
        if (sweep) {
            title = "".concat(sweep.id, "_").concat(sweep.sweep_uuid);
        }
        this.showcase.Renderer.takeScreenShot(resolution, {
            mattertags: false,
            sweeps: false
        }).then(function(url) {
            if (tour.client && tour.client.logo) {
                downloadImage(title, url, tour.clientId, width);
            } else {
                downloadDirect(url, title);
            }
            _this.setState({
                loading: false
            });
        });
    }
}
function preventTagAction(sid, actions) {
    var ref;
    if ((ref = this) === null || ref === void 0 ? void 0 : ref.showcase) {
        // eslint-disable-next-line no-console
        return this.showcase.Mattertag.preventAction(sid, actions).catch(console.error);
    }
    return null;
}
function navigateToTag(sid) {
    return _navigateToTag.apply(this, arguments);
}
function _navigateToTag() {
    _navigateToTag = (0,_async_to_generator/* default */.Z)(function(sid) {
        var ref, preventAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((ref = this) === null || ref === void 0 ? void 0 : ref.showcase)) return [
                        3,
                        4
                    ];
                    preventAction = preventTagAction.bind(this);
                    return [
                        4,
                        preventAction(sid, {
                            navigation: false
                        })
                    ];
                case 1:
                    _state.sent();
                    // eslint-disable-next-line no-console
                    return [
                        4,
                        this.showcase.Mattertag.navigateToTag(sid, this.showcase.Mattertag.Transition.FLY).catch(console.error)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        preventAction(sid, {
                            navigation: true
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _navigateToTag.apply(this, arguments);
}
function loadModel(name, url, type, tag, panoramaId) {
    return _loadModel.apply(this, arguments);
}
function _loadModel() {
    _loadModel = (0,_async_to_generator/* default */.Z)(function(name, url, type, tag, panoramaId) {
        var changeMinimap, changePanorama, iframeSettings, changeReel, gallery, _this, products, tour, segments, lastSeg, _lastSeg, slug, sameTour, _this1, ref, ref1, target, allTags, currentSID, ref2, ref3, s, currentSweep, targetPosition, closestSweep, closestDistance, targetSID, ref4, distance, inDistance, ref5, intervalID, ref6, currentSID1, targetSID1, ref7, allSweeps, ref8, target1, component, pipeConfig, selectedPipe;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    changeMinimap = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : true, changePanorama = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : false, iframeSettings = _arguments.length > 7 && _arguments[7] !== void 0 ? _arguments[7] : {}, changeReel = _arguments.length > 8 && _arguments[8] !== void 0 ? _arguments[8] : false, gallery = _arguments.length > 9 && _arguments[9] !== void 0 ? _arguments[9] : [];
                    _this = this;
                    if (!(type === Menu/* MenuType.Tab */.o.Tab)) return [
                        3,
                        1
                    ];
                    window.open(url);
                    return [
                        3,
                        10
                    ];
                case 1:
                    if (!(type === Menu/* MenuType.Gallery */.o.Gallery)) return [
                        3,
                        2
                    ];
                    // this.setState({ galleryOpen: true, menuOpen: false });
                    if ((gallery === null || gallery === void 0 ? void 0 : gallery.length) > 0) {
                        this.setState({
                            galleryArr: gallery,
                            menuOpen: false,
                            galleryName: name
                        });
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    if (!(type === Menu/* MenuType.Popup */.o.Popup)) return [
                        3,
                        3
                    ];
                    this.toggleExternalPopup(url);
                    return [
                        3,
                        10
                    ];
                case 3:
                    if (!(type === Menu/* MenuType.Iframe */.o.Iframe)) return [
                        3,
                        4
                    ];
                    this.toggleExternalPopup(url, iframeSettings);
                    return [
                        3,
                        10
                    ];
                case 4:
                    if (!(type === Menu/* MenuType.Product */.o.Product && tag !== null)) return [
                        3,
                        5
                    ];
                    products = this.state.products.filter(function(item) {
                        return ((item === null || item === void 0 ? void 0 : item.tags) || []).some(function(productTag) {
                            return productTag.sid === tag;
                        });
                    });
                    if (products && products.length > 0) {
                        this.setState({
                            currentProducts: products.length > 1 ? products : [],
                            currentProduct: products.length === 1 ? products[0] : null
                        });
                    }
                    navigateToTag(tag);
                    window.location.hash = tag;
                    return [
                        3,
                        10
                    ];
                case 5:
                    if (!(type === Menu/* MenuType.Panorama */.o.Panorama)) return [
                        3,
                        6
                    ];
                    this.setState({
                        panoramaOn: true,
                        activePano: panoramaId
                    });
                    return [
                        3,
                        10
                    ];
                case 6:
                    if (!(type === Menu/* MenuType.Treedis */.o.Treedis)) return [
                        3,
                        9
                    ];
                    if (!(window.top !== window.self)) return [
                        3,
                        8
                    ];
                    window.top.postMessage({
                        type: "tourLink",
                        url: url
                    }, "*");
                    // so the parent window can handle the link
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, 100);
                        })
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    if (url.includes("/experience/")) {
                        window.location.href = url;
                        return [
                            2
                        ];
                    }
                    tour = this.state.tour;
                    segments = url.split("/");
                    lastSeg = segments[segments.length - 1].split("?");
                    _lastSeg = (0,_sliced_to_array/* default */.Z)(lastSeg, 1), slug = _lastSeg[0];
                    sameTour = tour.slug === slug;
                    if (sameTour && lastSeg.length === 1) return [
                        2
                    ]; // same tour, no query params, we shouldn't get it again
                    if (url.includes("matterport.com")) {
                        react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                        return [
                            2
                        ];
                    }
                    _this1 = this;
                    // if isVSReady is true, then VS is configured (VS components, lights etc.) - can't init VS without it
                    // don't need to configure that if it's the same tour
                    this.setState({
                        panoramaOn: false,
                        activePano: null,
                        isVSReady: sameTour
                    }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            _this1.getTour({
                                slug: slug,
                                changeMenu: false,
                                changeMinimap: changeMinimap,
                                changePanorama: changePanorama,
                                changeReel: changeReel,
                                url: url,
                                hideIntroScreen: true
                            }); // false = dont change the menu/panorama
                            // change url to detect tour analytic from menu
                            try {
                                window.history.pushState({}, "", url);
                            } catch (error) {
                                console.warn("Failed to update URL:", error);
                            // Fallback if needed or just continue execution
                            }
                            return [
                                2
                            ];
                        });
                    }));
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (type === Menu/* MenuType.MatterportInstant */.o.MatterportInstant) {
                        this.setState({
                            isChangeIframe: this.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(url, "m")
                        }, function() {
                            var ref, ref1;
                            _this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(url)), false, true);
                        });
                    } else if (type === Menu/* MenuType.Tag */.o.Tag && tag !== null) {
                        ;
                        target = Array.from(this.state.allTags, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                            return value;
                        })// searching by temporary sid from Matterport
                        .find(function(item) {
                            return item.sid === tag || item.defaultSid === tag;
                        });
                        if ((target === null || target === void 0 ? void 0 : (ref = target.media) === null || ref === void 0 ? void 0 : ref.type) === "video" || (target === null || target === void 0 ? void 0 : target.type) === "video") {
                            audioHandler.pauseAllMusic();
                            this.setState({
                                tourAudioPlaying: false
                            });
                        }
                        if (!target) {
                            react_toastify_esm/* toast.error */.Am.error("Cannot find the tag on the tour");
                            return [
                                2
                            ];
                        }
                        allTags = this.state.allTags;
                        Array.from(allTags.values()).forEach(function(param) {
                            var sid = param.sid;
                            _this.showCaseTemp.showcase.Tag.close(sid);
                        });
                        if (target.treedisStyle && !target.navigationEnabled) {
                            setTimeout(function() {
                                _this.handleTagHoverEvent(target.sid, true);
                            }, 1000);
                        }
                        if (!this.showCaseTemp.navigationManager) return [
                            2
                        ];
                        currentSID = this.showCaseTemp.navigationManager.currentSID;
                        if (!currentSID) {
                            ;
                            s = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "s");
                            currentSweep = (ref2 = this.state) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sweeps) === null || ref3 === void 0 ? void 0 : ref3.find(function(sweep) {
                                return sweep.id === s || sweep.sweep_uuid === s;
                            });
                            if (!currentSweep) return [
                                2
                            ];
                            this.showCaseTemp.navigationManager.currentSweep = currentSweep;
                            this.showCaseTemp.navigationManager.currentSID = currentSweep.id;
                            currentSID = currentSweep.id;
                        }
                        targetPosition = {
                            x: target.positionX,
                            y: target.positionY,
                            z: target.positionZ
                        };
                        ;
                        closestDistance = Infinity;
                        this.state.allSweeps.forEach(function(sweep) {
                            if (sweep.floor === target.floor) {
                                var sweepPosition = {
                                    x: sweep.positionX,
                                    y: sweep.positionY,
                                    z: sweep.positionZ
                                };
                                var distance = (0,getDistance/* getDistance */.Sp)(sweepPosition, targetPosition);
                                if ((closestDistance === null || distance < closestDistance) && sweep.neighbourSweeps.length) {
                                    closestSweep = sweep;
                                    closestDistance = distance;
                                }
                            }
                        });
                        // If sweep is very far or doesn't exist, try to find the closest sweep on any floor
                        if (!closestSweep || closestDistance > 25) {
                            closestDistance = Infinity;
                            console.warn("No sweep found on the same floor or it's too far. Defaulting to closest sweep on any floor.");
                            this.state.allSweeps.forEach(function(sweep) {
                                var sweepPosition = {
                                    x: sweep.positionX,
                                    y: sweep.positionY,
                                    z: sweep.positionZ
                                };
                                var distance = (0,getDistance/* getDistance */.Sp)(sweepPosition, targetPosition);
                                if ((closestDistance === null || distance < closestDistance) && sweep.neighbourSweeps.length) {
                                    closestSweep = sweep;
                                    closestDistance = distance;
                                }
                            });
                        }
                        targetSID = closestSweep ? closestSweep.id : null;
                        if (!currentSID || !targetSID) {
                            console.error("Current or Target sweep not found", currentSID, targetSID);
                            return [
                                2
                            ];
                        }
                        if (!this.showCaseTemp.navigationManager) {
                            console.error("PathFinder Line is not defined");
                            return [
                                2
                            ];
                        }
                        if (!target.navigationEnabled || target.AROnly) {
                            ;
                            if (((ref4 = this.showCaseTemp.navigationManager.targetObjectData) === null || ref4 === void 0 ? void 0 : ref4.id) === (target === null || target === void 0 ? void 0 : target.id)) {
                                this.showCaseTemp.navigationManager.reset();
                                this.setActionPathNavbarVisible(false);
                            }
                            this.setState({
                                panoramaOn: false
                            }, function() {
                                _this.moveToTagIO(target, false);
                            });
                            return [
                                2
                            ];
                        }
                        distance = (0,getDistance/* getDistance */.Sp)(this.pose.position, targetPosition);
                        inDistance = distance < 3 && (this.state.currentFloor === target.floor || this.state.currentFloor === null) && this.currentSweep.id !== "";
                        if (inDistance) {
                            this.showCaseTemp.navigationManager.reset();
                            this.setActionPathNavbarVisible(false);
                            this.setState({
                                panoramaOn: false
                            }, function() {
                                _this.moveToTagIO(target, false);
                            });
                            return [
                                2
                            ];
                        }
                        this.setState({
                            actionPathNavbarData: {
                                enableNavBar: target.enableNavBar,
                                destinationTitle: target.title,
                                icon: target.iconFile ? "".concat("https://cdn.treedis.com", "/tours/").concat(target.tourId, "/tags/icons/").concat(target.iconFile) : null,
                                autoNavigation: target.autoNavigation,
                                enableTeleportBtn: target.enableTeleportBtn
                            }
                        });
                        if (this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE || this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN) {
                            this.setActionPathNavbarPlayButtonType("Play");
                            this.showCaseTemp.navigationManager.renderPath(this.prevSweep.id, targetSID, name, target);
                            return [
                                2
                            ];
                        }
                        if (target.autoNavigation) {
                            ;
                            if (target.navigationAutoPlay && ((ref5 = this.showCaseTemp.navigationManager.targetObjectData) === null || ref5 === void 0 ? void 0 : ref5.id) !== (target === null || target === void 0 ? void 0 : target.id)) {
                                if (this.currentSweep.id === "") {
                                    intervalID = setInterval(function() {
                                        if (_this.currentSweep.id !== "") {
                                            _this.showCaseTemp.navigationManager.reset();
                                            _this.setActionPathNavbarPlayButtonType("Pause");
                                            _this.showCaseTemp.navigationManager.renderPath(_this.currentSweep.id, targetSID, name, target).then(function() {
                                                _this.showCaseTemp.navigationManager.autoNavigateCurrentPath(null, // eslint-disable-next-line @typescript-eslint/no-empty-function
                                                function() {}, function() {
                                                    _this.showCaseTemp.navigationManager.inAutoNavigate = false;
                                                    _this.setActionPathNavbarPlayButtonType("Play");
                                                }).catch(function(e) {
                                                    return console.error(e);
                                                });
                                            });
                                            clearInterval(intervalID);
                                        }
                                    }, 250);
                                } else {
                                    this.showCaseTemp.navigationManager.reset();
                                    this.setActionPathNavbarPlayButtonType("Pause");
                                    this.showCaseTemp.navigationManager.renderPath(currentSID, targetSID, name, target).then(function() {
                                        _this.showCaseTemp.navigationManager.autoNavigateCurrentPath(null, // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        function() {}, function() {
                                            _this.showCaseTemp.navigationManager.inAutoNavigate = false;
                                            _this.setActionPathNavbarPlayButtonType("Play");
                                        }).catch(function(e) {
                                            return console.error(e);
                                        });
                                    });
                                }
                            } else {
                                this.setActionPathNavbarPlayButtonType("Play");
                                this.showCaseTemp.navigationManager.renderPath(currentSID, targetSID, name, target).then(function() {
                                    _this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
                                });
                            }
                            return [
                                2
                            ];
                        }
                        if (((ref1 = this.showCaseTemp.navigationManager.targetObjectData) === null || ref1 === void 0 ? void 0 : ref1.id) !== (target === null || target === void 0 ? void 0 : target.id)) {
                            this.setActionPathNavbarPlayButtonType("Play");
                            this.showCaseTemp.navigationManager.renderPath(currentSID, targetSID, name, target).then(function() {
                                _this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
                            });
                        } else {
                            return [
                                2
                            ];
                        }
                    } else if (type === Menu/* MenuType.NavigationPath */.o.NavigationPath) {
                        ;
                        currentSID1 = this.state.currentSweep.sid || this.state.currentSweep.sweep || ((ref6 = this.defaultSweep) === null || ref6 === void 0 ? void 0 : ref6.sid);
                        targetSID1 = (0,extractSweepIdFromURL/* extractSweepIdFromURL */.D)(url);
                        if (!currentSID1) {
                            console.error("Current sweep not found");
                            return [
                                2
                            ];
                        }
                        if (!targetSID1) {
                            console.error("Target sweep not found");
                            return [
                                2
                            ];
                        }
                        if (this.showCaseTemp.navigationManager) {
                            if (this.showCaseTemp.navigationManager.targetSID !== targetSID1) {
                                ;
                                allSweeps = ((ref7 = this.state.allSweeps) === null || ref7 === void 0 ? void 0 : ref7.size) ? Array.from(this.state.allSweeps, function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                    return value;
                                }) : [];
                                if (allSweeps.length === 0) {
                                    ;
                                    react_toastify_esm/* toast.info */.Am.info(((ref8 = this.state.translation) === null || ref8 === void 0 ? void 0 : ref8.pleaseWaitSweeps) || "Please wait for the sweeps to load");
                                    return [
                                        2
                                    ];
                                }
                                target1 = allSweeps === null || allSweeps === void 0 ? void 0 : allSweeps.find(function(item) {
                                    return item.sweep_uuid === targetSID1 || item.sweepId === targetSID1;
                                });
                                this.showCaseTemp.navigationManager.renderPath(this.showCaseTemp.navigationManager.currentSID, target1 === null || target1 === void 0 ? void 0 : target1.id, name, target1, this.showCaseTemp.navigationManager.navigationType);
                            } else {
                                this.showCaseTemp.navigationManager.reset();
                            }
                        }
                    } else if (type === Menu/* MenuType.BIMItem */.o.BIMItem) {
                        component = this.BIMComponent;
                        pipeConfig = data/* pipesConfig.pipes.find */.y.pipes.find(function(el) {
                            return el.id === url;
                        });
                        selectedPipe = (0,_to_consumable_array/* default */.Z)(pipeConfig.segments.map(function(s) {
                            return s.name;
                        })).concat((0,_to_consumable_array/* default */.Z)(pipeConfig.animatedSegments.map(function(s) {
                            return s.name;
                        })));
                        if (component.selectedPipe) {
                            component.selectedPipe.forEach(function(segment) {
                                var segmentId = component.getSegmentIdByName(segment);
                                if (segmentId) {
                                    component.setItemColor(segmentId, component.inputs.colorDefault);
                                    component.setItemOpacity(segmentId, component.inputs.opacityDefault);
                                    if (component.animatedPipes.has(segmentId)) {
                                        component.setAnimatedPipeOpacity(segmentId, 0);
                                    }
                                    var segmentItem = component.getItem(segmentId);
                                    if (segmentItem) segmentItem.selected = false;
                                }
                            });
                            component.selectedPipe = null;
                        }
                        selectedPipe.forEach(function(segment) {
                            var segmentId = component.getSegmentIdByName(segment);
                            if (segmentId) {
                                component.setItemColor(segmentId, component.inputs.colorClick);
                                component.setItemOpacity(segmentId, component.inputs.opacityClick);
                                if (component.animatedPipes.has(segmentId)) {
                                    component.setAnimatedPipeOpacity(segmentId, 1);
                                }
                                var segmentItem = component.getItem(segmentId);
                                if (segmentItem) segmentItem.selected = true;
                            }
                        });
                        component.selectedPipe = selectedPipe;
                    } else if (type !== Menu/* MenuType.Category */.o.Category) {
                        this.setState({
                            isChangeIframe: this.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(url, "m")
                        }, function() {
                            var ref, ref1;
                            _this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(url)), false, false);
                        });
                    }
                    _state.label = 10;
                case 10:
                    // DISabling GA for now
                    // if (name) {
                    //   sendToGA('event', {
                    //     eventCategory: 'Place',
                    //     eventAction: 'click',
                    //     eventLabel: name,
                    //   });
                    // }
                    if (name && this.state.chatToken && socket/* default */.Z && socket/* default.connected */.Z.connected && this.state.host) {
                        socket/* default.emit */.Z.emit("menu", {
                            menu: {
                                name: name,
                                url: url,
                                type: type
                            }
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _loadModel.apply(this, arguments);
}
function openedPanoHotspot(hotspot) {
    return _openedPanoHotspot.apply(this, arguments);
}
function _openedPanoHotspot() {
    _openedPanoHotspot = (0,_async_to_generator/* default */.Z)(function(hotspot) {
        var ref, ref1, ref2, ref3, ref4, ref5, windowSegments, segments, slug, hubRegex, gameOrVcommerceRegex, isHubUrl, isGameOrVCommerce, room, tourSlug, tour, changeMinimap, ref6, s, x, y, _this, tour1, ref7, noAudioMode;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (hotspot.type === Tag/* TagType.Matterport */.Qy.Matterport && hotspot.url) {
                        ;
                        if (this.state.appState !== "playing") {
                            ;
                            react_toastify_esm/* toast.info */.Am.info(((ref2 = this.state.translation) === null || ref2 === void 0 ? void 0 : ref2.pleaseWait) || "Please wait for the tour to load");
                            return [
                                2
                            ];
                        }
                        this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref = this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(hotspot.url)), false, true);
                        return [
                            2
                        ];
                    }
                    if (hotspot.type === Tag/* TagType.MatterportInstant */.Qy.MatterportInstant && hotspot.url) {
                        ;
                        if (this.state.appState !== "playing") {
                            ;
                            react_toastify_esm/* toast.info */.Am.info(((ref5 = this.state.translation) === null || ref5 === void 0 ? void 0 : ref5.pleaseWait) || "Please wait for the tour to load");
                            return [
                                2
                            ];
                        }
                        this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref3 = this.state.tour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.user) === null || ref4 === void 0 ? void 0 : ref4.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(hotspot.url)), false, false);
                        return [
                            2
                        ];
                    }
                    if (!(hotspot.type === Tag/* TagType.Treedis */.Qy.Treedis && hotspot.url)) return [
                        3,
                        5
                    ];
                    windowSegments = window.location.href.split("/");
                    segments = hotspot.url.split("/");
                    slug = hotspot.url.includes("?") ? segments[segments.length - 1].split("?")[0] : segments[4];
                    hubRegex = /(^|[^a-z])(host|guest)([^a-z]|$)/i;
                    gameOrVcommerceRegex = /(^|[^a-z])(experience|e-commerce-tour)([^a-z]|$)/i;
                    isHubUrl = hubRegex.test(hotspot.url);
                    isGameOrVCommerce = gameOrVcommerceRegex.test(hotspot.url);
                    room = isHubUrl ? segments[segments.length - 1] : this.state.room || null;
                    if ((0,util_all/* getQueryVariable */.Dv)(hotspot.url, "m")) {
                        react_toastify_esm/* toast.error */.Am.error("Can't use this link, to copy location in treedis tour, use CTRL+Y");
                        return [
                            2
                        ];
                    }
                    if (isGameOrVCommerce) {
                        tourSlug = windowSegments.pop().split("?")[0];
                        if (tourSlug !== slug) {
                            window.location.assign(hotspot.url);
                            return [
                                2
                            ];
                        }
                    }
                    tour = this.state.tour;
                    changeMinimap = tour && !tour.customMinimap;
                    if (!(tour.slug !== slug)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        this.getTour({
                            slug: slug,
                            changeMenu: false,
                            changeMinimap: changeMinimap,
                            changePanorama: false,
                            url: hotspot.url,
                            hideIntroScreen: true
                        })
                    ];
                case 1:
                    _state.sent(); // false = dont change the menu/panorama
                    return [
                        3,
                        4
                    ];
                case 2:
                    if (this.state.appState !== "playing") {
                        ;
                        react_toastify_esm/* toast.info */.Am.info(((ref6 = this.state.translation) === null || ref6 === void 0 ? void 0 : ref6.pleaseWait) || "Please wait for the tour to load");
                        return [
                            2
                        ];
                    }
                    s = (0,util_all/* getQueryVariable */.Dv)(hotspot.url, "s");
                    x = (0,util_all/* getQueryVariable */.Dv)(hotspot.url, "x");
                    y = (0,util_all/* getQueryVariable */.Dv)(hotspot.url, "y");
                    if (!(s && x && y)) return [
                        3,
                        4
                    ];
                    // We move inside the tour
                    return [
                        4,
                        this.moveToSweep(String(s), {
                            x: parseFloat(x),
                            y: parseFloat(y)
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    if (!socket/* default.connected */.Z.connected && isHubUrl) {
                        socket/* default.open */.Z.open();
                    }
                    _this = this;
                    this.setState({
                        panoramaOn: false,
                        activePano: null,
                        isVSReady: false,
                        room: room,
                        interacted: true
                    }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            if (_this.state.room && socket/* default */.Z && socket/* default.connected */.Z.connected && _this.state.host) {
                                socket/* default.emit */.Z.emit("pano-hotspot-click", {
                                    id: slug,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: hotspot.url
                                });
                            }
                            return [
                                2
                            ];
                        });
                    }));
                    return [
                        2
                    ];
                case 5:
                    if (!(hotspot.type === Tag/* TagType.Music */.Qy.Music && hotspot.url)) return [
                        3,
                        7
                    ];
                    tour1 = this.state.tour;
                    if (tour1.noAudioMode && this.state.chatToken) return [
                        2
                    ];
                    this.setState({
                        openedPanoHotspot: hotspot
                    });
                    return [
                        4,
                        audioHandler.playAudio({
                            type: AudioModule/* MusicObj.PANORAMAS */.nR.PANORAMAS,
                            id: hotspot.defaultId
                        })
                    ];
                case 6:
                    _state.sent();
                    return [
                        2
                    ];
                case 7:
                    if (hotspot.type === Tag/* TagType.Popup */.Qy.Popup && hotspot.url) {
                        ;
                        noAudioMode = ((ref7 = this.state) === null || ref7 === void 0 ? void 0 : ref7.tour).noAudioMode;
                        hotspot.url = (0,util_all/* getVideoLink */.rp)(hotspot.url, {
                            mute: noAudioMode && this.state.chatToken
                        });
                        audioHandler.pauseAllMusic();
                    }
                    this.setState({
                        panoPopOn: true,
                        openedPanoHotspot: hotspot
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _openedPanoHotspot.apply(this, arguments);
}
function openTagIframe(sid, options) {
    return _openTagIframe.apply(this, arguments);
}
function _openTagIframe() {
    _openTagIframe = (0,_async_to_generator/* default */.Z)(function(sid, options) {
        var _this, _state, allTags, tour, tourType, ref, _skipEmbedMediaCheck, skipEmbedMediaCheck, foundTag, tag, ref1, segmants, lastSeg, slug, changeMinimap, _, sweep, x, y, _this1, e, ref2, ref3, ref4, ref5, ref6, noAudioMode, ref7, ref8, ref9, noAudioMode1, disableActionForFlow, vsVideos, ref10, img;
        return (0,tslib_es6.__generator)(this, function(_state1) {
            switch(_state1.label){
                case 0:
                    _this = this;
                    _state = this.state, allTags = _state.allTags, tour = _state.tour, tourType = _state.tourType;
                    ref = options || {}, _skipEmbedMediaCheck = ref.skipEmbedMediaCheck, skipEmbedMediaCheck = _skipEmbedMediaCheck === void 0 ? false : _skipEmbedMediaCheck;
                    foundTag = Array.from(allTags, function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return value;
                    })// searching by temporary sid from Matterport
                    .find(function(item) {
                        return item.sid === sid || item.defaultSid === sid;
                    });
                    if (!foundTag) return [
                        3,
                        12
                    ];
                    if (!foundTag.type) return [
                        2,
                        null
                    ];
                    tag = (0,_object_spread/* default */.Z)({}, foundTag);
                    // Allow tag.type with NONE who participate in game actions like chapter, lock
                    if ((tour === null || tour === void 0 ? void 0 : tour.gameId) && tourType === Tour/* TourType.Game */.v.Game) {
                        this.unlockChapter(tag, GameBook/* ChapterType.Tag */._U.Tag);
                        if (this.handleTagLock(tag)) return [
                            2,
                            null
                        ];
                    } else if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                        this.setState({
                            clickedElement: {
                                id: tag.id,
                                sid: tag.sid,
                                defaultSid: tag.defaultSid,
                                type: Game/* EntityType.Tag */.py.Tag
                            }
                        });
                    }
                    if ((tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.None */.Qy.None) {
                        return [
                            2,
                            null
                        ];
                    }
                    if ((tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.Popup */.Qy.Popup || (tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.Iframe */.Qy.Iframe) {
                        this.setTagPopupOpen(true, false);
                        return [
                            2,
                            null
                        ];
                    }
                    if ((tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.Navigation */.Qy.Navigation) {
                        ;
                        if ((ref1 = this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.showNavTools) {
                            processNavigationPath({
                                tagNavigationLink: tag.navigationLink,
                                sweeps: this.state.sweeps,
                                startSweep: this.pose.sweep,
                                cb: function(param) {
                                    var sweepsPath = param.sweepsPath, rotation = param.rotation;
                                    var _tour = _this.state.tour, rotationAngle = _tour.rotationAngle, rotationSpeed = _tour.rotationSpeed, transitionSpeed = _tour.transitionSpeed, stopAfterSweep = _tour.stopAfterSweep;
                                    moveToSweeps({
                                        sweepsPath: sweepsPath,
                                        targetRotation: rotation,
                                        rotationAngle: rotationAngle,
                                        rotationSpeed: rotationSpeed,
                                        transitionSpeed: transitionSpeed,
                                        stopAfterSweep: stopAfterSweep,
                                        poseRotation: _this.pose.rotation,
                                        showcaseSweep: _this.showcase.Sweep
                                    }).then(function() {
                                        _this.setState({
                                            showPathFinderPopup: true
                                        });
                                    });
                                }
                            });
                        }
                        return [
                            2,
                            null
                        ];
                    }
                    if (!skipEmbedMediaCheck && tag.embedMedia && [
                        Tag/* TagType.Popup */.Qy.Popup,
                        Tag/* TagType.Iframe */.Qy.Iframe
                    ].includes(tag.type)) {
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Panorama */.Qy.Panorama) {
                        this.setState({
                            activePano: tag.panoramaId,
                            panoramaOn: true
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    if (!(tag.type === Tag/* TagType.Treedis */.Qy.Treedis && tag.url)) return [
                        3,
                        9
                    ];
                    segmants = tag.url.split("/");
                    lastSeg = segmants[segmants.length - 1].split("?");
                    slug = lastSeg[0];
                    if (tour.slug === slug && lastSeg.length === 1) return [
                        2,
                        null
                    ]; // same tour, no query params, we shouldn't get it again
                    if ((0,util_all/* getQueryVariable */.Dv)(tag.url, "m")) {
                        react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                        return [
                            2,
                            null
                        ];
                    }
                    changeMinimap = tour && !tour.customMinimap;
                    _state1.label = 1;
                case 1:
                    _state1.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    _ = tag.transition;
                    switch(_){
                        case Tag/* Transition.FlyOver */.uT.FlyOver:
                            return [
                                3,
                                2
                            ];
                        case Tag/* Transition.Instant */.uT.Instant:
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        5
                    ];
                case 2:
                    sweep = (0,util_all/* getQueryVariable */.Dv)(tag.url, "s");
                    x = (0,util_all/* getQueryVariable */.Dv)(tag.url, "x");
                    y = (0,util_all/* getQueryVariable */.Dv)(tag.url, "y");
                    return [
                        4,
                        this.moveToSweep(sweep, {
                            x: x ? +x : 0,
                            y: y ? +y : 0
                        }, "FLY")
                    ];
                case 3:
                    _state1.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    _this1 = this;
                    this.setState({
                        panoramaOn: false,
                        activePano: null,
                        isVSReady: false
                    }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _this1.stopVS()
                                    ];
                                case 1:
                                    _state.sent();
                                    _this1.modelNodes = [];
                                    _this1.vsObjects = [];
                                    _this1.getTour({
                                        slug: slug,
                                        changeMenu: false,
                                        changeMinimap: changeMinimap,
                                        changePanorama: false,
                                        url: tag.url,
                                        hideIntroScreen: true
                                    }); // false = dont change the menu/panorama
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                    return [
                        3,
                        6
                    ];
                case 5:
                    console.error("openTagIframe: Tag type unknown");
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        3,
                        8
                    ];
                case 7:
                    e = _state1.sent();
                    console.error(e);
                    return [
                        3,
                        8
                    ];
                case 8:
                    return [
                        2,
                        null
                    ];
                case 9:
                    if ((tag.type === Tag/* TagType.MatterportInstant */.Qy.MatterportInstant || tag.type === Tag/* TagType.Matterport */.Qy.Matterport && tag.transition === Tag/* Transition.Instant */.uT.Instant) && tag.url) {
                        ;
                        this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref2 = this.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(tag.url)), false, true);
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Matterport */.Qy.Matterport && tag.url) {
                        ;
                        this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref4 = this.state.tour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : ref5.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(tag.url)), false, false);
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Menu */.Qy.Menu) {
                        this.setState({
                            menuOpen: false,
                            activeMenu: null
                        }, function() {
                            _this.setState({
                                menuOpen: true,
                                menuOpened: true,
                                activeMenu: {
                                    menuId: tag.menuId,
                                    subMenuId: tag.subMenuId,
                                    subSubMenuId: tag.subSubMenuId
                                }
                            });
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Popup */.Qy.Popup && tag.url) {
                        ;
                        noAudioMode = ((ref6 = this.state) === null || ref6 === void 0 ? void 0 : ref6.tour).noAudioMode;
                        tag.url = (0,util_all/* getVideoLink */.rp)(tag.url, {
                            mute: noAudioMode && this.state.chatToken,
                            autoplay: tag.autoPlay
                        });
                        audioHandler.pauseAllMusic();
                    }
                    if (tag.type === Tag/* TagType.Tab */.Qy.Tab && tag.url) {
                        window.open(tag.url);
                        return [
                            2,
                            null
                        ];
                    }
                    if (!(tag.type === Tag/* TagType.Music */.Qy.Music && tag.url)) return [
                        3,
                        11
                    ];
                    noAudioMode1 = ((ref7 = this.state) === null || ref7 === void 0 ? void 0 : ref7.tour).noAudioMode;
                    disableActionForFlow = !!((ref8 = this.state.flowAssetsToDisableAction) === null || ref8 === void 0 ? void 0 : ref8.find(function(a) {
                        return a.asset === "tag" && a.assetId === tag.id;
                    }));
                    if (noAudioMode1 && this.state.chatToken || disableActionForFlow) return [
                        2,
                        null
                    ];
                    vsVideos = (ref9 = this.vsObjects) === null || ref9 === void 0 ? void 0 : ref9.filter(function(obj) {
                        var ref;
                        return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === VideoRenderer_component/* videoRendererType */.Im;
                    });
                    vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                        var _node = obj.node, vsVideo = _node.video, muteBtn = _node.muteBtn;
                        if (muteBtn && !muteBtn.active) {
                            vsVideo.muted = true;
                            muteBtn.active = true;
                            muteBtn.makeBtn(muteBtn.inputs.src);
                        }
                    });
                    return [
                        4,
                        audioHandler.playAudio({
                            type: AudioModule/* MusicObj.TAGS */.nR.TAGS,
                            id: tag.id
                        })
                    ];
                case 10:
                    _state1.sent();
                    return [
                        2,
                        null
                    ];
                case 11:
                    if (tag.type === Tag/* TagType.VideoChat */.Qy.VideoChat) {
                        this.setState({
                            videoChatTagPopOn: true,
                            openedTag: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                                sid: tag.sid
                            })
                        });
                        audioHandler.pauseAllMusic();
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.ExperiencePopUp */.Qy.ExperiencePopUp) {
                        ;
                        img = tag === null || tag === void 0 ? void 0 : tag.tagGalleries.find(function(g) {
                            return g.isImage;
                        });
                        this.setState({
                            tourMusicWasPaused: true,
                            sweepMusicWasPaused: true,
                            experiencePopUpIsOpen: true,
                            closedElementPopup: false,
                            experiencePopUpData: {
                                title: tag === null || tag === void 0 ? void 0 : tag.title,
                                url: (img === null || img === void 0 ? void 0 : img.file) || (tag === null || tag === void 0 ? void 0 : tag.videoUrl) || (tag === null || tag === void 0 ? void 0 : tag.actionURL),
                                description: tag === null || tag === void 0 ? void 0 : tag.description,
                                defaultImageUrl: "",
                                prefixImageUrl: "/tours/".concat((ref10 = this.state.tour) === null || ref10 === void 0 ? void 0 : ref10.id, "/tags/"),
                                rotation: tag === null || tag === void 0 ? void 0 : tag.rotation,
                                backgroundColor: tag === null || tag === void 0 ? void 0 : tag.backgroundColor,
                                backgroundOpacity: tag === null || tag === void 0 ? void 0 : tag.backgroundOpacity,
                                textColor: tag === null || tag === void 0 ? void 0 : tag.textColor,
                                buttonColor: tag === null || tag === void 0 ? void 0 : tag.buttonColor
                            }
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Flow */.Qy.Flow) {
                        this.setState({
                            startFlowFromAsset: tag.flowId
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    this.setState({
                        tagPopOn: true,
                        openedTag: tag,
                        closedElementPopup: false
                    });
                    return [
                        2,
                        tag
                    ];
                case 12:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _openTagIframe.apply(this, arguments);
}
function moveToMPLabels(menu) {
    return _moveToMPLabels.apply(this, arguments);
}
function _moveToMPLabels() {
    _moveToMPLabels = (0,_async_to_generator/* default */.Z)(function(menu) {
        var type, labelId, floorId, _state, mpLabels, sweeps, mpFloors, THREE, floorIndex, label, sweepsOnFloor, startPoint, distances, sweepsWithMinDistance, e;
        return (0,tslib_es6.__generator)(this, function(_state1) {
            switch(_state1.label){
                case 0:
                    type = menu.type, labelId = menu.labelId, floorId = menu.floorId;
                    _state = this.state, mpLabels = _state.mpLabels, sweeps = _state.sweeps, mpFloors = _state.mpFloors;
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state1.sent();
                    _state1.label = 2;
                case 2:
                    _state1.trys.push([
                        2,
                        10,
                        ,
                        11
                    ]);
                    switch(type){
                        case Menu/* MenuType.MatterportFloor */.o.MatterportFloor:
                            return [
                                3,
                                3
                            ];
                        case Menu/* MenuType.MatterportLabel */.o.MatterportLabel:
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 3:
                    floorIndex = mpFloors.findIndex(function(l) {
                        return String(l.id) === String(floorId);
                    });
                    return [
                        4,
                        this.changeViewMode(Tour/* TourMode.FLOORPLAN */.zz.FLOORPLAN)
                    ];
                case 4:
                    _state1.sent();
                    return [
                        4,
                        this.changeFloor(floorIndex)
                    ];
                case 5:
                    _state1.sent();
                    return [
                        3,
                        9
                    ];
                case 6:
                    label = mpLabels.find(function(l) {
                        return l.sid === labelId;
                    });
                    if (!label) console.error("Label not found");
                    sweepsOnFloor = sweeps.filter(function(x) {
                        return x.floorInfo.id === label.floorInfo.id && x.enabled;
                    });
                    if (sweepsOnFloor.length === 0) console.error("Sweeps not found");
                    startPoint = new THREE.Vector3(label.position.x, label.position.y, label.position.z);
                    distances = sweepsOnFloor.map(function(sweep) {
                        var endPoint = new THREE.Vector3(sweep.position.x, sweep.position.y, sweep.position.z);
                        var distance = Math.abs(startPoint.distanceTo(endPoint));
                        return (0,_object_spread/* default */.Z)({
                            distance: distance
                        }, sweep);
                    });
                    sweepsWithMinDistance = distances.reduce(function(a, b) {
                        return (a === null || a === void 0 ? void 0 : a.distance) <= (b === null || b === void 0 ? void 0 : b.distance) ? a : b;
                    });
                    // eslint-disable-next-line dot-notation
                    return [
                        4,
                        this.showcase.Sweep.moveTo(sweepsWithMinDistance["id"], {
                            // eslint-disable-next-line dot-notation
                            rotation: sweepsWithMinDistance["rotation"],
                            transition: this.showcase.Mode.TransitionType.FLY
                        })
                    ];
                case 7:
                    _state1.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    console.error("moveToMPLabels: Menu type unknown");
                    return [
                        3,
                        9
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    e = _state1.sent();
                    console.error(e);
                    return [
                        3,
                        11
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return _moveToMPLabels.apply(this, arguments);
}
function openVsObjectIframe(vsObject) {
    return _openVsObjectIframe.apply(this, arguments);
}
function _openVsObjectIframe() {
    _openVsObjectIframe = (0,_async_to_generator/* default */.Z)(function(vsObject) {
        var ref, hasTourGameId, doVSAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            hasTourGameId = (ref = this.state.tour) === null || ref === void 0 ? void 0 : ref.gameId;
            if (!hasTourGameId) return [
                2,
                false
            ];
            this.unlockChapter(vsObject, GameBook/* ChapterType.VSItem */._U.VSItem);
            doVSAction = this.handleVsObjectLock(vsObject, Game/* LockLocationType.vsItem */.A.vsItem);
            return [
                2,
                doVSAction
            ];
        });
    });
    return _openVsObjectIframe.apply(this, arguments);
}
function openVsImageIframe(vsImage) {
    return _openVsImageIframe.apply(this, arguments);
}
function _openVsImageIframe() {
    _openVsImageIframe = (0,_async_to_generator/* default */.Z)(function(vsImage) {
        var tour;
        return (0,tslib_es6.__generator)(this, function(_state) {
            tour = this.state.tour;
            if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                this.unlockChapter(vsImage, GameBook/* ChapterType.VSImage */._U.VSImage);
                if (this.handleVsObjectLock(vsImage, Game/* LockLocationType.vsImage */.A.vsImage)) return [
                    2,
                    null
                ];
            }
            return [
                2,
                null
            ];
        });
    });
    return _openVsImageIframe.apply(this, arguments);
}
function openVsVideoIframe(vsVideo) {
    return _openVsVideoIframe.apply(this, arguments);
}
function _openVsVideoIframe() {
    _openVsVideoIframe = (0,_async_to_generator/* default */.Z)(function(vsVideo) {
        var tour;
        return (0,tslib_es6.__generator)(this, function(_state) {
            tour = this.state.tour;
            if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                this.unlockChapter(vsVideo, GameBook/* ChapterType.VSVideo */._U.VSVideo);
                if (this.handleVsObjectLock(vsVideo, Game/* LockLocationType.vsVideo */.A.vsVideo)) return [
                    2,
                    null
                ];
            }
            return [
                2,
                null
            ];
        });
    });
    return _openVsVideoIframe.apply(this, arguments);
}


/***/ }),

/***/ 13607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// eslint-disable-next-line @typescript-eslint/no-var-requires
var io = (__webpack_require__(57046).io);
var socketsURI = "https://sockets.treedis.com" || 0;
var socket = io(socketsURI, {
    transports: [
        "websocket"
    ],
    autoConnect: false
});
socket.on("connect_error", function(err) {
    // eslint-disable-next-line no-console
    console.error(err);
});
/* harmony default export */ __webpack_exports__["Z"] = (socket);


/***/ }),

/***/ 24069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U_": function() { return /* binding */ calculateMobileHeight; }
/* harmony export */ });
/* unused harmony exports customSelectStyles, newEcommerceStyles, ecommerceDefaultColorBlackSelect */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var customSelectStyles = {
    control: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            minHeight: 38,
            borderRadius: 0,
            maxHeight: "40px",
            height: "40px",
            borderColor: "#D9EAEC",
            color: "red"
        });
    },
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "100%",
            margin: 0,
            padding: 0,
            color: "green"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none",
            color: "blue"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            fontWeight: "normal",
            cursor: "pointer",
            transform: "none",
            border: "none",
            top: "0",
            height: "40px",
            lineHeight: "40px"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px",
            color: "red"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base), {
            display: "none",
            color: "red"
        });
    }
};
var newEcommerceStyles = {
    control: function(provided, props) {
        var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            minHeight: 38,
            borderRadius: 0,
            maxHeight: "40px",
            height: "40px"
        });
        if (props === null || props === void 0 ? void 0 : props.isDisabled) {
            styles.backgroundColor = "rgba(239, 239, 239, 0.3)";
            styles.borderColor = "rgba(239, 239, 239, 0.3)";
        }
        return styles;
    },
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "100%",
            margin: 0,
            padding: 0,
            color: "black"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            fontWeight: "normal",
            cursor: "pointer",
            transform: "none",
            border: "none",
            top: "0",
            height: "40px",
            lineHeight: "40px",
            color: "black"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base);
    },
    option: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    }
};
var ecommerceDefaultColorBlackSelect = {
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base);
    },
    option: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    }
};
var calculateMobileHeight = function() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
};


/***/ }),

/***/ 31103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* reexport */ MittEvents; },
  "u": function() { return /* reexport */ emitter; }
});

// EXTERNAL MODULE: ./node_modules/mitt/dist/mitt.mjs
var mitt = __webpack_require__(59391);
;// CONCATENATED MODULE: ./events/mitt.ts

var emitter = (0,mitt/* default */.Z)();


;// CONCATENATED MODULE: ./events/MittEvents.ts
var MittEvents;
(function(MittEvents) {
    MittEvents["AUDIO_VOLUME"] = "audio_volume";
    MittEvents["AUDIO_MUTE"] = "audio_mute";
    MittEvents["TOUR_AUDIO_PLAY"] = "tour_audio_play";
})(MittEvents || (MittEvents = {}));

;// CONCATENATED MODULE: ./events/index.ts





/***/ }),

/***/ 97514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ showChoicePopupSearchField; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2804);

var showChoicePopupSearchField = (0,recoil__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)({
    key: "showChoicePopupSearchField",
    default: false
});


/***/ }),

/***/ 70989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nJ": function() { return /* reexport */ activeItemState; },
  "hm": function() { return /* reexport */ audioConfigsState; },
  "b1": function() { return /* reexport */ bgImageState; },
  "DF": function() { return /* reexport */ bottomBarOpenState; },
  "b_": function() { return /* reexport */ captionsEnabledState; },
  "g$": function() { return /* reexport */ forceShowPathSwitchMobileModalState; },
  "F3": function() { return /* reexport */ gamePointsState; },
  "WW": function() { return /* reexport */ gameSoundOnState; },
  "WN": function() { return /* reexport */ gameSoundVolumeState; },
  "uP": function() { return /* reexport */ infoModalDataState; },
  "wN": function() { return /* reexport */ lockInfoPopupStatusState; },
  "bG": function() { return /* reexport */ lockTimerState; },
  "vM": function() { return /* reexport */ navigationFinishScreenState; },
  "FZ": function() { return /* reexport */ navigationSettingsState; },
  "er": function() { return /* reexport */ navigationToastState; },
  "w": function() { return /* reexport */ navigationTranslationState; },
  "jF": function() { return /* reexport */ orderedTicketsState; },
  "Sy": function() { return /* reexport */ redirectTicketsState; },
  "y9": function() { return /* reexport */ sidebarMinimizedState; },
  "eo": function() { return /* reexport */ sidebarOpenState; },
  "Yb": function() { return /* reexport */ sliderValueState; },
  "Ys": function() { return /* reexport */ ticketingCurrentLanguage; },
  "$W": function() { return /* reexport */ ticketingDataState; },
  "Uq": function() { return /* reexport */ tourConfigsState; },
  "Jv": function() { return /* reexport */ translationDataState; },
  "FV": function() { return /* reexport */ recoil/* useRecoilState */.FV; },
  "sJ": function() { return /* reexport */ recoil/* useRecoilValue */.sJ; },
  "Zl": function() { return /* reexport */ recoil/* useSetRecoilState */.Zl; },
  "Jn": function() { return /* reexport */ youtubeOnState; }
});

// UNUSED EXPORTS: DefaultValue, RecoilLoadable, RecoilRoot, atom, atomFamily, constSelector, errorSelector, isRecoilValue, noWait, readOnlySelector, retentionZone, selector, selectorFamily, snapshot_UNSTABLE, useGetRecoilValueInfo_UNSTABLE, useGotoRecoilSnapshot, useRecoilBridgeAcrossReactRoots_UNSTABLE, useRecoilCallback, useRecoilRefresher_UNSTABLE, useRecoilSnapshot, useRecoilStateLoadable, useRecoilTransactionObserver_UNSTABLE, useRecoilTransaction_UNSTABLE, useRecoilValueLoadable, useResetRecoilState, useRetain, useSetUnvalidatedAtomValues_UNSTABLE, useTransactionObservation_UNSTABLE, waitForAll, waitForAllSettled, waitForAny, waitForNone

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
;// CONCATENATED MODULE: ./store/atoms/basic.ts

var captionsEnabledState = (0,recoil/* atom */.cn)({
    key: "captionsEnabledState",
    default: true
});
var translationDataState = (0,recoil/* atom */.cn)({
    key: "translationDataState",
    default: null
});
var tourConfigsState = (0,recoil/* atom */.cn)({
    key: "tourConfigsState",
    default: {}
});
var forceShowPathSwitchMobileModalState = (0,recoil/* atom */.cn)({
    key: "forceShowPathSwitchMobileModalState",
    default: false
});
var audioConfigsState = (0,recoil/* atom */.cn)({
    key: "audioConfigsState",
    default: {
        muted: false,
        volume: 0.5,
        captionsEnabled: true
    }
});

;// CONCATENATED MODULE: ./store/atoms/game/sound.ts

var gameSoundOnState = (0,recoil/* atom */.cn)({
    key: "gameSoundOnState",
    default: true
});
var gameSoundVolumeState = (0,recoil/* atom */.cn)({
    key: "gameSoundVolumeState",
    default: 0.5
});

;// CONCATENATED MODULE: ./store/atoms/game/basic.ts

var lockTimerState = (0,recoil/* atom */.cn)({
    key: "lockTimerState",
    default: {
        running: false,
        value: 0
    }
});
var lockInfoPopupStatusState = (0,recoil/* atom */.cn)({
    key: "lockInfoPopupStatusState",
    default: null
});
var gamePointsState = (0,recoil/* atom */.cn)({
    key: "gamePointsState",
    default: 0
});

;// CONCATENATED MODULE: ./store/atoms/game/index.ts



// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
;// CONCATENATED MODULE: ./store/atoms/ticketing.ts


var ticketingCurrentLanguage = (0,recoil/* atom */.cn)({
    key: "ticketingCurrentLanguage",
    default: {}
});
var infoModalDataState = (0,recoil/* atom */.cn)({
    key: "infoModalDataState",
    default: {
        mode: InfoModal/* EInfoModal.error */.Y.error,
        isOpen: false
    }
});
var redirectTicketsState = (0,recoil/* atom */.cn)({
    key: "redirectTicketsState",
    default: null
});
var orderedTicketsState = (0,recoil/* atom */.cn)({
    key: "orderedTicketsState",
    default: null
});
var ticketingDataState = (0,recoil/* atom */.cn)({
    key: "ticketingDataState",
    default: null
});
var bgImageState = (0,recoil/* atom */.cn)({
    key: "bgImageState",
    default: ""
});

// EXTERNAL MODULE: ./components-new/eCommerce/BottomBar/types.ts
var types = __webpack_require__(40803);
;// CONCATENATED MODULE: ./store/atoms/eCommerce.ts


var activeItemState = (0,recoil/* atom */.cn)({
    key: "activeItemState",
    default: types/* EBottomBarActiveItem.cart */.C.cart
});
var bottomBarOpenState = (0,recoil/* atom */.cn)({
    key: "bottomBarOpenState",
    default: false
});
var sidebarMinimizedState = (0,recoil/* atom */.cn)({
    key: "sidebarMinimizedState",
    default: true
});
var sidebarOpenState = (0,recoil/* atom */.cn)({
    key: "sidebarOpenState",
    default: false
});
var youtubeOnState = (0,recoil/* atom */.cn)({
    key: "youtubeOnState",
    default: false
});

;// CONCATENATED MODULE: ./store/atoms/navigation/basic.ts

var navigationSettingsState = (0,recoil/* atom */.cn)({
    key: "navigationSettingsState",
    default: {
        titleEnabled: false,
        title: "",
        navbarCustomColorsEnabled: false,
        navbarBgColor: "",
        navbarBgOpacity: 0.7,
        navbarTextColor: "",
        navbarButtonPrimaryColor: "",
        navbarButtonSecondaryColor: "",
        navbarPathColor: "",
        sortingEnabled: true,
        defaultSorting: "default",
        descriptionEnabled: false,
        filtersEnabled: true,
        webContentEnabled: true,
        webThumbnailEnabled: true,
        teleportButtonEnabled: false,
        autoMoveButtonEnabled: true,
        autoPlayEnabled: true,
        detailedRouteEnabled: false
    }
});
var navigationFinishScreenState = (0,recoil/* atom */.cn)({
    key: "navigationFinishScreenState",
    default: {
        ratingEnabled: true,
        beforeVoteText: "",
        afterVoteText: "",
        sharingEnabled: true,
        popupTitle: "Get the route on your phone!",
        qrEnabled: true,
        qrTitle: "Scan this QR code",
        smsEnabled: false,
        smsTitle: "",
        smsText: "",
        policy: ""
    }
});
var sliderValueState = (0,recoil/* atom */.cn)({
    key: "sliderValueState",
    default: 0
});
var navigationToastState = (0,recoil/* atom */.cn)({
    key: "navigationToastState",
    default: false
});
var navigationTranslationState = (0,recoil/* atom */.cn)({
    key: "navigationTranslationState",
    default: {}
});

;// CONCATENATED MODULE: ./store/atoms/index.ts






;// CONCATENATED MODULE: ./store/index.ts

 // export * from './selectors';


/***/ }),

/***/ 33797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ extractSweepIdFromURL; }
/* harmony export */ });
var extractSweepIdFromURL = function(urlString) {
    var startIndex = urlString.indexOf("s=") + 2;
    var endIndex = urlString.indexOf("&", startIndex);
    if (startIndex >= 2 && endIndex !== -1) {
        return urlString.substring(startIndex, endIndex);
    }
    return null;
};


/***/ }),

/***/ 7926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sp": function() { return /* binding */ getDistance; },
/* harmony export */   "TB": function() { return /* binding */ getDetailedRouteDistance; }
/* harmony export */ });
/* unused harmony exports checkIntersection, getClosestSweep */
/* harmony import */ var _models_virtualStaging_PathFinderLine_utils_getCurveLength__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35083);

var getDistance = function(pos1, pos2) {
    var dx = pos1.x - pos2.x;
    var dy = pos1.y - pos2.y;
    var dz = pos1.z - pos2.z;
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
};
var getDetailedRouteDistance = function(matterPath, THREE) {
    var fullDistance = 0;
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < matterPath.length; i++){
        if (matterPath[i] && matterPath[i + 1]) {
            var start = new THREE.Vector3(matterPath[i].data.position.x, matterPath[i].data.position.y + 0.15, matterPath[i].data.position.z);
            var end = new THREE.Vector3(matterPath[i + 1].data.position.x, matterPath[i + 1].data.position.y + 0.15, matterPath[i + 1].data.position.z);
            var path = new THREE.CatmullRomCurve3([
                start,
                end
            ]);
            var distance = (0,_models_virtualStaging_PathFinderLine_utils_getCurveLength__WEBPACK_IMPORTED_MODULE_0__/* .getCurveLength */ .U)(path);
            fullDistance += distance;
        }
    }
    return fullDistance;
};
function checkIntersection(point1, point2, barrier, scene, THREE) {
    var start = new THREE.Vector3(point1.positionX, point1.isCustom ? point1.positionY : point1.positionY - 1.15, point1.positionZ);
    var end = new THREE.Vector3(point2.positionX, point2.isCustom ? point2.positionY : point2.positionY - 1.15, point2.positionZ);
    var direction = new THREE.Vector3().subVectors(end, start).normalize();
    var raycaster = new THREE.Raycaster(start, direction);
    var intersects = raycaster.intersectObject(barrier, true);
    // Debug method, uncomment to see all sweep connections
    // Red lines represent connections blocked by barriers
    // addDebugLineBetweenPoints(
    //   point1,
    //   point2,
    //   intersects.length > 0 ? 0xff0000 : 0x0000ff,
    //   scene,
    //   THREE
    // );
    return intersects;
}
var getClosestSweep = function(startPointPosition, sweeps, sceneBarrierNodes, THREE) {
    if (!sweeps) return null;
    // const THREE = context.current.three;
    var minDistance = 10;
    var minDistanceSweep = null;
    sweeps.forEach(function(sweep) {
        var sweepPos = new THREE.Vector3(sweep.position.x, sweep.isCustom ? sweep.position.y : sweep.position.y - 1.15, sweep.position.z);
        var distance = sweepPos.distanceTo(startPointPosition);
        if (distance > minDistance) return;
        var intersectsBarrier = false;
        sceneBarrierNodes.forEach(function(barrierNode) {
            var intersects = checkIntersection(sweep, {
                positionX: startPointPosition.x,
                positionY: startPointPosition.y,
                positionZ: startPointPosition.z,
                isCustom: true
            }, barrierNode[0].obj3D, barrierNode[1].context.scene, THREE);
            if (intersects.length) {
                var isBarrierFront = false;
                intersects.every(function(i) {
                    if (i.object.name === "barrierFront" && i.object.visible) {
                        isBarrierFront = true;
                        return false;
                    }
                    if (i.object.name === "barrierBack" && i.object.visible) {
                        return false;
                    }
                    return true;
                });
                if (isBarrierFront) return;
                intersectsBarrier = true;
            }
        });
        // If intersects polygon, skip this sweep connection
        if (intersectsBarrier) return;
        if (distance < minDistance) {
            minDistance = distance;
            minDistanceSweep = sweep;
        }
    });
    return minDistanceSweep;
};


/***/ }),

/***/ 18066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ randomNumberId; }
/* harmony export */ });
var randomNumberId = function() {
    var nr = String(Math.random()).split(".")[1];
    if (Number(nr)) {
        return Number(nr);
    }
    return Math.random();
};


/***/ }),

/***/ 98765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ extractContentFromHTML; },
/* harmony export */   "d": function() { return /* binding */ removeHTMLTagsFromString; }
/* harmony export */ });
var removeHTMLTagsFromString = function(str) {
    if (!str) return "";
    return str.replace(/<br\s*\/?>/gi, " ").replace(/<\/?[^>]+(>|$)/g, "").replace(/\s+/g, " ").replace(/amp;/g, "").trim();
};
var extractContentFromHTML = function(str) {
    var span = document.createElement("span");
    span.innerHTML = str;
    return span.textContent || span.innerText;
};


/***/ })

}]);